export const ENUMS = [
  {
    'Tag': '4',
    'Value': 'B',
    'SymbolicName': 'Buy',
    'Group': '',
    'Sort': '1',
    'Description': 'Buy',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '4',
    'Value': 'S',
    'SymbolicName': 'Sell',
    'Group': '',
    'Sort': '2',
    'Description': 'Sell',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '4',
    'Value': 'T',
    'SymbolicName': 'Trade',
    'Group': '',
    'Sort': '3',
    'Description': 'Trade',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '4',
    'Value': 'X',
    'SymbolicName': 'Cross',
    'Group': '',
    'Sort': '4',
    'Description': 'Cross',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '5',
    'Value': 'N',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '5',
    'Value': 'C',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '5',
    'Value': 'R',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '3',
    'Description': 'Replace',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '13',
    'Value': '1',
    'SymbolicName': 'PerUnit',
    'Group': '',
    'Sort': '1',
    'Description': 'Per Unit (implying shares, par, currency, etc.)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '13',
    'Value': '2',
    'SymbolicName': 'Percent',
    'Group': '',
    'Sort': '2',
    'Description': 'Percent',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '13',
    'Value': '3',
    'SymbolicName': 'Absolute',
    'Group': '',
    'Sort': '3',
    'Description': 'Absolute (total monetary amount)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '13',
    'Value': '4',
    'SymbolicName': 'PercentageWaivedCashDiscount',
    'Group': '',
    'Sort': '4',
    'Description': 'Percentage waived - cash discount (for CIV buy orders)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '13',
    'Value': '5',
    'SymbolicName': 'PercentageWaivedEnhancedUnits',
    'Group': '',
    'Sort': '5',
    'Description': 'Percentage waived -= enhanced units (for CIV buy orders)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '13',
    'Value': '6',
    'SymbolicName': 'PointsPerBondOrContract',
    'Group': '',
    'Sort': '6',
    'Description': 'Points per bond or contract (supply ContractMultiplier (231) in the <Instrument> component block if the object security is denominated in a size other than the industry default - 1000 par for bonds)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': '0',
    'SymbolicName': 'StayOnOfferSide',
    'Group': '',
    'Sort': '1',
    'Description': 'Stay on offer side',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '1',
    'SymbolicName': 'NotHeld',
    'Group': '',
    'Sort': '2',
    'Description': 'Not held',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '2',
    'SymbolicName': 'Work',
    'Group': '',
    'Sort': '3',
    'Description': 'Work',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '3',
    'SymbolicName': 'GoAlong',
    'Group': '',
    'Sort': '4',
    'Description': 'Go along',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '4',
    'SymbolicName': 'OverTheDay',
    'Group': '',
    'Sort': '5',
    'Description': 'Over the day',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '5',
    'SymbolicName': 'Held',
    'Group': '',
    'Sort': '6',
    'Description': 'Held',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '6',
    'SymbolicName': 'ParticipateDoNotInitiate',
    'Group': '',
    'Sort': '7',
    'Description': 'Participate don\'t initiate',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '7',
    'SymbolicName': 'StrictScale',
    'Group': '',
    'Sort': '8',
    'Description': 'Strict scale',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '8',
    'SymbolicName': 'TryToScale',
    'Group': '',
    'Sort': '9',
    'Description': 'Try to scale',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': '9',
    'SymbolicName': 'StayOnBidSide',
    'Group': '',
    'Sort': '10',
    'Description': 'Stay on bid side',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'A',
    'SymbolicName': 'NoCross',
    'Group': '',
    'Sort': '11',
    'Description': 'No cross (cross is forbidden)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'B',
    'SymbolicName': 'OKToCross',
    'Group': '',
    'Sort': '12',
    'Description': 'OK to cross',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'C',
    'SymbolicName': 'CallFirst',
    'Group': '',
    'Sort': '13',
    'Description': 'Call first',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'D',
    'SymbolicName': 'PercentOfVolume',
    'Group': '',
    'Sort': '14',
    'Description': 'Percent of volume (indicates that the sender does not want to be all of the volume on the floor vs. a specific percentage)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'E',
    'SymbolicName': 'DoNotIncrease',
    'Group': '',
    'Sort': '15',
    'Description': 'Do not increase - DNI',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'F',
    'SymbolicName': 'DoNotReduce',
    'Group': '',
    'Sort': '16',
    'Description': 'Do not reduce - DNR',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'G',
    'SymbolicName': 'AllOrNone',
    'Group': '',
    'Sort': '17',
    'Description': 'All or none - AON',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '18',
    'Value': 'H',
    'SymbolicName': 'ReinstateOnSystemFailure',
    'Group': '',
    'Sort': '18',
    'Description': 'Reinstate on system failure (mutually exclusive with Q and l)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': 'I',
    'SymbolicName': 'InstitutionsOnly',
    'Group': '',
    'Sort': '19',
    'Description': 'Institutions only',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '18',
    'Value': 'J',
    'SymbolicName': 'ReinstateOnTradingHalt',
    'Group': '',
    'Sort': '20',
    'Description': 'Reinstate on Trading Halt (mutually exclusive with K and m)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': 'K',
    'SymbolicName': 'CancelOnTradingHalt',
    'Group': '',
    'Sort': '21',
    'Description': 'Cancel on Trading Halt (mutually exclusive with J and m)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': 'L',
    'SymbolicName': 'LastPeg',
    'Group': '',
    'Sort': '22',
    'Description': 'Last peg (last sale)',
    'Added': 'FIX.3.0',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'M',
    'SymbolicName': 'MidPricePeg',
    'Group': '',
    'Sort': '23',
    'Description': 'Mid-price peg (midprice of inside quote)',
    'Added': 'FIX.3.0',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'N',
    'SymbolicName': 'NonNegotiable',
    'Group': '',
    'Sort': '24',
    'Description': 'Non-negotiable',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '18',
    'Value': 'O',
    'SymbolicName': 'OpeningPeg',
    'Group': '',
    'Sort': '25',
    'Description': 'Opening peg',
    'Added': 'FIX.3.0',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'P',
    'SymbolicName': 'MarketPeg',
    'Group': '',
    'Sort': '26',
    'Description': 'Market peg',
    'Added': 'FIX.3.0',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'Q',
    'SymbolicName': 'CancelOnSystemFailure',
    'Group': '',
    'Sort': '27',
    'Description': 'Cancel on system failure (mutually exclusive with H and l)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': 'R',
    'SymbolicName': 'PrimaryPeg',
    'Group': '',
    'Sort': '28',
    'Description': 'Primary peg (primary market - buy at bid/sell at offer)',
    'Added': 'FIX.3.0',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'S',
    'SymbolicName': 'Suspend',
    'Group': '',
    'Sort': '29',
    'Description': 'Suspend',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '18',
    'Value': 'T',
    'SymbolicName': 'FixedPegToLocalBestBidOrOfferAtTimeOfOrder',
    'Group': '',
    'Sort': '30',
    'Description': 'Fixed Peg to Local best bid or offer at time of order',
    'Added': 'FIX.4.4',
    'AddedEP': '35',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'U',
    'SymbolicName': 'CustomerDisplayInstruction',
    'Group': '',
    'Sort': '31',
    'Description': 'Customer Display Instruction (Rule 11Ac1-1/4)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '18',
    'Value': 'V',
    'SymbolicName': 'Netting',
    'Group': '',
    'Sort': '32',
    'Description': 'Netting (for Forex)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '18',
    'Value': 'W',
    'SymbolicName': 'PegToVWAP',
    'Group': '',
    'Sort': '33',
    'Description': 'Peg to VWAP',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'X',
    'SymbolicName': 'TradeAlong',
    'Group': '',
    'Sort': '34',
    'Description': 'Trade Along',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': 'Y',
    'SymbolicName': 'TryToStop',
    'Group': '',
    'Sort': '35',
    'Description': 'Try To Stop',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '18',
    'Value': 'Z',
    'SymbolicName': 'CancelIfNotBest',
    'Group': '',
    'Sort': '36',
    'Description': 'Cancel if not best',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '18',
    'Value': 'a',
    'SymbolicName': 'TrailingStopPeg',
    'Group': '',
    'Sort': '37',
    'Description': 'Trailing Stop Peg',
    'Added': 'FIX.4.4',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'b',
    'SymbolicName': 'StrictLimit',
    'Group': '',
    'Sort': '38',
    'Description': 'Strict Limit (No price improvement)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '18',
    'Value': 'c',
    'SymbolicName': 'IgnorePriceValidityChecks',
    'Group': '',
    'Sort': '39',
    'Description': 'Ignore Price Validity Checks',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '18',
    'Value': 'd',
    'SymbolicName': 'PegToLimitPrice',
    'Group': '',
    'Sort': '40',
    'Description': 'Peg to Limit Price',
    'Added': 'FIX.4.4',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '18',
    'Value': 'e',
    'SymbolicName': 'WorkToTargetStrategy',
    'Group': '',
    'Sort': '41',
    'Description': 'Work to Target Strategy',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '18',
    'Value': 'f',
    'SymbolicName': 'IntermarketSweep',
    'Group': '',
    'Sort': '42',
    'Description': 'Intermarket Sweep',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '18',
    'Value': 'g',
    'SymbolicName': 'ExternalRoutingAllowed',
    'Group': '',
    'Sort': '43',
    'Description': 'External Routing Allowed',
    'Added': 'FIX.4.4',
    'AddedEP': '14'
  },
  {
    'Tag': '18',
    'Value': 'h',
    'SymbolicName': 'ExternalRoutingNotAllowed',
    'Group': '',
    'Sort': '44',
    'Description': 'External Routing Not Allowed',
    'Added': 'FIX.4.4',
    'AddedEP': '14'
  },
  {
    'Tag': '18',
    'Value': 'i',
    'SymbolicName': 'ImbalanceOnly',
    'Group': '',
    'Sort': '45',
    'Description': 'Imbalance Only',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '18',
    'Value': 'j',
    'SymbolicName': 'SingleExecutionRequestedForBlockTrade',
    'Group': '',
    'Sort': '46',
    'Description': 'Single execution requested for block trade',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '18',
    'Value': 'k',
    'SymbolicName': 'BestExecution',
    'Group': '',
    'Sort': '47',
    'Description': 'Best Execution',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '18',
    'Value': 'l',
    'SymbolicName': 'SuspendOnSystemFailure',
    'Group': '',
    'Sort': '48',
    'Description': 'Suspend on system failure (mutually exclusive with H and Q)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '18',
    'Value': 'm',
    'SymbolicName': 'SuspendOnTradingHalt',
    'Group': '',
    'Sort': '49',
    'Description': 'Suspend on Trading Halt (mutually exclusive with J and K)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '18',
    'Value': 'n',
    'SymbolicName': 'ReinstateOnConnectionLoss',
    'Group': '',
    'Sort': '50',
    'Description': 'Reinstate on connection loss (mutually exclusive with o and p)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '18',
    'Value': 'o',
    'SymbolicName': 'CancelOnConnectionLoss',
    'Group': '',
    'Sort': '51',
    'Description': 'Cancel on connection loss (mutually exclusive with n and p)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '18',
    'Value': 'p',
    'SymbolicName': 'SuspendOnConnectionLoss',
    'Group': '',
    'Sort': '52',
    'Description': 'Suspend on connection loss (mutually exclusive with n and o)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '18',
    'Value': 'q',
    'SymbolicName': 'ReleaseFromSuspension',
    'Group': '',
    'Sort': '53',
    'Description': 'Release from suspension (mutually exclusive with S)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '18',
    'Value': 'r',
    'SymbolicName': 'ExecuteAsDeltaNeutral',
    'Group': '',
    'Sort': '54',
    'Description': 'Execute as delta neutral using volatility provided',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '18',
    'Value': 's',
    'SymbolicName': 'ExecuteAsDurationNeutral',
    'Group': '',
    'Sort': '55',
    'Description': 'Execute as duration neutral',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '18',
    'Value': 't',
    'SymbolicName': 'ExecuteAsFXNeutral',
    'Group': '',
    'Sort': '56',
    'Description': 'Execute as FX neutral',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '20',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '20',
    'Value': '1',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '20',
    'Value': '2',
    'SymbolicName': 'Correct',
    'Group': '',
    'Sort': '3',
    'Description': 'Correct',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '20',
    'Value': '3',
    'SymbolicName': 'Status',
    'Group': '',
    'Sort': '4',
    'Description': 'Status',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '21',
    'Value': '1',
    'SymbolicName': 'AutomatedExecutionNoIntervention',
    'Group': '',
    'Sort': '1',
    'Description': 'Automated execution order, private, no Broker intervention',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '21',
    'Value': '2',
    'SymbolicName': 'AutomatedExecutionInterventionOK',
    'Group': '',
    'Sort': '2',
    'Description': 'Automated execution order, public, Broker intervention OK',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '21',
    'Value': '3',
    'SymbolicName': 'ManualOrder',
    'Group': '',
    'Sort': '3',
    'Description': 'Manual order, best execution',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '22',
    'Value': '1',
    'SymbolicName': 'CUSIP',
    'Group': '',
    'Sort': '1',
    'Description': 'CUSIP',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '22',
    'Value': '2',
    'SymbolicName': 'SEDOL',
    'Group': '',
    'Sort': '2',
    'Description': 'SEDOL',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '22',
    'Value': '3',
    'SymbolicName': 'QUIK',
    'Group': '',
    'Sort': '3',
    'Description': 'QUIK',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '22',
    'Value': '4',
    'SymbolicName': 'ISINNumber',
    'Group': '',
    'Sort': '4',
    'Description': 'ISIN number',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '22',
    'Value': '5',
    'SymbolicName': 'RICCode',
    'Group': '',
    'Sort': '5',
    'Description': 'RIC code',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '22',
    'Value': '6',
    'SymbolicName': 'ISOCurrencyCode',
    'Group': '',
    'Sort': '6',
    'Description': 'ISO Currency Code',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '22',
    'Value': '7',
    'SymbolicName': 'ISOCountryCode',
    'Group': '',
    'Sort': '7',
    'Description': 'ISO Country Code',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '22',
    'Value': '8',
    'SymbolicName': 'ExchangeSymbol',
    'Group': '',
    'Sort': '8',
    'Description': 'Exchange Symbol',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '22',
    'Value': '9',
    'SymbolicName': 'ConsolidatedTapeAssociation',
    'Group': '',
    'Sort': '9',
    'Description': 'Consolidated Tape Association (CTA) Symbol (SIAC CTS/CQS line format)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '22',
    'Value': 'A',
    'SymbolicName': 'BloombergSymbol',
    'Group': '',
    'Sort': '10',
    'Description': 'Bloomberg Symbol',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'B',
    'SymbolicName': 'Wertpapier',
    'Group': '',
    'Sort': '11',
    'Description': 'Wertpapier',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'C',
    'SymbolicName': 'Dutch',
    'Group': '',
    'Sort': '12',
    'Description': 'Dutch',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'D',
    'SymbolicName': 'Valoren',
    'Group': '',
    'Sort': '13',
    'Description': 'Valoren',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'E',
    'SymbolicName': 'Sicovam',
    'Group': '',
    'Sort': '14',
    'Description': 'Sicovam',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'F',
    'SymbolicName': 'Belgian',
    'Group': '',
    'Sort': '15',
    'Description': 'Belgian',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'G',
    'SymbolicName': 'Common',
    'Group': '',
    'Sort': '16',
    'Description': '\'Common\' (Clearstream and Euroclear)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '22',
    'Value': 'H',
    'SymbolicName': 'ClearingHouse',
    'Group': '',
    'Sort': '17',
    'Description': 'Clearing House / Clearing Organization',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '22',
    'Value': 'I',
    'SymbolicName': 'ISDAFpMLSpecification',
    'Group': '',
    'Sort': '18',
    'Description': 'ISDA/FpML Product Specification (XML in EncodedSecurityDesc)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '22',
    'Value': 'J',
    'SymbolicName': 'OptionPriceReportingAuthority',
    'Group': '',
    'Sort': '19',
    'Description': 'Option Price Reporting Authority',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '22',
    'Value': 'K',
    'SymbolicName': 'ISDAFpMLURL',
    'Group': '',
    'Sort': '20',
    'Description': 'ISDA/FpML Product URL (URL in SecurityID)',
    'Added': 'FIX.4.4',
    'AddedEP': '15'
  },
  {
    'Tag': '22',
    'Value': 'L',
    'SymbolicName': 'LetterOfCredit',
    'Group': '',
    'Sort': '21',
    'Description': 'Letter of Credit',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '22',
    'Value': 'M',
    'SymbolicName': 'MarketplaceAssignedIdentifier',
    'Group': '',
    'Sort': '22',
    'Description': 'Marketplace-assigned Identifier',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '25',
    'Value': 'H',
    'SymbolicName': 'High',
    'Group': '',
    'Sort': '1',
    'Description': 'High',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '25',
    'Value': 'L',
    'SymbolicName': 'Low',
    'Group': '',
    'Sort': '2',
    'Description': 'Low',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '25',
    'Value': 'M',
    'SymbolicName': 'Medium',
    'Group': '',
    'Sort': '3',
    'Description': 'Medium',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '27',
    'Value': 'S',
    'SymbolicName': 'Small',
    'Group': '',
    'Sort': '2',
    'Description': 'Small',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '27',
    'Value': 'M',
    'SymbolicName': 'Medium',
    'Group': '',
    'Sort': '3',
    'Description': 'Medium',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '27',
    'Value': 'L',
    'SymbolicName': 'Large',
    'Group': '',
    'Sort': '4',
    'Description': 'Large',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '27',
    'Value': 'U',
    'SymbolicName': 'UndisclosedQuantity',
    'Group': '',
    'Sort': '5',
    'Description': 'Undisclosed Quantity',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '28',
    'Value': 'N',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '28',
    'Value': 'C',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '28',
    'Value': 'R',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '3',
    'Description': 'Replace',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '29',
    'Value': '1',
    'SymbolicName': 'Agent',
    'Group': '',
    'Sort': '1',
    'Description': 'Agent',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '29',
    'Value': '2',
    'SymbolicName': 'CrossAsAgent',
    'Group': '',
    'Sort': '2',
    'Description': 'Cross as agent',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '29',
    'Value': '3',
    'SymbolicName': 'CrossAsPrincipal',
    'Group': '',
    'Sort': '3',
    'Description': 'Cross as principal',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '29',
    'Value': '4',
    'SymbolicName': 'Principal',
    'Group': '',
    'Sort': '4',
    'Description': 'Principal',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '1',
    'SymbolicName': 'PartiallyFilled',
    'Group': '',
    'Sort': '2',
    'Description': 'Partially filled',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '2',
    'SymbolicName': 'Filled',
    'Group': '',
    'Sort': '3',
    'Description': 'Filled',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '3',
    'SymbolicName': 'DoneForDay',
    'Group': '',
    'Sort': '4',
    'Description': 'Done for day',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '4',
    'SymbolicName': 'Canceled',
    'Group': '',
    'Sort': '5',
    'Description': 'Canceled',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '5',
    'SymbolicName': 'Replaced',
    'Group': '',
    'Sort': '6',
    'Description': 'Replaced (No longer used)',
    'Added': 'FIX.4.4',
    'AddedEP': '35',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '39',
    'Value': '6',
    'SymbolicName': 'PendingCancel',
    'Group': '',
    'Sort': '7',
    'Description': 'Pending Cancel (i.e. result of Order Cancel Request)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '7',
    'SymbolicName': 'Stopped',
    'Group': '',
    'Sort': '8',
    'Description': 'Stopped',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '8',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '9',
    'Description': 'Rejected',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '39',
    'Value': '9',
    'SymbolicName': 'Suspended',
    'Group': '',
    'Sort': '10',
    'Description': 'Suspended',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '39',
    'Value': 'A',
    'SymbolicName': 'PendingNew',
    'Group': '',
    'Sort': '11',
    'Description': 'Pending New',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '39',
    'Value': 'B',
    'SymbolicName': 'Calculated',
    'Group': '',
    'Sort': '12',
    'Description': 'Calculated',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '39',
    'Value': 'C',
    'SymbolicName': 'Expired',
    'Group': '',
    'Sort': '13',
    'Description': 'Expired',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '39',
    'Value': 'D',
    'SymbolicName': 'AcceptedForBidding',
    'Group': '',
    'Sort': '14',
    'Description': 'Accepted for Bidding',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '39',
    'Value': 'E',
    'SymbolicName': 'PendingReplace',
    'Group': '',
    'Sort': '15',
    'Description': 'Pending Replace (i.e. result of Order Cancel/Replace Request)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '40',
    'Value': '1',
    'SymbolicName': 'Market',
    'Group': '',
    'Sort': '1',
    'Description': 'Market',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': '2',
    'SymbolicName': 'Limit',
    'Group': '',
    'Sort': '2',
    'Description': 'Limit',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': '3',
    'SymbolicName': 'Stop',
    'Group': '',
    'Sort': '3',
    'Description': 'Stop / Stop Loss',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': '4',
    'SymbolicName': 'StopLimit',
    'Group': '',
    'Sort': '4',
    'Description': 'Stop Limit',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': '5',
    'SymbolicName': 'MarketOnClose',
    'Group': '',
    'Sort': '5',
    'Description': 'Market On Close (No longer used)',
    'Added': 'FIX.2.7',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': '6',
    'SymbolicName': 'WithOrWithout',
    'Group': '',
    'Sort': '6',
    'Description': 'With Or Without',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': '7',
    'SymbolicName': 'LimitOrBetter',
    'Group': '',
    'Sort': '7',
    'Description': 'Limit Or Better',
    'Added': 'FIX.2.7',
    'Deprecated': 'FIX.4.4'
  },
  {
    'Tag': '40',
    'Value': '8',
    'SymbolicName': 'LimitWithOrWithout',
    'Group': '',
    'Sort': '8',
    'Description': 'Limit With Or Without',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': '9',
    'SymbolicName': 'OnBasis',
    'Group': '',
    'Sort': '9',
    'Description': 'On Basis',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '40',
    'Value': 'A',
    'SymbolicName': 'OnClose',
    'Group': '',
    'Sort': '10',
    'Description': 'On Close (No longer used)',
    'Added': 'FIX.2.7',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'B',
    'SymbolicName': 'LimitOnClose',
    'Group': '',
    'Sort': '11',
    'Description': 'Limit On Close (No longer used)',
    'Added': 'FIX.2.7',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'C',
    'SymbolicName': 'ForexMarket',
    'Group': '',
    'Sort': '12',
    'Description': 'Forex Market (No longer used)',
    'Added': 'FIX.4.0',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'D',
    'SymbolicName': 'PreviouslyQuoted',
    'Group': '',
    'Sort': '13',
    'Description': 'Previously Quoted',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '40',
    'Value': 'E',
    'SymbolicName': 'PreviouslyIndicated',
    'Group': '',
    'Sort': '14',
    'Description': 'Previously Indicated',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '40',
    'Value': 'F',
    'SymbolicName': 'ForexLimit',
    'Group': '',
    'Sort': '15',
    'Description': 'Forex Limit (No longer used)',
    'Added': 'FIX.4.1',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'G',
    'SymbolicName': 'ForexSwap',
    'Group': '',
    'Sort': '16',
    'Description': 'Forex Swap',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '40',
    'Value': 'H',
    'SymbolicName': 'ForexPreviouslyQuoted',
    'Group': '',
    'Sort': '17',
    'Description': 'Forex Previously Quoted (No longer used)',
    'Added': 'FIX.4.1',
    'Deprecated': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'I',
    'SymbolicName': 'Funari',
    'Group': '',
    'Sort': '18',
    'Description': 'Funari (Limit day order with unexecuted portion handles as Market On Close. E.g. Japan)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '40',
    'Value': 'J',
    'SymbolicName': 'MarketIfTouched',
    'Group': '',
    'Sort': '19',
    'Description': 'Market If Touched (MIT)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'K',
    'SymbolicName': 'MarketWithLeftOverAsLimit',
    'Group': '',
    'Sort': '20',
    'Description': 'Market With Left Over as Limit (market order with unexecuted quantity becoming limit order at last price)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'L',
    'SymbolicName': 'PreviousFundValuationPoint',
    'Group': '',
    'Sort': '21',
    'Description': 'Previous Fund Valuation Point (Historic pricing; for CIV)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'M',
    'SymbolicName': 'NextFundValuationPoint',
    'Group': '',
    'Sort': '22',
    'Description': 'Next Fund Valuation Point (Forward pricing; for CIV)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '40',
    'Value': 'P',
    'SymbolicName': 'Pegged',
    'Group': '',
    'Sort': '23',
    'Description': 'Pegged',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '40',
    'Value': 'Q',
    'SymbolicName': 'CounterOrderSelection',
    'Group': '',
    'Sort': '24',
    'Description': 'Counter-order selection',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '43',
    'Value': 'N',
    'SymbolicName': 'OriginalTransmission',
    'Group': '',
    'Sort': '1',
    'Description': 'Original transmission',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '43',
    'Value': 'Y',
    'SymbolicName': 'PossibleDuplicate',
    'Group': '',
    'Sort': '2',
    'Description': 'Possible duplicate',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'A',
    'SymbolicName': 'AgencySingleOrder',
    'Group': '',
    'Sort': '1',
    'Description': 'Agency single order',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'B',
    'SymbolicName': 'ShortExemptTransactionAType',
    'Group': '',
    'Sort': '2',
    'Description': 'Short exempt transaction (refer to A type)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'C',
    'SymbolicName': 'ProprietaryNonAlgo',
    'Group': '',
    'Sort': '3',
    'Description': 'Proprietary, Non-Algorithmic Program Trade (non-index arbitrage)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'D',
    'SymbolicName': 'ProgramOrderMember',
    'Group': '',
    'Sort': '4',
    'Description': 'Program order, index arb, for Member firm/org',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'E',
    'SymbolicName': 'ShortExemptTransactionForPrincipal',
    'Group': '',
    'Sort': '5',
    'Description': 'Short Exempt Transaction for Principal (was incorrectly identified in the FIX spec as \'Registered Equity Market Maker trades\')',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'F',
    'SymbolicName': 'ShortExemptTransactionWType',
    'Group': '',
    'Sort': '6',
    'Description': 'Short exempt transaction (refer to W type)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'H',
    'SymbolicName': 'ShortExemptTransactionIType',
    'Group': '',
    'Sort': '7',
    'Description': 'Short exempt transaction (refer to I type)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'I',
    'SymbolicName': 'IndividualInvestor',
    'Group': '',
    'Sort': '8',
    'Description': 'Individual Investor, single order',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'J',
    'SymbolicName': 'ProprietaryAlgo',
    'Group': '',
    'Sort': '9',
    'Description': 'Proprietary, Algorithmic Program Trading (non-index arbitrage)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'K',
    'SymbolicName': 'AgencyAlgo',
    'Group': '',
    'Sort': '10',
    'Description': 'Agency, Algorithmic Program Trading (non-index arbitrage)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'L',
    'SymbolicName': 'ShortExemptTransactionMemberAffliated',
    'Group': '',
    'Sort': '11',
    'Description': 'Short exempt transaction for member competing market-maker affliated with the firm clearing the trade (refer to P and O types)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'M',
    'SymbolicName': 'ProgramOrderOtherMember',
    'Group': '',
    'Sort': '12',
    'Description': 'Program Order, index arb, for other member',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'N',
    'SymbolicName': 'AgentForOtherMember',
    'Group': '',
    'Sort': '13',
    'Description': 'Agent for other Member, Non-Algorithmic Program Trade (non-index arbitrage)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'O',
    'SymbolicName': 'ProprietaryTransactionAffiliated',
    'Group': '',
    'Sort': '14',
    'Description': 'Proprietary transactions for competing market-maker that is affiliated with the clearing member (was incorrectly identified in the FIX spec as \'Competing dealer trades\')',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'P',
    'SymbolicName': 'Principal',
    'Group': '',
    'Sort': '15',
    'Description': 'Principal',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'R',
    'SymbolicName': 'TransactionNonMember',
    'Group': '',
    'Sort': '16',
    'Description': 'Transactions for the account of a non-member compting market-maker (was incorrectly identified in the FIX spec as \'Competing dealer trades\')',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'S',
    'SymbolicName': 'SpecialistTrades',
    'Group': '',
    'Sort': '17',
    'Description': 'Specialist trades',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'T',
    'SymbolicName': 'TransactionUnaffiliatedMember',
    'Group': '',
    'Sort': '18',
    'Description': 'Transactions for the account of an unaffiliated member\'s competing market-maker (was incorrectly identified in the FIX spec as \'Competing dealer trades\')',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'U',
    'SymbolicName': 'AgencyIndexArb',
    'Group': '',
    'Sort': '19',
    'Description': 'Agency, Index Arbitrage (includes Individual, Index Arbitrage trades)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'W',
    'SymbolicName': 'AllOtherOrdersAsAgentForOtherMember',
    'Group': '',
    'Sort': '20',
    'Description': 'All other orders as agent for other member',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'X',
    'SymbolicName': 'ShortExemptTransactionMemberNotAffliated',
    'Group': '',
    'Sort': '21',
    'Description': 'Short exempt transaction for member competing market-maker not affiliated with the firm clearing the trade (refer to W and T types)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '47',
    'Value': 'Y',
    'SymbolicName': 'AgencyNonAlgo',
    'Group': '',
    'Sort': '22',
    'Description': 'Agency, Non-Algorithmic Program Trade (non-index arbitrage)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '47',
    'Value': 'Z',
    'SymbolicName': 'ShortExemptTransactionNonMember',
    'Group': '',
    'Sort': '23',
    'Description': 'Short exempt transaction for non-member competing market-maker (refer to A and R types)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '54',
    'Value': '1',
    'SymbolicName': 'Buy',
    'Group': '',
    'Sort': '1',
    'Description': 'Buy',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '54',
    'Value': '2',
    'SymbolicName': 'Sell',
    'Group': '',
    'Sort': '2',
    'Description': 'Sell',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '54',
    'Value': '3',
    'SymbolicName': 'BuyMinus',
    'Group': '',
    'Sort': '3',
    'Description': 'Buy minus',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '54',
    'Value': '4',
    'SymbolicName': 'SellPlus',
    'Group': '',
    'Sort': '4',
    'Description': 'Sell plus',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '54',
    'Value': '5',
    'SymbolicName': 'SellShort',
    'Group': '',
    'Sort': '5',
    'Description': 'Sell short',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '54',
    'Value': '6',
    'SymbolicName': 'SellShortExempt',
    'Group': '',
    'Sort': '6',
    'Description': 'Sell short exempt',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '54',
    'Value': '7',
    'SymbolicName': 'Undisclosed',
    'Group': '',
    'Sort': '7',
    'Description': 'Undisclosed (valid for IOI and List Order messages only)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '54',
    'Value': '8',
    'SymbolicName': 'Cross',
    'Group': '',
    'Sort': '8',
    'Description': 'Cross (orders where counterparty is an exchange, valid for all messages except IOIs)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '54',
    'Value': '9',
    'SymbolicName': 'CrossShort',
    'Group': '',
    'Sort': '9',
    'Description': 'Cross short',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '54',
    'Value': 'A',
    'SymbolicName': 'CrossShortExempt',
    'Group': '',
    'Sort': '10',
    'Description': 'Cross short exempt',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '54',
    'Value': 'B',
    'SymbolicName': 'AsDefined',
    'Group': '',
    'Sort': '11',
    'Description': '\'As Defined\' (for use with multileg instruments)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '54',
    'Value': 'C',
    'SymbolicName': 'Opposite',
    'Group': '',
    'Sort': '12',
    'Description': '\'Opposite\' (for use with multileg instruments)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '54',
    'Value': 'D',
    'SymbolicName': 'Subscribe',
    'Group': '',
    'Sort': '13',
    'Description': 'Subscribe (e.g. CIV)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '54',
    'Value': 'E',
    'SymbolicName': 'Redeem',
    'Group': '',
    'Sort': '14',
    'Description': 'Redeem (e.g. CIV)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '54',
    'Value': 'F',
    'SymbolicName': 'Lend',
    'Group': '',
    'Sort': '15',
    'Description': 'Lend (FINANCING - identifies direction of collateral)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '54',
    'Value': 'G',
    'SymbolicName': 'Borrow',
    'Group': '',
    'Sort': '16',
    'Description': 'Borrow (FINANCING - identifies direction of collateral)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '59',
    'Value': '0',
    'SymbolicName': 'Day',
    'Group': '',
    'Sort': '1',
    'Description': 'Day (or session)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '59',
    'Value': '1',
    'SymbolicName': 'GoodTillCancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Good Till Cancel (GTC)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '59',
    'Value': '2',
    'SymbolicName': 'AtTheOpening',
    'Group': '',
    'Sort': '3',
    'Description': 'At the Opening (OPG)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '59',
    'Value': '3',
    'SymbolicName': 'ImmediateOrCancel',
    'Group': '',
    'Sort': '4',
    'Description': 'Immediate Or Cancel (IOC)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '59',
    'Value': '4',
    'SymbolicName': 'FillOrKill',
    'Group': '',
    'Sort': '5',
    'Description': 'Fill Or Kill (FOK)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '59',
    'Value': '5',
    'SymbolicName': 'GoodTillCrossing',
    'Group': '',
    'Sort': '6',
    'Description': 'Good Till Crossing (GTX)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '59',
    'Value': '6',
    'SymbolicName': 'GoodTillDate',
    'Group': '',
    'Sort': '7',
    'Description': 'Good Till Date (GTD)',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '59',
    'Value': '7',
    'SymbolicName': 'AtTheClose',
    'Group': '',
    'Sort': '8',
    'Description': 'At the Close',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '59',
    'Value': '8',
    'SymbolicName': 'GoodThroughCrossing',
    'Group': '',
    'Sort': '9',
    'Description': 'Good Through Crossing',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '59',
    'Value': '9',
    'SymbolicName': 'AtCrossing',
    'Group': '',
    'Sort': '10',
    'Description': 'At Crossing',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '61',
    'Value': '0',
    'SymbolicName': 'Normal',
    'Group': '',
    'Sort': '1',
    'Description': 'Normal',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '61',
    'Value': '1',
    'SymbolicName': 'Flash',
    'Group': '',
    'Sort': '2',
    'Description': 'Flash',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '61',
    'Value': '2',
    'SymbolicName': 'Background',
    'Group': '',
    'Sort': '3',
    'Description': 'Background',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '0',
    'SymbolicName': 'Regular',
    'Group': '',
    'Sort': '1',
    'Description': 'Regular / FX Spot settlement (T+1 or T+2 depending on currency)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '1',
    'SymbolicName': 'Cash',
    'Group': '',
    'Sort': '2',
    'Description': 'Cash (TOD / T+0)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '2',
    'SymbolicName': 'NextDay',
    'Group': '',
    'Sort': '3',
    'Description': 'Next Day (TOM / T+1)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '3',
    'SymbolicName': 'TPlus2',
    'Group': '',
    'Sort': '4',
    'Description': 'T+2',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '4',
    'SymbolicName': 'TPlus3',
    'Group': '',
    'Sort': '5',
    'Description': 'T+3',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '5',
    'SymbolicName': 'TPlus4',
    'Group': '',
    'Sort': '6',
    'Description': 'T+4',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '6',
    'SymbolicName': 'Future',
    'Group': '',
    'Sort': '7',
    'Description': 'Future',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '7',
    'SymbolicName': 'WhenAndIfIssued',
    'Group': '',
    'Sort': '8',
    'Description': 'When And If Issued',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '8',
    'SymbolicName': 'SellersOption',
    'Group': '',
    'Sort': '9',
    'Description': 'Sellers Option',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '63',
    'Value': '9',
    'SymbolicName': 'TPlus5',
    'Group': '',
    'Sort': '10',
    'Description': 'T+5',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '63',
    'Value': 'B',
    'SymbolicName': 'BrokenDate',
    'Group': '',
    'Sort': '12',
    'Description': 'Broken date - for FX expressing non-standard tenor, SettlDate (64) must be specified',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '63',
    'Value': 'C',
    'SymbolicName': 'FXSpotNextSettlement',
    'Group': '',
    'Sort': '99',
    'Description': 'FX Spot Next settlement (Spot+1, aka next day)',
    'Added': 'FIX.4.4',
    'AddedEP': '21'
  },
  {
    'Tag': '65',
    'Value': 'CD',
    'SymbolicName': 'EUCPWithLumpSumInterest',
    'Group': 'For Fixed Income',
    'Sort': '1',
    'Description': 'EUCP with lump-sum interest rather than discount price',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '65',
    'Value': 'WI',
    'SymbolicName': 'WhenIssued',
    'Group': 'For Fixed Income',
    'Sort': '2',
    'Description': '\'When Issued\' for a security to be reissued under an old CUSIP or ISIN',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '71',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '71',
    'Value': '1',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '2',
    'Description': 'Replace',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '71',
    'Value': '2',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '71',
    'Value': '3',
    'SymbolicName': 'Preliminary',
    'Group': '',
    'Sort': '4',
    'Description': 'Preliminary (without MiscFees and NetMoney) (Removed/Replaced)',
    'Added': 'FIX.4.1',
    'Deprecated': 'FIX.4.2'
  },
  {
    'Tag': '71',
    'Value': '4',
    'SymbolicName': 'Calculated',
    'Group': '',
    'Sort': '5',
    'Description': 'Calculated (includes MiscFees and NetMoney) (Removed/Replaced)',
    'Added': 'FIX.4.1',
    'Deprecated': 'FIX.4.2'
  },
  {
    'Tag': '71',
    'Value': '5',
    'SymbolicName': 'CalculatedWithoutPreliminary',
    'Group': '',
    'Sort': '6',
    'Description': 'Calculated without Preliminary (sent unsolicited by broker, includes MiscFees and NetMoney) (Removed/Replaced)',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.4.2'
  },
  {
    'Tag': '71',
    'Value': '6',
    'SymbolicName': 'Reversal',
    'Group': '',
    'Sort': '7',
    'Description': 'Reversal',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '77',
    'Value': 'C',
    'SymbolicName': 'Close',
    'Group': '',
    'Sort': '1',
    'Description': 'Close',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '77',
    'Value': 'F',
    'SymbolicName': 'FIFO',
    'Group': '',
    'Sort': '2',
    'Description': 'FIFO',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '77',
    'Value': 'O',
    'SymbolicName': 'Open',
    'Group': '',
    'Sort': '3',
    'Description': 'Open',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '77',
    'Value': 'R',
    'SymbolicName': 'Rolled',
    'Group': '',
    'Sort': '4',
    'Description': 'Rolled',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '77',
    'Value': 'N',
    'SymbolicName': 'CloseButNotifyOnOpen',
    'Group': '',
    'Sort': '5',
    'Description': 'Close but notify on open',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '77',
    'Value': 'D',
    'SymbolicName': 'Default',
    'Group': '',
    'Sort': '6',
    'Description': 'Default',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '81',
    'Value': '0',
    'SymbolicName': 'Regular',
    'Group': '',
    'Sort': '1',
    'Description': 'Regular',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '81',
    'Value': '1',
    'SymbolicName': 'SoftDollar',
    'Group': '',
    'Sort': '2',
    'Description': 'Soft Dollar',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '81',
    'Value': '2',
    'SymbolicName': 'StepIn',
    'Group': '',
    'Sort': '3',
    'Description': 'Step-In',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '81',
    'Value': '3',
    'SymbolicName': 'StepOut',
    'Group': '',
    'Sort': '4',
    'Description': 'Step-Out',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '81',
    'Value': '4',
    'SymbolicName': 'SoftDollarStepIn',
    'Group': '',
    'Sort': '5',
    'Description': 'Soft-dollar Step-In',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '81',
    'Value': '5',
    'SymbolicName': 'SoftDollarStepOut',
    'Group': '',
    'Sort': '6',
    'Description': 'Soft-dollar Step-Out',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '81',
    'Value': '6',
    'SymbolicName': 'PlanSponsor',
    'Group': '',
    'Sort': '7',
    'Description': 'Plan Sponsor',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '87',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'accepted (successfully processed)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '87',
    'Value': '1',
    'SymbolicName': 'BlockLevelReject',
    'Group': '',
    'Sort': '2',
    'Description': 'block level reject',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '87',
    'Value': '2',
    'SymbolicName': 'AccountLevelReject',
    'Group': '',
    'Sort': '3',
    'Description': 'account level reject',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '87',
    'Value': '3',
    'SymbolicName': 'Received',
    'Group': '',
    'Sort': '4',
    'Description': 'received (received, not yet processed)',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '87',
    'Value': '4',
    'SymbolicName': 'Incomplete',
    'Group': '',
    'Sort': '5',
    'Description': 'incomplete',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '87',
    'Value': '5',
    'SymbolicName': 'RejectedByIntermediary',
    'Group': '',
    'Sort': '6',
    'Description': 'rejected by intermediary',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '87',
    'Value': '6',
    'SymbolicName': 'AllocationPending',
    'Group': '',
    'Sort': '7',
    'Description': 'allocation pending',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '87',
    'Value': '7',
    'SymbolicName': 'Reversed',
    'Group': '',
    'Sort': '8',
    'Description': 'reversed',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '88',
    'Value': '0',
    'SymbolicName': 'UnknownAccount',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown account(s)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '1',
    'SymbolicName': 'IncorrectQuantity',
    'Group': '',
    'Sort': '2',
    'Description': 'Incorrect quantity',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '2',
    'SymbolicName': 'IncorrectAveragegPrice',
    'Group': '',
    'Sort': '3',
    'Description': 'Incorrect averageg price',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '3',
    'SymbolicName': 'UnknownExecutingBrokerMnemonic',
    'Group': '',
    'Sort': '4',
    'Description': 'Unknown executing broker mnemonic',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '4',
    'SymbolicName': 'CommissionDifference',
    'Group': '',
    'Sort': '5',
    'Description': 'Commission difference',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '5',
    'SymbolicName': 'UnknownOrderID',
    'Group': '',
    'Sort': '6',
    'Description': 'Unknown OrderID (37)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '6',
    'SymbolicName': 'UnknownListID',
    'Group': '',
    'Sort': '7',
    'Description': 'Unknown ListID (66)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '7',
    'SymbolicName': 'OtherSeeText',
    'Group': '',
    'Sort': '8',
    'Description': 'Other (further in Text (58))',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '88',
    'Value': '8',
    'SymbolicName': 'IncorrectAllocatedQuantity',
    'Group': '',
    'Sort': '9',
    'Description': 'Incorrect allocated quantity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '88',
    'Value': '9',
    'SymbolicName': 'CalculationDifference',
    'Group': '',
    'Sort': '10',
    'Description': 'Calculation difference',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '88',
    'Value': '10',
    'SymbolicName': 'UnknownOrStaleExecID',
    'Group': '',
    'Sort': '11',
    'Description': 'Unknown or stale ExecID',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '88',
    'Value': '11',
    'SymbolicName': 'MismatchedData',
    'Group': '',
    'Sort': '12',
    'Description': 'Mismatched data',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '88',
    'Value': '12',
    'SymbolicName': 'UnknownClOrdID',
    'Group': '',
    'Sort': '13',
    'Description': 'Unknown ClOrdID',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '88',
    'Value': '13',
    'SymbolicName': 'WarehouseRequestRejected',
    'Group': '',
    'Sort': '14',
    'Description': 'Warehouse request rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '94',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '94',
    'Value': '1',
    'SymbolicName': 'Reply',
    'Group': '',
    'Sort': '2',
    'Description': 'Reply',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '94',
    'Value': '2',
    'SymbolicName': 'AdminReply',
    'Group': '',
    'Sort': '3',
    'Description': 'Admin Reply',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '97',
    'Value': 'N',
    'SymbolicName': 'OriginalTransmission',
    'Group': '',
    'Sort': '1',
    'Description': 'Original Transmission',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '97',
    'Value': 'Y',
    'SymbolicName': 'PossibleResend',
    'Group': '',
    'Sort': '2',
    'Description': 'Possible Resend',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '98',
    'Value': '0',
    'SymbolicName': 'None',
    'Group': '',
    'Sort': '1',
    'Description': 'None / Other',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '98',
    'Value': '1',
    'SymbolicName': 'PKCS',
    'Group': '',
    'Sort': '2',
    'Description': 'PKCS (Proprietary)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '98',
    'Value': '2',
    'SymbolicName': 'DES',
    'Group': '',
    'Sort': '3',
    'Description': 'DES (ECB Mode)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '98',
    'Value': '3',
    'SymbolicName': 'PKCSDES',
    'Group': '',
    'Sort': '4',
    'Description': 'PKCS / DES (Proprietary)',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '98',
    'Value': '4',
    'SymbolicName': 'PGPDES',
    'Group': '',
    'Sort': '5',
    'Description': 'PGP / DES (Defunct)',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '98',
    'Value': '5',
    'SymbolicName': 'PGPDESMD5',
    'Group': '',
    'Sort': '6',
    'Description': 'PGP / DES-MD5 (See app note on FIX web site)',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '98',
    'Value': '6',
    'SymbolicName': 'PEM',
    'Group': '',
    'Sort': '7',
    'Description': 'PEM / DES-MD5 (see app note on FIX web site)',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '102',
    'Value': '0',
    'SymbolicName': 'TooLateToCancel',
    'Group': '',
    'Sort': '1',
    'Description': 'Too late to cancel',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '102',
    'Value': '1',
    'SymbolicName': 'UnknownOrder',
    'Group': '',
    'Sort': '2',
    'Description': 'Unknown order',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '102',
    'Value': '2',
    'SymbolicName': 'BrokerCredit',
    'Group': '',
    'Sort': '3',
    'Description': 'Broker / Exchange Option',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '102',
    'Value': '3',
    'SymbolicName': 'OrderAlreadyInPendingStatus',
    'Group': '',
    'Sort': '4',
    'Description': 'Order already in Pending Cancel or Pending Replace status',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '102',
    'Value': '4',
    'SymbolicName': 'UnableToProcessOrderMassCancelRequest',
    'Group': '',
    'Sort': '5',
    'Description': 'Unable to process Order Mass Cancel Request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '102',
    'Value': '5',
    'SymbolicName': 'OrigOrdModTime',
    'Group': '',
    'Sort': '6',
    'Description': 'OrigOrdModTime (586) did not match last TransactTime (60) of order',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '102',
    'Value': '6',
    'SymbolicName': 'DuplicateClOrdID',
    'Group': '',
    'Sort': '7',
    'Description': 'Duplicate ClOrdID (11) received',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '102',
    'Value': '7',
    'SymbolicName': 'PriceExceedsCurrentPrice',
    'Group': '',
    'Sort': '8',
    'Description': 'Price exceeds current price',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '102',
    'Value': '8',
    'SymbolicName': 'PriceExceedsCurrentPriceBand',
    'Group': '',
    'Sort': '9',
    'Description': 'Price exceeds current price band',
    'Added': 'FIX.5.0',
    'AddedEP': '43'
  },
  {
    'Tag': '102',
    'Value': '18',
    'SymbolicName': 'InvalidPriceIncrement',
    'Group': '',
    'Sort': '18',
    'Description': 'Invalid price increment',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '102',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '103',
    'Value': '0',
    'SymbolicName': 'BrokerCredit',
    'Group': '',
    'Sort': '0',
    'Description': 'Broker / Exchange option',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '103',
    'Value': '1',
    'SymbolicName': 'UnknownSymbol',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown symbol',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '103',
    'Value': '2',
    'SymbolicName': 'ExchangeClosed',
    'Group': '',
    'Sort': '2',
    'Description': 'Exchange closed',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '103',
    'Value': '3',
    'SymbolicName': 'OrderExceedsLimit',
    'Group': '',
    'Sort': '3',
    'Description': 'Order exceeds limit',
    'Added': 'FIX.2.7'
  },
  {
    'Tag': '103',
    'Value': '4',
    'SymbolicName': 'TooLateToEnter',
    'Group': '',
    'Sort': '4',
    'Description': 'Too late to enter',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '103',
    'Value': '5',
    'SymbolicName': 'UnknownOrder',
    'Group': '',
    'Sort': '5',
    'Description': 'Unknown order',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '103',
    'Value': '6',
    'SymbolicName': 'DuplicateOrder',
    'Group': '',
    'Sort': '6',
    'Description': 'Duplicate Order (e.g. dupe ClOrdID)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '103',
    'Value': '7',
    'SymbolicName': 'DuplicateOfAVerballyCommunicatedOrder',
    'Group': '',
    'Sort': '7',
    'Description': 'Duplicate of a verbally communicated order',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '103',
    'Value': '8',
    'SymbolicName': 'StaleOrder',
    'Group': '',
    'Sort': '8',
    'Description': 'Stale order',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '103',
    'Value': '9',
    'SymbolicName': 'TradeAlongRequired',
    'Group': '',
    'Sort': '9',
    'Description': 'Trade along required',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '103',
    'Value': '10',
    'SymbolicName': 'InvalidInvestorID',
    'Group': '',
    'Sort': '10',
    'Description': 'Invalid Investor ID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '103',
    'Value': '11',
    'SymbolicName': 'UnsupportedOrderCharacteristic',
    'Group': '',
    'Sort': '11',
    'Description': 'Unsupported order characteristic',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '103',
    'Value': '12',
    'SymbolicName': 'SurveillenceOption',
    'Group': '',
    'Sort': '12',
    'Description': 'Surveillence Option',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '103',
    'Value': '13',
    'SymbolicName': 'IncorrectQuantity',
    'Group': '',
    'Sort': '13',
    'Description': 'Incorrect quantity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '103',
    'Value': '14',
    'SymbolicName': 'IncorrectAllocatedQuantity',
    'Group': '',
    'Sort': '14',
    'Description': 'Incorrect allocated quantity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '103',
    'Value': '15',
    'SymbolicName': 'UnknownAccount',
    'Group': '',
    'Sort': '15',
    'Description': 'Unknown account(s)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '103',
    'Value': '16',
    'SymbolicName': 'PriceExceedsCurrentPriceBand',
    'Group': '',
    'Sort': '16',
    'Description': 'Price exceeds current price band',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '103',
    'Value': '18',
    'SymbolicName': 'InvalidPriceIncrement',
    'Group': '',
    'Sort': '18',
    'Description': 'Invalid price increment',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '103',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '104',
    'Value': 'A',
    'SymbolicName': 'AllOrNone',
    'Group': '',
    'Sort': '1',
    'Description': 'All or None (AON)',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'B',
    'SymbolicName': 'MarketOnClose',
    'Group': '',
    'Sort': '2',
    'Description': 'Market On Close (MOC) (held to close)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '104',
    'Value': 'C',
    'SymbolicName': 'AtTheClose',
    'Group': '',
    'Sort': '3',
    'Description': 'At the close (around/not held to close)',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'D',
    'SymbolicName': 'VWAP',
    'Group': '',
    'Sort': '4',
    'Description': 'VWAP (Volume Weighted Average Price)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '104',
    'Value': 'I',
    'SymbolicName': 'InTouchWith',
    'Group': '',
    'Sort': '5',
    'Description': 'In touch with',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'L',
    'SymbolicName': 'Limit',
    'Group': '',
    'Sort': '6',
    'Description': 'Limit',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'M',
    'SymbolicName': 'MoreBehind',
    'Group': '',
    'Sort': '7',
    'Description': 'More Behind',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'O',
    'SymbolicName': 'AtTheOpen',
    'Group': '',
    'Sort': '8',
    'Description': 'At the Open',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'P',
    'SymbolicName': 'TakingAPosition',
    'Group': '',
    'Sort': '9',
    'Description': 'Taking a Position',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'Q',
    'SymbolicName': 'AtTheMarket',
    'Group': '',
    'Sort': '10',
    'Description': 'At the Market (previously called Current Quote)',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'R',
    'SymbolicName': 'ReadyToTrade',
    'Group': '',
    'Sort': '11',
    'Description': 'Ready to Trade',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '104',
    'Value': 'S',
    'SymbolicName': 'PortfolioShown',
    'Group': '',
    'Sort': '12',
    'Description': 'Portfolio Shown',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'T',
    'SymbolicName': 'ThroughTheDay',
    'Group': '',
    'Sort': '13',
    'Description': 'Through the Day',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'V',
    'SymbolicName': 'Versus',
    'Group': '',
    'Sort': '14',
    'Description': 'Versus',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'W',
    'SymbolicName': 'Indication',
    'Group': '',
    'Sort': '15',
    'Description': 'Indication - Working Away',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'X',
    'SymbolicName': 'CrossingOpportunity',
    'Group': '',
    'Sort': '16',
    'Description': 'Crossing Opportunity',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '104',
    'Value': 'Y',
    'SymbolicName': 'AtTheMidpoint',
    'Group': '',
    'Sort': '17',
    'Description': 'At the Midpoint',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '104',
    'Value': 'Z',
    'SymbolicName': 'PreOpen',
    'Group': '',
    'Sort': '18',
    'Description': 'Pre-open',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '113',
    'Value': 'N',
    'SymbolicName': 'SenderReports',
    'Group': '',
    'Sort': '1',
    'Description': 'Indicates the party sending message will report trade',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '113',
    'Value': 'Y',
    'SymbolicName': 'ReceiverReports',
    'Group': '',
    'Sort': '2',
    'Description': 'Indicates the party receiving message must report trade',
    'Added': 'FIX.3.0'
  },
  {
    'Tag': '114',
    'Value': 'N',
    'SymbolicName': 'No',
    'Group': '',
    'Sort': '1',
    'Description': 'Indicates the broker is not required to locate',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '114',
    'Value': 'Y',
    'SymbolicName': 'Yes',
    'Group': '',
    'Sort': '2',
    'Description': 'Indicates the broker is responsible for locating the stock',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '121',
    'Value': 'N',
    'SymbolicName': 'DoNotExecuteForexAfterSecurityTrade',
    'Group': '',
    'Sort': '1',
    'Description': 'Do Not Execute Forex After Security Trade',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '121',
    'Value': 'Y',
    'SymbolicName': 'ExecuteForexAfterSecurityTrade',
    'Group': '',
    'Sort': '2',
    'Description': 'Execute Forex After Security Trade',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '123',
    'Value': 'N',
    'SymbolicName': 'SequenceReset',
    'Group': '',
    'Sort': '1',
    'Description': 'Sequence Reset, Ignore Msg Seq Num (N/A For FIXML - Not Used)',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '123',
    'Value': 'Y',
    'SymbolicName': 'GapFillMessage',
    'Group': '',
    'Sort': '2',
    'Description': 'Gap Fill Message, Msg Seq Num Field Valid',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '127',
    'Value': 'A',
    'SymbolicName': 'UnknownSymbol',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown Symbol',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '127',
    'Value': 'B',
    'SymbolicName': 'WrongSide',
    'Group': '',
    'Sort': '2',
    'Description': 'Wrong Side',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '127',
    'Value': 'C',
    'SymbolicName': 'QuantityExceedsOrder',
    'Group': '',
    'Sort': '3',
    'Description': 'Quantity Exceeds Order',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '127',
    'Value': 'D',
    'SymbolicName': 'NoMatchingOrder',
    'Group': '',
    'Sort': '4',
    'Description': 'No Matching Order',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '127',
    'Value': 'E',
    'SymbolicName': 'PriceExceedsLimit',
    'Group': '',
    'Sort': '5',
    'Description': 'Price Exceeds Limit',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '127',
    'Value': 'F',
    'SymbolicName': 'CalculationDifference',
    'Group': '',
    'Sort': '6',
    'Description': 'Calculation Difference',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '127',
    'Value': 'Z',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '7',
    'Description': 'Other',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '130',
    'Value': 'N',
    'SymbolicName': 'NotNatural',
    'Group': '',
    'Sort': '1',
    'Description': 'Not Natural',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '130',
    'Value': 'Y',
    'SymbolicName': 'Natural',
    'Group': '',
    'Sort': '2',
    'Description': 'Natural',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '1',
    'SymbolicName': 'Regulatory',
    'Group': '',
    'Sort': '0',
    'Description': 'Regulatory (e.g. SEC)',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '2',
    'SymbolicName': 'Tax',
    'Group': '',
    'Sort': '1',
    'Description': 'Tax',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '3',
    'SymbolicName': 'LocalCommission',
    'Group': '',
    'Sort': '2',
    'Description': 'Local Commission',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '4',
    'SymbolicName': 'ExchangeFees',
    'Group': '',
    'Sort': '3',
    'Description': 'Exchange Fees',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '5',
    'SymbolicName': 'Stamp',
    'Group': '',
    'Sort': '4',
    'Description': 'Stamp',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '6',
    'SymbolicName': 'Levy',
    'Group': '',
    'Sort': '5',
    'Description': 'Levy',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '7',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '6',
    'Description': 'Other',
    'Added': 'FIX.4.0'
  },
  {
    'Tag': '139',
    'Value': '8',
    'SymbolicName': 'Markup',
    'Group': '',
    'Sort': '7',
    'Description': 'Markup',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '139',
    'Value': '9',
    'SymbolicName': 'ConsumptionTax',
    'Group': '',
    'Sort': '8',
    'Description': 'Consumption Tax',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '139',
    'Value': '10',
    'SymbolicName': 'PerTransaction',
    'Group': '',
    'Sort': '9',
    'Description': 'Per transaction',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '139',
    'Value': '11',
    'SymbolicName': 'Conversion',
    'Group': '',
    'Sort': '10',
    'Description': 'Conversion',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '139',
    'Value': '12',
    'SymbolicName': 'Agent',
    'Group': '',
    'Sort': '11',
    'Description': 'Agent',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '139',
    'Value': '13',
    'SymbolicName': 'TransferFee',
    'Group': '',
    'Sort': '15',
    'Description': 'Transfer Fee',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '139',
    'Value': '14',
    'SymbolicName': 'SecurityLending',
    'Group': '',
    'Sort': '16',
    'Description': 'Security Lending',
    'Added': 'FIX.4.4',
    'AddedEP': '25'
  },
  {
    'Tag': '141',
    'Value': 'N',
    'SymbolicName': 'No',
    'Group': '',
    'Sort': '1',
    'Description': 'No',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '141',
    'Value': 'Y',
    'SymbolicName': 'Yes',
    'Group': '',
    'Sort': '2',
    'Description': 'Yes, reset sequence numbers',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '3',
    'SymbolicName': 'DoneForDay',
    'Group': '',
    'Sort': '2',
    'Description': 'Done for day',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '4',
    'SymbolicName': 'Canceled',
    'Group': '',
    'Sort': '3',
    'Description': 'Canceled',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '5',
    'SymbolicName': 'Replaced',
    'Group': '',
    'Sort': '4',
    'Description': 'Replaced',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '6',
    'SymbolicName': 'PendingCancel',
    'Group': '',
    'Sort': '5',
    'Description': 'Pending Cancel (e.g. result of Order Cancel Request)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '7',
    'SymbolicName': 'Stopped',
    'Group': '',
    'Sort': '6',
    'Description': 'Stopped',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '8',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '7',
    'Description': 'Rejected',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': '9',
    'SymbolicName': 'Suspended',
    'Group': '',
    'Sort': '8',
    'Description': 'Suspended',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': 'A',
    'SymbolicName': 'PendingNew',
    'Group': '',
    'Sort': '9',
    'Description': 'Pending New',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': 'B',
    'SymbolicName': 'Calculated',
    'Group': '',
    'Sort': '10',
    'Description': 'Calculated',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': 'C',
    'SymbolicName': 'Expired',
    'Group': '',
    'Sort': '11',
    'Description': 'Expired',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '150',
    'Value': 'D',
    'SymbolicName': 'Restated',
    'Group': '',
    'Sort': '12',
    'Description': 'Restated (Execution Report sent unsolicited by sellside, with ExecRestatementReason (378) set)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '150',
    'Value': 'E',
    'SymbolicName': 'PendingReplace',
    'Group': '',
    'Sort': '13',
    'Description': 'Pending Replace (e.g. result of Order Cancel/Replace Request)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '150',
    'Value': 'F',
    'SymbolicName': 'Trade',
    'Group': '',
    'Sort': '14',
    'Description': 'Trade (partial fill or fill)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '150',
    'Value': 'G',
    'SymbolicName': 'TradeCorrect',
    'Group': '',
    'Sort': '15',
    'Description': 'Trade Correct',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '150',
    'Value': 'H',
    'SymbolicName': 'TradeCancel',
    'Group': '',
    'Sort': '16',
    'Description': 'Trade Cancel',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '150',
    'Value': 'I',
    'SymbolicName': 'OrderStatus',
    'Group': '',
    'Sort': '17',
    'Description': 'Order Status',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '150',
    'Value': 'J',
    'SymbolicName': 'TradeInAClearingHold',
    'Group': '',
    'Sort': '18',
    'Description': 'Trade in a Clearing Hold',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '150',
    'Value': 'K',
    'SymbolicName': 'TradeHasBeenReleasedToClearing',
    'Group': '',
    'Sort': '19',
    'Description': 'Trade has been released to Clearing',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '150',
    'Value': 'L',
    'SymbolicName': 'TriggeredOrActivatedBySystem',
    'Group': '',
    'Sort': '20',
    'Description': 'Triggered or Activated by System',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '156',
    'Value': 'M',
    'SymbolicName': 'Multiply',
    'Group': '',
    'Sort': '1',
    'Description': 'Multiply',
    'Added': 'FIX.4.4',
    'AddedEP': '38'
  },
  {
    'Tag': '156',
    'Value': 'D',
    'SymbolicName': 'Divide',
    'Group': '',
    'Sort': '2',
    'Description': 'Divide',
    'Added': 'FIX.4.4',
    'AddedEP': '38'
  },
  {
    'Tag': '160',
    'Value': '0',
    'SymbolicName': 'Default',
    'Group': '',
    'Sort': '1',
    'Description': 'Default (Replaced)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '160',
    'Value': '1',
    'SymbolicName': 'StandingInstructionsProvided',
    'Group': '',
    'Sort': '2',
    'Description': 'Standing Instructions Provided',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '160',
    'Value': '2',
    'SymbolicName': 'SpecificAllocationAccountOverriding',
    'Group': '',
    'Sort': '3',
    'Description': 'Specific Allocation Account Overriding (Replaced)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '160',
    'Value': '3',
    'SymbolicName': 'SpecificAllocationAccountStanding',
    'Group': '',
    'Sort': '4',
    'Description': 'Specific Allocation Account Standing (Replaced)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '160',
    'Value': '4',
    'SymbolicName': 'SpecificOrderForASingleAccount',
    'Group': '',
    'Sort': '5',
    'Description': 'Specific Order for a single account (for CIV)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '160',
    'Value': '5',
    'SymbolicName': 'RequestReject',
    'Group': '',
    'Sort': '6',
    'Description': 'Request reject',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '163',
    'Value': 'N',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '163',
    'Value': 'C',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '163',
    'Value': 'R',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '3',
    'Description': 'Replace',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '163',
    'Value': 'T',
    'SymbolicName': 'Restate',
    'Group': '',
    'Sort': '4',
    'Description': 'Restate',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '165',
    'Value': '1',
    'SymbolicName': 'BrokerCredit',
    'Group': '',
    'Sort': '1',
    'Description': 'Broker\'s Instructions',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '165',
    'Value': '2',
    'SymbolicName': 'Institution',
    'Group': '',
    'Sort': '2',
    'Description': 'Institution\'s Instructions',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '165',
    'Value': '3',
    'SymbolicName': 'Investor',
    'Group': '',
    'Sort': '3',
    'Description': 'Investor (e.g. CIV use)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '166',
    'Value': 'CED',
    'SymbolicName': 'CEDEL',
    'Group': '',
    'Sort': '1',
    'Description': 'CEDEL',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '166',
    'Value': 'DTC',
    'SymbolicName': 'DepositoryTrustCompany',
    'Group': '',
    'Sort': '2',
    'Description': 'Depository Trust Company',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '166',
    'Value': 'EUR',
    'SymbolicName': 'EuroClear',
    'Group': '',
    'Sort': '3',
    'Description': 'Euro clear',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '166',
    'Value': 'FED',
    'SymbolicName': 'FederalBookEntry',
    'Group': '',
    'Sort': '4',
    'Description': 'Federal Book Entry',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '166',
    'Value': 'ISO_Country_Code',
    'SymbolicName': 'LocalMarketSettleLocation',
    'Group': '',
    'Sort': '5',
    'Description': 'Local Market Settle Location',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '166',
    'Value': 'PNY',
    'SymbolicName': 'Physical',
    'Group': '',
    'Sort': '6',
    'Description': 'Physical',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '166',
    'Value': 'PTC',
    'SymbolicName': 'ParticipantTrustCompany',
    'Group': '',
    'Sort': '7',
    'Description': 'Participant Trust Company',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'UST',
    'SymbolicName': 'USTreasuryNoteOld',
    'Group': '',
    'Sort': '3',
    'Description': 'US Treasury Note (Deprecated Value Use TNOTE)',
    'Added': 'FIX.4.3',
    'Deprecated': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'USTB',
    'SymbolicName': 'USTreasuryBillOld',
    'Group': '',
    'Sort': '4',
    'Description': 'US Treasury Bill (Deprecated Value Use TBILL)',
    'Added': 'FIX.4.1',
    'Deprecated': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'EUSUPRA',
    'SymbolicName': 'EuroSupranationalCoupons',
    'Group': 'Agency',
    'Sort': '0',
    'Description': 'Euro Supranational Coupons *',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'FAC',
    'SymbolicName': 'FederalAgencyCoupon',
    'Group': 'Agency',
    'Sort': '1',
    'Description': 'Federal Agency Coupon',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'FADN',
    'SymbolicName': 'FederalAgencyDiscountNote',
    'Group': 'Agency',
    'Sort': '2',
    'Description': 'Federal Agency Discount Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'PEF',
    'SymbolicName': 'PrivateExportFunding',
    'Group': 'Agency',
    'Sort': '3',
    'Description': 'Private Export Funding *',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'SUPRA',
    'SymbolicName': 'USDSupranationalCoupons',
    'Group': 'Agency',
    'Sort': '4',
    'Description': 'USD Supranational Coupons *',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'CORP',
    'SymbolicName': 'CorporateBond',
    'Group': 'Corporate',
    'Sort': '0',
    'Description': 'Corporate Bond',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'CPP',
    'SymbolicName': 'CorporatePrivatePlacement',
    'Group': 'Corporate',
    'Sort': '1',
    'Description': 'Corporate Private Placement',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'CB',
    'SymbolicName': 'ConvertibleBond',
    'Group': 'Corporate',
    'Sort': '2',
    'Description': 'Convertible Bond',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '167',
    'Value': 'DUAL',
    'SymbolicName': 'DualCurrency',
    'Group': 'Corporate',
    'Sort': '3',
    'Description': 'Dual Currency',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'EUCORP',
    'SymbolicName': 'EuroCorporateBond',
    'Group': 'Corporate',
    'Sort': '4',
    'Description': 'Euro Corporate Bond',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'EUFRN',
    'SymbolicName': 'EuroCorporateFloatingRateNotes',
    'Group': 'Corporate',
    'Sort': '5',
    'Description': 'Euro Corporate Floating Rate Notes',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'FRN',
    'SymbolicName': 'USCorporateFloatingRateNotes',
    'Group': 'Corporate',
    'Sort': '6',
    'Description': 'US Corporate Floating Rate Notes',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'XLINKD',
    'SymbolicName': 'IndexedLinked',
    'Group': 'Corporate',
    'Sort': '7',
    'Description': 'Indexed Linked',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'STRUCT',
    'SymbolicName': 'StructuredNotes',
    'Group': 'Corporate',
    'Sort': '8',
    'Description': 'Structured Notes',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'YANK',
    'SymbolicName': 'YankeeCorporateBond',
    'Group': 'Corporate',
    'Sort': '9',
    'Description': 'Yankee Corporate Bond',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'FOR',
    'SymbolicName': 'ForeignExchangeContract',
    'Group': 'Currency',
    'Sort': '0',
    'Description': 'Foreign Exchange Contract',
    'Deprecated': 'FIX.5.0SP1',
    'DeprecatedEP': '82',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'CDS',
    'SymbolicName': 'CreditDefaultSwap',
    'Group': 'Derivatives',
    'Sort': '0',
    'Description': 'Credit Default Swap',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'FUT',
    'SymbolicName': 'Future',
    'Group': 'Derivatives',
    'Sort': '1',
    'Description': 'Future',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'OPT',
    'SymbolicName': 'Option',
    'Group': 'Derivatives',
    'Sort': '2',
    'Description': 'Option',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'OOF',
    'SymbolicName': 'OptionsOnFutures',
    'Group': 'Derivatives',
    'Sort': '3',
    'Description': 'Options on Futures',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '167',
    'Value': 'OOP',
    'SymbolicName': 'OptionsOnPhysical',
    'Group': 'Derivatives',
    'Sort': '4',
    'Description': 'Options on Physical - use not recommended',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '167',
    'Value': 'IRS',
    'SymbolicName': 'InterestRateSwap',
    'Group': 'Derivatives',
    'Sort': '5',
    'Description': 'Interest Rate Swap',
    'Added': 'FIX.5.0',
    'AddedEP': '54'
  },
  {
    'Tag': '167',
    'Value': 'OOC',
    'SymbolicName': 'OptionsOnCombo',
    'Group': 'Derivatives',
    'Sort': '6',
    'Description': 'Options on Combo',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '167',
    'Value': 'CS',
    'SymbolicName': 'CommonStock',
    'Group': 'Equity',
    'Sort': '0',
    'Description': 'Common Stock',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'PS',
    'SymbolicName': 'PreferredStock',
    'Group': 'Equity',
    'Sort': '1',
    'Description': 'Preferred Stock',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'REPO',
    'SymbolicName': 'Repurchase',
    'Group': 'Financing',
    'Sort': '0',
    'Description': 'Repurchase',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'FORWARD',
    'SymbolicName': 'Forward',
    'Group': 'Financing',
    'Sort': '1',
    'Description': 'Forward',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'BUYSELL',
    'SymbolicName': 'BuySellback',
    'Group': 'Financing',
    'Sort': '2',
    'Description': 'Buy Sellback',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'SECLOAN',
    'SymbolicName': 'SecuritiesLoan',
    'Group': 'Financing',
    'Sort': '3',
    'Description': 'Securities Loan',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'SECPLEDGE',
    'SymbolicName': 'SecuritiesPledge',
    'Group': 'Financing',
    'Sort': '4',
    'Description': 'Securities Pledge',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'BRADY',
    'SymbolicName': 'BradyBond',
    'Group': 'Government',
    'Sort': '0',
    'Description': 'Brady Bond',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'CAN',
    'SymbolicName': 'CanadianTreasuryNotes',
    'Group': 'Government',
    'Sort': '1',
    'Description': 'Canadian Treasury Notes',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'CTB',
    'SymbolicName': 'CanadianTreasuryBills',
    'Group': 'Government',
    'Sort': '2',
    'Description': 'Canadian Treasury Bills',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'EUSOV',
    'SymbolicName': 'EuroSovereigns',
    'Group': 'Government',
    'Sort': '3',
    'Description': 'Euro Sovereigns *',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'PROV',
    'SymbolicName': 'CanadianProvincialBonds',
    'Group': 'Government',
    'Sort': '4',
    'Description': 'Canadian Provincial Bonds',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'TB',
    'SymbolicName': 'TreasuryBill',
    'Group': 'Government',
    'Sort': '5',
    'Description': 'Treasury Bill - non US',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'TBOND',
    'SymbolicName': 'USTreasuryBond',
    'Group': 'Government',
    'Sort': '6',
    'Description': 'US Treasury Bond',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TINT',
    'SymbolicName': 'InterestStripFromAnyBondOrNote',
    'Group': 'Government',
    'Sort': '7',
    'Description': 'Interest Strip From Any Bond Or Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TBILL',
    'SymbolicName': 'USTreasuryBill',
    'Group': 'Government',
    'Sort': '8',
    'Description': 'US Treasury Bill',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'TIPS',
    'SymbolicName': 'TreasuryInflationProtectedSecurities',
    'Group': 'Government',
    'Sort': '8',
    'Description': 'Treasury Inflation Protected Securities',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TCAL',
    'SymbolicName': 'PrincipalStripOfACallableBondOrNote',
    'Group': 'Government',
    'Sort': '9',
    'Description': 'Principal Strip Of A Callable Bond Or Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TPRN',
    'SymbolicName': 'PrincipalStripFromANonCallableBondOrNote',
    'Group': 'Government',
    'Sort': '10',
    'Description': 'Principal Strip From A Non-Callable Bond Or Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TNOTE',
    'SymbolicName': 'USTreasuryNote',
    'Group': 'Government',
    'Sort': '11',
    'Description': 'US Treasury Note',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'TERM',
    'SymbolicName': 'TermLoan',
    'Group': 'Loan',
    'Sort': '0',
    'Description': 'Term Loan',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'RVLV',
    'SymbolicName': 'RevolverLoan',
    'Group': 'Loan',
    'Sort': '1',
    'Description': 'Revolver Loan',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'RVLVTRM',
    'SymbolicName': 'Revolver',
    'Group': 'Loan',
    'Sort': '2',
    'Description': 'Revolver/Term Loan',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'BRIDGE',
    'SymbolicName': 'BridgeLoan',
    'Group': 'Loan',
    'Sort': '3',
    'Description': 'Bridge Loan',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'LOFC',
    'SymbolicName': 'LetterOfCredit',
    'Group': 'Loan',
    'Sort': '4',
    'Description': 'Letter Of Credit',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'SWING',
    'SymbolicName': 'SwingLineFacility',
    'Group': 'Loan',
    'Sort': '5',
    'Description': 'Swing Line Facility',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'DINP',
    'SymbolicName': 'DebtorInPossession',
    'Group': 'Loan',
    'Sort': '6',
    'Description': 'Debtor In Possession',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'DEFLTED',
    'SymbolicName': 'Defaulted',
    'Group': 'Loan',
    'Sort': '7',
    'Description': 'Defaulted',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'WITHDRN',
    'SymbolicName': 'Withdrawn',
    'Group': 'Loan',
    'Sort': '8',
    'Description': 'Withdrawn',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'REPLACD',
    'SymbolicName': 'Replaced',
    'Group': 'Loan',
    'Sort': '9',
    'Description': 'Replaced',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'MATURED',
    'SymbolicName': 'Matured',
    'Group': 'Loan',
    'Sort': '10',
    'Description': 'Matured',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'AMENDED',
    'SymbolicName': 'Amended',
    'Group': 'Loan',
    'Sort': '11',
    'Description': 'Amended & Restated',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'RETIRED',
    'SymbolicName': 'Retired',
    'Group': 'Loan',
    'Sort': '12',
    'Description': 'Retired',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'BA',
    'SymbolicName': 'BankersAcceptance',
    'Group': 'Money Market',
    'Sort': '0',
    'Description': 'Bankers Acceptance',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'BDN',
    'SymbolicName': 'BankDepositoryNote',
    'Group': 'Money Market',
    'Sort': '1',
    'Description': 'Bank Depository Note',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'BN',
    'SymbolicName': 'BankNotes',
    'Group': 'Money Market',
    'Sort': '2',
    'Description': 'Bank Notes',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'BOX',
    'SymbolicName': 'BillOfExchanges',
    'Group': 'Money Market',
    'Sort': '3',
    'Description': 'Bill Of Exchanges',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'CAMM',
    'SymbolicName': 'CanadianMoneyMarkets',
    'Group': 'Money Market',
    'Sort': '4',
    'Description': 'Canadian Money Markets',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'CD',
    'SymbolicName': 'CertificateOfDeposit',
    'Group': 'Money Market',
    'Sort': '5',
    'Description': 'Certificate Of Deposit',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'CL',
    'SymbolicName': 'CallLoans',
    'Group': 'Money Market',
    'Sort': '6',
    'Description': 'Call Loans',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'CP',
    'SymbolicName': 'CommercialPaper',
    'Group': 'Money Market',
    'Sort': '7',
    'Description': 'Commercial Paper',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'DN',
    'SymbolicName': 'DepositNotes',
    'Group': 'Money Market',
    'Sort': '8',
    'Description': 'Deposit Notes',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'EUCD',
    'SymbolicName': 'EuroCertificateOfDeposit',
    'Group': 'Money Market',
    'Sort': '9',
    'Description': 'Euro Certificate Of Deposit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'EUCP',
    'SymbolicName': 'EuroCommercialPaper',
    'Group': 'Money Market',
    'Sort': '10',
    'Description': 'Euro Commercial Paper',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'LQN',
    'SymbolicName': 'LiquidityNote',
    'Group': 'Money Market',
    'Sort': '11',
    'Description': 'Liquidity Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'MTN',
    'SymbolicName': 'MediumTermNotes',
    'Group': 'Money Market',
    'Sort': '12',
    'Description': 'Medium Term Notes',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'ONITE',
    'SymbolicName': 'Overnight',
    'Group': 'Money Market',
    'Sort': '13',
    'Description': 'Overnight',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'PN',
    'SymbolicName': 'PromissoryNote',
    'Group': 'Money Market',
    'Sort': '14',
    'Description': 'Promissory Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'STN',
    'SymbolicName': 'ShortTermLoanNote',
    'Group': 'Money Market',
    'Sort': '14',
    'Description': 'Short Term Loan Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'PZFJ',
    'SymbolicName': 'PlazosFijos',
    'Group': 'Money Market',
    'Sort': '15',
    'Description': 'Plazos Fijos',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'SLQN',
    'SymbolicName': 'SecuredLiquidityNote',
    'Group': 'Money Market',
    'Sort': '16',
    'Description': 'Secured Liquidity Note',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'TD',
    'SymbolicName': 'TimeDeposit',
    'Group': 'Money Market',
    'Sort': '17',
    'Description': 'Time Deposit',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'TLQN',
    'SymbolicName': 'TermLiquidityNote',
    'Group': 'Money Market',
    'Sort': '19',
    'Description': 'Term Liquidity Note',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'XCN',
    'SymbolicName': 'ExtendedCommNote',
    'Group': 'Money Market',
    'Sort': '20',
    'Description': 'Extended Comm Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'YCD',
    'SymbolicName': 'YankeeCertificateOfDeposit',
    'Group': 'Money Market',
    'Sort': '21',
    'Description': 'Yankee Certificate Of Deposit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'ABS',
    'SymbolicName': 'AssetBackedSecurities',
    'Group': 'Mortgage',
    'Sort': '0',
    'Description': 'Asset-backed Securities',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'CMB',
    'SymbolicName': 'CanadianMortgageBonds',
    'Group': 'Mortgage',
    'Sort': '1',
    'Description': 'Canadian Mortgage Bonds',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'CMBS',
    'SymbolicName': 'Corp',
    'Group': 'Mortgage',
    'Sort': '2',
    'Description': 'Corp. Mortgage-backed Securities',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'CMO',
    'SymbolicName': 'CollateralizedMortgageObligation',
    'Group': 'Mortgage',
    'Sort': '3',
    'Description': 'Collateralized Mortgage Obligation',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'IET',
    'SymbolicName': 'IOETTEMortgage',
    'Group': 'Mortgage',
    'Sort': '4',
    'Description': 'IOETTE Mortgage',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '167',
    'Value': 'MBS',
    'SymbolicName': 'MortgageBackedSecurities',
    'Group': 'Mortgage',
    'Sort': '5',
    'Description': 'Mortgage-backed Securities',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'MIO',
    'SymbolicName': 'MortgageInterestOnly',
    'Group': 'Mortgage',
    'Sort': '6',
    'Description': 'Mortgage Interest Only',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'MPO',
    'SymbolicName': 'MortgagePrincipalOnly',
    'Group': 'Mortgage',
    'Sort': '7',
    'Description': 'Mortgage Principal Only',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'MPP',
    'SymbolicName': 'MortgagePrivatePlacement',
    'Group': 'Mortgage',
    'Sort': '8',
    'Description': 'Mortgage Private Placement',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'MPT',
    'SymbolicName': 'MiscellaneousPassThrough',
    'Group': 'Mortgage',
    'Sort': '9',
    'Description': 'Miscellaneous Pass-through',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'PFAND',
    'SymbolicName': 'Pfandbriefe',
    'Group': 'Mortgage',
    'Sort': '10',
    'Description': 'Pfandbriefe *',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '167',
    'Value': 'TBA',
    'SymbolicName': 'ToBeAnnounced',
    'Group': 'Mortgage',
    'Sort': '11',
    'Description': 'To Be Announced',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'AN',
    'SymbolicName': 'OtherAnticipationNotes',
    'Group': 'Municipal',
    'Sort': '0',
    'Description': 'Other Anticipation Notes (BAN, GAN, etc.)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'COFO',
    'SymbolicName': 'CertificateOfObligation',
    'Group': 'Municipal',
    'Sort': '1',
    'Description': 'Certificate Of Obligation',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'COFP',
    'SymbolicName': 'CertificateOfParticipation',
    'Group': 'Municipal',
    'Sort': '2',
    'Description': 'Certificate Of Participation',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'GO',
    'SymbolicName': 'GeneralObligationBonds',
    'Group': 'Municipal',
    'Sort': '3',
    'Description': 'General Obligation Bonds',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'MT',
    'SymbolicName': 'MandatoryTender',
    'Group': 'Municipal',
    'Sort': '4',
    'Description': 'Mandatory Tender',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'RAN',
    'SymbolicName': 'RevenueAnticipationNote',
    'Group': 'Municipal',
    'Sort': '5',
    'Description': 'Revenue Anticipation Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'REV',
    'SymbolicName': 'RevenueBonds',
    'Group': 'Municipal',
    'Sort': '6',
    'Description': 'Revenue Bonds',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'SPCLA',
    'SymbolicName': 'SpecialAssessment',
    'Group': 'Municipal',
    'Sort': '7',
    'Description': 'Special Assessment',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'SPCLO',
    'SymbolicName': 'SpecialObligation',
    'Group': 'Municipal',
    'Sort': '8',
    'Description': 'Special Obligation',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'SPCLT',
    'SymbolicName': 'SpecialTax',
    'Group': 'Municipal',
    'Sort': '9',
    'Description': 'Special Tax',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TAN',
    'SymbolicName': 'TaxAnticipationNote',
    'Group': 'Municipal',
    'Sort': '10',
    'Description': 'Tax Anticipation Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TAXA',
    'SymbolicName': 'TaxAllocation',
    'Group': 'Municipal',
    'Sort': '11',
    'Description': 'Tax Allocation',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TECP',
    'SymbolicName': 'TaxExemptCommercialPaper',
    'Group': 'Municipal',
    'Sort': '12',
    'Description': 'Tax Exempt Commercial Paper',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'TMCP',
    'SymbolicName': 'TaxableMunicipalCP',
    'Group': 'Municipal',
    'Sort': '13',
    'Description': 'Taxable Municipal CP',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '167',
    'Value': 'TRAN',
    'SymbolicName': 'TaxRevenueAnticipationNote',
    'Group': 'Municipal',
    'Sort': '14',
    'Description': 'Tax Revenue Anticipation Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'VRDN',
    'SymbolicName': 'VariableRateDemandNote',
    'Group': 'Municipal',
    'Sort': '15',
    'Description': 'Variable Rate Demand Note',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'WAR',
    'SymbolicName': 'Warrant',
    'Group': 'Municipal',
    'Sort': '16',
    'Description': 'Warrant',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'MF',
    'SymbolicName': 'MutualFund',
    'Group': 'Other',
    'Sort': '0',
    'Description': 'Mutual Fund',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': 'MLEG',
    'SymbolicName': 'MultilegInstrument',
    'Group': 'Other',
    'Sort': '1',
    'Description': 'Multileg Instrument',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '167',
    'Value': 'NONE',
    'SymbolicName': 'NoSecurityType',
    'Group': 'Other',
    'Sort': '2',
    'Description': 'No Security Type',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '167',
    'Value': '?',
    'SymbolicName': 'Wildcard',
    'Group': 'Other',
    'Sort': '5',
    'Description': 'Wildcard entry for use on Security Definition Request',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '167',
    'Value': 'CASH',
    'SymbolicName': 'Cash',
    'Group': 'Other',
    'Sort': '6',
    'Description': 'Cash',
    'Added': 'FIX.4.4',
    'AddedEP': '28'
  },
  {
    'Tag': '169',
    'Value': '0',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '1',
    'Description': 'Other',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '169',
    'Value': '1',
    'SymbolicName': 'DTCSID',
    'Group': '',
    'Sort': '2',
    'Description': 'DTC SID',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '169',
    'Value': '2',
    'SymbolicName': 'ThomsonALERT',
    'Group': '',
    'Sort': '3',
    'Description': 'Thomson ALERT',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '169',
    'Value': '3',
    'SymbolicName': 'AGlobalCustodian',
    'Group': '',
    'Sort': '4',
    'Description': 'A Global Custodian (StandInstDBName (70) must be provided)',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '169',
    'Value': '4',
    'SymbolicName': 'AccountNet',
    'Group': '',
    'Sort': '5',
    'Description': 'AccountNet',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '172',
    'Value': '0',
    'SymbolicName': 'Versus',
    'Group': '',
    'Sort': '1',
    'Description': '\'Versus. Payment\': Deliver (if Sell) or Receive (if Buy) vs. (Against) Payment',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '172',
    'Value': '1',
    'SymbolicName': 'Free',
    'Group': '',
    'Sort': '2',
    'Description': '\'Free\': Deliver (if Sell) or Receive (if Buy) Free',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '172',
    'Value': '2',
    'SymbolicName': 'TriParty',
    'Group': '',
    'Sort': '3',
    'Description': 'Tri-Party',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '172',
    'Value': '3',
    'SymbolicName': 'HoldInCustody',
    'Group': '',
    'Sort': '4',
    'Description': 'Hold In Custody',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '197',
    'Value': '0',
    'SymbolicName': 'FXNetting',
    'Group': '',
    'Sort': '1',
    'Description': 'FX Netting',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '197',
    'Value': '1',
    'SymbolicName': 'FXSwap',
    'Group': '',
    'Sort': '2',
    'Description': 'FX Swap',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '201',
    'Value': '0',
    'SymbolicName': 'Put',
    'Group': '',
    'Sort': '1',
    'Description': 'Put',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '201',
    'Value': '1',
    'SymbolicName': 'Call',
    'Group': '',
    'Sort': '2',
    'Description': 'Call',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '203',
    'Value': '0',
    'SymbolicName': 'Covered',
    'Group': '',
    'Sort': '1',
    'Description': 'Covered',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '203',
    'Value': '1',
    'SymbolicName': 'Uncovered',
    'Group': '',
    'Sort': '2',
    'Description': 'Uncovered',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '204',
    'Value': '0',
    'SymbolicName': 'Customer',
    'Group': '',
    'Sort': '1',
    'Description': 'Customer',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '204',
    'Value': '1',
    'SymbolicName': 'Firm',
    'Group': '',
    'Sort': '2',
    'Description': 'Firm',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '208',
    'Value': 'N',
    'SymbolicName': 'DetailsShouldNotBeCommunicated',
    'Group': '',
    'Sort': '1',
    'Description': 'Details should not be communicated',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '208',
    'Value': 'Y',
    'SymbolicName': 'DetailsShouldBeCommunicated',
    'Group': '',
    'Sort': '2',
    'Description': 'Details should be communicated',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '209',
    'Value': '1',
    'SymbolicName': 'Match',
    'Group': '',
    'Sort': '1',
    'Description': 'Match',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '209',
    'Value': '2',
    'SymbolicName': 'Forward',
    'Group': '',
    'Sort': '2',
    'Description': 'Forward',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '209',
    'Value': '3',
    'SymbolicName': 'ForwardAndMatch',
    'Group': '',
    'Sort': '3',
    'Description': 'Forward and Match',
    'Added': 'FIX.4.1'
  },
  {
    'Tag': '216',
    'Value': '1',
    'SymbolicName': 'TargetFirm',
    'Group': '',
    'Sort': '1',
    'Description': 'Target Firm',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '216',
    'Value': '2',
    'SymbolicName': 'TargetList',
    'Group': '',
    'Sort': '2',
    'Description': 'Target List',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '216',
    'Value': '3',
    'SymbolicName': 'BlockFirm',
    'Group': '',
    'Sort': '3',
    'Description': 'Block Firm',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '216',
    'Value': '4',
    'SymbolicName': 'BlockList',
    'Group': '',
    'Sort': '4',
    'Description': 'Block List',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '1',
    'SymbolicName': 'CURVE',
    'Group': '',
    'Sort': '1',
    'Description': 'CURVE',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '2',
    'SymbolicName': 'FiveYR',
    'Group': '',
    'Sort': '2',
    'Description': '5YR',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '3',
    'SymbolicName': 'OLD5',
    'Group': '',
    'Sort': '3',
    'Description': 'OLD5',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '4',
    'SymbolicName': 'TenYR',
    'Group': '',
    'Sort': '4',
    'Description': '10YR',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '5',
    'SymbolicName': 'OLD10',
    'Group': '',
    'Sort': '5',
    'Description': 'OLD10',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '6',
    'SymbolicName': 'ThirtyYR',
    'Group': '',
    'Sort': '6',
    'Description': '30YR',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '7',
    'SymbolicName': 'OLD30',
    'Group': '',
    'Sort': '7',
    'Description': 'OLD30',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '8',
    'SymbolicName': 'ThreeMOLIBOR',
    'Group': '',
    'Sort': '8',
    'Description': '3MOLIBOR',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '219',
    'Value': '9',
    'SymbolicName': 'SixMOLIBOR',
    'Group': '',
    'Sort': '9',
    'Description': '6MOLIBOR',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '221',
    'Value': 'EONIA',
    'SymbolicName': 'EONIA',
    'Group': '',
    'Sort': '1',
    'Description': 'EONIA',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '221',
    'Value': 'EUREPO',
    'SymbolicName': 'EUREPO',
    'Group': '',
    'Sort': '2',
    'Description': 'EUREPO',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '221',
    'Value': 'Euribor',
    'SymbolicName': 'Euribor',
    'Group': '',
    'Sort': '3',
    'Description': 'Euribor',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'FutureSWAP',
    'SymbolicName': 'FutureSWAP',
    'Group': '',
    'Sort': '4',
    'Description': 'FutureSWAP',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'LIBID',
    'SymbolicName': 'LIBID',
    'Group': '',
    'Sort': '5',
    'Description': 'LIBID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'LIBOR',
    'SymbolicName': 'LIBOR',
    'Group': '',
    'Sort': '6',
    'Description': 'LIBOR (London Inter-Bank Offer)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'MuniAAA',
    'SymbolicName': 'MuniAAA',
    'Group': '',
    'Sort': '7',
    'Description': 'MuniAAA',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'OTHER',
    'SymbolicName': 'OTHER',
    'Group': '',
    'Sort': '8',
    'Description': 'OTHER',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'Pfandbriefe',
    'SymbolicName': 'Pfandbriefe',
    'Group': '',
    'Sort': '9',
    'Description': 'Pfandbriefe',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'SONIA',
    'SymbolicName': 'SONIA',
    'Group': '',
    'Sort': '10',
    'Description': 'SONIA',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '221',
    'Value': 'SWAP',
    'SymbolicName': 'SWAP',
    'Group': '',
    'Sort': '11',
    'Description': 'SWAP',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '221',
    'Value': 'Treasury',
    'SymbolicName': 'Treasury',
    'Group': '',
    'Sort': '12',
    'Description': 'Treasury',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'AMT',
    'SymbolicName': 'AlternativeMinimumTax',
    'Group': '',
    'Sort': '1',
    'Description': 'Alternative Minimum Tax (Y/N)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'AUTOREINV',
    'SymbolicName': 'AutoReinvestment',
    'Group': '',
    'Sort': '2',
    'Description': 'Auto Reinvestment at <rate> or better',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'BANKQUAL',
    'SymbolicName': 'BankQualified',
    'Group': '',
    'Sort': '3',
    'Description': 'Bank qualified (Y/N)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'BGNCON',
    'SymbolicName': 'BargainConditions',
    'Group': '',
    'Sort': '4',
    'Description': 'Bargain conditions (see StipulationValue (234) for values)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'COUPON',
    'SymbolicName': 'CouponRange',
    'Group': '',
    'Sort': '5',
    'Description': 'Coupon range',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'CURRENCY',
    'SymbolicName': 'ISOCurrencyCode',
    'Group': '',
    'Sort': '6',
    'Description': 'ISO Currency Code',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'CUSTOMDATE',
    'SymbolicName': 'CustomStart',
    'Group': '',
    'Sort': '7',
    'Description': 'Custom start/end date',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'GEOG',
    'SymbolicName': 'Geographics',
    'Group': '',
    'Sort': '8',
    'Description': 'Geographics and % range (ex. 234=CA 0-80 [minimum of 80% California assets])',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'HAIRCUT',
    'SymbolicName': 'ValuationDiscount',
    'Group': '',
    'Sort': '9',
    'Description': 'Valuation Discount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'INSURED',
    'SymbolicName': 'Insured',
    'Group': '',
    'Sort': '10',
    'Description': 'Insured (Y/N)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'ISSUE',
    'SymbolicName': 'IssueDate',
    'Group': '',
    'Sort': '11',
    'Description': 'Year Or Year/Month of Issue (ex. 234=2002/09)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'ISSUER',
    'SymbolicName': 'Issuer',
    'Group': '',
    'Sort': '12',
    'Description': 'Issuer\'s ticker',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'ISSUESIZE',
    'SymbolicName': 'IssueSizeRange',
    'Group': '',
    'Sort': '13',
    'Description': 'issue size range',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'LOOKBACK',
    'SymbolicName': 'LookbackDays',
    'Group': '',
    'Sort': '14',
    'Description': 'Lookback Days',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'LOT',
    'SymbolicName': 'ExplicitLotIdentifier',
    'Group': '',
    'Sort': '15',
    'Description': 'Explicit lot identifier',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'LOTVAR',
    'SymbolicName': 'LotVariance',
    'Group': '',
    'Sort': '16',
    'Description': 'Lot Variance (value in percent maximum over- or under-allocation allowed)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'MAT',
    'SymbolicName': 'MaturityYearAndMonth',
    'Group': '',
    'Sort': '17',
    'Description': 'Maturity Year And Month',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'MATURITY',
    'SymbolicName': 'MaturityRange',
    'Group': '',
    'Sort': '18',
    'Description': 'Maturity range',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'MAXSUBS',
    'SymbolicName': 'MaximumSubstitutions',
    'Group': '',
    'Sort': '19',
    'Description': 'Maximum substitutions (Repo)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'MINDNOM',
    'SymbolicName': 'MinimumDenomination',
    'Group': '',
    'Sort': '20',
    'Description': 'Minimum denomination',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'MININCR',
    'SymbolicName': 'MinimumIncrement',
    'Group': '',
    'Sort': '21',
    'Description': 'Minimum increment',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'MINQTY',
    'SymbolicName': 'MinimumQuantity',
    'Group': '',
    'Sort': '22',
    'Description': 'Minimum quantity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'PAYFREQ',
    'SymbolicName': 'PaymentFrequency',
    'Group': '',
    'Sort': '23',
    'Description': 'Payment frequency, calendar',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'PIECES',
    'SymbolicName': 'NumberOfPieces',
    'Group': '',
    'Sort': '24',
    'Description': 'Number Of Pieces',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PMAX',
    'SymbolicName': 'PoolsMaximum',
    'Group': '',
    'Sort': '25',
    'Description': 'Pools Maximum',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PPL',
    'SymbolicName': 'PoolsPerLot',
    'Group': '',
    'Sort': '26',
    'Description': 'Pools per Lot',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PPM',
    'SymbolicName': 'PoolsPerMillion',
    'Group': '',
    'Sort': '27',
    'Description': 'Pools per Million',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PPT',
    'SymbolicName': 'PoolsPerTrade',
    'Group': '',
    'Sort': '28',
    'Description': 'Pools per Trade',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PRICE',
    'SymbolicName': 'PriceRange',
    'Group': '',
    'Sort': '29',
    'Description': 'Price Range',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'PRICEFREQ',
    'SymbolicName': 'PricingFrequency',
    'Group': '',
    'Sort': '30',
    'Description': 'Pricing frequency',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'PROD',
    'SymbolicName': 'ProductionYear',
    'Group': '',
    'Sort': '31',
    'Description': 'Production Year',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PROTECT',
    'SymbolicName': 'CallProtection',
    'Group': '',
    'Sort': '32',
    'Description': 'Call protection',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'PURPOSE',
    'SymbolicName': 'Purpose',
    'Group': '',
    'Sort': '33',
    'Description': 'Purpose',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'PXSOURCE',
    'SymbolicName': 'BenchmarkPriceSource',
    'Group': '',
    'Sort': '34',
    'Description': 'Benchmark price source',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'RATING',
    'SymbolicName': 'RatingSourceAndRange',
    'Group': '',
    'Sort': '35',
    'Description': 'Rating source and range',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'REDEMPTION',
    'SymbolicName': 'TypeOfRedemption',
    'Group': '',
    'Sort': '36',
    'Description': 'Type Of Redemption - values are: NonCallable, Prefunded, EscrowedToMaturity, Putable, Convertible',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'RESTRICTED',
    'SymbolicName': 'Restricted',
    'Group': '',
    'Sort': '37',
    'Description': 'Restricted (Y/N)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'SECTOR',
    'SymbolicName': 'MarketSector',
    'Group': '',
    'Sort': '38',
    'Description': 'Market Sector',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'SECTYPE',
    'SymbolicName': 'SecurityTypeIncludedOrExcluded',
    'Group': '',
    'Sort': '39',
    'Description': 'Security Type included or excluded',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'STRUCT',
    'SymbolicName': 'Structure',
    'Group': '',
    'Sort': '40',
    'Description': 'Structure',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'SUBSFREQ',
    'SymbolicName': 'SubstitutionsFrequency',
    'Group': '',
    'Sort': '41',
    'Description': 'Substitutions frequency (Repo)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'SUBSLEFT',
    'SymbolicName': 'SubstitutionsLeft',
    'Group': '',
    'Sort': '42',
    'Description': 'Substitutions left (Repo)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'TEXT',
    'SymbolicName': 'FreeformText',
    'Group': '',
    'Sort': '43',
    'Description': 'Freeform Text',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'TRDVAR',
    'SymbolicName': 'TradeVariance',
    'Group': '',
    'Sort': '44',
    'Description': 'Trade Variance (value in percent maximum over- or under-allocation allowed)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'WAC',
    'SymbolicName': 'WeightedAverageCoupon',
    'Group': '',
    'Sort': '45',
    'Description': 'Weighted Average Coupon - value in percent (exact or range) plus \'Gross\' or \'Net\' of servicing spread (the default) (ex. 234=6.5-Net [minimum of 6.5% net of servicing fee])',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'WAL',
    'SymbolicName': 'WeightedAverageLifeCoupon',
    'Group': '',
    'Sort': '46',
    'Description': 'Weighted Average Life Coupon - value in percent (exact or range)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'WALA',
    'SymbolicName': 'WeightedAverageLoanAge',
    'Group': '',
    'Sort': '47',
    'Description': 'Weighted Average Loan Age - value in months (exact or range)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'WAM',
    'SymbolicName': 'WeightedAverageMaturity',
    'Group': '',
    'Sort': '48',
    'Description': 'Weighted Average Maturity - value in months (exact or range)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'WHOLE',
    'SymbolicName': 'WholePool',
    'Group': '',
    'Sort': '49',
    'Description': 'Whole Pool (Y/N)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'YIELD',
    'SymbolicName': 'YieldRange',
    'Group': '',
    'Sort': '50',
    'Description': 'Yield Range',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '233',
    'Value': 'AVFICO',
    'SymbolicName': 'AverageFICOScore',
    'Group': 'Other',
    'Sort': '51',
    'Description': 'Average FICO Score',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'AVSIZE',
    'SymbolicName': 'AverageLoanSize',
    'Group': 'Other',
    'Sort': '52',
    'Description': 'Average Loan Size',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'MAXBAL',
    'SymbolicName': 'MaximumLoanBalance',
    'Group': 'Other',
    'Sort': '53',
    'Description': 'Maximum Loan Balance',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'POOL',
    'SymbolicName': 'PoolIdentifier',
    'Group': 'Other',
    'Sort': '54',
    'Description': 'Pool Identifier',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'ROLLTYPE',
    'SymbolicName': 'TypeOfRollTrade',
    'Group': 'Other',
    'Sort': '55',
    'Description': 'Type of Roll trade',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'REFTRADE',
    'SymbolicName': 'ReferenceToRollingOrClosingTrade',
    'Group': 'Other',
    'Sort': '56',
    'Description': 'reference to rolling or closing trade',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'REFPRIN',
    'SymbolicName': 'PrincipalOfRollingOrClosingTrade',
    'Group': 'Other',
    'Sort': '57',
    'Description': 'principal of rolling or closing trade',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'REFINT',
    'SymbolicName': 'InterestOfRollingOrClosingTrade',
    'Group': 'Other',
    'Sort': '58',
    'Description': 'interest of rolling or closing trade',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'AVAILQTY',
    'SymbolicName': 'AvailableOfferQuantityToBeShownToTheStreet',
    'Group': 'Other',
    'Sort': '59',
    'Description': 'Available offer quantity to be shown to the street',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'BROKERCREDIT',
    'SymbolicName': 'BrokerCredit',
    'Group': 'Other',
    'Sort': '60',
    'Description': 'Broker\'s sales credit',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'INTERNALPX',
    'SymbolicName': 'OfferPriceToBeShownToInternalBrokers',
    'Group': 'Other',
    'Sort': '61',
    'Description': 'Offer price to be shown to internal brokers',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'INTERNALQTY',
    'SymbolicName': 'OfferQuantityToBeShownToInternalBrokers',
    'Group': 'Other',
    'Sort': '62',
    'Description': 'Offer quantity to be shown to internal brokers',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'LEAVEQTY',
    'SymbolicName': 'TheMinimumResidualOfferQuantity',
    'Group': 'Other',
    'Sort': '63',
    'Description': 'The minimum residual offer quantity',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'MAXORDQTY',
    'SymbolicName': 'MaximumOrderSize',
    'Group': 'Other',
    'Sort': '64',
    'Description': 'Maximum order size',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'ORDRINCR',
    'SymbolicName': 'OrderQuantityIncrement',
    'Group': 'Other',
    'Sort': '65',
    'Description': 'Order quantity increment',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'PRIMARY',
    'SymbolicName': 'PrimaryOrSecondaryMarketIndicator',
    'Group': 'Other',
    'Sort': '66',
    'Description': 'Primary or Secondary market indicator',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'SALESCREDITOVR',
    'SymbolicName': 'BrokerSalesCreditOverride',
    'Group': 'Other',
    'Sort': '67',
    'Description': 'Broker sales credit override',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'TRADERCREDIT',
    'SymbolicName': 'TraderCredit',
    'Group': 'Other',
    'Sort': '68',
    'Description': 'Trader\'s credit',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'DISCOUNT',
    'SymbolicName': 'DiscountRate',
    'Group': 'Other',
    'Sort': '69',
    'Description': 'Discount Rate (when price is denominated in percent of par)',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'YTM',
    'SymbolicName': 'YieldToMaturity',
    'Group': 'Other',
    'Sort': '71',
    'Description': 'Yield to Maturity (when YieldType(235) and Yield(236) show a different yield)',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '233',
    'Value': 'ABS',
    'SymbolicName': 'AbsolutePrepaymentSpeed',
    'Group': 'Prepayment Speeds',
    'Sort': '1',
    'Description': 'Absolute Prepayment Speed',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'CPP',
    'SymbolicName': 'ConstantPrepaymentPenalty',
    'Group': 'Prepayment Speeds',
    'Sort': '2',
    'Description': 'Constant Prepayment Penalty',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'CPR',
    'SymbolicName': 'ConstantPrepaymentRate',
    'Group': 'Prepayment Speeds',
    'Sort': '3',
    'Description': 'Constant Prepayment Rate',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'CPY',
    'SymbolicName': 'ConstantPrepaymentYield',
    'Group': 'Prepayment Speeds',
    'Sort': '4',
    'Description': 'Constant Prepayment Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'HEP',
    'SymbolicName': 'FinalCPROfHomeEquityPrepaymentCurve',
    'Group': 'Prepayment Speeds',
    'Sort': '5',
    'Description': 'final CPR of Home Equity Prepayment Curve',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'MHP',
    'SymbolicName': 'PercentOfManufacturedHousingPrepaymentCurve',
    'Group': 'Prepayment Speeds',
    'Sort': '6',
    'Description': 'Percent of Manufactured Housing Prepayment Curve',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'MPR',
    'SymbolicName': 'MonthlyPrepaymentRate',
    'Group': 'Prepayment Speeds',
    'Sort': '7',
    'Description': 'Monthly Prepayment Rate',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PPC',
    'SymbolicName': 'PercentOfProspectusPrepaymentCurve',
    'Group': 'Prepayment Speeds',
    'Sort': '8',
    'Description': 'Percent of Prospectus Prepayment Curve',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'PSA',
    'SymbolicName': 'PercentOfBMAPrepaymentCurve',
    'Group': 'Prepayment Speeds',
    'Sort': '9',
    'Description': 'Percent of BMA Prepayment Curve',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '233',
    'Value': 'SMM',
    'SymbolicName': 'SingleMonthlyMortality',
    'Group': 'Prepayment Speeds',
    'Sort': '10',
    'Description': 'Single Monthly Mortality',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'AFTERTAX',
    'SymbolicName': 'AfterTaxYield',
    'Group': '',
    'Sort': '1',
    'Description': 'After Tax Yield (Municipals)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'ANNUAL',
    'SymbolicName': 'AnnualYield',
    'Group': '',
    'Sort': '2',
    'Description': 'Annual Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'ATISSUE',
    'SymbolicName': 'YieldAtIssue',
    'Group': '',
    'Sort': '3',
    'Description': 'Yield At Issue (Municipals)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'AVGMATURITY',
    'SymbolicName': 'YieldToAverageMaturity',
    'Group': '',
    'Sort': '4',
    'Description': 'Yield To Avg Maturity',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'BOOK',
    'SymbolicName': 'BookYield',
    'Group': '',
    'Sort': '5',
    'Description': 'Book Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'CALL',
    'SymbolicName': 'YieldToNextCall',
    'Group': '',
    'Sort': '6',
    'Description': 'Yield to Next Call',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'CHANGE',
    'SymbolicName': 'YieldChangeSinceClose',
    'Group': '',
    'Sort': '7',
    'Description': 'Yield Change Since Close',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'CLOSE',
    'SymbolicName': 'ClosingYield',
    'Group': '',
    'Sort': '8',
    'Description': 'Closing Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'COMPOUND',
    'SymbolicName': 'CompoundYield',
    'Group': '',
    'Sort': '9',
    'Description': 'Compound Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'CURRENT',
    'SymbolicName': 'CurrentYield',
    'Group': '',
    'Sort': '10',
    'Description': 'Current Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'GOVTEQUIV',
    'SymbolicName': 'GvntEquivalentYield',
    'Group': '',
    'Sort': '11',
    'Description': 'Gvnt Equivalent Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'GROSS',
    'SymbolicName': 'TrueGrossYield',
    'Group': '',
    'Sort': '12',
    'Description': 'True Gross Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'INFLATION',
    'SymbolicName': 'YieldWithInflationAssumption',
    'Group': '',
    'Sort': '13',
    'Description': 'Yield with Inflation Assumption',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'INVERSEFLOATER',
    'SymbolicName': 'InverseFloaterBondYield',
    'Group': '',
    'Sort': '14',
    'Description': 'Inverse Floater Bond Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'LASTCLOSE',
    'SymbolicName': 'MostRecentClosingYield',
    'Group': '',
    'Sort': '15',
    'Description': 'Most Recent Closing Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'LASTMONTH',
    'SymbolicName': 'ClosingYieldMostRecentMonth',
    'Group': '',
    'Sort': '16',
    'Description': 'Closing Yield Most Recent Month',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'LASTQUARTER',
    'SymbolicName': 'ClosingYieldMostRecentQuarter',
    'Group': '',
    'Sort': '17',
    'Description': 'Closing Yield Most Recent Quarter',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'LASTYEAR',
    'SymbolicName': 'ClosingYieldMostRecentYear',
    'Group': '',
    'Sort': '18',
    'Description': 'Closing Yield Most Recent Year',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'LONGAVGLIFE',
    'SymbolicName': 'YieldToLongestAverageLife',
    'Group': '',
    'Sort': '19',
    'Description': 'Yield to Longest Average Life',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'MARK',
    'SymbolicName': 'MarkToMarketYield',
    'Group': '',
    'Sort': '20',
    'Description': 'Mark to Market Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'MATURITY',
    'SymbolicName': 'YieldToMaturity',
    'Group': '',
    'Sort': '21',
    'Description': 'Yield to Maturity',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'NEXTREFUND',
    'SymbolicName': 'YieldToNextRefund',
    'Group': '',
    'Sort': '22',
    'Description': 'Yield to Next Refund (Sinking Fund Bonds)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'OPENAVG',
    'SymbolicName': 'OpenAverageYield',
    'Group': '',
    'Sort': '23',
    'Description': 'Open Average Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'PREVCLOSE',
    'SymbolicName': 'PreviousCloseYield',
    'Group': '',
    'Sort': '24',
    'Description': 'Previous Close Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'PROCEEDS',
    'SymbolicName': 'ProceedsYield',
    'Group': '',
    'Sort': '25',
    'Description': 'Proceeds Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'PUT',
    'SymbolicName': 'YieldToNextPut',
    'Group': '',
    'Sort': '26',
    'Description': 'Yield to Next Put',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'SEMIANNUAL',
    'SymbolicName': 'SemiAnnualYield',
    'Group': '',
    'Sort': '27',
    'Description': 'Semi-annual Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'SHORTAVGLIFE',
    'SymbolicName': 'YieldToShortestAverageLife',
    'Group': '',
    'Sort': '28',
    'Description': 'Yield to Shortest Average Life',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'SIMPLE',
    'SymbolicName': 'SimpleYield',
    'Group': '',
    'Sort': '29',
    'Description': 'Simple Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'TAXEQUIV',
    'SymbolicName': 'TaxEquivalentYield',
    'Group': '',
    'Sort': '30',
    'Description': 'Tax Equivalent Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'TENDER',
    'SymbolicName': 'YieldToTenderDate',
    'Group': '',
    'Sort': '31',
    'Description': 'Yield to Tender Date',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'TRUE',
    'SymbolicName': 'TrueYield',
    'Group': '',
    'Sort': '32',
    'Description': 'True Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '235',
    'Value': 'VALUE1_32',
    'SymbolicName': 'YieldValueOf32nds',
    'Group': '',
    'Sort': '33',
    'Description': 'Yield Value Of 1/32',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '235',
    'Value': 'WORST',
    'SymbolicName': 'YieldToWorst',
    'Group': '',
    'Sort': '34',
    'Description': 'Yield To Worst',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '258',
    'Value': 'N',
    'SymbolicName': 'NotTradedFlat',
    'Group': '',
    'Sort': '1',
    'Description': 'Not Traded Flat',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '258',
    'Value': 'Y',
    'SymbolicName': 'TradedFlat',
    'Group': '',
    'Sort': '2',
    'Description': 'Traded Flat',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '263',
    'Value': '0',
    'SymbolicName': 'Snapshot',
    'Group': '',
    'Sort': '1',
    'Description': 'Snapshot',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '263',
    'Value': '1',
    'SymbolicName': 'SnapshotAndUpdates',
    'Group': '',
    'Sort': '2',
    'Description': 'Snapshot + Updates (Subscribe)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '263',
    'Value': '2',
    'SymbolicName': 'DisablePreviousSnapshot',
    'Group': '',
    'Sort': '3',
    'Description': 'Disable previous Snapshot + Update Request (Unsubscribe)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '265',
    'Value': '0',
    'SymbolicName': 'FullRefresh',
    'Group': '',
    'Sort': '1',
    'Description': 'Full refresh',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '265',
    'Value': '1',
    'SymbolicName': 'IncrementalRefresh',
    'Group': '',
    'Sort': '2',
    'Description': 'Incremental refresh',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '266',
    'Value': 'Y',
    'SymbolicName': 'BookEntriesToBeAggregated',
    'Group': '',
    'Sort': '1',
    'Description': 'book entries to be aggregated',
    'Added': 'FIX.4.4',
    'AddedEP': '34'
  },
  {
    'Tag': '266',
    'Value': 'N',
    'SymbolicName': 'BookEntriesShouldNotBeAggregated',
    'Group': '',
    'Sort': '2',
    'Description': 'book entries should not be aggregated',
    'Added': 'FIX.4.4',
    'AddedEP': '34'
  },
  {
    'Tag': '269',
    'Value': '0',
    'SymbolicName': 'Bid',
    'Group': '',
    'Sort': '1',
    'Description': 'Bid',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '1',
    'SymbolicName': 'Offer',
    'Group': '',
    'Sort': '2',
    'Description': 'Offer',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '2',
    'SymbolicName': 'Trade',
    'Group': '',
    'Sort': '3',
    'Description': 'Trade',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '3',
    'SymbolicName': 'IndexValue',
    'Group': '',
    'Sort': '4',
    'Description': 'Index Value',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '4',
    'SymbolicName': 'OpeningPrice',
    'Group': '',
    'Sort': '5',
    'Description': 'Opening Price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '5',
    'SymbolicName': 'ClosingPrice',
    'Group': '',
    'Sort': '6',
    'Description': 'Closing Price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '6',
    'SymbolicName': 'SettlementPrice',
    'Group': '',
    'Sort': '7',
    'Description': 'Settlement Price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '7',
    'SymbolicName': 'TradingSessionHighPrice',
    'Group': '',
    'Sort': '8',
    'Description': 'Trading Session High Price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '8',
    'SymbolicName': 'TradingSessionLowPrice',
    'Group': '',
    'Sort': '9',
    'Description': 'Trading Session Low Price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': '9',
    'SymbolicName': 'TradingSessionVWAPPrice',
    'Group': '',
    'Sort': '10',
    'Description': 'Trading Session VWAP Price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '269',
    'Value': 'A',
    'SymbolicName': 'Imbalance',
    'Group': '',
    'Sort': '11',
    'Description': 'Imbalance',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '269',
    'Value': 'B',
    'SymbolicName': 'TradeVolume',
    'Group': '',
    'Sort': '12',
    'Description': 'Trade Volume',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '269',
    'Value': 'C',
    'SymbolicName': 'OpenInterest',
    'Group': '',
    'Sort': '13',
    'Description': 'Open Interest',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '269',
    'Value': 'D',
    'SymbolicName': 'CompositeUnderlyingPrice',
    'Group': '',
    'Sort': '14',
    'Description': 'Composite Underlying Price',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '269',
    'Value': 'E',
    'SymbolicName': 'SimulatedSellPrice',
    'Group': '',
    'Sort': '15',
    'Description': 'Simulated Sell Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'F',
    'SymbolicName': 'SimulatedBuyPrice',
    'Group': '',
    'Sort': '16',
    'Description': 'Simulated Buy Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'G',
    'SymbolicName': 'MarginRate',
    'Group': '',
    'Sort': '17',
    'Description': 'Margin Rate',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'H',
    'SymbolicName': 'MidPrice',
    'Group': '',
    'Sort': '18',
    'Description': 'Mid Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'J',
    'SymbolicName': 'EmptyBook',
    'Group': '',
    'Sort': '19',
    'Description': 'Empty Book',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'K',
    'SymbolicName': 'SettleHighPrice',
    'Group': '',
    'Sort': '20',
    'Description': 'Settle High Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'L',
    'SymbolicName': 'SettleLowPrice',
    'Group': '',
    'Sort': '21',
    'Description': 'Settle Low Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'M',
    'SymbolicName': 'PriorSettlePrice',
    'Group': '',
    'Sort': '22',
    'Description': 'Prior Settle Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'N',
    'SymbolicName': 'SessionHighBid',
    'Group': '',
    'Sort': '23',
    'Description': 'Session High Bid',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'O',
    'SymbolicName': 'SessionLowOffer',
    'Group': '',
    'Sort': '24',
    'Description': 'Session Low Offer',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '269',
    'Value': 'P',
    'SymbolicName': 'EarlyPrices',
    'Group': '',
    'Sort': '25',
    'Description': 'Early Prices',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '269',
    'Value': 'Q',
    'SymbolicName': 'AuctionClearingPrice',
    'Group': '',
    'Sort': '26',
    'Description': 'Auction Clearing Price',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '269',
    'Value': 'S',
    'SymbolicName': 'SwapValueFactor',
    'Group': '',
    'Sort': '27',
    'Description': 'Swap Value Factor (SVP) for swaps cleared through a central counterparty (CCP)',
    'Added': 'FIX.5.0',
    'AddedEP': '54'
  },
  {
    'Tag': '269',
    'Value': 'R',
    'SymbolicName': 'DailyValueAdjustmentForLongPositions',
    'Group': '',
    'Sort': '28',
    'Description': 'Daily value adjustment for long positions',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '269',
    'Value': 'T',
    'SymbolicName': 'CumulativeValueAdjustmentForLongPositions',
    'Group': '',
    'Sort': '29',
    'Description': 'Cumulative Value Adjustment for long positions',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '269',
    'Value': 'U',
    'SymbolicName': 'DailyValueAdjustmentForShortPositions',
    'Group': '',
    'Sort': '30',
    'Description': 'Daily Value Adjustment for Short Positions',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '269',
    'Value': 'V',
    'SymbolicName': 'CumulativeValueAdjustmentForShortPositions',
    'Group': '',
    'Sort': '31',
    'Description': 'Cumulative Value Adjustment for Short Positions',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '274',
    'Value': '0',
    'SymbolicName': 'PlusTick',
    'Group': '',
    'Sort': '1',
    'Description': 'Plus Tick',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '274',
    'Value': '1',
    'SymbolicName': 'ZeroPlusTick',
    'Group': '',
    'Sort': '2',
    'Description': 'Zero-Plus Tick',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '274',
    'Value': '2',
    'SymbolicName': 'MinusTick',
    'Group': '',
    'Sort': '3',
    'Description': 'Minus Tick',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '274',
    'Value': '3',
    'SymbolicName': 'ZeroMinusTick',
    'Group': '',
    'Sort': '4',
    'Description': 'Zero-Minus Tick',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'A',
    'SymbolicName': 'Open',
    'Group': '',
    'Sort': '1',
    'Description': 'Open/Active',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'B',
    'SymbolicName': 'Closed',
    'Group': '',
    'Sort': '2',
    'Description': 'Closed/Inactive',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'C',
    'SymbolicName': 'ExchangeBest',
    'Group': '',
    'Sort': '3',
    'Description': 'Exchange Best',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'D',
    'SymbolicName': 'ConsolidatedBest',
    'Group': '',
    'Sort': '4',
    'Description': 'Consolidated Best',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'E',
    'SymbolicName': 'Locked',
    'Group': '',
    'Sort': '5',
    'Description': 'Locked',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'F',
    'SymbolicName': 'Crossed',
    'Group': '',
    'Sort': '6',
    'Description': 'Crossed',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'G',
    'SymbolicName': 'Depth',
    'Group': '',
    'Sort': '7',
    'Description': 'Depth',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'H',
    'SymbolicName': 'FastTrading',
    'Group': '',
    'Sort': '8',
    'Description': 'Fast Trading',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'I',
    'SymbolicName': 'NonFirm',
    'Group': '',
    'Sort': '9',
    'Description': 'Non-Firm',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '276',
    'Value': 'L',
    'SymbolicName': 'Manual',
    'Group': '',
    'Sort': '10',
    'Description': 'Manual/Slow Quote',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '276',
    'Value': 'J',
    'SymbolicName': 'OutrightPrice',
    'Group': '',
    'Sort': '11',
    'Description': 'Outright Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'K',
    'SymbolicName': 'ImpliedPrice',
    'Group': '',
    'Sort': '12',
    'Description': 'Implied Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'M',
    'SymbolicName': 'DepthOnOffer',
    'Group': '',
    'Sort': '13',
    'Description': 'Depth on Offer',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'N',
    'SymbolicName': 'DepthOnBid',
    'Group': '',
    'Sort': '14',
    'Description': 'Depth on Bid',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'O',
    'SymbolicName': 'Closing',
    'Group': '',
    'Sort': '15',
    'Description': 'Closing',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'P',
    'SymbolicName': 'NewsDissemination',
    'Group': '',
    'Sort': '16',
    'Description': 'News Dissemination',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'Q',
    'SymbolicName': 'TradingRange',
    'Group': '',
    'Sort': '17',
    'Description': 'Trading Range',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'R',
    'SymbolicName': 'OrderInflux',
    'Group': '',
    'Sort': '18',
    'Description': 'Order Influx',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'S',
    'SymbolicName': 'DueToRelated',
    'Group': '',
    'Sort': '19',
    'Description': 'Due to Related',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'T',
    'SymbolicName': 'NewsPending',
    'Group': '',
    'Sort': '20',
    'Description': 'News Pending',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'U',
    'SymbolicName': 'AdditionalInfo',
    'Group': '',
    'Sort': '21',
    'Description': 'Additional Info',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'V',
    'SymbolicName': 'AdditionalInfoDueToRelated',
    'Group': '',
    'Sort': '22',
    'Description': 'Additional Info due to related',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'W',
    'SymbolicName': 'Resume',
    'Group': '',
    'Sort': '23',
    'Description': 'Resume',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'X',
    'SymbolicName': 'ViewOfCommon',
    'Group': '',
    'Sort': '24',
    'Description': 'View of Common',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'Y',
    'SymbolicName': 'VolumeAlert',
    'Group': '',
    'Sort': '25',
    'Description': 'Volume Alert',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'Z',
    'SymbolicName': 'OrderImbalance',
    'Group': '',
    'Sort': '26',
    'Description': 'Order Imbalance',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'a',
    'SymbolicName': 'EquipmentChangeover',
    'Group': '',
    'Sort': '27',
    'Description': 'Equipment Changeover',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'b',
    'SymbolicName': 'NoOpen',
    'Group': '',
    'Sort': '28',
    'Description': 'No Open / No Resume',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'c',
    'SymbolicName': 'RegularETH',
    'Group': '',
    'Sort': '29',
    'Description': 'Regular ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'd',
    'SymbolicName': 'AutomaticExecution',
    'Group': '',
    'Sort': '30',
    'Description': 'Automatic Execution',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'e',
    'SymbolicName': 'AutomaticExecutionETH',
    'Group': '',
    'Sort': '31',
    'Description': 'Automatic Execution ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'f ',
    'SymbolicName': 'FastMarketETH',
    'Group': '',
    'Sort': '32',
    'Description': 'Fast Market ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '276',
    'Value': 'g',
    'SymbolicName': 'InactiveETH',
    'Group': '',
    'Sort': '33',
    'Description': 'Inactive ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'h',
    'SymbolicName': 'Rotation',
    'Group': '',
    'Sort': '34',
    'Description': 'Rotation',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'i',
    'SymbolicName': 'RotationETH',
    'Group': '',
    'Sort': '35',
    'Description': 'Rotation ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'j',
    'SymbolicName': 'Halt',
    'Group': '',
    'Sort': '36',
    'Description': 'Halt',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'k',
    'SymbolicName': 'HaltETH',
    'Group': '',
    'Sort': '37',
    'Description': 'Halt ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'l',
    'SymbolicName': 'DueToNewsDissemination',
    'Group': '',
    'Sort': '38',
    'Description': 'Due to News Dissemination',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'm',
    'SymbolicName': 'DueToNewsPending',
    'Group': '',
    'Sort': '39',
    'Description': 'Due to News Pending',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'n',
    'SymbolicName': 'TradingResume',
    'Group': '',
    'Sort': '40',
    'Description': 'Trading Resume',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'o',
    'SymbolicName': 'OutOfSequence',
    'Group': '',
    'Sort': '41',
    'Description': 'Out of Sequence',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'p',
    'SymbolicName': 'BidSpecialist',
    'Group': '',
    'Sort': '42',
    'Description': 'Bid Specialist',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'q',
    'SymbolicName': 'OfferSpecialist',
    'Group': '',
    'Sort': '43',
    'Description': 'Offer Specialist',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'r',
    'SymbolicName': 'BidOfferSpecialist',
    'Group': '',
    'Sort': '44',
    'Description': 'Bid Offer Specialist',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 's',
    'SymbolicName': 'EndOfDaySAM',
    'Group': '',
    'Sort': '45',
    'Description': 'End of Day SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 't',
    'SymbolicName': 'ForbiddenSAM',
    'Group': '',
    'Sort': '46',
    'Description': 'Forbidden SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'u',
    'SymbolicName': 'FrozenSAM',
    'Group': '',
    'Sort': '47',
    'Description': 'Frozen SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'v',
    'SymbolicName': 'PreOpeningSAM',
    'Group': '',
    'Sort': '48',
    'Description': 'PreOpening SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'w',
    'SymbolicName': 'OpeningSAM',
    'Group': '',
    'Sort': '49',
    'Description': 'Opening SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'x',
    'SymbolicName': 'OpenSAM',
    'Group': '',
    'Sort': '50',
    'Description': 'Open SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'y',
    'SymbolicName': 'SurveillanceSAM',
    'Group': '',
    'Sort': '51',
    'Description': 'Surveillance SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': 'z',
    'SymbolicName': 'SuspendedSAM',
    'Group': '',
    'Sort': '52',
    'Description': 'Suspended SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': '0',
    'SymbolicName': 'ReservedSAM',
    'Group': '',
    'Sort': '53',
    'Description': 'Reserved SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': '1',
    'SymbolicName': 'NoActiveSAM',
    'Group': '',
    'Sort': '54',
    'Description': 'No Active SAM',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': '2',
    'SymbolicName': 'Restricted',
    'Group': '',
    'Sort': '55',
    'Description': 'Restricted',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '276',
    'Value': '3',
    'SymbolicName': 'RestOfBookVWAP',
    'Group': '',
    'Sort': '56',
    'Description': 'Rest of Book VWAP',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '276',
    'Value': '4',
    'SymbolicName': 'BetterPricesInConditionalOrders',
    'Group': '',
    'Sort': '57',
    'Description': 'Better Prices in Conditional Orders',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '276',
    'Value': '5',
    'SymbolicName': 'MedianPrice',
    'Group': '',
    'Sort': '58',
    'Description': 'Median Price',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '277',
    'Value': 'A',
    'SymbolicName': 'Cash',
    'Group': '',
    'Sort': '0',
    'Description': 'Cash (only) Market',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'B',
    'SymbolicName': 'AveragePriceTrade',
    'Group': '',
    'Sort': '1',
    'Description': 'Average Price Trade',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'C',
    'SymbolicName': 'CashTrade',
    'Group': '',
    'Sort': '2',
    'Description': 'Cash Trade (same day clearing)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'D',
    'SymbolicName': 'NextDay',
    'Group': '',
    'Sort': '3',
    'Description': 'Next Day (only)Market',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'E',
    'SymbolicName': 'Opening',
    'Group': '',
    'Sort': '4',
    'Description': 'Opening/Reopening Trade Detail',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'F',
    'SymbolicName': 'IntradayTradeDetail',
    'Group': '',
    'Sort': '5',
    'Description': 'Intraday Trade Detail',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'G',
    'SymbolicName': 'Rule127Trade',
    'Group': '',
    'Sort': '6',
    'Description': 'Rule 127 Trade (NYSE)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'H',
    'SymbolicName': 'Rule155Trade',
    'Group': '',
    'Sort': '7',
    'Description': 'Rule 155 Trade (AMEX)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'I',
    'SymbolicName': 'SoldLast',
    'Group': '',
    'Sort': '8',
    'Description': 'Sold Last (late reporting)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'J',
    'SymbolicName': 'NextDayTrade',
    'Group': '',
    'Sort': '9',
    'Description': 'Next Day Trade (next day clearing)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'K',
    'SymbolicName': 'Opened',
    'Group': '',
    'Sort': '10',
    'Description': 'Opened (late report of opened trade)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'L',
    'SymbolicName': 'Seller',
    'Group': '',
    'Sort': '11',
    'Description': 'Seller',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'M',
    'SymbolicName': 'Sold',
    'Group': '',
    'Sort': '12',
    'Description': 'Sold (out of sequence)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'N',
    'SymbolicName': 'StoppedStock',
    'Group': '',
    'Sort': '13',
    'Description': 'Stopped Stock (guarantee of price but does not execute the order)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '277',
    'Value': 'P',
    'SymbolicName': 'ImbalanceMoreBuyers',
    'Group': '',
    'Sort': '14',
    'Description': 'Imbalance More Buyers (cannot be used in combination with Q)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '277',
    'Value': 'Q',
    'SymbolicName': 'ImbalanceMoreSellers',
    'Group': '',
    'Sort': '15',
    'Description': 'Imbalance More Sellers (cannot be used in combination with P)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '277',
    'Value': 'R',
    'SymbolicName': 'OpeningPrice',
    'Group': '',
    'Sort': '16',
    'Description': 'Opening Price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '277',
    'Value': 'S',
    'SymbolicName': 'BargainCondition',
    'Group': '',
    'Sort': '17',
    'Description': 'Bargain Condition (LSE)',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'T',
    'SymbolicName': 'ConvertedPriceIndicator',
    'Group': '',
    'Sort': '18',
    'Description': 'Converted Price Indicator',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'U',
    'SymbolicName': 'ExchangeLast',
    'Group': '',
    'Sort': '19',
    'Description': 'Exchange Last',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'V',
    'SymbolicName': 'FinalPriceOfSession',
    'Group': '',
    'Sort': '20',
    'Description': 'Final Price of Session',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'W',
    'SymbolicName': 'ExPit',
    'Group': '',
    'Sort': '21',
    'Description': 'Ex-pit',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'X',
    'SymbolicName': 'Crossed',
    'Group': '',
    'Sort': '22',
    'Description': 'Crossed',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'Y',
    'SymbolicName': 'TradesResultingFromManual',
    'Group': '',
    'Sort': '23',
    'Description': 'Trades resulting from manual/slow quote',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '277',
    'Value': 'Z',
    'SymbolicName': 'TradesResultingFromIntermarketSweep',
    'Group': '',
    'Sort': '24',
    'Description': 'Trades resulting from intermarket sweep',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '277',
    'Value': 'a',
    'SymbolicName': 'VolumeOnly',
    'Group': '',
    'Sort': '25',
    'Description': 'Volume Only',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'b',
    'SymbolicName': 'DirectPlus',
    'Group': '',
    'Sort': '26',
    'Description': 'Direct Plus',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'c',
    'SymbolicName': 'Acquisition',
    'Group': '',
    'Sort': '27',
    'Description': 'Acquisition',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'd',
    'SymbolicName': 'Bunched',
    'Group': '',
    'Sort': '28',
    'Description': 'Bunched',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'e',
    'SymbolicName': 'Distribution',
    'Group': '',
    'Sort': '29',
    'Description': 'Distribution',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'f',
    'SymbolicName': 'BunchedSale',
    'Group': '',
    'Sort': '30',
    'Description': 'Bunched Sale',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'g',
    'SymbolicName': 'SplitTrade',
    'Group': '',
    'Sort': '31',
    'Description': 'Split Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'h',
    'SymbolicName': 'CancelStopped',
    'Group': '',
    'Sort': '32',
    'Description': 'Cancel Stopped',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'i',
    'SymbolicName': 'CancelETH',
    'Group': '',
    'Sort': '33',
    'Description': 'Cancel ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'j',
    'SymbolicName': 'CancelStoppedETH',
    'Group': '',
    'Sort': '34',
    'Description': 'Cancel Stopped ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'k',
    'SymbolicName': 'OutOfSequenceETH',
    'Group': '',
    'Sort': '35',
    'Description': 'Out of Sequence ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'l',
    'SymbolicName': 'CancelLastETH',
    'Group': '',
    'Sort': '36',
    'Description': 'Cancel Last ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'm',
    'SymbolicName': 'SoldLastSaleETH',
    'Group': '',
    'Sort': '37',
    'Description': 'Sold Last Sale ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'n',
    'SymbolicName': 'CancelLast',
    'Group': '',
    'Sort': '38',
    'Description': 'Cancel Last',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'o',
    'SymbolicName': 'SoldLastSale',
    'Group': '',
    'Sort': '39',
    'Description': 'Sold Last Sale',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'p',
    'SymbolicName': 'CancelOpen',
    'Group': '',
    'Sort': '40',
    'Description': 'Cancel Open',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'q',
    'SymbolicName': 'CancelOpenETH',
    'Group': '',
    'Sort': '41',
    'Description': 'Cancel Open ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'r',
    'SymbolicName': 'OpenedSaleETH',
    'Group': '',
    'Sort': '42',
    'Description': 'Opened Sale ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 's',
    'SymbolicName': 'CancelOnly',
    'Group': '',
    'Sort': '43',
    'Description': 'Cancel Only',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 't',
    'SymbolicName': 'CancelOnlyETH',
    'Group': '',
    'Sort': '44',
    'Description': 'Cancel Only ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'u',
    'SymbolicName': 'LateOpenETH',
    'Group': '',
    'Sort': '45',
    'Description': 'Late Open ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'v',
    'SymbolicName': 'AutoExecutionETH',
    'Group': '',
    'Sort': '46',
    'Description': 'Auto Execution ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'w',
    'SymbolicName': 'Reopen',
    'Group': '',
    'Sort': '47',
    'Description': 'Reopen',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'x',
    'SymbolicName': 'ReopenETH',
    'Group': '',
    'Sort': '48',
    'Description': 'Reopen ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'y',
    'SymbolicName': 'Adjusted',
    'Group': '',
    'Sort': '49',
    'Description': 'Adjusted',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'z',
    'SymbolicName': 'AdjustedETH',
    'Group': '',
    'Sort': '50',
    'Description': 'Adjusted ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AA',
    'SymbolicName': 'Spread',
    'Group': '',
    'Sort': '51',
    'Description': 'Spread',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AB',
    'SymbolicName': 'SpreadETH',
    'Group': '',
    'Sort': '52',
    'Description': 'Spread ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AC',
    'SymbolicName': 'Straddle',
    'Group': '',
    'Sort': '53',
    'Description': 'Straddle',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AD',
    'SymbolicName': 'StraddleETH',
    'Group': '',
    'Sort': '54',
    'Description': 'Straddle ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AE',
    'SymbolicName': 'Stopped',
    'Group': '',
    'Sort': '55',
    'Description': 'Stopped',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AF',
    'SymbolicName': 'StoppedETH',
    'Group': '',
    'Sort': '56',
    'Description': 'Stopped ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AG',
    'SymbolicName': 'RegularETH',
    'Group': '',
    'Sort': '57',
    'Description': 'Regular ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AH',
    'SymbolicName': 'Combo',
    'Group': '',
    'Sort': '58',
    'Description': 'Combo',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AI',
    'SymbolicName': 'ComboETH',
    'Group': '',
    'Sort': '59',
    'Description': 'Combo ETH',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AJ',
    'SymbolicName': 'OfficialClosingPrice',
    'Group': '',
    'Sort': '60',
    'Description': 'Official Closing Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AK',
    'SymbolicName': 'PriorReferencePrice',
    'Group': '',
    'Sort': '61',
    'Description': 'Prior Reference Price',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': '0',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '62',
    'Description': 'Cancel',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AL',
    'SymbolicName': 'StoppedSoldLast',
    'Group': '',
    'Sort': '71',
    'Description': 'Stopped Sold Last',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AM',
    'SymbolicName': 'StoppedOutOfSequence',
    'Group': '',
    'Sort': '72',
    'Description': 'Stopped Out of Sequence',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AN',
    'SymbolicName': 'OfficalClosingPrice',
    'Group': '',
    'Sort': '73',
    'Description': 'Offical Closing Price (duplicate enumeration - use \'AJ\' instead)',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AO',
    'SymbolicName': 'CrossedOld',
    'Group': '',
    'Sort': '74',
    'Description': 'Crossed (duplicate enumeration - use \'X\' instead)',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AP',
    'SymbolicName': 'FastMarket',
    'Group': '',
    'Sort': '75',
    'Description': 'Fast Market',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AQ',
    'SymbolicName': 'AutomaticExecution',
    'Group': '',
    'Sort': '76',
    'Description': 'Automatic Execution',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AR',
    'SymbolicName': 'FormT',
    'Group': '',
    'Sort': '77',
    'Description': 'Form T',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AS',
    'SymbolicName': 'BasketIndex',
    'Group': '',
    'Sort': '78',
    'Description': 'Basket Index',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AT',
    'SymbolicName': 'BurstBasket',
    'Group': '',
    'Sort': '79',
    'Description': 'Burst Basket',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': 'AV',
    'SymbolicName': 'OutsideSpread',
    'Group': '',
    'Sort': '98',
    'Description': 'Outside Spread',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '277',
    'Value': '1',
    'SymbolicName': 'ImpliedTrade',
    'Group': '',
    'Sort': '99',
    'Description': 'Implied Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': '2',
    'SymbolicName': 'MarketplaceEnteredTrade',
    'Group': '',
    'Sort': '100',
    'Description': 'Marketplace entered trade',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': '3',
    'SymbolicName': 'MultAssetClassMultilegTrade',
    'Group': '',
    'Sort': '101',
    'Description': 'Mult Asset Class Multileg Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '277',
    'Value': '4',
    'SymbolicName': 'MultilegToMultilegTrade',
    'Group': '',
    'Sort': '102',
    'Description': 'Multileg-to-Multileg Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '279',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '279',
    'Value': '1',
    'SymbolicName': 'Change',
    'Group': '',
    'Sort': '2',
    'Description': 'Change',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '279',
    'Value': '2',
    'SymbolicName': 'Delete',
    'Group': '',
    'Sort': '3',
    'Description': 'Delete',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '279',
    'Value': '3',
    'SymbolicName': 'DeleteThru',
    'Group': '',
    'Sort': '4',
    'Description': 'Delete Thru',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '279',
    'Value': '4',
    'SymbolicName': 'DeleteFrom',
    'Group': '',
    'Sort': '5',
    'Description': 'Delete From',
    'Added': 'FIX.4.4',
    'AddedEP': '7'
  },
  {
    'Tag': '279',
    'Value': '5',
    'SymbolicName': 'Overlay',
    'Group': '',
    'Sort': '10',
    'Description': 'Overlay',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '281',
    'Value': '0',
    'SymbolicName': 'UnknownSymbol',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown symbol',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '1',
    'SymbolicName': 'DuplicateMDReqID',
    'Group': '',
    'Sort': '2',
    'Description': 'Duplicate MDReqID',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '2',
    'SymbolicName': 'InsufficientBandwidth',
    'Group': '',
    'Sort': '3',
    'Description': 'Insufficient Bandwidth',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '3',
    'SymbolicName': 'InsufficientPermissions',
    'Group': '',
    'Sort': '4',
    'Description': 'Insufficient Permissions',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '4',
    'SymbolicName': 'UnsupportedSubscriptionRequestType',
    'Group': '',
    'Sort': '5',
    'Description': 'Unsupported SubscriptionRequestType',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '5',
    'SymbolicName': 'UnsupportedMarketDepth',
    'Group': '',
    'Sort': '6',
    'Description': 'Unsupported MarketDepth',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '6',
    'SymbolicName': 'UnsupportedMDUpdateType',
    'Group': '',
    'Sort': '7',
    'Description': 'Unsupported MDUpdateType',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '7',
    'SymbolicName': 'UnsupportedAggregatedBook',
    'Group': '',
    'Sort': '8',
    'Description': 'Unsupported AggregatedBook',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '8',
    'SymbolicName': 'UnsupportedMDEntryType',
    'Group': '',
    'Sort': '9',
    'Description': 'Unsupported MDEntryType',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '281',
    'Value': '9',
    'SymbolicName': 'UnsupportedTradingSessionID',
    'Group': '',
    'Sort': '10',
    'Description': 'Unsupported TradingSessionID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '281',
    'Value': 'A',
    'SymbolicName': 'UnsupportedScope',
    'Group': '',
    'Sort': '11',
    'Description': 'Unsupported Scope',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '281',
    'Value': 'B',
    'SymbolicName': 'UnsupportedOpenCloseSettleFlag',
    'Group': '',
    'Sort': '12',
    'Description': 'Unsupported OpenCloseSettleFlag',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '281',
    'Value': 'C',
    'SymbolicName': 'UnsupportedMDImplicitDelete',
    'Group': '',
    'Sort': '13',
    'Description': 'Unsupported MDImplicitDelete',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '281',
    'Value': 'D',
    'SymbolicName': 'InsufficientCredit',
    'Group': '',
    'Sort': '14',
    'Description': 'Insufficient credit',
    'Added': 'FIX.4.4',
    'AddedEP': '21'
  },
  {
    'Tag': '285',
    'Value': '0',
    'SymbolicName': 'Cancellation',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancellation / Trade Bust',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '285',
    'Value': '1',
    'SymbolicName': 'Error',
    'Group': '',
    'Sort': '2',
    'Description': 'Error',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '286',
    'Value': '0',
    'SymbolicName': 'DailyOpen',
    'Group': '',
    'Sort': '1',
    'Description': 'Daily Open / Close / Settlement entry',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '286',
    'Value': '1',
    'SymbolicName': 'SessionOpen',
    'Group': '',
    'Sort': '2',
    'Description': 'Session Open / Close / Settlement entry',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '286',
    'Value': '2',
    'SymbolicName': 'DeliverySettlementEntry',
    'Group': '',
    'Sort': '3',
    'Description': 'Delivery Settlement entry',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '286',
    'Value': '3',
    'SymbolicName': 'ExpectedEntry',
    'Group': '',
    'Sort': '4',
    'Description': 'Expected entry',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '286',
    'Value': '4',
    'SymbolicName': 'EntryFromPreviousBusinessDay',
    'Group': '',
    'Sort': '5',
    'Description': 'Entry from previous business day',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '286',
    'Value': '5',
    'SymbolicName': 'TheoreticalPriceValue',
    'Group': '',
    'Sort': '6',
    'Description': 'Theoretical Price value',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '291',
    'Value': '1',
    'SymbolicName': 'Bankrupt',
    'Group': '',
    'Sort': '1',
    'Description': 'Bankrupt',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '291',
    'Value': '2',
    'SymbolicName': 'PendingDelisting',
    'Group': '',
    'Sort': '2',
    'Description': 'Pending delisting',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '291',
    'Value': '3',
    'SymbolicName': 'Restricted',
    'Group': '',
    'Sort': '3',
    'Description': 'Restricted',
    'Added': 'FIX.4.4',
    'AddedEP': '12'
  },
  {
    'Tag': '292',
    'Value': 'A',
    'SymbolicName': 'ExDividend',
    'Group': '',
    'Sort': '1',
    'Description': 'Ex-Dividend',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '292',
    'Value': 'B',
    'SymbolicName': 'ExDistribution',
    'Group': '',
    'Sort': '2',
    'Description': 'Ex-Distribution',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '292',
    'Value': 'C',
    'SymbolicName': 'ExRights',
    'Group': '',
    'Sort': '3',
    'Description': 'Ex-Rights',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '292',
    'Value': 'D',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '4',
    'Description': 'New',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '292',
    'Value': 'E',
    'SymbolicName': 'ExInterest',
    'Group': '',
    'Sort': '5',
    'Description': 'Ex-Interest',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '292',
    'Value': 'F',
    'SymbolicName': 'CashDividend',
    'Group': '',
    'Sort': '6',
    'Description': 'Cash Dividend',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'G',
    'SymbolicName': 'StockDividend',
    'Group': '',
    'Sort': '7',
    'Description': 'Stock Dividend',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'H',
    'SymbolicName': 'NonIntegerStockSplit',
    'Group': '',
    'Sort': '8',
    'Description': 'Non-Integer Stock Split',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'I',
    'SymbolicName': 'ReverseStockSplit',
    'Group': '',
    'Sort': '9',
    'Description': 'Reverse Stock Split',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'J',
    'SymbolicName': 'StandardIntegerStockSplit',
    'Group': '',
    'Sort': '10',
    'Description': 'Standard-Integer Stock Split',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'K',
    'SymbolicName': 'PositionConsolidation',
    'Group': '',
    'Sort': '11',
    'Description': 'Position Consolidation',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'L',
    'SymbolicName': 'LiquidationReorganization',
    'Group': '',
    'Sort': '12',
    'Description': 'Liquidation Reorganization',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'M',
    'SymbolicName': 'MergerReorganization',
    'Group': '',
    'Sort': '13',
    'Description': 'Merger Reorganization',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'N',
    'SymbolicName': 'RightsOffering',
    'Group': '',
    'Sort': '14',
    'Description': 'Rights Offering',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'O',
    'SymbolicName': 'ShareholderMeeting',
    'Group': '',
    'Sort': '15',
    'Description': 'Shareholder Meeting',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'P',
    'SymbolicName': 'Spinoff',
    'Group': '',
    'Sort': '16',
    'Description': 'Spinoff',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'Q',
    'SymbolicName': 'TenderOffer',
    'Group': '',
    'Sort': '17',
    'Description': 'Tender Offer',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'R',
    'SymbolicName': 'Warrant',
    'Group': '',
    'Sort': '18',
    'Description': 'Warrant',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'S',
    'SymbolicName': 'SpecialAction',
    'Group': '',
    'Sort': '19',
    'Description': 'Special Action',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'T',
    'SymbolicName': 'SymbolConversion',
    'Group': '',
    'Sort': '20',
    'Description': 'Symbol Conversion',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'U',
    'SymbolicName': 'CUSIP',
    'Group': '',
    'Sort': '21',
    'Description': 'CUSIP / Name Change',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '292',
    'Value': 'V',
    'SymbolicName': 'LeapRollover',
    'Group': '',
    'Sort': '22',
    'Description': 'Leap Rollover',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '292',
    'Value': 'W',
    'SymbolicName': 'SuccessionEvent',
    'Group': '',
    'Sort': '99',
    'Description': 'Succession Event',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '297',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '0',
    'Description': 'Accepted',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '297',
    'Value': '1',
    'SymbolicName': 'CancelForSymbol',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel for Symbol(s)',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '297',
    'Value': '2',
    'SymbolicName': 'CanceledForSecurityType',
    'Group': '',
    'Sort': '2',
    'Description': 'Canceled for Security Type(s)',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '297',
    'Value': '3',
    'SymbolicName': 'CanceledForUnderlying',
    'Group': '',
    'Sort': '3',
    'Description': 'Canceled for Underlying',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '297',
    'Value': '4',
    'SymbolicName': 'CanceledAll',
    'Group': '',
    'Sort': '4',
    'Description': 'Canceled All',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0'
  },
  {
    'Tag': '297',
    'Value': '5',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '5',
    'Description': 'Rejected',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '297',
    'Value': '6',
    'SymbolicName': 'RemovedFromMarket',
    'Group': '',
    'Sort': '6',
    'Description': 'Removed from Market',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '297',
    'Value': '7',
    'SymbolicName': 'Expired',
    'Group': '',
    'Sort': '7',
    'Description': 'Expired',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '297',
    'Value': '8',
    'SymbolicName': 'Query',
    'Group': '',
    'Sort': '8',
    'Description': 'Query',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '297',
    'Value': '9',
    'SymbolicName': 'QuoteNotFound',
    'Group': '',
    'Sort': '9',
    'Description': 'Quote Not Found',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '297',
    'Value': '10',
    'SymbolicName': 'Pending',
    'Group': '',
    'Sort': '10',
    'Description': 'Pending',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '297',
    'Value': '11',
    'SymbolicName': 'Pass',
    'Group': '',
    'Sort': '11',
    'Description': 'Pass',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '297',
    'Value': '12',
    'SymbolicName': 'LockedMarketWarning',
    'Group': '',
    'Sort': '12',
    'Description': 'Locked Market Warning',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '297',
    'Value': '13',
    'SymbolicName': 'CrossMarketWarning',
    'Group': '',
    'Sort': '13',
    'Description': 'Cross Market Warning',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '297',
    'Value': '14',
    'SymbolicName': 'CanceledDueToLockMarket',
    'Group': '',
    'Sort': '14',
    'Description': 'Canceled Due To Lock Market',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '297',
    'Value': '15',
    'SymbolicName': 'CanceledDueToCrossMarket',
    'Group': '',
    'Sort': '15',
    'Description': 'Canceled Due To Cross Market',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '297',
    'Value': '16',
    'SymbolicName': 'Active',
    'Group': '',
    'Sort': '17',
    'Description': 'Active',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '297',
    'Value': '17',
    'SymbolicName': 'Canceled',
    'Group': '',
    'Sort': '18',
    'Description': 'Canceled',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '297',
    'Value': '18',
    'SymbolicName': 'UnsolicitedQuoteReplenishment',
    'Group': '',
    'Sort': '19',
    'Description': 'Unsolicited Quote Replenishment',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '297',
    'Value': '19',
    'SymbolicName': 'PendingEndTrade',
    'Group': '',
    'Sort': '20',
    'Description': 'Pending End Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '297',
    'Value': '20',
    'SymbolicName': 'TooLateToEnd',
    'Group': '',
    'Sort': '21',
    'Description': 'Too Late to End',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '298',
    'Value': '1',
    'SymbolicName': 'CancelForOneOrMoreSecurities',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel for one or more securities',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '78',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '298',
    'Value': '2',
    'SymbolicName': 'CancelForSecurityType',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel for Security Type(s)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '298',
    'Value': '3',
    'SymbolicName': 'CancelForUnderlyingSecurity',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel for underlying security',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '78',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '298',
    'Value': '4',
    'SymbolicName': 'CancelAllQuotes',
    'Group': '',
    'Sort': '4',
    'Description': 'Cancel All Quotes',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '298',
    'Value': '5',
    'SymbolicName': 'CancelQuoteSpecifiedInQuoteID',
    'Group': '',
    'Sort': '5',
    'Description': 'Cancel quote specified in QuoteID',
    'Added': 'FIX.4.4',
    'AddedEP': '21'
  },
  {
    'Tag': '300',
    'Value': '1',
    'SymbolicName': 'UnknownSymbol',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown Symbol (security)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '2',
    'SymbolicName': 'Exchange',
    'Group': '',
    'Sort': '2',
    'Description': 'Exchange (Security) closed',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '3',
    'SymbolicName': 'QuoteRequestExceedsLimit',
    'Group': '',
    'Sort': '3',
    'Description': 'Quote Request exceeds limit',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '4',
    'SymbolicName': 'TooLateToEnter',
    'Group': '',
    'Sort': '4',
    'Description': 'Too late to enter',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '5',
    'SymbolicName': 'UnknownQuote',
    'Group': '',
    'Sort': '5',
    'Description': 'Unknown Quote',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '6',
    'SymbolicName': 'DuplicateQuote',
    'Group': '',
    'Sort': '6',
    'Description': 'Duplicate Quote',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '7',
    'SymbolicName': 'InvalidBid',
    'Group': '',
    'Sort': '7',
    'Description': 'Invalid bid/ask spread',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '8',
    'SymbolicName': 'InvalidPrice',
    'Group': '',
    'Sort': '8',
    'Description': 'Invalid price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '9',
    'SymbolicName': 'NotAuthorizedToQuoteSecurity',
    'Group': '',
    'Sort': '9',
    'Description': 'Not authorized to quote security',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '300',
    'Value': '10',
    'SymbolicName': 'PriceExceedsCurrentPriceBand',
    'Group': '',
    'Sort': '10',
    'Description': 'Price exceeds current price band',
    'Added': 'FIX.5.0',
    'AddedEP': '43'
  },
  {
    'Tag': '300',
    'Value': '11',
    'SymbolicName': 'QuoteLocked',
    'Group': '',
    'Sort': '11',
    'Description': 'Quote Locked - Unable to Update/Cancel',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '300',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '301',
    'Value': '0',
    'SymbolicName': 'NoAcknowledgement',
    'Group': '',
    'Sort': '1',
    'Description': 'No Acknowledgement',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '301',
    'Value': '1',
    'SymbolicName': 'AcknowledgeOnlyNegativeOrErroneousQuotes',
    'Group': '',
    'Sort': '2',
    'Description': 'Acknowledge only negative or erroneous quotes',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '301',
    'Value': '2',
    'SymbolicName': 'AcknowledgeEachQuoteMessage',
    'Group': '',
    'Sort': '3',
    'Description': 'Acknowledge each quote message',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '301',
    'Value': '3',
    'SymbolicName': 'SummaryAcknowledgement',
    'Group': '',
    'Sort': '4',
    'Description': 'Summary Acknowledgement',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '303',
    'Value': '1',
    'SymbolicName': 'Manual',
    'Group': '',
    'Sort': '1',
    'Description': 'Manual',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '303',
    'Value': '2',
    'SymbolicName': 'Automatic',
    'Group': '',
    'Sort': '2',
    'Description': 'Automatic',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '321',
    'Value': '0',
    'SymbolicName': 'RequestSecurityIdentityAndSpecifications',
    'Group': '',
    'Sort': '1',
    'Description': 'Request Security identity and specifications',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '321',
    'Value': '1',
    'SymbolicName': 'RequestSecurityIdentityForSpecifications',
    'Group': '',
    'Sort': '2',
    'Description': 'Request Security identity for the specifications provided (name of the security is not supplied)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '321',
    'Value': '2',
    'SymbolicName': 'RequestListSecurityTypes',
    'Group': '',
    'Sort': '3',
    'Description': 'Request List Security Types',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0SP1'
  },
  {
    'Tag': '321',
    'Value': '3',
    'SymbolicName': 'RequestListSecurities',
    'Group': '',
    'Sort': '4',
    'Description': 'Request List Securities (can be qualified with Symbol, SecurityType, TradingSessionID, SecurityExchange. If provided then only list Securities for the specific type.)',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0SP1'
  },
  {
    'Tag': '321',
    'Value': '4',
    'SymbolicName': 'Symbol',
    'Group': '',
    'Sort': '5',
    'Description': 'Symbol',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '321',
    'Value': '5',
    'SymbolicName': 'SecurityTypeAndOrCFICode',
    'Group': '',
    'Sort': '6',
    'Description': 'SecurityType and or CFICode',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '321',
    'Value': '6',
    'SymbolicName': 'Product',
    'Group': '',
    'Sort': '7',
    'Description': 'Product',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '321',
    'Value': '7',
    'SymbolicName': 'TradingSessionID',
    'Group': '',
    'Sort': '8',
    'Description': 'TradingSessionID',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '321',
    'Value': '8',
    'SymbolicName': 'AllSecurities',
    'Group': '',
    'Sort': '9',
    'Description': 'All Securities',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '321',
    'Value': '9',
    'SymbolicName': 'MarketIDOrMarketID',
    'Group': '',
    'Sort': '10',
    'Description': 'MarketID or MarketID + MarketSegmentID',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '323',
    'Value': '1',
    'SymbolicName': 'AcceptAsIs',
    'Group': '',
    'Sort': '1',
    'Description': 'Accept security proposal as-is',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '323',
    'Value': '2',
    'SymbolicName': 'AcceptWithRevisions',
    'Group': '',
    'Sort': '2',
    'Description': 'Accept security proposal with revisions as indicated in the message',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '323',
    'Value': '3',
    'SymbolicName': 'ListOfSecurityTypesReturnedPerRequest',
    'Group': '',
    'Sort': '3',
    'Description': 'List of security types returned per request',
    'Added': 'FIX.4.2',
    'Deprecated': 'FIX.5.0SP1'
  },
  {
    'Tag': '323',
    'Value': '4',
    'SymbolicName': 'ListOfSecuritiesReturnedPerRequest',
    'Group': '',
    'Sort': '4',
    'Description': 'List of securities returned per request',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '323',
    'Value': '5',
    'SymbolicName': 'RejectSecurityProposal',
    'Group': '',
    'Sort': '5',
    'Description': 'Reject security proposal',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '323',
    'Value': '6',
    'SymbolicName': 'CannotMatchSelectionCriteria',
    'Group': '',
    'Sort': '6',
    'Description': 'Cannot match selection criteria',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '325',
    'Value': 'N',
    'SymbolicName': 'MessageIsBeingSentAsAResultOfAPriorRequest',
    'Group': '',
    'Sort': '1',
    'Description': 'Message is being sent as a result of a prior request',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '325',
    'Value': 'Y',
    'SymbolicName': 'MessageIsBeingSentUnsolicited',
    'Group': '',
    'Sort': '2',
    'Description': 'Message is being sent unsolicited',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '1',
    'SymbolicName': 'OpeningDelay',
    'Group': '',
    'Sort': '0',
    'Description': 'Opening delay',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '2',
    'SymbolicName': 'TradingHalt',
    'Group': '',
    'Sort': '1',
    'Description': 'Trading halt',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '3',
    'SymbolicName': 'Resume',
    'Group': '',
    'Sort': '2',
    'Description': 'Resume',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '4',
    'SymbolicName': 'NoOpen',
    'Group': '',
    'Sort': '3',
    'Description': 'No Open / No Resume',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '5',
    'SymbolicName': 'PriceIndication',
    'Group': '',
    'Sort': '4',
    'Description': 'Price indication',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '6',
    'SymbolicName': 'TradingRangeIndication',
    'Group': '',
    'Sort': '5',
    'Description': 'Trading Range Indication',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '7',
    'SymbolicName': 'MarketImbalanceBuy',
    'Group': '',
    'Sort': '6',
    'Description': 'Market Imbalance Buy',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '8',
    'SymbolicName': 'MarketImbalanceSell',
    'Group': '',
    'Sort': '7',
    'Description': 'Market Imbalance Sell',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '9',
    'SymbolicName': 'MarketOnCloseImbalanceBuy',
    'Group': '',
    'Sort': '8',
    'Description': 'Market on Close Imbalance Buy',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '10',
    'SymbolicName': 'MarketOnCloseImbalanceSell',
    'Group': '',
    'Sort': '9',
    'Description': 'Market on Close Imbalance Sell',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '12',
    'SymbolicName': 'NoMarketImbalance',
    'Group': '',
    'Sort': '11',
    'Description': 'No Market Imbalance',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '13',
    'SymbolicName': 'NoMarketOnCloseImbalance',
    'Group': '',
    'Sort': '12',
    'Description': 'No Market on Close Imbalance',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '14',
    'SymbolicName': 'ITSPreOpening',
    'Group': '',
    'Sort': '13',
    'Description': 'ITS Pre-opening',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '15',
    'SymbolicName': 'NewPriceIndication',
    'Group': '',
    'Sort': '14',
    'Description': 'New Price Indication',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '16',
    'SymbolicName': 'TradeDisseminationTime',
    'Group': '',
    'Sort': '15',
    'Description': 'Trade Dissemination Time',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '17',
    'SymbolicName': 'ReadyToTrade',
    'Group': '',
    'Sort': '16',
    'Description': 'Ready to trade (start of session)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '18',
    'SymbolicName': 'NotAvailableForTrading',
    'Group': '',
    'Sort': '17',
    'Description': 'Not available for trading (end of session)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '19',
    'SymbolicName': 'NotTradedOnThisMarket',
    'Group': '',
    'Sort': '18',
    'Description': 'Not traded on this market',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '20',
    'SymbolicName': 'UnknownOrInvalid',
    'Group': '',
    'Sort': '19',
    'Description': 'Unknown or Invalid',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '326',
    'Value': '21',
    'SymbolicName': 'PreOpen',
    'Group': '',
    'Sort': '20',
    'Description': 'Pre-open',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '326',
    'Value': '22',
    'SymbolicName': 'OpeningRotation',
    'Group': '',
    'Sort': '21',
    'Description': 'Opening Rotation',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '326',
    'Value': '23',
    'SymbolicName': 'FastMarket',
    'Group': '',
    'Sort': '22',
    'Description': 'Fast Market',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '326',
    'Value': '24',
    'SymbolicName': 'PreCross',
    'Group': '',
    'Sort': '98',
    'Description': 'Pre-Cross - system is in a pre-cross state allowing market to respond to either side of cross',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '326',
    'Value': '25',
    'SymbolicName': 'Cross',
    'Group': '',
    'Sort': '99',
    'Description': 'Cross - system has crossed a percentage of the orders and allows market to respond prior to crossing remaining portion',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '328',
    'Value': 'N',
    'SymbolicName': 'HaltWasNotRelatedToAHaltOfTheCommonStock',
    'Group': '',
    'Sort': '1',
    'Description': 'Halt was not related to a halt of the common stock',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '328',
    'Value': 'Y',
    'SymbolicName': 'HaltWasDueToCommonStockBeingHalted',
    'Group': '',
    'Sort': '2',
    'Description': 'Halt was due to common stock being halted',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '329',
    'Value': 'N',
    'SymbolicName': 'NotRelatedToSecurityHalt',
    'Group': '',
    'Sort': '1',
    'Description': 'Halt was not related to a halt of the related security',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '329',
    'Value': 'Y',
    'SymbolicName': 'RelatedToSecurityHalt',
    'Group': '',
    'Sort': '2',
    'Description': 'Halt was due to related security being halted',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '334',
    'Value': '1',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '334',
    'Value': '2',
    'SymbolicName': 'Error',
    'Group': '',
    'Sort': '2',
    'Description': 'Error',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '334',
    'Value': '3',
    'SymbolicName': 'Correction',
    'Group': '',
    'Sort': '3',
    'Description': 'Correction',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '336',
    'Value': '1',
    'SymbolicName': 'Day',
    'Group': '',
    'Sort': '1',
    'Description': 'Day',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '336',
    'Value': '2',
    'SymbolicName': 'HalfDay',
    'Group': '',
    'Sort': '2',
    'Description': 'HalfDay',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '336',
    'Value': '3',
    'SymbolicName': 'Morning',
    'Group': '',
    'Sort': '3',
    'Description': 'Morning',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '336',
    'Value': '4',
    'SymbolicName': 'Afternoon',
    'Group': '',
    'Sort': '4',
    'Description': 'Afternoon',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '336',
    'Value': '5',
    'SymbolicName': 'Evening',
    'Group': '',
    'Sort': '5',
    'Description': 'Evening',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '336',
    'Value': '6',
    'SymbolicName': 'AfterHours',
    'Group': '',
    'Sort': '6',
    'Description': 'After-hours',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '338',
    'Value': '1',
    'SymbolicName': 'Electronic',
    'Group': '',
    'Sort': '1',
    'Description': 'Electronic',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '338',
    'Value': '2',
    'SymbolicName': 'OpenOutcry',
    'Group': '',
    'Sort': '2',
    'Description': 'Open Outcry',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '338',
    'Value': '3',
    'SymbolicName': 'TwoParty',
    'Group': '',
    'Sort': '3',
    'Description': 'Two Party',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '339',
    'Value': '1',
    'SymbolicName': 'Testing',
    'Group': '',
    'Sort': '1',
    'Description': 'Testing',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '339',
    'Value': '2',
    'SymbolicName': 'Simulated',
    'Group': '',
    'Sort': '2',
    'Description': 'Simulated',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '339',
    'Value': '3',
    'SymbolicName': 'Production',
    'Group': '',
    'Sort': '3',
    'Description': 'Production',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '340',
    'Value': '0',
    'SymbolicName': 'Unknown',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '340',
    'Value': '1',
    'SymbolicName': 'Halted',
    'Group': '',
    'Sort': '2',
    'Description': 'Halted',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '340',
    'Value': '2',
    'SymbolicName': 'Open',
    'Group': '',
    'Sort': '3',
    'Description': 'Open',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '340',
    'Value': '3',
    'SymbolicName': 'Closed',
    'Group': '',
    'Sort': '4',
    'Description': 'Closed',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '340',
    'Value': '4',
    'SymbolicName': 'PreOpen',
    'Group': '',
    'Sort': '5',
    'Description': 'Pre-Open',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '340',
    'Value': '5',
    'SymbolicName': 'PreClose',
    'Group': '',
    'Sort': '6',
    'Description': 'Pre-Close',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '340',
    'Value': '6',
    'SymbolicName': 'RequestRejected',
    'Group': '',
    'Sort': '7',
    'Description': 'Request Rejected',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '0',
    'SymbolicName': 'InvalidTagNumber',
    'Group': '',
    'Sort': '0',
    'Description': 'Invalid Tag Number',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '1',
    'SymbolicName': 'RequiredTagMissing',
    'Group': '',
    'Sort': '1',
    'Description': 'Required Tag Missing',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '2',
    'SymbolicName': 'TagNotDefinedForThisMessageType',
    'Group': '',
    'Sort': '2',
    'Description': 'Tag not defined for this message type',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '3',
    'SymbolicName': 'UndefinedTag',
    'Group': '',
    'Sort': '3',
    'Description': 'Undefined tag',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '4',
    'SymbolicName': 'TagSpecifiedWithoutAValue',
    'Group': '',
    'Sort': '4',
    'Description': 'Tag specified without a value',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '5',
    'SymbolicName': 'ValueIsIncorrect',
    'Group': '',
    'Sort': '5',
    'Description': 'Value is incorrect (out of range) for this tag',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '6',
    'SymbolicName': 'IncorrectDataFormatForValue',
    'Group': '',
    'Sort': '6',
    'Description': 'Incorrect data format for value',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '7',
    'SymbolicName': 'DecryptionProblem',
    'Group': '',
    'Sort': '7',
    'Description': 'Decryption problem',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '8',
    'SymbolicName': 'SignatureProblem',
    'Group': '',
    'Sort': '8',
    'Description': 'Signature problem',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '9',
    'SymbolicName': 'CompIDProblem',
    'Group': '',
    'Sort': '9',
    'Description': 'CompID problem',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '10',
    'SymbolicName': 'SendingTimeAccuracyProblem',
    'Group': '',
    'Sort': '10',
    'Description': 'SendingTime Accuracy Problem',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '11',
    'SymbolicName': 'InvalidMsgType',
    'Group': '',
    'Sort': '11',
    'Description': 'Invalid MsgType',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '373',
    'Value': '12',
    'SymbolicName': 'XMLValidationError',
    'Group': '',
    'Sort': '12',
    'Description': 'XML Validation Error',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '13',
    'SymbolicName': 'TagAppearsMoreThanOnce',
    'Group': '',
    'Sort': '13',
    'Description': 'Tag appears more than once',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '14',
    'SymbolicName': 'TagSpecifiedOutOfRequiredOrder',
    'Group': '',
    'Sort': '14',
    'Description': 'Tag specified out of required order',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '15',
    'SymbolicName': 'RepeatingGroupFieldsOutOfOrder',
    'Group': '',
    'Sort': '15',
    'Description': 'Repeating group fields out of order',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '16',
    'SymbolicName': 'IncorrectNumInGroupCountForRepeatingGroup',
    'Group': '',
    'Sort': '16',
    'Description': 'Incorrect NumInGroup count for repeating group',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '17',
    'SymbolicName': 'Non',
    'Group': '',
    'Sort': '17',
    'Description': 'Non \'Data\' value includes field delimiter (<SOH> character)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '373',
    'Value': '18',
    'SymbolicName': 'Invalid',
    'Group': '',
    'Sort': '19',
    'Description': 'Invalid/Unsupported Application Version',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '373',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '374',
    'Value': 'C',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '374',
    'Value': 'N',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '2',
    'Description': 'New',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '377',
    'Value': 'N',
    'SymbolicName': 'WasNotSolicited',
    'Group': '',
    'Sort': '1',
    'Description': 'Was not solicited',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '377',
    'Value': 'Y',
    'SymbolicName': 'WasSolicited',
    'Group': '',
    'Sort': '2',
    'Description': 'Was solicited',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '0',
    'SymbolicName': 'GTCorporateAction',
    'Group': '',
    'Sort': '0',
    'Description': 'GT corporate action',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '1',
    'SymbolicName': 'GTRenewal',
    'Group': '',
    'Sort': '1',
    'Description': 'GT renewal / restatement (no corporate action)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '2',
    'SymbolicName': 'VerbalChange',
    'Group': '',
    'Sort': '2',
    'Description': 'Verbal change',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '3',
    'SymbolicName': 'RepricingOfOrder',
    'Group': '',
    'Sort': '3',
    'Description': 'Repricing of order',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '4',
    'SymbolicName': 'BrokerOption',
    'Group': '',
    'Sort': '4',
    'Description': 'Broker option',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '5',
    'SymbolicName': 'PartialDeclineOfOrderQty',
    'Group': '',
    'Sort': '5',
    'Description': 'Partial decline of OrderQty (e.g. exchange initiated partial cancel)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '378',
    'Value': '6',
    'SymbolicName': 'CancelOnTradingHalt',
    'Group': '',
    'Sort': '6',
    'Description': 'Cancel on Trading Halt',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '378',
    'Value': '7',
    'SymbolicName': 'CancelOnSystemFailure',
    'Group': '',
    'Sort': '7',
    'Description': 'Cancel on System Failure',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '378',
    'Value': '8',
    'SymbolicName': 'Market',
    'Group': '',
    'Sort': '8',
    'Description': 'Market (Exchange) option',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '378',
    'Value': '9',
    'SymbolicName': 'Canceled',
    'Group': '',
    'Sort': '9',
    'Description': 'Canceled, not best',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '378',
    'Value': '10',
    'SymbolicName': 'WarehouseRecap',
    'Group': '',
    'Sort': '10',
    'Description': 'Warehouse Recap',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '378',
    'Value': '11',
    'SymbolicName': 'PegRefresh',
    'Group': '',
    'Sort': '11',
    'Description': 'Peg Refresh',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '378',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '380',
    'Value': '0',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '1',
    'Description': 'Other',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '380',
    'Value': '1',
    'SymbolicName': 'UnknownID',
    'Group': '',
    'Sort': '2',
    'Description': 'Unknown ID',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '380',
    'Value': '2',
    'SymbolicName': 'UnknownSecurity',
    'Group': '',
    'Sort': '3',
    'Description': 'Unknown Security',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '380',
    'Value': '3',
    'SymbolicName': 'UnsupportedMessageType',
    'Group': '',
    'Sort': '4',
    'Description': 'Unsupported Message Type',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '380',
    'Value': '4',
    'SymbolicName': 'ApplicationNotAvailable',
    'Group': '',
    'Sort': '5',
    'Description': 'Application not available',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '380',
    'Value': '5',
    'SymbolicName': 'ConditionallyRequiredFieldMissing',
    'Group': '',
    'Sort': '6',
    'Description': 'Conditionally required field missing',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '380',
    'Value': '6',
    'SymbolicName': 'NotAuthorized',
    'Group': '',
    'Sort': '7',
    'Description': 'Not Authorized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '380',
    'Value': '7',
    'SymbolicName': 'DeliverToFirmNotAvailableAtThisTime',
    'Group': '',
    'Sort': '8',
    'Description': 'DeliverTo firm not available at this time',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '380',
    'Value': '18',
    'SymbolicName': 'InvalidPriceIncrement',
    'Group': '',
    'Sort': '9',
    'Description': 'Invalid price increment',
    'Added': 'FIX.4.4',
    'AddedEP': '6'
  },
  {
    'Tag': '385',
    'Value': 'R',
    'SymbolicName': 'Receive',
    'Group': '',
    'Sort': '1',
    'Description': 'Receive',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '385',
    'Value': 'S',
    'SymbolicName': 'Send',
    'Group': '',
    'Sort': '2',
    'Description': 'Send',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '0',
    'SymbolicName': 'RelatedToDisplayedPrice',
    'Group': '',
    'Sort': '1',
    'Description': 'Related to displayed price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '1',
    'SymbolicName': 'RelatedToMarketPrice',
    'Group': '',
    'Sort': '2',
    'Description': 'Related to market price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '2',
    'SymbolicName': 'RelatedToPrimaryPrice',
    'Group': '',
    'Sort': '3',
    'Description': 'Related to primary price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '3',
    'SymbolicName': 'RelatedToLocalPrimaryPrice',
    'Group': '',
    'Sort': '4',
    'Description': 'Related to local primary price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '4',
    'SymbolicName': 'RelatedToMidpointPrice',
    'Group': '',
    'Sort': '5',
    'Description': 'Related to midpoint price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '5',
    'SymbolicName': 'RelatedToLastTradePrice',
    'Group': '',
    'Sort': '6',
    'Description': 'Related to last trade price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '388',
    'Value': '6',
    'SymbolicName': 'RelatedToVWAP',
    'Group': '',
    'Sort': '7',
    'Description': 'Related to VWAP',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '388',
    'Value': '7',
    'SymbolicName': 'AveragePriceGuarantee',
    'Group': '',
    'Sort': '8',
    'Description': 'Average Price Guarantee',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '394',
    'Value': '1',
    'SymbolicName': 'NonDisclosed',
    'Group': '',
    'Sort': '1',
    'Description': '\'Non Disclosed\' style (e.g. US/European)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '394',
    'Value': '2',
    'SymbolicName': 'Disclosed',
    'Group': '',
    'Sort': '2',
    'Description': '\'Disclosed\' sytle (e.g. Japanese)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '394',
    'Value': '3',
    'SymbolicName': 'NoBiddingProcess',
    'Group': '',
    'Sort': '3',
    'Description': 'No bidding process',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '399',
    'Value': '1',
    'SymbolicName': 'Sector',
    'Group': '',
    'Sort': '1',
    'Description': 'Sector',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '399',
    'Value': '2',
    'SymbolicName': 'Country',
    'Group': '',
    'Sort': '2',
    'Description': 'Country',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '399',
    'Value': '3',
    'SymbolicName': 'Index',
    'Group': '',
    'Sort': '3',
    'Description': 'Index',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '401',
    'Value': '1',
    'SymbolicName': 'SideValue1',
    'Group': '',
    'Sort': '1',
    'Description': 'Side Value 1',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '401',
    'Value': '2',
    'SymbolicName': 'SideValue2',
    'Group': '',
    'Sort': '2',
    'Description': 'Side Value 2',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '409',
    'Value': '1',
    'SymbolicName': 'FiveDayMovingAverage',
    'Group': '',
    'Sort': '1',
    'Description': '5-day moving average',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '409',
    'Value': '2',
    'SymbolicName': 'TwentyDayMovingAverage',
    'Group': '',
    'Sort': '2',
    'Description': '20-day moving average',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '409',
    'Value': '3',
    'SymbolicName': 'NormalMarketSize',
    'Group': '',
    'Sort': '3',
    'Description': 'Normal market size',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '409',
    'Value': '4',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '4',
    'Description': 'Other',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '411',
    'Value': 'N',
    'SymbolicName': 'False',
    'Group': '',
    'Sort': '1',
    'Description': 'False',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '411',
    'Value': 'Y',
    'SymbolicName': 'True',
    'Group': '',
    'Sort': '2',
    'Description': 'True',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '414',
    'Value': '1',
    'SymbolicName': 'BuySideRequests',
    'Group': '',
    'Sort': '1',
    'Description': 'Buy-side explicitly requests status using Statue Request (default), the sell-side firm can, however, send a DONE status List STatus Response in an unsolicited fashion',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '414',
    'Value': '2',
    'SymbolicName': 'SellSideSends',
    'Group': '',
    'Sort': '2',
    'Description': 'Sell-side periodically sends status using List Status. Period optionally specified in ProgressPeriod.',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '414',
    'Value': '3',
    'SymbolicName': 'RealTimeExecutionReports',
    'Group': '',
    'Sort': '3',
    'Description': 'Real-time execution reports (to be discourage)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '416',
    'Value': '1',
    'SymbolicName': 'Net',
    'Group': '',
    'Sort': '1',
    'Description': 'Net',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '416',
    'Value': '2',
    'SymbolicName': 'Gross',
    'Group': '',
    'Sort': '2',
    'Description': 'Gross',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '418',
    'Value': 'A',
    'SymbolicName': 'Agency',
    'Group': '',
    'Sort': '1',
    'Description': 'Agency',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '418',
    'Value': 'G',
    'SymbolicName': 'VWAPGuarantee',
    'Group': '',
    'Sort': '2',
    'Description': 'VWAP Guarantee',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '418',
    'Value': 'J',
    'SymbolicName': 'GuaranteedClose',
    'Group': '',
    'Sort': '3',
    'Description': 'Guaranteed Close',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '418',
    'Value': 'R',
    'SymbolicName': 'RiskTrade',
    'Group': '',
    'Sort': '4',
    'Description': 'Risk Trade',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '2',
    'SymbolicName': 'ClosingPriceAtMorningSession',
    'Group': '',
    'Sort': '1',
    'Description': 'Closing price at morning session',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '3',
    'SymbolicName': 'ClosingPrice',
    'Group': '',
    'Sort': '2',
    'Description': 'Closing price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '4',
    'SymbolicName': 'CurrentPrice',
    'Group': '',
    'Sort': '3',
    'Description': 'Current price',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '5',
    'SymbolicName': 'SQ',
    'Group': '',
    'Sort': '4',
    'Description': 'SQ',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '6',
    'SymbolicName': 'VWAPThroughADay',
    'Group': '',
    'Sort': '5',
    'Description': 'VWAP through a day',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '7',
    'SymbolicName': 'VWAPThroughAMorningSession',
    'Group': '',
    'Sort': '6',
    'Description': 'VWAP through a morning session',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '8',
    'SymbolicName': 'VWAPThroughAnAfternoonSession',
    'Group': '',
    'Sort': '7',
    'Description': 'VWAP through an afternoon session',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': '9',
    'SymbolicName': 'VWAPThroughADayExcept',
    'Group': '',
    'Sort': '8',
    'Description': 'VWAP through a day except \'YORI\' (an opening auction)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': 'A',
    'SymbolicName': 'VWAPThroughAMorningSessionExcept',
    'Group': '',
    'Sort': '9',
    'Description': 'VWAP through a morning session except \'YORI\' (an opening auction)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': 'B',
    'SymbolicName': 'VWAPThroughAnAfternoonSessionExcept',
    'Group': '',
    'Sort': '10',
    'Description': 'VWAP through an afternoon session except \'YORI\' (an opening auction)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': 'C',
    'SymbolicName': 'Strike',
    'Group': '',
    'Sort': '11',
    'Description': 'Strike',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': 'D',
    'SymbolicName': 'Open',
    'Group': '',
    'Sort': '12',
    'Description': 'Open',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '419',
    'Value': 'Z',
    'SymbolicName': 'Others',
    'Group': '',
    'Sort': '30',
    'Description': 'Others',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '423',
    'Value': '1',
    'SymbolicName': 'Percentage',
    'Group': '',
    'Sort': '0',
    'Description': 'Percentage (i.e. percent of par) (often called \'dollar price\' for fixed income)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '423',
    'Value': '2',
    'SymbolicName': 'PerUnit',
    'Group': '',
    'Sort': '1',
    'Description': 'Per unit (i.e. per share or contract)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '423',
    'Value': '3',
    'SymbolicName': 'FixedAmount',
    'Group': '',
    'Sort': '2',
    'Description': 'Fixed amount (absolute value)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '423',
    'Value': '4',
    'SymbolicName': 'Discount',
    'Group': '',
    'Sort': '3',
    'Description': 'Discount - percentage points below par',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '423',
    'Value': '5',
    'SymbolicName': 'Premium',
    'Group': '',
    'Sort': '4',
    'Description': 'Premium - percentage points over par',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '423',
    'Value': '6',
    'SymbolicName': 'Spread',
    'Group': '',
    'Sort': '5',
    'Description': 'Spread (basis points spread)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '423',
    'Value': '7',
    'SymbolicName': 'TEDPrice',
    'Group': '',
    'Sort': '6',
    'Description': 'TED Price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '423',
    'Value': '8',
    'SymbolicName': 'TEDYield',
    'Group': '',
    'Sort': '7',
    'Description': 'TED Yield',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '423',
    'Value': '9',
    'SymbolicName': 'Yield',
    'Group': '',
    'Sort': '8',
    'Description': 'Yield',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '423',
    'Value': '10',
    'SymbolicName': 'FixedCabinetTradePrice',
    'Group': '',
    'Sort': '9',
    'Description': 'Fixed cabinet trade price (primarily for listed futures and options)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '423',
    'Value': '11',
    'SymbolicName': 'VariableCabinetTradePrice',
    'Group': '',
    'Sort': '10',
    'Description': 'Variable cabinet trade price (primarily for listed futures and options)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '423',
    'Value': '13',
    'SymbolicName': 'ProductTicksInHalfs',
    'Group': '',
    'Sort': '12',
    'Description': 'Product ticks in halfs',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '423',
    'Value': '14',
    'SymbolicName': 'ProductTicksInFourths',
    'Group': '',
    'Sort': '13',
    'Description': 'Product ticks in fourths',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '423',
    'Value': '15',
    'SymbolicName': 'ProductTicksInEights',
    'Group': '',
    'Sort': '14',
    'Description': 'Product ticks in eights',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '423',
    'Value': '16',
    'SymbolicName': 'ProductTicksInSixteenths',
    'Group': '',
    'Sort': '15',
    'Description': 'Product ticks in sixteenths',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '423',
    'Value': '17',
    'SymbolicName': 'ProductTicksInThirtySeconds',
    'Group': '',
    'Sort': '16',
    'Description': 'Product ticks in thirty-seconds',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '423',
    'Value': '18',
    'SymbolicName': 'ProductTicksInSixtyForths',
    'Group': '',
    'Sort': '17',
    'Description': 'Product ticks in sixty-forths',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '423',
    'Value': '19',
    'SymbolicName': 'ProductTicksInOneTwentyEights',
    'Group': '',
    'Sort': '18',
    'Description': 'Product ticks in one-twenty-eights',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '427',
    'Value': '0',
    'SymbolicName': 'BookOutAllTradesOnDayOfExecution',
    'Group': '',
    'Sort': '1',
    'Description': 'Book out all trades on day of execution',
    'Added': 'FIX.4.2',
    'Issue': 'SPEC-398'
  },
  {
    'Tag': '427',
    'Value': '1',
    'SymbolicName': 'AccumulateUntilFilledOrExpired',
    'Group': '',
    'Sort': '2',
    'Description': 'Accumulate executions until order is filled or expires',
    'Added': 'FIX.4.2',
    'Issue': 'SPEC-398'
  },
  {
    'Tag': '427',
    'Value': '2',
    'SymbolicName': 'AccumulateUntilVerballyNotifiedOtherwise',
    'Group': '',
    'Sort': '3',
    'Description': 'Accumulate until verbally notified otherwise',
    'Added': 'FIX.4.2',
    'Issue': 'SPEC-398'
  },
  {
    'Tag': '429',
    'Value': '1',
    'SymbolicName': 'Ack',
    'Group': '',
    'Sort': '1',
    'Description': 'Ack',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '429',
    'Value': '2',
    'SymbolicName': 'Response',
    'Group': '',
    'Sort': '2',
    'Description': 'Response',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '429',
    'Value': '3',
    'SymbolicName': 'Timed',
    'Group': '',
    'Sort': '3',
    'Description': 'Timed',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '429',
    'Value': '4',
    'SymbolicName': 'ExecStarted',
    'Group': '',
    'Sort': '4',
    'Description': 'Exec Started',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '429',
    'Value': '5',
    'SymbolicName': 'AllDone',
    'Group': '',
    'Sort': '5',
    'Description': 'All Done',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '429',
    'Value': '6',
    'SymbolicName': 'Alert',
    'Group': '',
    'Sort': '6',
    'Description': 'Alert',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '430',
    'Value': '1',
    'SymbolicName': 'Net',
    'Group': '',
    'Sort': '1',
    'Description': 'Net',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '430',
    'Value': '2',
    'SymbolicName': 'Gross',
    'Group': '',
    'Sort': '2',
    'Description': 'Gross',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '431',
    'Value': '1',
    'SymbolicName': 'InBiddingProcess',
    'Group': '',
    'Sort': '1',
    'Description': 'In bidding process',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '431',
    'Value': '2',
    'SymbolicName': 'ReceivedForExecution',
    'Group': '',
    'Sort': '2',
    'Description': 'Received for execution',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '431',
    'Value': '3',
    'SymbolicName': 'Executing',
    'Group': '',
    'Sort': '3',
    'Description': 'Executing',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '431',
    'Value': '4',
    'SymbolicName': 'Cancelling',
    'Group': '',
    'Sort': '4',
    'Description': 'Cancelling',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '431',
    'Value': '5',
    'SymbolicName': 'Alert',
    'Group': '',
    'Sort': '5',
    'Description': 'Alert',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '431',
    'Value': '6',
    'SymbolicName': 'AllDone',
    'Group': '',
    'Sort': '6',
    'Description': 'All Done',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '431',
    'Value': '7',
    'SymbolicName': 'Reject',
    'Group': '',
    'Sort': '7',
    'Description': 'Reject',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '433',
    'Value': '1',
    'SymbolicName': 'Immediate',
    'Group': '',
    'Sort': '1',
    'Description': 'Immediate',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '433',
    'Value': '2',
    'SymbolicName': 'WaitForInstruction',
    'Group': '',
    'Sort': '2',
    'Description': 'Wait for Execut Instruction (i.e. a List Execut message or phone call before proceeding with execution of the list)',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '433',
    'Value': '3',
    'SymbolicName': 'SellDriven',
    'Group': '',
    'Sort': '3',
    'Description': 'Exchange/switch CIV order - Sell driven',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '433',
    'Value': '4',
    'SymbolicName': 'BuyDrivenCashTopUp',
    'Group': '',
    'Sort': '4',
    'Description': 'Exchange/switch CIV order - Buy driven, cash top-up (i.e. additional cash will be provided to fulfill the order)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '433',
    'Value': '5',
    'SymbolicName': 'BuyDrivenCashWithdraw',
    'Group': '',
    'Sort': '5',
    'Description': 'Exchange/switch CIV order - Buy driven, cash withdraw (i.e. additional cash will not be provided to fulfill the order)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '434',
    'Value': '1',
    'SymbolicName': 'OrderCancelRequest',
    'Group': '',
    'Sort': '1',
    'Description': 'Order cancel request',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '434',
    'Value': '2',
    'SymbolicName': 'OrderCancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Order cancel/replace request',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '442',
    'Value': '1',
    'SymbolicName': 'SingleSecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Single security (default if not specified)',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '442',
    'Value': '2',
    'SymbolicName': 'IndividualLegOfAMultiLegSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Individual leg of a multi-leg security',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '442',
    'Value': '3',
    'SymbolicName': 'MultiLegSecurity',
    'Group': '',
    'Sort': '3',
    'Description': 'Multi-leg security',
    'Added': 'FIX.4.2'
  },
  {
    'Tag': '447',
    'Value': '6',
    'SymbolicName': 'UKNationalInsuranceOrPensionNumber',
    'Group': 'For PartyRole = \'InvestorID\' and for CIV',
    'Sort': '1',
    'Description': 'UK National Insurance or Pension Number',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '7',
    'SymbolicName': 'USSocialSecurityNumber',
    'Group': 'For PartyRole = \'InvestorID\' and for CIV',
    'Sort': '2',
    'Description': 'US Social Security Number',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '8',
    'SymbolicName': 'USEmployerOrTaxIDNumber',
    'Group': 'For PartyRole = \'InvestorID\' and for CIV',
    'Sort': '3',
    'Description': 'US Employer or Tax ID Number',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '9',
    'SymbolicName': 'AustralianBusinessNumber',
    'Group': 'For PartyRole = \'InvestorID\' and for CIV',
    'Sort': '4',
    'Description': 'Australian Business Number',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'A',
    'SymbolicName': 'AustralianTaxFileNumber',
    'Group': 'For PartyRole = \'InvestorID\' and for CIV',
    'Sort': '5',
    'Description': 'Australian Tax File Number',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '1',
    'SymbolicName': 'KoreanInvestorID',
    'Group': 'For PartyRole = \'InvestorID\' and for Equities',
    'Sort': '1',
    'Description': 'Korean Investor ID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '2',
    'SymbolicName': 'TaiwaneseForeignInvestorID',
    'Group': 'For PartyRole = \'InvestorID\' and for Equities',
    'Sort': '2',
    'Description': 'Taiwanese Qualified Foreign Investor ID QFII/FID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '3',
    'SymbolicName': 'TaiwaneseTradingAcct',
    'Group': 'For PartyRole = \'InvestorID\' and for Equities',
    'Sort': '3',
    'Description': 'Taiwanese Trading Acct',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '4',
    'SymbolicName': 'MalaysianCentralDepository',
    'Group': 'For PartyRole = \'InvestorID\' and for Equities',
    'Sort': '4',
    'Description': 'Malaysian Central Depository (MCD) number',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': '5',
    'SymbolicName': 'ChineseInvestorID',
    'Group': 'For PartyRole = \'InvestorID\' and for Equities',
    'Sort': '5',
    'Description': 'Chinese Investor ID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'I',
    'SymbolicName': 'ISITCAcronym',
    'Group': 'For PartyRole=\'Broker of Credit\'',
    'Sort': '1',
    'Description': 'Directed broker three character acronym as defined in ISITC \'ETC Best Practice\' guidelines document',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '447',
    'Value': 'B',
    'SymbolicName': 'BIC',
    'Group': 'For all PartyRoles',
    'Sort': '1',
    'Description': 'BIC (Bank Identification Code - SWIFT managed) code (ISO9362 - See \'Appendix 6-B\')',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'C',
    'SymbolicName': 'GeneralIdentifier',
    'Group': 'For all PartyRoles',
    'Sort': '2',
    'Description': 'Generally accepted market participant identifier (e.g. NASD mnemonic)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'D',
    'SymbolicName': 'Proprietary',
    'Group': 'For all PartyRoles',
    'Sort': '3',
    'Description': 'Proprietary / Custom code',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'E',
    'SymbolicName': 'ISOCountryCode',
    'Group': 'For all PartyRoles',
    'Sort': '4',
    'Description': 'ISO Country Code',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'F',
    'SymbolicName': 'SettlementEntityLocation',
    'Group': 'For all PartyRoles',
    'Sort': '5',
    'Description': 'Settlement Entity Location (note if Local Market Settlement use \'E=ISO Country Code\') (see \'Appendix 6-G\' for valid values)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '447',
    'Value': 'G',
    'SymbolicName': 'MIC',
    'Group': 'For all PartyRoles',
    'Sort': '6',
    'Description': 'MIC (ISO 10383 - Market Identificer Code) (See \'Appendix 6-C\')',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '447',
    'Value': 'H',
    'SymbolicName': 'CSDParticipant',
    'Group': 'For all PartyRoles',
    'Sort': '7',
    'Description': 'CSD participant/member code (e.g.. Euroclear, DTC, CREST or Kassenverein number)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '1',
    'SymbolicName': 'ExecutingFirm',
    'Group': '',
    'Sort': '1',
    'Description': 'Executing Firm (formerly FIX 4.2 ExecBroker)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '2',
    'SymbolicName': 'BrokerOfCredit',
    'Group': '',
    'Sort': '2',
    'Description': 'Broker of Credit (formerly FIX 4.2 BrokerOfCredit)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '3',
    'SymbolicName': 'ClientID',
    'Group': '',
    'Sort': '3',
    'Description': 'Client ID (formerly FIX 4.2 ClientID)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '4',
    'SymbolicName': 'ClearingFirm',
    'Group': '',
    'Sort': '4',
    'Description': 'Clearing Firm (formerly FIX 4.2 ClearingFirm)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '5',
    'SymbolicName': 'InvestorID',
    'Group': '',
    'Sort': '5',
    'Description': 'Investor ID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '6',
    'SymbolicName': 'IntroducingFirm',
    'Group': '',
    'Sort': '6',
    'Description': 'Introducing Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '7',
    'SymbolicName': 'EnteringFirm',
    'Group': '',
    'Sort': '7',
    'Description': 'Entering Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '8',
    'SymbolicName': 'Locate',
    'Group': '',
    'Sort': '8',
    'Description': 'Locate / Lending Firm (for short-sales)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '9',
    'SymbolicName': 'FundManagerClientID',
    'Group': '',
    'Sort': '9',
    'Description': 'Fund Manager Client ID (for CIV)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '10',
    'SymbolicName': 'SettlementLocation',
    'Group': '',
    'Sort': '10',
    'Description': 'Settlement Location (formerly FIX 4.2 SettlLocation)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '11',
    'SymbolicName': 'OrderOriginationTrader',
    'Group': '',
    'Sort': '11',
    'Description': 'Order Origination Trader (associated with Order Origination Firm - i.e. trader who initiates/submits the order)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '12',
    'SymbolicName': 'ExecutingTrader',
    'Group': '',
    'Sort': '12',
    'Description': 'Executing Trader (associated with Executing Firm - actually executes)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '13',
    'SymbolicName': 'OrderOriginationFirm',
    'Group': '',
    'Sort': '13',
    'Description': 'Order Origination Firm (e.g. buy-side firm)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '14',
    'SymbolicName': 'GiveupClearingFirm',
    'Group': '',
    'Sort': '14',
    'Description': 'Giveup Clearing Firm (firm to which trade is given up)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '15',
    'SymbolicName': 'CorrespondantClearingFirm',
    'Group': '',
    'Sort': '15',
    'Description': 'Correspondant Clearing Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '16',
    'SymbolicName': 'ExecutingSystem',
    'Group': '',
    'Sort': '16',
    'Description': 'Executing System',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '17',
    'SymbolicName': 'ContraFirm',
    'Group': '',
    'Sort': '17',
    'Description': 'Contra Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '18',
    'SymbolicName': 'ContraClearingFirm',
    'Group': '',
    'Sort': '18',
    'Description': 'Contra Clearing Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '19',
    'SymbolicName': 'SponsoringFirm',
    'Group': '',
    'Sort': '19',
    'Description': 'Sponsoring Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '20',
    'SymbolicName': 'UnderlyingContraFirm',
    'Group': '',
    'Sort': '20',
    'Description': 'Underlying Contra Firm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '452',
    'Value': '21',
    'SymbolicName': 'ClearingOrganization',
    'Group': '',
    'Sort': '21',
    'Description': 'Clearing Organization',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '22',
    'SymbolicName': 'Exchange',
    'Group': '',
    'Sort': '22',
    'Description': 'Exchange',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '24',
    'SymbolicName': 'CustomerAccount',
    'Group': '',
    'Sort': '24',
    'Description': 'Customer Account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '25',
    'SymbolicName': 'CorrespondentClearingOrganization',
    'Group': '',
    'Sort': '25',
    'Description': 'Correspondent Clearing Organization',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '26',
    'SymbolicName': 'CorrespondentBroker',
    'Group': '',
    'Sort': '26',
    'Description': 'Correspondent Broker',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '27',
    'SymbolicName': 'Buyer',
    'Group': '',
    'Sort': '27',
    'Description': 'Buyer/Seller (Receiver/Deliverer)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '28',
    'SymbolicName': 'Custodian',
    'Group': '',
    'Sort': '28',
    'Description': 'Custodian',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '29',
    'SymbolicName': 'Intermediary',
    'Group': '',
    'Sort': '29',
    'Description': 'Intermediary',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '30',
    'SymbolicName': 'Agent',
    'Group': '',
    'Sort': '30',
    'Description': 'Agent',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '31',
    'SymbolicName': 'SubCustodian',
    'Group': '',
    'Sort': '31',
    'Description': 'Sub-custodian',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '32',
    'SymbolicName': 'Beneficiary',
    'Group': '',
    'Sort': '32',
    'Description': 'Beneficiary',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '33',
    'SymbolicName': 'InterestedParty',
    'Group': '',
    'Sort': '33',
    'Description': 'Interested party',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '34',
    'SymbolicName': 'RegulatoryBody',
    'Group': '',
    'Sort': '34',
    'Description': 'Regulatory body',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '35',
    'SymbolicName': 'LiquidityProvider',
    'Group': '',
    'Sort': '35',
    'Description': 'Liquidity provider',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '36',
    'SymbolicName': 'EnteringTrader',
    'Group': '',
    'Sort': '36',
    'Description': 'Entering trader',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '37',
    'SymbolicName': 'ContraTrader',
    'Group': '',
    'Sort': '37',
    'Description': 'Contra trader',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '38',
    'SymbolicName': 'PositionAccount',
    'Group': '',
    'Sort': '38',
    'Description': 'Position account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '452',
    'Value': '39',
    'SymbolicName': 'ContraInvestorID',
    'Group': '',
    'Sort': '39',
    'Description': 'Contra Investor ID',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '452',
    'Value': '40',
    'SymbolicName': 'TransferToFirm',
    'Group': '',
    'Sort': '40',
    'Description': 'Transfer to Firm',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '452',
    'Value': '41',
    'SymbolicName': 'ContraPositionAccount',
    'Group': '',
    'Sort': '41',
    'Description': 'Contra Position Account',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '452',
    'Value': '42',
    'SymbolicName': 'ContraExchange',
    'Group': '',
    'Sort': '42',
    'Description': 'Contra Exchange',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '452',
    'Value': '43',
    'SymbolicName': 'InternalCarryAccount',
    'Group': '',
    'Sort': '43',
    'Description': 'Internal Carry Account',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '452',
    'Value': '44',
    'SymbolicName': 'OrderEntryOperatorID',
    'Group': '',
    'Sort': '44',
    'Description': 'Order Entry Operator ID',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '452',
    'Value': '45',
    'SymbolicName': 'SecondaryAccountNumber',
    'Group': '',
    'Sort': '45',
    'Description': 'Secondary Account Number',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '452',
    'Value': '46',
    'SymbolicName': 'ForeignFirm',
    'Group': '',
    'Sort': '46',
    'Description': 'Foreign Firm',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '47',
    'SymbolicName': 'ThirdPartyAllocationFirm',
    'Group': '',
    'Sort': '47',
    'Description': 'Third Party Allocation Firm',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '48',
    'SymbolicName': 'ClaimingAccount',
    'Group': '',
    'Sort': '48',
    'Description': 'Claiming Account',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '49',
    'SymbolicName': 'AssetManager',
    'Group': '',
    'Sort': '49',
    'Description': 'Asset Manager',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '50',
    'SymbolicName': 'PledgorAccount',
    'Group': '',
    'Sort': '50',
    'Description': 'Pledgor Account',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '51',
    'SymbolicName': 'PledgeeAccount',
    'Group': '',
    'Sort': '51',
    'Description': 'Pledgee Account',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '52',
    'SymbolicName': 'LargeTraderReportableAccount',
    'Group': '',
    'Sort': '52',
    'Description': 'Large Trader Reportable Account',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '53',
    'SymbolicName': 'TraderMnemonic',
    'Group': '',
    'Sort': '53',
    'Description': 'Trader mnemonic',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '54',
    'SymbolicName': 'SenderLocation',
    'Group': '',
    'Sort': '54',
    'Description': 'Sender Location',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '55',
    'SymbolicName': 'SessionID',
    'Group': '',
    'Sort': '55',
    'Description': 'Session ID',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '452',
    'Value': '56',
    'SymbolicName': 'AcceptableCounterparty',
    'Group': '',
    'Sort': '56',
    'Description': 'Acceptable Counterparty',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '452',
    'Value': '57',
    'SymbolicName': 'UnacceptableCounterparty',
    'Group': '',
    'Sort': '57',
    'Description': 'Unacceptable Counterparty',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '452',
    'Value': '58',
    'SymbolicName': 'EnteringUnit',
    'Group': '',
    'Sort': '58',
    'Description': 'Entering Unit',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '452',
    'Value': '59',
    'SymbolicName': 'ExecutingUnit',
    'Group': '',
    'Sort': '59',
    'Description': 'Executing Unit',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '452',
    'Value': '60',
    'SymbolicName': 'IntroducingBroker',
    'Group': '',
    'Sort': '60',
    'Description': 'Introducing Broker',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '452',
    'Value': '61',
    'SymbolicName': 'QuoteOriginator',
    'Group': '',
    'Sort': '61',
    'Description': 'Quote originator',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '62',
    'SymbolicName': 'ReportOriginator',
    'Group': '',
    'Sort': '62',
    'Description': 'Report originator',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '63',
    'SymbolicName': 'SystematicInternaliser',
    'Group': '',
    'Sort': '63',
    'Description': 'Systematic internaliser (SI)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '64',
    'SymbolicName': 'MultilateralTradingFacility',
    'Group': '',
    'Sort': '64',
    'Description': 'Multilateral Trading Facility (MTF)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '65',
    'SymbolicName': 'RegulatedMarket',
    'Group': '',
    'Sort': '65',
    'Description': 'Regulated Market (RM)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '66',
    'SymbolicName': 'MarketMaker',
    'Group': '',
    'Sort': '66',
    'Description': 'Market Maker',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '67',
    'SymbolicName': 'InvestmentFirm',
    'Group': '',
    'Sort': '67',
    'Description': 'Investment Firm',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '68',
    'SymbolicName': 'HostCompetentAuthority',
    'Group': '',
    'Sort': '68',
    'Description': 'Host Competent Authority (Host CA)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '69',
    'SymbolicName': 'HomeCompetentAuthority',
    'Group': '',
    'Sort': '69',
    'Description': 'Home Competent Authority (Home CA)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '70',
    'SymbolicName': 'CompetentAuthorityLiquidity',
    'Group': '',
    'Sort': '70',
    'Description': 'Competent Authority of the most relevant market in terms of liquidity (CAL)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '71',
    'SymbolicName': 'CompetentAuthorityTransactionVenue',
    'Group': '',
    'Sort': '71',
    'Description': 'Competent Authority of the Transaction (Execution) Venue (CATV)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '72',
    'SymbolicName': 'ReportingIntermediary',
    'Group': '',
    'Sort': '72',
    'Description': 'Reporting intermediary (medium/vendor via which report has been published)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '73',
    'SymbolicName': 'ExecutionVenue',
    'Group': '',
    'Sort': '73',
    'Description': 'Execution Venue',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '74',
    'SymbolicName': 'MarketDataEntryOriginator',
    'Group': '',
    'Sort': '74',
    'Description': 'Market data entry originator',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '75',
    'SymbolicName': 'LocationID',
    'Group': '',
    'Sort': '75',
    'Description': 'Location ID',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '76',
    'SymbolicName': 'DeskID',
    'Group': '',
    'Sort': '76',
    'Description': 'Desk ID',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '77',
    'SymbolicName': 'MarketDataMarket',
    'Group': '',
    'Sort': '77',
    'Description': 'Market data market',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '452',
    'Value': '78',
    'SymbolicName': 'AllocationEntity',
    'Group': '',
    'Sort': '78',
    'Description': 'Allocation Entity',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '452',
    'Value': '79',
    'SymbolicName': 'PrimeBroker',
    'Group': '',
    'Sort': '79',
    'Description': 'Prime Broker providing General Trade Services',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '452',
    'Value': '80',
    'SymbolicName': 'StepOutFirm',
    'Group': '',
    'Sort': '80',
    'Description': 'Step-Out Firm (Prime Broker)',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '452',
    'Value': '81',
    'SymbolicName': 'BrokerClearingID',
    'Group': '',
    'Sort': '81',
    'Description': 'BrokerClearingID',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '460',
    'Value': '1',
    'SymbolicName': 'AGENCY',
    'Group': '',
    'Sort': '1',
    'Description': 'AGENCY',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '2',
    'SymbolicName': 'COMMODITY',
    'Group': '',
    'Sort': '2',
    'Description': 'COMMODITY',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '3',
    'SymbolicName': 'CORPORATE',
    'Group': '',
    'Sort': '3',
    'Description': 'CORPORATE',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '4',
    'SymbolicName': 'CURRENCY',
    'Group': '',
    'Sort': '4',
    'Description': 'CURRENCY',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '5',
    'SymbolicName': 'EQUITY',
    'Group': '',
    'Sort': '5',
    'Description': 'EQUITY',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '6',
    'SymbolicName': 'GOVERNMENT',
    'Group': '',
    'Sort': '6',
    'Description': 'GOVERNMENT',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '7',
    'SymbolicName': 'INDEX',
    'Group': '',
    'Sort': '7',
    'Description': 'INDEX',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '8',
    'SymbolicName': 'LOAN',
    'Group': '',
    'Sort': '8',
    'Description': 'LOAN',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '9',
    'SymbolicName': 'MONEYMARKET',
    'Group': '',
    'Sort': '9',
    'Description': 'MONEYMARKET',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '10',
    'SymbolicName': 'MORTGAGE',
    'Group': '',
    'Sort': '10',
    'Description': 'MORTGAGE',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '11',
    'SymbolicName': 'MUNICIPAL',
    'Group': '',
    'Sort': '11',
    'Description': 'MUNICIPAL',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '12',
    'SymbolicName': 'OTHER',
    'Group': '',
    'Sort': '12',
    'Description': 'OTHER',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '460',
    'Value': '13',
    'SymbolicName': 'FINANCING',
    'Group': '',
    'Sort': '13',
    'Description': 'FINANCING',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '464',
    'Value': 'N',
    'SymbolicName': 'Fales',
    'Group': '',
    'Sort': '1',
    'Description': 'Fales (Production)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '464',
    'Value': 'Y',
    'SymbolicName': 'True',
    'Group': '',
    'Sort': '2',
    'Description': 'True (Test)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '1',
    'SymbolicName': 'SHARES',
    'Group': '',
    'Sort': '1',
    'Description': 'SHARES',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '2',
    'SymbolicName': 'BONDS',
    'Group': '',
    'Sort': '2',
    'Description': 'BONDS',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '3',
    'SymbolicName': 'CURRENTFACE',
    'Group': '',
    'Sort': '3',
    'Description': 'CURRENTFACE',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '4',
    'SymbolicName': 'ORIGINALFACE',
    'Group': '',
    'Sort': '4',
    'Description': 'ORIGINALFACE',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '5',
    'SymbolicName': 'CURRENCY',
    'Group': '',
    'Sort': '5',
    'Description': 'CURRENCY',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '6',
    'SymbolicName': 'CONTRACTS',
    'Group': '',
    'Sort': '6',
    'Description': 'CONTRACTS',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '7',
    'SymbolicName': 'OTHER',
    'Group': '',
    'Sort': '7',
    'Description': 'OTHER',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '465',
    'Value': '8',
    'SymbolicName': 'PAR',
    'Group': '',
    'Sort': '8',
    'Description': 'PAR',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '468',
    'Value': '0',
    'SymbolicName': 'RoundToNearest',
    'Group': '',
    'Sort': '1',
    'Description': 'Round to nearest',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '468',
    'Value': '1',
    'SymbolicName': 'RoundDown',
    'Group': '',
    'Sort': '2',
    'Description': 'Round down',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '468',
    'Value': '2',
    'SymbolicName': 'RoundUp',
    'Group': '',
    'Sort': '3',
    'Description': 'Round up',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '477',
    'Value': '1',
    'SymbolicName': 'CREST',
    'Group': '',
    'Sort': '1',
    'Description': 'CREST',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '2',
    'SymbolicName': 'NSCC',
    'Group': '',
    'Sort': '2',
    'Description': 'NSCC',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '3',
    'SymbolicName': 'Euroclear',
    'Group': '',
    'Sort': '3',
    'Description': 'Euroclear',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '4',
    'SymbolicName': 'Clearstream',
    'Group': '',
    'Sort': '4',
    'Description': 'Clearstream',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '5',
    'SymbolicName': 'Cheque',
    'Group': '',
    'Sort': '5',
    'Description': 'Cheque',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '6',
    'SymbolicName': 'TelegraphicTransfer',
    'Group': '',
    'Sort': '6',
    'Description': 'Telegraphic Transfer',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '7',
    'SymbolicName': 'FedWire',
    'Group': '',
    'Sort': '7',
    'Description': 'Fed Wire',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '8',
    'SymbolicName': 'DirectCredit',
    'Group': '',
    'Sort': '8',
    'Description': 'Direct Credit (BECS, BACS)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '9',
    'SymbolicName': 'ACHCredit',
    'Group': '',
    'Sort': '9',
    'Description': 'ACH Credit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '10',
    'SymbolicName': 'BPAY',
    'Group': '',
    'Sort': '10',
    'Description': 'BPAY',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '11',
    'SymbolicName': 'HighValueClearingSystemHVACS',
    'Group': '',
    'Sort': '11',
    'Description': 'High Value Clearing System HVACS',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '477',
    'Value': '12',
    'SymbolicName': 'ReinvestInFund',
    'Group': '',
    'Sort': '12',
    'Description': 'Reinvest In Fund',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '480',
    'Value': 'Y',
    'SymbolicName': 'Yes',
    'Group': '',
    'Sort': '1',
    'Description': 'Yes',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '480',
    'Value': 'N',
    'SymbolicName': 'NoExecutionOnly',
    'Group': '',
    'Sort': '2',
    'Description': 'No - Execution Only',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '480',
    'Value': 'M',
    'SymbolicName': 'NoWaiverAgreement',
    'Group': '',
    'Sort': '3',
    'Description': 'No - Waiver agreement',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '480',
    'Value': 'O',
    'SymbolicName': 'NoInstitutional',
    'Group': '',
    'Sort': '4',
    'Description': 'No - Institutional',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '481',
    'Value': 'Y',
    'SymbolicName': 'Passed',
    'Group': '',
    'Sort': '1',
    'Description': 'Passed',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '481',
    'Value': 'N',
    'SymbolicName': 'NotChecked',
    'Group': '',
    'Sort': '2',
    'Description': 'Not Checked',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '481',
    'Value': '1',
    'SymbolicName': 'ExemptBelowLimit',
    'Group': '',
    'Sort': '3',
    'Description': 'Exempt - Below the Limit',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '481',
    'Value': '2',
    'SymbolicName': 'ExemptMoneyType',
    'Group': '',
    'Sort': '4',
    'Description': 'Exempt - Client Money Type exemption',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '481',
    'Value': '3',
    'SymbolicName': 'ExemptAuthorised',
    'Group': '',
    'Sort': '5',
    'Description': 'Exempt - Authorised Credit or financial institution',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'B',
    'SymbolicName': 'BidPrice',
    'Group': '',
    'Sort': '1',
    'Description': 'Bid price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'C',
    'SymbolicName': 'CreationPrice',
    'Group': '',
    'Sort': '2',
    'Description': 'Creation price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'D',
    'SymbolicName': 'CreationPricePlusAdjustmentPercent',
    'Group': '',
    'Sort': '3',
    'Description': 'Creation price plus adjustment percent',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'E',
    'SymbolicName': 'CreationPricePlusAdjustmentAmount',
    'Group': '',
    'Sort': '4',
    'Description': 'Creation price plus adjustment amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'O',
    'SymbolicName': 'OfferPrice',
    'Group': '',
    'Sort': '5',
    'Description': 'Offer price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'P',
    'SymbolicName': 'OfferPriceMinusAdjustmentPercent',
    'Group': '',
    'Sort': '6',
    'Description': 'Offer price minus adjustment percent',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'Q',
    'SymbolicName': 'OfferPriceMinusAdjustmentAmount',
    'Group': '',
    'Sort': '7',
    'Description': 'Offer price minus adjustment amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '484',
    'Value': 'S',
    'SymbolicName': 'SinglePrice',
    'Group': '',
    'Sort': '8',
    'Description': 'Single price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '487',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '487',
    'Value': '1',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '487',
    'Value': '2',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '3',
    'Description': 'Replace',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '487',
    'Value': '3',
    'SymbolicName': 'Release',
    'Group': '',
    'Sort': '4',
    'Description': 'Release',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '487',
    'Value': '4',
    'SymbolicName': 'Reverse',
    'Group': '',
    'Sort': '5',
    'Description': 'Reverse',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '487',
    'Value': '5',
    'SymbolicName': 'CancelDueToBackOutOfTrade',
    'Group': '',
    'Sort': '6',
    'Description': 'Cancel Due To Back Out of Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '492',
    'Value': '1',
    'SymbolicName': 'CREST',
    'Group': '',
    'Sort': '1',
    'Description': 'CREST',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '2',
    'SymbolicName': 'NSCC',
    'Group': '',
    'Sort': '2',
    'Description': 'NSCC',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '3',
    'SymbolicName': 'Euroclear',
    'Group': '',
    'Sort': '3',
    'Description': 'Euroclear',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '4',
    'SymbolicName': 'Clearstream',
    'Group': '',
    'Sort': '4',
    'Description': 'Clearstream',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '5',
    'SymbolicName': 'Cheque',
    'Group': '',
    'Sort': '5',
    'Description': 'Cheque',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '6',
    'SymbolicName': 'TelegraphicTransfer',
    'Group': '',
    'Sort': '6',
    'Description': 'Telegraphic Transfer',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '7',
    'SymbolicName': 'FedWire',
    'Group': '',
    'Sort': '7',
    'Description': 'Fed Wire',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '8',
    'SymbolicName': 'DebitCard',
    'Group': '',
    'Sort': '8',
    'Description': 'Debit Card',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '9',
    'SymbolicName': 'DirectDebit',
    'Group': '',
    'Sort': '9',
    'Description': 'Direct Debit (BECS)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '10',
    'SymbolicName': 'DirectCredit',
    'Group': '',
    'Sort': '10',
    'Description': 'Direct Credit (BECS)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '11',
    'SymbolicName': 'CreditCard',
    'Group': '',
    'Sort': '11',
    'Description': 'Credit Card',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '12',
    'SymbolicName': 'ACHDebit',
    'Group': '',
    'Sort': '12',
    'Description': 'ACH Debit',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '13',
    'SymbolicName': 'ACHCredit',
    'Group': '',
    'Sort': '13',
    'Description': 'ACH Credit',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '14',
    'SymbolicName': 'BPAY',
    'Group': '',
    'Sort': '14',
    'Description': 'BPAY',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '492',
    'Value': '15',
    'SymbolicName': 'HighValueClearingSystem',
    'Group': '',
    'Sort': '15',
    'Description': 'High Value Clearing System (HVACS)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '0',
    'SymbolicName': 'None',
    'Group': '',
    'Sort': '0',
    'Description': 'None/Not Applicable (default)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '1',
    'SymbolicName': 'MaxiISA',
    'Group': '',
    'Sort': '1',
    'Description': 'Maxi ISA (UK)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '2',
    'SymbolicName': 'TESSA',
    'Group': '',
    'Sort': '2',
    'Description': 'TESSA (UK)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '3',
    'SymbolicName': 'MiniCashISA',
    'Group': '',
    'Sort': '3',
    'Description': 'Mini Cash ISA (UK)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '4',
    'SymbolicName': 'MiniStocksAndSharesISA',
    'Group': '',
    'Sort': '4',
    'Description': 'Mini Stocks And Shares ISA (UK)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '5',
    'SymbolicName': 'MiniInsuranceISA',
    'Group': '',
    'Sort': '5',
    'Description': 'Mini Insurance ISA (UK)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '6',
    'SymbolicName': 'CurrentYearPayment',
    'Group': '',
    'Sort': '6',
    'Description': 'Current Year Payment (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '7',
    'SymbolicName': 'PriorYearPayment',
    'Group': '',
    'Sort': '7',
    'Description': 'Prior Year Payment (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '8',
    'SymbolicName': 'AssetTransfer',
    'Group': '',
    'Sort': '8',
    'Description': 'Asset Transfer (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '9',
    'SymbolicName': 'EmployeePriorYear',
    'Group': '',
    'Sort': '9',
    'Description': 'Employee - prior year (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '10',
    'SymbolicName': 'EmployeeCurrentYear',
    'Group': '',
    'Sort': '10',
    'Description': 'Employee - current year (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '11',
    'SymbolicName': 'EmployerPriorYear',
    'Group': '',
    'Sort': '11',
    'Description': 'Employer - prior year (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '12',
    'SymbolicName': 'EmployerCurrentYear',
    'Group': '',
    'Sort': '12',
    'Description': 'Employer - current year (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '13',
    'SymbolicName': 'NonFundPrototypeIRA',
    'Group': '',
    'Sort': '13',
    'Description': 'Non-fund prototype IRA (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '14',
    'SymbolicName': 'NonFundQualifiedPlan',
    'Group': '',
    'Sort': '14',
    'Description': 'Non-fund qualified plan (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '15',
    'SymbolicName': 'DefinedContributionPlan',
    'Group': '',
    'Sort': '15',
    'Description': 'Defined contribution plan (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '16',
    'SymbolicName': 'IRA',
    'Group': '',
    'Sort': '16',
    'Description': 'Individual Retirement Account (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '17',
    'SymbolicName': 'IRARollover',
    'Group': '',
    'Sort': '17',
    'Description': 'Individual Retirement Account - Rollover (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '18',
    'SymbolicName': 'KEOGH',
    'Group': '',
    'Sort': '18',
    'Description': 'KEOGH (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '19',
    'SymbolicName': 'ProfitSharingPlan',
    'Group': '',
    'Sort': '19',
    'Description': 'Profit Sharing Plan (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '20',
    'SymbolicName': 'US401K',
    'Group': '',
    'Sort': '20',
    'Description': '401(k) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '21',
    'SymbolicName': 'SelfDirectedIRA',
    'Group': '',
    'Sort': '21',
    'Description': 'Self-directed IRA (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '22',
    'SymbolicName': 'US403b',
    'Group': '',
    'Sort': '22',
    'Description': '403(b) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '23',
    'SymbolicName': 'US457',
    'Group': '',
    'Sort': '23',
    'Description': '457 (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '24',
    'SymbolicName': 'RothIRAPrototype',
    'Group': '',
    'Sort': '24',
    'Description': 'Roth IRA (Fund Prototype) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '25',
    'SymbolicName': 'RothIRANonPrototype',
    'Group': '',
    'Sort': '25',
    'Description': 'Roth IRA (Non-prototype) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '26',
    'SymbolicName': 'RothConversionIRAPrototype',
    'Group': '',
    'Sort': '26',
    'Description': 'Roth Conversion IRA (Fund Prototype) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '27',
    'SymbolicName': 'RothConversionIRANonPrototype',
    'Group': '',
    'Sort': '27',
    'Description': 'Roth Conversion IRA (Non-prototype) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '28',
    'SymbolicName': 'EducationIRAPrototype',
    'Group': '',
    'Sort': '28',
    'Description': 'Education IRA (Fund Prototype) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '29',
    'SymbolicName': 'EducationIRANonPrototype',
    'Group': '',
    'Sort': '29',
    'Description': 'Education IRA (Non-prototype) (US)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '495',
    'Value': '999',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '497',
    'Value': 'N',
    'SymbolicName': 'No',
    'Group': '',
    'Sort': '1',
    'Description': 'No',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '497',
    'Value': 'Y',
    'SymbolicName': 'Yes',
    'Group': '',
    'Sort': '2',
    'Description': 'Yes',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '506',
    'Value': 'A',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '506',
    'Value': 'R',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '2',
    'Description': 'Rejected',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '506',
    'Value': 'H',
    'SymbolicName': 'Held',
    'Group': '',
    'Sort': '3',
    'Description': 'Held',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '506',
    'Value': 'N',
    'SymbolicName': 'Reminder',
    'Group': '',
    'Sort': '4',
    'Description': 'Reminder - i.e. Registration Instructions are still outstanding',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '1',
    'SymbolicName': 'InvalidAccountType',
    'Group': '',
    'Sort': '1',
    'Description': 'Invalid/unacceptable Account Type',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '2',
    'SymbolicName': 'InvalidTaxExemptType',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid/unacceptable Tax Exempt Type',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '3',
    'SymbolicName': 'InvalidOwnershipType',
    'Group': '',
    'Sort': '3',
    'Description': 'Invalid/unacceptable Ownership Type',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '4',
    'SymbolicName': 'NoRegDetails',
    'Group': '',
    'Sort': '4',
    'Description': 'Invalid/unacceptable No Reg Details',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '5',
    'SymbolicName': 'InvalidRegSeqNo',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid/unacceptable Reg Seq No',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '6',
    'SymbolicName': 'InvalidRegDetails',
    'Group': '',
    'Sort': '6',
    'Description': 'Invalid/unacceptable Reg Details',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '7',
    'SymbolicName': 'InvalidMailingDetails',
    'Group': '',
    'Sort': '7',
    'Description': 'Invalid/unacceptable Mailing Details',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '8',
    'SymbolicName': 'InvalidMailingInstructions',
    'Group': '',
    'Sort': '8',
    'Description': 'Invalid/unacceptable Mailing Instructions',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '9',
    'SymbolicName': 'InvalidInvestorID',
    'Group': '',
    'Sort': '9',
    'Description': 'Invalid/unacceptable Investor ID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '10',
    'SymbolicName': 'InvalidInvestorIDSource',
    'Group': '',
    'Sort': '10',
    'Description': 'Invalid/unaceeptable Investor ID Source',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '11',
    'SymbolicName': 'InvalidDateOfBirth',
    'Group': '',
    'Sort': '11',
    'Description': 'Invalid/unacceptable Date Of Birth',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '12',
    'SymbolicName': 'InvalidCountry',
    'Group': '',
    'Sort': '12',
    'Description': 'Invalid/unacceptable Investor Country Of Residence',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '13',
    'SymbolicName': 'InvalidDistribInstns',
    'Group': '',
    'Sort': '13',
    'Description': 'Invalid/unacceptable No Distrib Instns',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '14',
    'SymbolicName': 'InvalidPercentage',
    'Group': '',
    'Sort': '14',
    'Description': 'Invalid/unacceptable Distrib Percentage',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '15',
    'SymbolicName': 'InvalidPaymentMethod',
    'Group': '',
    'Sort': '15',
    'Description': 'Invalid/unacceptable Distrib Payment Method',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '16',
    'SymbolicName': 'InvalidAccountName',
    'Group': '',
    'Sort': '16',
    'Description': 'Invalid/unacceptable Cash Distrib Agent Acct Name',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '17',
    'SymbolicName': 'InvalidAgentCode',
    'Group': '',
    'Sort': '17',
    'Description': 'Invalid/unacceptable Cash Distrib Agent Code',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '18',
    'SymbolicName': 'InvalidAccountNum',
    'Group': '',
    'Sort': '18',
    'Description': 'Invalid/unacceptable Cash Distrib Agent Acct Num',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '507',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '514',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '514',
    'Value': '2',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '514',
    'Value': '1',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '3',
    'Description': 'Replace',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '517',
    'Value': 'J',
    'SymbolicName': 'JointInvestors',
    'Group': '',
    'Sort': '1',
    'Description': 'Joint Investors',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '517',
    'Value': 'T',
    'SymbolicName': 'TenantsInCommon',
    'Group': '',
    'Sort': '2',
    'Description': 'Tenants in Common',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '517',
    'Value': '2',
    'SymbolicName': 'JointTrustees',
    'Group': '',
    'Sort': '3',
    'Description': 'Joint Trustees',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '519',
    'Value': '1',
    'SymbolicName': 'CommissionAmount',
    'Group': '',
    'Sort': '1',
    'Description': 'Commission amount (actual)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '2',
    'SymbolicName': 'CommissionPercent',
    'Group': '',
    'Sort': '2',
    'Description': 'Commission percent (actual)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '3',
    'SymbolicName': 'InitialChargeAmount',
    'Group': '',
    'Sort': '3',
    'Description': 'Initial Charge Amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '4',
    'SymbolicName': 'InitialChargePercent',
    'Group': '',
    'Sort': '4',
    'Description': 'Initial Charge Percent',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '5',
    'SymbolicName': 'DiscountAmount',
    'Group': '',
    'Sort': '5',
    'Description': 'Discount Amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '6',
    'SymbolicName': 'DiscountPercent',
    'Group': '',
    'Sort': '6',
    'Description': 'Discount Percent',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '7',
    'SymbolicName': 'DilutionLevyAmount',
    'Group': '',
    'Sort': '7',
    'Description': 'Dilution Levy Amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '8',
    'SymbolicName': 'DilutionLevyPercent',
    'Group': '',
    'Sort': '8',
    'Description': 'Dilution Levy Percent',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '9',
    'SymbolicName': 'ExitChargeAmount',
    'Group': '',
    'Sort': '9',
    'Description': 'Exit Charge Amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '10',
    'SymbolicName': 'ExitChargePercent',
    'Group': '',
    'Sort': '10',
    'Description': 'Exit Charge Percent',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '11',
    'SymbolicName': 'FundBasedRenewalCommissionPercent',
    'Group': '',
    'Sort': '11',
    'Description': 'Fund-Based Renewal Commission Percent (a.k.a. Trail commission)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '12',
    'SymbolicName': 'ProjectedFundValue',
    'Group': '',
    'Sort': '12',
    'Description': 'Projected Fund Value (i.e. for investments intended to realise or exceed a specific future value)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '13',
    'SymbolicName': 'FundBasedRenewalCommissionOnOrder',
    'Group': '',
    'Sort': '13',
    'Description': 'Fund-Based Renewal Commission Amount (based on Order value)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '14',
    'SymbolicName': 'FundBasedRenewalCommissionOnFund',
    'Group': '',
    'Sort': '14',
    'Description': 'Fund-Based Renewal Commission Amount (based on Projected Fund value)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '519',
    'Value': '15',
    'SymbolicName': 'NetSettlementAmount',
    'Group': '',
    'Sort': '15',
    'Description': 'Net Settlement Amount',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '1',
    'SymbolicName': 'IndividualInvestor',
    'Group': '',
    'Sort': '1',
    'Description': 'Individual Investor',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '2',
    'SymbolicName': 'PublicCompany',
    'Group': '',
    'Sort': '2',
    'Description': 'Public Company',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '3',
    'SymbolicName': 'PrivateCompany',
    'Group': '',
    'Sort': '3',
    'Description': 'Private Company',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '4',
    'SymbolicName': 'IndividualTrustee',
    'Group': '',
    'Sort': '4',
    'Description': 'Individual Trustee',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '5',
    'SymbolicName': 'CompanyTrustee',
    'Group': '',
    'Sort': '5',
    'Description': 'Company Trustee',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '6',
    'SymbolicName': 'PensionPlan',
    'Group': '',
    'Sort': '6',
    'Description': 'Pension Plan',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '7',
    'SymbolicName': 'CustodianUnderGiftsToMinorsAct',
    'Group': '',
    'Sort': '7',
    'Description': 'Custodian Under Gifts to Minors Act',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '8',
    'SymbolicName': 'Trusts',
    'Group': '',
    'Sort': '8',
    'Description': 'Trusts',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '9',
    'SymbolicName': 'Fiduciaries',
    'Group': '',
    'Sort': '9',
    'Description': 'Fiduciaries',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '10',
    'SymbolicName': 'NetworkingSubAccount',
    'Group': '',
    'Sort': '10',
    'Description': 'Networking Sub-account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '11',
    'SymbolicName': 'NonProfitOrganization',
    'Group': '',
    'Sort': '11',
    'Description': 'Non-profit organization',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '12',
    'SymbolicName': 'CorporateBody',
    'Group': '',
    'Sort': '12',
    'Description': 'Corporate Body',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '522',
    'Value': '13',
    'SymbolicName': 'Nominee',
    'Group': '',
    'Sort': '13',
    'Description': 'Nominee',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '528',
    'Value': 'A',
    'SymbolicName': 'Agency',
    'Group': '',
    'Sort': '1',
    'Description': 'Agency',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '528',
    'Value': 'G',
    'SymbolicName': 'Proprietary',
    'Group': '',
    'Sort': '2',
    'Description': 'Proprietary',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '528',
    'Value': 'I',
    'SymbolicName': 'Individual',
    'Group': '',
    'Sort': '3',
    'Description': 'Individual',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '528',
    'Value': 'P',
    'SymbolicName': 'Principal',
    'Group': '',
    'Sort': '4',
    'Description': 'Principal (Note for CMS purposes, \'Principal\' includes \'Proprietary\')',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '528',
    'Value': 'R',
    'SymbolicName': 'RisklessPrincipal',
    'Group': '',
    'Sort': '5',
    'Description': 'Riskless Principal',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '528',
    'Value': 'W',
    'SymbolicName': 'AgentForOtherMember',
    'Group': '',
    'Sort': '6',
    'Description': 'Agent for Other Member',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '1',
    'SymbolicName': 'ProgramTrade',
    'Group': '',
    'Sort': '1',
    'Description': 'Program Trade',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '2',
    'SymbolicName': 'IndexArbitrage',
    'Group': '',
    'Sort': '2',
    'Description': 'Index Arbitrage',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '3',
    'SymbolicName': 'NonIndexArbitrage',
    'Group': '',
    'Sort': '3',
    'Description': 'Non-Index Arbitrage',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '4',
    'SymbolicName': 'CompetingMarketMaker',
    'Group': '',
    'Sort': '4',
    'Description': 'Competing Market Maker',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '5',
    'SymbolicName': 'ActingAsMarketMakerOrSpecialistInSecurity',
    'Group': '',
    'Sort': '5',
    'Description': 'Acting as Market Maker or Specialist in the security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '6',
    'SymbolicName': 'ActingAsMarketMakerOrSpecialistInUnderlying',
    'Group': '',
    'Sort': '6',
    'Description': 'Acting as Market Maker or Specialist in the underlying security of a derivative security',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '7',
    'SymbolicName': 'ForeignEntity',
    'Group': '',
    'Sort': '7',
    'Description': 'Foreign Entity (of foreign government or regulatory jurisdiction)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '8',
    'SymbolicName': 'ExternalMarketParticipant',
    'Group': '',
    'Sort': '8',
    'Description': 'External Market Participant',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': '9',
    'SymbolicName': 'ExternalInterConnectedMarketLinkage',
    'Group': '',
    'Sort': '9',
    'Description': 'External Inter-connected Market Linkage',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': 'A',
    'SymbolicName': 'RisklessArbitrage',
    'Group': '',
    'Sort': '10',
    'Description': 'Riskless Arbitrage',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '529',
    'Value': 'B',
    'SymbolicName': 'IssuerHolding',
    'Group': '',
    'Sort': '11',
    'Description': 'Issuer Holding',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '529',
    'Value': 'C',
    'SymbolicName': 'IssuePriceStabilization',
    'Group': '',
    'Sort': '12',
    'Description': 'Issue Price Stabilization',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '529',
    'Value': 'D',
    'SymbolicName': 'NonAlgorithmic',
    'Group': '',
    'Sort': '13',
    'Description': 'Non-algorithmic',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '529',
    'Value': 'E',
    'SymbolicName': 'Algorithmic',
    'Group': '',
    'Sort': '14',
    'Description': 'Algorithmic',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '530',
    'Value': '1',
    'SymbolicName': 'CancelOrdersForASecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel orders for a security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '2',
    'SymbolicName': 'CancelOrdersForAnUnderlyingSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel orders for an underlying security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '3',
    'SymbolicName': 'CancelOrdersForAProduct',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel orders for a Product',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '4',
    'SymbolicName': 'CancelOrdersForACFICode',
    'Group': '',
    'Sort': '4',
    'Description': 'Cancel orders for a CFICode',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '5',
    'SymbolicName': 'CancelOrdersForASecurityType',
    'Group': '',
    'Sort': '5',
    'Description': 'Cancel orders for a SecurityType',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '6',
    'SymbolicName': 'CancelOrdersForATradingSession',
    'Group': '',
    'Sort': '6',
    'Description': 'Cancel orders for a trading session',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '7',
    'SymbolicName': 'CancelAllOrders',
    'Group': '',
    'Sort': '7',
    'Description': 'Cancel all orders',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '530',
    'Value': '8',
    'SymbolicName': 'CancelOrdersForAMarket',
    'Group': '',
    'Sort': '8',
    'Description': 'Cancel orders for a market',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '530',
    'Value': '9',
    'SymbolicName': 'CancelOrdersForAMarketSegment',
    'Group': '',
    'Sort': '9',
    'Description': 'Cancel orders for a market segment',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '530',
    'Value': 'A',
    'SymbolicName': 'CancelOrdersForASecurityGroup',
    'Group': '',
    'Sort': '10',
    'Description': 'Cancel orders for a security group',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '531',
    'Value': '0',
    'SymbolicName': 'CancelRequestRejected',
    'Group': '',
    'Sort': '0',
    'Description': 'Cancel Request Rejected - See MassCancelRejectReason (532)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '1',
    'SymbolicName': 'CancelOrdersForASecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel orders for a security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '2',
    'SymbolicName': 'CancelOrdersForAnUnderlyingSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Cancel orders for an Underlying Security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '3',
    'SymbolicName': 'CancelOrdersForAProduct',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel orders for a Product',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '4',
    'SymbolicName': 'CancelOrdersForACFICode',
    'Group': '',
    'Sort': '4',
    'Description': 'Cancel orders for a CFICode',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '5',
    'SymbolicName': 'CancelOrdersForASecurityType',
    'Group': '',
    'Sort': '5',
    'Description': 'Cancel orders for a SecurityType',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '6',
    'SymbolicName': 'CancelOrdersForATradingSession',
    'Group': '',
    'Sort': '6',
    'Description': 'Cancel orders for a trading session',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '7',
    'SymbolicName': 'CancelAllOrders',
    'Group': '',
    'Sort': '7',
    'Description': 'Cancel All Orders',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '531',
    'Value': '8',
    'SymbolicName': 'CancelOrdersForAMarket',
    'Group': '',
    'Sort': '8',
    'Description': 'Cancel orders for a market',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '531',
    'Value': '9',
    'SymbolicName': 'CancelOrdersForAMarketSegment',
    'Group': '',
    'Sort': '9',
    'Description': 'Cancel orders for a market segment',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '531',
    'Value': 'A',
    'SymbolicName': 'CancelOrdersForASecurityGroup',
    'Group': '',
    'Sort': '10',
    'Description': 'Cancel orders for a security group',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '532',
    'Value': '0',
    'SymbolicName': 'MassCancelNotSupported',
    'Group': '',
    'Sort': '0',
    'Description': 'Mass Cancel Not Supported',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '1',
    'SymbolicName': 'InvalidOrUnknownSecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Invalid or Unknown Security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '2',
    'SymbolicName': 'InvalidOrUnkownUnderlyingSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid or Unkown Underlying security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '3',
    'SymbolicName': 'InvalidOrUnknownProduct',
    'Group': '',
    'Sort': '3',
    'Description': 'Invalid or Unknown Product',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '4',
    'SymbolicName': 'InvalidOrUnknownCFICode',
    'Group': '',
    'Sort': '4',
    'Description': 'Invalid or Unknown CFICode',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '5',
    'SymbolicName': 'InvalidOrUnknownSecurityType',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid or Unknown SecurityType',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '6',
    'SymbolicName': 'InvalidOrUnknownTradingSession',
    'Group': '',
    'Sort': '6',
    'Description': 'Invalid or Unknown Trading Session',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '532',
    'Value': '7',
    'SymbolicName': 'InvalidOrUnknownMarket',
    'Group': '',
    'Sort': '8',
    'Description': 'Invalid or unknown Market',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '532',
    'Value': '8',
    'SymbolicName': 'InvalidOrUnkownMarketSegment',
    'Group': '',
    'Sort': '9',
    'Description': 'Invalid or unkown Market Segment',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '532',
    'Value': '9',
    'SymbolicName': 'InvalidOrUnknownSecurityGroup',
    'Group': '',
    'Sort': '10',
    'Description': 'Invalid or unknown Security Group',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '532',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '537',
    'Value': '0',
    'SymbolicName': 'Indicative',
    'Group': '',
    'Sort': '1',
    'Description': 'Indicative',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '537',
    'Value': '1',
    'SymbolicName': 'Tradeable',
    'Group': '',
    'Sort': '2',
    'Description': 'Tradeable',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '537',
    'Value': '2',
    'SymbolicName': 'RestrictedTradeable',
    'Group': '',
    'Sort': '3',
    'Description': 'Restricted Tradeable',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '537',
    'Value': '3',
    'SymbolicName': 'Counter',
    'Group': '',
    'Sort': '4',
    'Description': 'Counter (tradeable)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '544',
    'Value': '1',
    'SymbolicName': 'Cash',
    'Group': '',
    'Sort': '1',
    'Description': 'Cash',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '544',
    'Value': '2',
    'SymbolicName': 'MarginOpen',
    'Group': '',
    'Sort': '2',
    'Description': 'Margin Open',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '544',
    'Value': '3',
    'SymbolicName': 'MarginClose',
    'Group': '',
    'Sort': '3',
    'Description': 'Margin Close',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '546',
    'Value': '1',
    'SymbolicName': 'LocalMarket',
    'Group': '',
    'Sort': '1',
    'Description': 'Local Market (Exchange, ECN, ATS)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '546',
    'Value': '2',
    'SymbolicName': 'National',
    'Group': '',
    'Sort': '2',
    'Description': 'National',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '546',
    'Value': '3',
    'SymbolicName': 'Global',
    'Group': '',
    'Sort': '3',
    'Description': 'Global',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '547',
    'Value': 'N',
    'SymbolicName': 'No',
    'Group': '',
    'Sort': '1',
    'Description': 'Server must send an explicit delete for bids or offers falling outside the requested MarketDepth of the request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '547',
    'Value': 'Y',
    'SymbolicName': 'Yes',
    'Group': '',
    'Sort': '2',
    'Description': 'Client has responsibility for implicitly deleting bids or offers falling outside the MarketDepth of the request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '549',
    'Value': '1',
    'SymbolicName': 'CrossAON',
    'Group': '',
    'Sort': '1',
    'Description': 'Cross AON - cross trade which is executed completely or not. Both sides are treated in the same manner. This is equivalent to an \'All or None\'.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '549',
    'Value': '2',
    'SymbolicName': 'CrossIOC',
    'Group': '',
    'Sort': '2',
    'Description': 'Cross IOC - cross trade which is executed partially and the rest is cancelled. One side is fully executed, the other side is partially executed with the remainder being cancelled. This is equivalent to an IOC on the other side. Note: CrossPrioritization(550) field may be used to indicate which side should fully execute in this scenario.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '549',
    'Value': '3',
    'SymbolicName': 'CrossOneSide',
    'Group': '',
    'Sort': '3',
    'Description': 'Cross One Side - cross trade which is partially executed with the unfilled portions remaining active. One side of the cross is fully executed (as denoted by the CrossPrioritization (550) field), but the unfilled portion remains active.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '549',
    'Value': '4',
    'SymbolicName': 'CrossSamePrice',
    'Group': '',
    'Sort': '4',
    'Description': 'Cross Same Price - cross trade is executed with existing orders with the same price. In this case other orders exist with the same price, the quantity of the Cross is executed against the existing orders and quotes, the remainder of the cross is executed against the other side of the cross. The two sides potentially have different quantities.',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '550',
    'Value': '0',
    'SymbolicName': 'None',
    'Group': '',
    'Sort': '1',
    'Description': 'None',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '550',
    'Value': '1',
    'SymbolicName': 'BuySideIsPrioritized',
    'Group': '',
    'Sort': '2',
    'Description': 'Buy side is prioritized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '550',
    'Value': '2',
    'SymbolicName': 'SellSideIsPrioritized',
    'Group': '',
    'Sort': '3',
    'Description': 'Sell side is prioritized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '552',
    'Value': '1',
    'SymbolicName': 'OneSide',
    'Group': '',
    'Sort': '1',
    'Description': 'One Side',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '552',
    'Value': '2',
    'SymbolicName': 'BothSides',
    'Group': '',
    'Sort': '2',
    'Description': 'Both Sides',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '559',
    'Value': '0',
    'SymbolicName': 'Symbol',
    'Group': '',
    'Sort': '0',
    'Description': 'Symbol',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '559',
    'Value': '1',
    'SymbolicName': 'SecurityTypeAnd',
    'Group': '',
    'Sort': '1',
    'Description': 'SecurityType and/or CFICode',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '559',
    'Value': '2',
    'SymbolicName': 'Product',
    'Group': '',
    'Sort': '2',
    'Description': 'Product',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '559',
    'Value': '3',
    'SymbolicName': 'TradingSessionID',
    'Group': '',
    'Sort': '3',
    'Description': 'TradingSessionID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '559',
    'Value': '4',
    'SymbolicName': 'AllSecurities',
    'Group': '',
    'Sort': '4',
    'Description': 'All Securities',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '559',
    'Value': '5',
    'SymbolicName': 'MarketIDOrMarketID',
    'Group': '',
    'Sort': '6',
    'Description': 'MarketID or MarketID + MarketSegmentID',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '560',
    'Value': '0',
    'SymbolicName': 'ValidRequest',
    'Group': '',
    'Sort': '0',
    'Description': 'Valid request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '560',
    'Value': '1',
    'SymbolicName': 'InvalidOrUnsupportedRequest',
    'Group': '',
    'Sort': '1',
    'Description': 'Invalid or unsupported request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '560',
    'Value': '2',
    'SymbolicName': 'NoInstrumentsFound',
    'Group': '',
    'Sort': '2',
    'Description': 'No instruments found that match selection criteria',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '560',
    'Value': '3',
    'SymbolicName': 'NotAuthorizedToRetrieveInstrumentData',
    'Group': '',
    'Sort': '3',
    'Description': 'Not authorized to retrieve instrument data',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '560',
    'Value': '4',
    'SymbolicName': 'InstrumentDataTemporarilyUnavailable',
    'Group': '',
    'Sort': '4',
    'Description': 'Instrument data temporarily unavailable',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '560',
    'Value': '5',
    'SymbolicName': 'RequestForInstrumentDataNotSupported',
    'Group': '',
    'Sort': '5',
    'Description': 'Request for instrument data not supported',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '563',
    'Value': '0',
    'SymbolicName': 'ReportByMulitlegSecurityOnly',
    'Group': '',
    'Sort': '0',
    'Description': 'Report by mulitleg security only (do not report legs)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '563',
    'Value': '1',
    'SymbolicName': 'ReportByMultilegSecurityAndInstrumentLegs',
    'Group': '',
    'Sort': '1',
    'Description': 'Report by multileg security and by instrument legs belonging to the multileg security',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '563',
    'Value': '2',
    'SymbolicName': 'ReportByInstrumentLegsOnly',
    'Group': '',
    'Sort': '2',
    'Description': 'Report by instrument legs belonging to the multileg security only (do not report status of multileg security)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '567',
    'Value': '1',
    'SymbolicName': 'UnknownOrInvalidTradingSessionID',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown or invalid TradingSessionID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '567',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '569',
    'Value': '0',
    'SymbolicName': 'AllTrades',
    'Group': '',
    'Sort': '0',
    'Description': 'All Trades',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '569',
    'Value': '1',
    'SymbolicName': 'MatchedTradesMatchingCriteria',
    'Group': '',
    'Sort': '1',
    'Description': 'Matched trades matching criteria provided on request (Parties, ExecID, TradeID, OrderID, Instrument, InputSource, etc.)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '569',
    'Value': '2',
    'SymbolicName': 'UnmatchedTradesThatMatchCriteria',
    'Group': '',
    'Sort': '2',
    'Description': 'Unmatched trades that match criteria',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '569',
    'Value': '3',
    'SymbolicName': 'UnreportedTradesThatMatchCriteria',
    'Group': '',
    'Sort': '3',
    'Description': 'Unreported trades that match criteria',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '569',
    'Value': '4',
    'SymbolicName': 'AdvisoriesThatMatchCriteria',
    'Group': '',
    'Sort': '4',
    'Description': 'Advisories that match criteria',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '570',
    'Value': 'N',
    'SymbolicName': 'NotReportedToCounterparty',
    'Group': '',
    'Sort': '1',
    'Description': 'Not reported to counterparty',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '570',
    'Value': 'Y',
    'SymbolicName': 'PerviouslyReportedToCounterparty',
    'Group': '',
    'Sort': '2',
    'Description': 'Perviously reported to counterparty',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '573',
    'Value': '0',
    'SymbolicName': 'Compared',
    'Group': '',
    'Sort': '0',
    'Description': 'Compared, matched or affirmed',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '573',
    'Value': '1',
    'SymbolicName': 'Uncompared',
    'Group': '',
    'Sort': '1',
    'Description': 'Uncompared, unmatched, or unaffirmed',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '573',
    'Value': '2',
    'SymbolicName': 'AdvisoryOrAlert',
    'Group': '',
    'Sort': '2',
    'Description': 'Advisory or alert',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': '1',
    'SymbolicName': 'OnePartyTradeReport',
    'Group': 'General Purpose',
    'Sort': '70',
    'Description': 'One-Party Trade Report (privately negotiated trade)',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '2',
    'SymbolicName': 'TwoPartyTradeReport',
    'Group': 'General Purpose',
    'Sort': '71',
    'Description': 'Two-Party Trade Report (privately negotiated trade)',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '3',
    'SymbolicName': 'ConfirmedTradeReport',
    'Group': 'General Purpose',
    'Sort': '72',
    'Description': 'Confirmed Trade Report (reporting from recognized markets)',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '4',
    'SymbolicName': 'AutoMatch',
    'Group': 'General Purpose',
    'Sort': '73',
    'Description': 'Auto-match',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '5',
    'SymbolicName': 'CrossAuction',
    'Group': 'General Purpose',
    'Sort': '74',
    'Description': 'Cross Auction',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '6',
    'SymbolicName': 'CounterOrderSelection',
    'Group': 'General Purpose',
    'Sort': '75',
    'Description': 'Counter-Order Selection',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '7',
    'SymbolicName': 'CallAuction',
    'Group': 'General Purpose',
    'Sort': '76',
    'Description': 'Call Auction',
    'Added': 'FIX.4.4',
    'AddedEP': '22'
  },
  {
    'Tag': '574',
    'Value': '8',
    'SymbolicName': 'Issuing',
    'Group': 'General Purpose',
    'Sort': '77',
    'Description': 'Issuing/Buy Back Auction',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '574',
    'Value': 'M3',
    'SymbolicName': 'ACTAcceptedTrade',
    'Group': 'NASDAQ',
    'Sort': '2',
    'Description': 'ACT Accepted Trade',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'M4',
    'SymbolicName': 'ACTDefaultTrade',
    'Group': 'NASDAQ',
    'Sort': '3',
    'Description': 'ACT Default Trade',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'M5',
    'SymbolicName': 'ACTDefaultAfterM2',
    'Group': 'NASDAQ',
    'Sort': '4',
    'Description': 'ACT Default After M2',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'M6',
    'SymbolicName': 'ACTM6Match',
    'Group': 'NASDAQ',
    'Sort': '5',
    'Description': 'ACT M6 Match',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'A1',
    'SymbolicName': 'ExactMatchPlus4BadgesExecTime',
    'Group': 'NYSE and AMEX',
    'Sort': '0',
    'Description': 'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator plus four badges and execution time (within two-minute window)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'A2',
    'SymbolicName': 'ExactMatchPlus4Badges',
    'Group': 'NYSE and AMEX',
    'Sort': '1',
    'Description': 'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus four badges',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'A3',
    'SymbolicName': 'ExactMatchPlus2BadgesExecTime',
    'Group': 'NYSE and AMEX',
    'Sort': '2',
    'Description': 'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges and execution time (within two-minute window)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'A4',
    'SymbolicName': 'ExactMatchPlus2Badges',
    'Group': 'NYSE and AMEX',
    'Sort': '3',
    'Description': 'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator, plus two badges',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'A5',
    'SymbolicName': 'ExactMatchPlusExecTime',
    'Group': 'NYSE and AMEX',
    'Sort': '4',
    'Description': 'Exact match on Trade Date, Stock Symbol, Quantity, Price, TradeType, and Special Trade Indicator plus execution time (within two-minute window)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'AQ',
    'SymbolicName': 'StampedAdvisoriesOrSpecialistAccepts',
    'Group': 'NYSE and AMEX',
    'Sort': '5',
    'Description': 'Compared records resulting from stamped advisories or specialist accepts/pair-offs',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'S1',
    'SymbolicName': 'A1ExactMatchSummarizedQuantity',
    'Group': 'NYSE and AMEX',
    'Sort': '6',
    'Description': 'Summarized match using A1 exact match criteria except quantity is summaried',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'S2',
    'SymbolicName': 'A2ExactMatchSummarizedQuantity',
    'Group': 'NYSE and AMEX',
    'Sort': '7',
    'Description': 'Summarized match using A2 exact match criteria except quantity is summarized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'S3',
    'SymbolicName': 'A3ExactMatchSummarizedQuantity',
    'Group': 'NYSE and AMEX',
    'Sort': '8',
    'Description': 'Summarized match using A3 exact match criteria except quantity is summarized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'S4',
    'SymbolicName': 'A4ExactMatchSummarizedQuantity',
    'Group': 'NYSE and AMEX',
    'Sort': '9',
    'Description': 'Summarized match using A4 exact match criteria except quantity is summarized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'S5',
    'SymbolicName': 'A5ExactMatchSummarizedQuantity',
    'Group': 'NYSE and AMEX',
    'Sort': '10',
    'Description': 'Summarized match using A5 exact match criteria except quantity is summarized',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'M1',
    'SymbolicName': 'ExactMatchMinusBadgesTimes',
    'Group': 'NYSE, AMEX and NASDAQ',
    'Sort': '11',
    'Description': 'Exact match on Trade Date, Stock Symbol, Quantity, Price, Trade Type, and Special Trade Indicator minus badges And times: ACT M1 match',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'M2',
    'SymbolicName': 'SummarizedMatchMinusBadgesTimes',
    'Group': 'NYSE, AMEX and NASDAQ',
    'Sort': '12',
    'Description': 'Summarized match minus badges and times: ACT M2 Match',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '574',
    'Value': 'MT',
    'SymbolicName': 'OCSLockedIn',
    'Group': 'NYSE, AMEX and NASDAQ',
    'Sort': '13',
    'Description': 'OCS Locked In: Non-ACT',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '575',
    'Value': 'N',
    'SymbolicName': 'TreatAsRoundLot',
    'Group': '',
    'Sort': '1',
    'Description': 'Treat as round lot (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '575',
    'Value': 'Y',
    'SymbolicName': 'TreatAsOddLot',
    'Group': '',
    'Sort': '2',
    'Description': 'Treat as odd lot',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '577',
    'Value': '0',
    'SymbolicName': 'ProcessNormally',
    'Group': '',
    'Sort': '0',
    'Description': 'Process normally',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '1',
    'SymbolicName': 'ExcludeFromAllNetting',
    'Group': '',
    'Sort': '1',
    'Description': 'Exclude from all netting',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '2',
    'SymbolicName': 'BilateralNettingOnly',
    'Group': '',
    'Sort': '2',
    'Description': 'Bilateral netting only',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '3',
    'SymbolicName': 'ExClearing',
    'Group': '',
    'Sort': '3',
    'Description': 'Ex clearing',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '4',
    'SymbolicName': 'SpecialTrade',
    'Group': '',
    'Sort': '4',
    'Description': 'Special trade',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '5',
    'SymbolicName': 'MultilateralNetting',
    'Group': '',
    'Sort': '5',
    'Description': 'Multilateral netting',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '6',
    'SymbolicName': 'ClearAgainstCentralCounterparty',
    'Group': '',
    'Sort': '6',
    'Description': 'Clear against central counterparty',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '7',
    'SymbolicName': 'ExcludeFromCentralCounterparty',
    'Group': '',
    'Sort': '7',
    'Description': 'Exclude from central counterparty',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '8',
    'SymbolicName': 'ManualMode',
    'Group': '',
    'Sort': '8',
    'Description': 'Manual mode (pre-posting and/or pre-giveup)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '9',
    'SymbolicName': 'AutomaticPostingMode',
    'Group': '',
    'Sort': '9',
    'Description': 'Automatic posting mode (trade posting to the position account number specified)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '10',
    'SymbolicName': 'AutomaticGiveUpMode',
    'Group': '',
    'Sort': '10',
    'Description': 'Automatic give-up mode (trade give-up to the give-up destination number specified)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '577',
    'Value': '11',
    'SymbolicName': 'QualifiedServiceRepresentativeQSR',
    'Group': '',
    'Sort': '11',
    'Description': 'Qualified Service Representative QSR',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '577',
    'Value': '12',
    'SymbolicName': 'CustomerTrade',
    'Group': '',
    'Sort': '12',
    'Description': 'Customer trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '577',
    'Value': '13',
    'SymbolicName': 'SelfClearing',
    'Group': '',
    'Sort': '13',
    'Description': 'Self clearing',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '581',
    'Value': '1',
    'SymbolicName': 'CarriedCustomerSide',
    'Group': '',
    'Sort': '1',
    'Description': 'Account is carried on customer side of the books',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '581',
    'Value': '2',
    'SymbolicName': 'CarriedNonCustomerSide',
    'Group': '',
    'Sort': '2',
    'Description': 'Account is carried on non-customer side of books',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '581',
    'Value': '3',
    'SymbolicName': 'HouseTrader',
    'Group': '',
    'Sort': '3',
    'Description': 'House Trader',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '581',
    'Value': '4',
    'SymbolicName': 'FloorTrader',
    'Group': '',
    'Sort': '4',
    'Description': 'Floor Trader',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '581',
    'Value': '6',
    'SymbolicName': 'CarriedNonCustomerSideCrossMargined',
    'Group': '',
    'Sort': '5',
    'Description': 'Account is carried on non-customer side of books and is cross margined',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '581',
    'Value': '7',
    'SymbolicName': 'HouseTraderCrossMargined',
    'Group': '',
    'Sort': '6',
    'Description': 'Account is house trader and is cross margined',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '581',
    'Value': '8',
    'SymbolicName': 'JointBackOfficeAccount',
    'Group': '',
    'Sort': '7',
    'Description': 'Joint back office account (JBO)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '582',
    'Value': '1',
    'SymbolicName': 'MemberTradingForTheirOwnAccount',
    'Group': '',
    'Sort': '1',
    'Description': 'Member trading for their own account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '582',
    'Value': '2',
    'SymbolicName': 'ClearingFirmTradingForItsProprietaryAccount',
    'Group': '',
    'Sort': '2',
    'Description': 'Clearing Firm trading for its proprietary account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '582',
    'Value': '3',
    'SymbolicName': 'MemberTradingForAnotherMember',
    'Group': '',
    'Sort': '3',
    'Description': 'Member trading for another member',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '582',
    'Value': '4',
    'SymbolicName': 'AllOther',
    'Group': '',
    'Sort': '4',
    'Description': 'All other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '585',
    'Value': '1',
    'SymbolicName': 'StatusForOrdersForASecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Status for orders for a Security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '2',
    'SymbolicName': 'StatusForOrdersForAnUnderlyingSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Status for orders for an Underlying Security',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '3',
    'SymbolicName': 'StatusForOrdersForAProduct',
    'Group': '',
    'Sort': '3',
    'Description': 'Status for orders for a Product',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '4',
    'SymbolicName': 'StatusForOrdersForACFICode',
    'Group': '',
    'Sort': '4',
    'Description': 'Status for orders for a CFICode',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '5',
    'SymbolicName': 'StatusForOrdersForASecurityType',
    'Group': '',
    'Sort': '5',
    'Description': 'Status for orders for a SecurityType',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '6',
    'SymbolicName': 'StatusForOrdersForATradingSession',
    'Group': '',
    'Sort': '6',
    'Description': 'Status for orders for a trading session',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '7',
    'SymbolicName': 'StatusForAllOrders',
    'Group': '',
    'Sort': '7',
    'Description': 'Status for all orders',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '585',
    'Value': '8',
    'SymbolicName': 'StatusForOrdersForAPartyID',
    'Group': '',
    'Sort': '8',
    'Description': 'Status for orders for a PartyID',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '589',
    'Value': '0',
    'SymbolicName': 'Auto',
    'Group': '',
    'Sort': '1',
    'Description': 'Can trigger booking without reference to the order initiator (\'auto\')',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '589',
    'Value': '1',
    'SymbolicName': 'SpeakWithOrderInitiatorBeforeBooking',
    'Group': '',
    'Sort': '2',
    'Description': 'Speak with order initiator before booking (\'speak first\')',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '589',
    'Value': '2',
    'SymbolicName': 'Accumulate',
    'Group': '',
    'Sort': '3',
    'Description': 'Accumulate',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '590',
    'Value': '0',
    'SymbolicName': 'EachPartialExecutionIsABookableUnit',
    'Group': '',
    'Sort': '1',
    'Description': 'Each partial execution is a bookable unit',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '590',
    'Value': '1',
    'SymbolicName': 'AggregatePartialExecutionsOnThisOrder',
    'Group': '',
    'Sort': '2',
    'Description': 'Aggregate partial executions on this order, and book one trade per order',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '590',
    'Value': '2',
    'SymbolicName': 'AggregateExecutionsForThisSymbol',
    'Group': '',
    'Sort': '3',
    'Description': 'Aggregate executions for this symbol, side, and settlement date',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '591',
    'Value': '0',
    'SymbolicName': 'ProRata',
    'Group': '',
    'Sort': '1',
    'Description': 'Pro rata',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '591',
    'Value': '1',
    'SymbolicName': 'DoNotProRata',
    'Group': '',
    'Sort': '2',
    'Description': 'Do not pro-rata - discuss first',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '625',
    'Value': '1',
    'SymbolicName': 'PreTrading',
    'Group': '',
    'Sort': '1',
    'Description': 'Pre-Trading',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '625',
    'Value': '2',
    'SymbolicName': 'OpeningOrOpeningAuction',
    'Group': '',
    'Sort': '2',
    'Description': 'Opening or opening auction',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '625',
    'Value': '3',
    'SymbolicName': 'Continuous',
    'Group': '',
    'Sort': '3',
    'Description': '(Continuous) Trading',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '625',
    'Value': '4',
    'SymbolicName': 'ClosingOrClosingAuction',
    'Group': '',
    'Sort': '4',
    'Description': 'Closing or closing auction',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '625',
    'Value': '5',
    'SymbolicName': 'PostTrading',
    'Group': '',
    'Sort': '5',
    'Description': 'Post-Trading',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '625',
    'Value': '6',
    'SymbolicName': 'IntradayAuction',
    'Group': '',
    'Sort': '6',
    'Description': 'Intraday Auction',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '625',
    'Value': '7',
    'SymbolicName': 'Quiescent',
    'Group': '',
    'Sort': '7',
    'Description': 'Quiescent',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '626',
    'Value': '1',
    'SymbolicName': 'Calculated',
    'Group': '',
    'Sort': '1',
    'Description': 'Calculated (includes MiscFees and NetMoney)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '626',
    'Value': '2',
    'SymbolicName': 'Preliminary',
    'Group': '',
    'Sort': '2',
    'Description': 'Preliminary (without MiscFees and NetMoney)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '626',
    'Value': '3',
    'SymbolicName': 'SellsideCalculatedUsingPreliminary',
    'Group': '',
    'Sort': '3',
    'Description': 'Sellside Calculated Using Preliminary (includes MiscFees and NetMoney) (Replaced)',
    'Added': 'FIX.4.3',
    'Deprecated': 'FIX.4.2'
  },
  {
    'Tag': '626',
    'Value': '4',
    'SymbolicName': 'SellsideCalculatedWithoutPreliminary',
    'Group': '',
    'Sort': '4',
    'Description': 'Sellside Calculated Without Preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney) (Replaced)',
    'Added': 'FIX.4.3',
    'Deprecated': 'FIX.4.2'
  },
  {
    'Tag': '626',
    'Value': '5',
    'SymbolicName': 'ReadyToBook',
    'Group': '',
    'Sort': '5',
    'Description': 'Ready-To-Book - Single Order',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '626',
    'Value': '6',
    'SymbolicName': 'BuysideReadyToBook',
    'Group': '',
    'Sort': '6',
    'Description': 'Buyside Ready-To-Book - Combined Set of Orders (Replaced)',
    'Added': 'FIX.4.3',
    'Deprecated': 'FIX.4.2'
  },
  {
    'Tag': '626',
    'Value': '7',
    'SymbolicName': 'WarehouseInstruction',
    'Group': '',
    'Sort': '7',
    'Description': 'Warehouse Instruction',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '626',
    'Value': '8',
    'SymbolicName': 'RequestToIntermediary',
    'Group': '',
    'Sort': '8',
    'Description': 'Request to Intermediary',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '626',
    'Value': '9',
    'SymbolicName': 'Accept',
    'Group': '',
    'Sort': '9',
    'Description': 'Accept',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '626',
    'Value': '10',
    'SymbolicName': 'Reject',
    'Group': '',
    'Sort': '10',
    'Description': 'Reject',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '626',
    'Value': '11',
    'SymbolicName': 'AcceptPending',
    'Group': '',
    'Sort': '11',
    'Description': 'Accept Pending',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '626',
    'Value': '12',
    'SymbolicName': 'IncompleteGroup',
    'Group': '',
    'Sort': '12',
    'Description': 'Incomplete Group',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '626',
    'Value': '13',
    'SymbolicName': 'CompleteGroup',
    'Group': '',
    'Sort': '13',
    'Description': 'Complete Group',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '626',
    'Value': '14',
    'SymbolicName': 'ReversalPending',
    'Group': '',
    'Sort': '14',
    'Description': 'Reversal Pending',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '635',
    'Value': '1',
    'SymbolicName': 'FirstYearDelegate',
    'Group': '',
    'Sort': '1',
    'Description': '1st year delegate trading for own account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': '2',
    'SymbolicName': 'SecondYearDelegate',
    'Group': '',
    'Sort': '2',
    'Description': '2nd year delegate trading for own account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': '3',
    'SymbolicName': 'ThirdYearDelegate',
    'Group': '',
    'Sort': '3',
    'Description': '3rd year delegate trading for own account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': '4',
    'SymbolicName': 'FourthYearDelegate',
    'Group': '',
    'Sort': '4',
    'Description': '4th year delegate trading for own account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': '5',
    'SymbolicName': 'FifthYearDelegate',
    'Group': '',
    'Sort': '5',
    'Description': '5th year delegate trading for own account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': '9',
    'SymbolicName': 'SixthYearDelegate',
    'Group': '',
    'Sort': '6',
    'Description': '6th year delegate trading for own account',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'B',
    'SymbolicName': 'CBOEMember',
    'Group': '',
    'Sort': '7',
    'Description': 'CBOE Member',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'C',
    'SymbolicName': 'NonMemberAndCustomer',
    'Group': '',
    'Sort': '8',
    'Description': 'Non-member and Customer',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'E',
    'SymbolicName': 'EquityMemberAndClearingMember',
    'Group': '',
    'Sort': '9',
    'Description': 'Equity Member and Clearing Member',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'F',
    'SymbolicName': 'FullAndAssociateMember',
    'Group': '',
    'Sort': '10',
    'Description': 'Full and Associate Member trading for own account and as floor brokers',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'H',
    'SymbolicName': 'Firms106HAnd106J',
    'Group': '',
    'Sort': '11',
    'Description': '106.H and 106.J firms',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'I',
    'SymbolicName': 'GIM',
    'Group': '',
    'Sort': '12',
    'Description': 'GIM, IDEM and COM Membership Interest Holders',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'L',
    'SymbolicName': 'Lessee106FEmployees',
    'Group': '',
    'Sort': '13',
    'Description': 'Lessee 106.F Employees',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '635',
    'Value': 'M',
    'SymbolicName': 'AllOtherOwnershipTypes',
    'Group': '',
    'Sort': '14',
    'Description': 'All other ownership types',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '636',
    'Value': 'N',
    'SymbolicName': 'NotWorking',
    'Group': '',
    'Sort': '1',
    'Description': 'Order has been accepted but not yet in a working state',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '636',
    'Value': 'Y',
    'SymbolicName': 'Working',
    'Group': '',
    'Sort': '2',
    'Description': 'Order is currently being worked',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '638',
    'Value': '0',
    'SymbolicName': 'PriorityUnchanged',
    'Group': '',
    'Sort': '1',
    'Description': 'Priority unchanged',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '638',
    'Value': '1',
    'SymbolicName': 'LostPriorityAsResultOfOrderChange',
    'Group': '',
    'Sort': '2',
    'Description': 'Lost Priority as result of order change',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '650',
    'Value': 'N',
    'SymbolicName': 'DoesNotConsituteALegalConfirm',
    'Group': '',
    'Sort': '1',
    'Description': 'Does not consitute a Legal Confirm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '650',
    'Value': 'Y',
    'SymbolicName': 'LegalConfirm',
    'Group': '',
    'Sort': '2',
    'Description': 'Legal Confirm',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '653',
    'Value': '0',
    'SymbolicName': 'PendingApproval',
    'Group': '',
    'Sort': '1',
    'Description': 'Pending Approval',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '653',
    'Value': '1',
    'SymbolicName': 'Approved',
    'Group': '',
    'Sort': '2',
    'Description': 'Approved (Accepted)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '653',
    'Value': '2',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '3',
    'Description': 'Rejected',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '653',
    'Value': '3',
    'SymbolicName': 'UnauthorizedRequest',
    'Group': '',
    'Sort': '4',
    'Description': 'Unauthorized Request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '653',
    'Value': '4',
    'SymbolicName': 'InvalidDefinitionRequest',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid Definition Request',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '1',
    'SymbolicName': 'UnknownSymbol',
    'Group': '',
    'Sort': '0',
    'Description': 'Unknown Symbol (Security)',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '2',
    'SymbolicName': 'Exchange',
    'Group': '',
    'Sort': '1',
    'Description': 'Exchange (Security) Closed',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '3',
    'SymbolicName': 'QuoteRequestExceedsLimit',
    'Group': '',
    'Sort': '2',
    'Description': 'Quote Request Exceeds Limit',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '4',
    'SymbolicName': 'TooLateToEnter',
    'Group': '',
    'Sort': '3',
    'Description': 'Too Late to enter',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '5',
    'SymbolicName': 'InvalidPrice',
    'Group': '',
    'Sort': '4',
    'Description': 'Invalid Price',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '6',
    'SymbolicName': 'NotAuthorizedToRequestQuote',
    'Group': '',
    'Sort': '5',
    'Description': 'Not Authorized To Request Quote',
    'Added': 'FIX.4.3'
  },
  {
    'Tag': '658',
    'Value': '7',
    'SymbolicName': 'NoMatchForInquiry',
    'Group': '',
    'Sort': '6',
    'Description': 'No Match For Inquiry',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '658',
    'Value': '8',
    'SymbolicName': 'NoMarketForInstrument',
    'Group': '',
    'Sort': '7',
    'Description': 'No Market For Instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '658',
    'Value': '9',
    'SymbolicName': 'NoInventory',
    'Group': '',
    'Sort': '8',
    'Description': 'No Inventory',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '658',
    'Value': '10',
    'SymbolicName': 'Pass',
    'Group': '',
    'Sort': '9',
    'Description': 'Pass',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '658',
    'Value': '11',
    'SymbolicName': 'InsufficientCredit',
    'Group': '',
    'Sort': '10',
    'Description': 'Insufficient credit',
    'Added': 'FIX.4.4',
    'AddedEP': '21'
  },
  {
    'Tag': '658',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '660',
    'Value': '1',
    'SymbolicName': 'BIC',
    'Group': '',
    'Sort': '1',
    'Description': 'BIC',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '660',
    'Value': '2',
    'SymbolicName': 'SIDCode',
    'Group': '',
    'Sort': '2',
    'Description': 'SID Code',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '660',
    'Value': '3',
    'SymbolicName': 'TFM',
    'Group': '',
    'Sort': '3',
    'Description': 'TFM (GSPTA)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '660',
    'Value': '4',
    'SymbolicName': 'OMGEO',
    'Group': '',
    'Sort': '4',
    'Description': 'OMGEO (Alert ID)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '660',
    'Value': '5',
    'SymbolicName': 'DTCCCode',
    'Group': '',
    'Sort': '5',
    'Description': 'DTCC Code',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '660',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other (custom or proprietary)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '665',
    'Value': '1',
    'SymbolicName': 'Received',
    'Group': '',
    'Sort': '1',
    'Description': 'Received',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '665',
    'Value': '2',
    'SymbolicName': 'MismatchedAccount',
    'Group': '',
    'Sort': '2',
    'Description': 'Mismatched Account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '665',
    'Value': '3',
    'SymbolicName': 'MissingSettlementInstructions',
    'Group': '',
    'Sort': '3',
    'Description': 'Missing Settlement Instructions',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '665',
    'Value': '4',
    'SymbolicName': 'Confirmed',
    'Group': '',
    'Sort': '4',
    'Description': 'Confirmed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '665',
    'Value': '5',
    'SymbolicName': 'RequestRejected',
    'Group': '',
    'Sort': '5',
    'Description': 'Request Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '666',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '666',
    'Value': '1',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '2',
    'Description': 'Replace',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '666',
    'Value': '2',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '668',
    'Value': '1',
    'SymbolicName': 'BookEntry',
    'Group': '',
    'Sort': '1',
    'Description': 'Book Entry (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '668',
    'Value': '2',
    'SymbolicName': 'Bearer',
    'Group': '',
    'Sort': '2',
    'Description': 'Bearer',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '690',
    'Value': '1',
    'SymbolicName': 'ParForPar',
    'Group': '',
    'Sort': '1',
    'Description': 'Par For Par',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '690',
    'Value': '2',
    'SymbolicName': 'ModifiedDuration',
    'Group': '',
    'Sort': '2',
    'Description': 'Modified Duration',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '690',
    'Value': '4',
    'SymbolicName': 'Risk',
    'Group': '',
    'Sort': '3',
    'Description': 'Risk',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '690',
    'Value': '5',
    'SymbolicName': 'Proceeds',
    'Group': '',
    'Sort': '4',
    'Description': 'Proceeds',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '1',
    'SymbolicName': 'Percent',
    'Group': '',
    'Sort': '0',
    'Description': 'Percent (percent of par)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '2',
    'SymbolicName': 'PerShare',
    'Group': '',
    'Sort': '1',
    'Description': 'Per Share (e.g. cents per share)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '3',
    'SymbolicName': 'FixedAmount',
    'Group': '',
    'Sort': '2',
    'Description': 'Fixed Amount (absolute value)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '4',
    'SymbolicName': 'Discount',
    'Group': '',
    'Sort': '3',
    'Description': 'Discount - percentage points below par',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '5',
    'SymbolicName': 'Premium',
    'Group': '',
    'Sort': '4',
    'Description': 'Premium - percentage points over par',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '6',
    'SymbolicName': 'Spread',
    'Group': '',
    'Sort': '5',
    'Description': 'Spread - basis points relative to benchmark',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '7',
    'SymbolicName': 'TEDPrice',
    'Group': '',
    'Sort': '6',
    'Description': 'TED Price',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '8',
    'SymbolicName': 'TEDYield',
    'Group': '',
    'Sort': '7',
    'Description': 'TED Yield',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '9',
    'SymbolicName': 'YieldSpread',
    'Group': '',
    'Sort': '8',
    'Description': 'Yield Spread (swaps)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '692',
    'Value': '10',
    'SymbolicName': 'Yield',
    'Group': '',
    'Sort': '9',
    'Description': 'Yield',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '1',
    'SymbolicName': 'Hit',
    'Group': '',
    'Sort': '1',
    'Description': 'Hit/Lift',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '2',
    'SymbolicName': 'Counter',
    'Group': '',
    'Sort': '2',
    'Description': 'Counter',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '3',
    'SymbolicName': 'Expired',
    'Group': '',
    'Sort': '3',
    'Description': 'Expired',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '4',
    'SymbolicName': 'Cover',
    'Group': '',
    'Sort': '4',
    'Description': 'Cover',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '5',
    'SymbolicName': 'DoneAway',
    'Group': '',
    'Sort': '5',
    'Description': 'Done Away',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '6',
    'SymbolicName': 'Pass',
    'Group': '',
    'Sort': '6',
    'Description': 'Pass',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '694',
    'Value': '7',
    'SymbolicName': 'EndTrade',
    'Group': '',
    'Sort': '7',
    'Description': 'End Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '694',
    'Value': '8',
    'SymbolicName': 'TimedOut',
    'Group': '',
    'Sort': '8',
    'Description': 'Timed Out',
    'Added': 'FIX.5.0',
    'AddedEP': '68'
  },
  {
    'Tag': '703',
    'Value': 'ALC',
    'SymbolicName': 'AllocationTradeQty',
    'Group': '',
    'Sort': '1',
    'Description': 'Allocation Trade Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'AS',
    'SymbolicName': 'OptionAssignment',
    'Group': '',
    'Sort': '2',
    'Description': 'Option Assignment',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'ASF',
    'SymbolicName': 'AsOfTradeQty',
    'Group': '',
    'Sort': '3',
    'Description': 'As-of Trade Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'DLV',
    'SymbolicName': 'DeliveryQty',
    'Group': '',
    'Sort': '4',
    'Description': 'Delivery Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'ETR',
    'SymbolicName': 'ElectronicTradeQty',
    'Group': '',
    'Sort': '5',
    'Description': 'Electronic Trade Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'EX',
    'SymbolicName': 'OptionExerciseQty',
    'Group': '',
    'Sort': '6',
    'Description': 'Option Exercise Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'FIN',
    'SymbolicName': 'EndOfDayQty',
    'Group': '',
    'Sort': '7',
    'Description': 'End-of-Day Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'IAS',
    'SymbolicName': 'IntraSpreadQty',
    'Group': '',
    'Sort': '8',
    'Description': 'Intra-spread Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'IES',
    'SymbolicName': 'InterSpreadQty',
    'Group': '',
    'Sort': '9',
    'Description': 'Inter-spread Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'PA',
    'SymbolicName': 'AdjustmentQty',
    'Group': '',
    'Sort': '10',
    'Description': 'Adjustment Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'PIT',
    'SymbolicName': 'PitTradeQty',
    'Group': '',
    'Sort': '11',
    'Description': 'Pit Trade Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'SOD',
    'SymbolicName': 'StartOfDayQty',
    'Group': '',
    'Sort': '12',
    'Description': 'Start-of-Day Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'SPL',
    'SymbolicName': 'IntegralSplit',
    'Group': '',
    'Sort': '13',
    'Description': 'Integral Split',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'TA',
    'SymbolicName': 'TransactionFromAssignment',
    'Group': '',
    'Sort': '14',
    'Description': 'Transaction from Assignment',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'TOT',
    'SymbolicName': 'TotalTransactionQty',
    'Group': '',
    'Sort': '15',
    'Description': 'Total Transaction Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'TQ',
    'SymbolicName': 'TransactionQuantity',
    'Group': '',
    'Sort': '16',
    'Description': 'Transaction Quantity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'TRF',
    'SymbolicName': 'TransferTradeQty',
    'Group': '',
    'Sort': '17',
    'Description': 'Transfer Trade Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'TX',
    'SymbolicName': 'TransactionFromExercise',
    'Group': '',
    'Sort': '18',
    'Description': 'Transaction from Exercise',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'XM',
    'SymbolicName': 'CrossMarginQty',
    'Group': '',
    'Sort': '19',
    'Description': 'Cross Margin Qty',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '703',
    'Value': 'RCV',
    'SymbolicName': 'ReceiveQuantity',
    'Group': '',
    'Sort': '20',
    'Description': 'Receive Quantity',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '703',
    'Value': 'CAA',
    'SymbolicName': 'CorporateActionAdjustment',
    'Group': '',
    'Sort': '21',
    'Description': 'Corporate Action Adjustment',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '703',
    'Value': 'DN',
    'SymbolicName': 'DeliveryNoticeQty',
    'Group': '',
    'Sort': '22',
    'Description': 'Delivery Notice Qty',
    'Added': 'FIX.4.4',
    'AddedEP': '13'
  },
  {
    'Tag': '703',
    'Value': 'EP',
    'SymbolicName': 'ExchangeForPhysicalQty',
    'Group': '',
    'Sort': '23',
    'Description': 'Exchange for Physical Qty',
    'Added': 'FIX.4.4',
    'AddedEP': '13'
  },
  {
    'Tag': '703',
    'Value': 'PNTN',
    'SymbolicName': 'PrivatelyNegotiatedTradeQty',
    'Group': '',
    'Sort': '24',
    'Description': 'Privately negotiated Trade Qty (Non-regulated)',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '706',
    'Value': '0',
    'SymbolicName': 'Submitted',
    'Group': '',
    'Sort': '1',
    'Description': 'Submitted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '706',
    'Value': '1',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '2',
    'Description': 'Accepted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '706',
    'Value': '2',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '3',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'CASH',
    'SymbolicName': 'CashAmount',
    'Group': '',
    'Sort': '0',
    'Description': 'Cash Amount (Corporate Event)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'CRES',
    'SymbolicName': 'CashResidualAmount',
    'Group': '',
    'Sort': '1',
    'Description': 'Cash Residual Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'FMTM',
    'SymbolicName': 'FinalMarkToMarketAmount',
    'Group': '',
    'Sort': '2',
    'Description': 'Final Mark-to-Market Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'IMTM',
    'SymbolicName': 'IncrementalMarkToMarketAmount',
    'Group': '',
    'Sort': '3',
    'Description': 'Incremental Mark-to-Market Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'PREM',
    'SymbolicName': 'PremiumAmount',
    'Group': '',
    'Sort': '4',
    'Description': 'Premium Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'SMTM',
    'SymbolicName': 'StartOfDayMarkToMarketAmount',
    'Group': '',
    'Sort': '5',
    'Description': 'Start-of-Day Mark-to-Market Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'TVAR',
    'SymbolicName': 'TradeVariationAmount',
    'Group': '',
    'Sort': '6',
    'Description': 'Trade Variation Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'VADJ',
    'SymbolicName': 'ValueAdjustedAmount',
    'Group': '',
    'Sort': '7',
    'Description': 'Value Adjusted Amount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '707',
    'Value': 'SETL',
    'SymbolicName': 'SettlementValue',
    'Group': '',
    'Sort': '8',
    'Description': 'Settlement Value',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '709',
    'Value': '1',
    'SymbolicName': 'Exercise',
    'Group': '',
    'Sort': '1',
    'Description': 'Exercise',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '709',
    'Value': '2',
    'SymbolicName': 'DoNotExercise',
    'Group': '',
    'Sort': '2',
    'Description': 'Do Not Exercise',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '709',
    'Value': '3',
    'SymbolicName': 'PositionAdjustment',
    'Group': '',
    'Sort': '3',
    'Description': 'Position Adjustment',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '709',
    'Value': '4',
    'SymbolicName': 'PositionChangeSubmission',
    'Group': '',
    'Sort': '4',
    'Description': 'Position Change Submission/Margin Disposition',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '709',
    'Value': '5',
    'SymbolicName': 'Pledge',
    'Group': '',
    'Sort': '5',
    'Description': 'Pledge',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '709',
    'Value': '6',
    'SymbolicName': 'LargeTraderSubmission',
    'Group': '',
    'Sort': '6',
    'Description': 'Large Trader Submission',
    'Added': 'FIX.4.4',
    'AddedEP': '13'
  },
  {
    'Tag': '712',
    'Value': '1',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New - used to increment the overall transaction quantity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '712',
    'Value': '2',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '2',
    'Description': 'Replace - used to override the overall transaction quantity or specifi add messages based on the reference ID',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '712',
    'Value': '3',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel - used to remove the overall transaction or specific add messages based on reference ID',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '712',
    'Value': '4',
    'SymbolicName': 'Reverse',
    'Group': '',
    'Sort': '4',
    'Description': 'Reverse - used to completelly back-out the transaction such that the transaction never existed',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '716',
    'Value': 'ITD',
    'SymbolicName': 'Intraday',
    'Group': '',
    'Sort': '1',
    'Description': 'Intraday',
    'Added': 'FIX.4.4',
    'AddedEP': '1'
  },
  {
    'Tag': '716',
    'Value': 'RTH',
    'SymbolicName': 'RegularTradingHours',
    'Group': '',
    'Sort': '2',
    'Description': 'Regular Trading Hours',
    'Added': 'FIX.4.4',
    'AddedEP': '1'
  },
  {
    'Tag': '716',
    'Value': 'ETH',
    'SymbolicName': 'ElectronicTradingHours',
    'Group': '',
    'Sort': '3',
    'Description': 'Electronic Trading Hours',
    'Added': 'FIX.4.4',
    'AddedEP': '1'
  },
  {
    'Tag': '716',
    'Value': 'EOD',
    'SymbolicName': 'EndOfDay',
    'Group': '',
    'Sort': '4',
    'Description': 'End Of Day',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '718',
    'Value': '0',
    'SymbolicName': 'ProcessRequestAsMarginDisposition',
    'Group': '',
    'Sort': '1',
    'Description': 'Process Request As Margin Disposition',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '718',
    'Value': '1',
    'SymbolicName': 'DeltaPlus',
    'Group': '',
    'Sort': '2',
    'Description': 'Delta Plus',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '718',
    'Value': '2',
    'SymbolicName': 'DeltaMinus',
    'Group': '',
    'Sort': '3',
    'Description': 'Delta Minus',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '718',
    'Value': '3',
    'SymbolicName': 'Final',
    'Group': '',
    'Sort': '4',
    'Description': 'Final',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '722',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '722',
    'Value': '1',
    'SymbolicName': 'AcceptedWithWarnings',
    'Group': '',
    'Sort': '2',
    'Description': 'Accepted With Warnings',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '722',
    'Value': '2',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '3',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '722',
    'Value': '3',
    'SymbolicName': 'Completed',
    'Group': '',
    'Sort': '4',
    'Description': 'Completed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '722',
    'Value': '4',
    'SymbolicName': 'CompletedWithWarnings',
    'Group': '',
    'Sort': '5',
    'Description': 'Completed With Warnings',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '723',
    'Value': '0',
    'SymbolicName': 'SuccessfulCompletion',
    'Group': '',
    'Sort': '1',
    'Description': 'Successful Completion - no warnings or errors',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '723',
    'Value': '1',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '2',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '723',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '724',
    'Value': '0',
    'SymbolicName': 'Positions',
    'Group': '',
    'Sort': '1',
    'Description': 'Positions',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '724',
    'Value': '1',
    'SymbolicName': 'Trades',
    'Group': '',
    'Sort': '2',
    'Description': 'Trades',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '724',
    'Value': '2',
    'SymbolicName': 'Exercises',
    'Group': '',
    'Sort': '3',
    'Description': 'Exercises',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '724',
    'Value': '3',
    'SymbolicName': 'Assignments',
    'Group': '',
    'Sort': '4',
    'Description': 'Assignments',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '724',
    'Value': '4',
    'SymbolicName': 'SettlementActivity',
    'Group': '',
    'Sort': '5',
    'Description': 'Settlement Activity',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '724',
    'Value': '5',
    'SymbolicName': 'BackoutMessage',
    'Group': '',
    'Sort': '6',
    'Description': 'Backout Message',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '725',
    'Value': '0',
    'SymbolicName': 'Inband',
    'Group': '',
    'Sort': '1',
    'Description': 'Inband - transport the request was sent over (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '725',
    'Value': '1',
    'SymbolicName': 'OutOfBand',
    'Group': '',
    'Sort': '2',
    'Description': 'Out of Band - pre-arranged out-of-band delivery mechanizm (i.e. FTP, HTTP, NDM, etc.) between counterparties. Details specified via ResponseDestination (726).',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '728',
    'Value': '0',
    'SymbolicName': 'ValidRequest',
    'Group': '',
    'Sort': '1',
    'Description': 'Valid request',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '728',
    'Value': '1',
    'SymbolicName': 'InvalidOrUnsupportedRequest',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid or unsupported request',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '728',
    'Value': '2',
    'SymbolicName': 'NoPositionsFoundThatMatchCriteria',
    'Group': '',
    'Sort': '3',
    'Description': 'No positions found that match criteria',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '728',
    'Value': '3',
    'SymbolicName': 'NotAuthorizedToRequestPositions',
    'Group': '',
    'Sort': '4',
    'Description': 'Not authorized to request positions',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '728',
    'Value': '4',
    'SymbolicName': 'RequestForPositionNotSupported',
    'Group': '',
    'Sort': '5',
    'Description': 'Request for position not supported',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '728',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other (use Text (58) in conjunction with this code for an explaination)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '729',
    'Value': '0',
    'SymbolicName': 'Completed',
    'Group': '',
    'Sort': '1',
    'Description': 'Completed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '729',
    'Value': '1',
    'SymbolicName': 'CompletedWithWarnings',
    'Group': '',
    'Sort': '2',
    'Description': 'Completed With Warnings',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '729',
    'Value': '2',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '3',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '731',
    'Value': '1',
    'SymbolicName': 'Final',
    'Group': '',
    'Sort': '1',
    'Description': 'Final',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '731',
    'Value': '2',
    'SymbolicName': 'Theoretical',
    'Group': '',
    'Sort': '2',
    'Description': 'Theoretical',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '744',
    'Value': 'P',
    'SymbolicName': 'ProRata',
    'Group': '',
    'Sort': '1',
    'Description': 'Pro rata',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '744',
    'Value': 'R',
    'SymbolicName': 'Random',
    'Group': '',
    'Sort': '2',
    'Description': 'Random',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '747',
    'Value': 'A',
    'SymbolicName': 'Automatic',
    'Group': '',
    'Sort': '1',
    'Description': 'Automatic',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '747',
    'Value': 'M',
    'SymbolicName': 'Manual',
    'Group': '',
    'Sort': '2',
    'Description': 'Manual',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '0',
    'SymbolicName': 'Successful',
    'Group': '',
    'Sort': '1',
    'Description': 'Successful (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '1',
    'SymbolicName': 'InvalidOrUnknownInstrument',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid or unknown instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '2',
    'SymbolicName': 'InvalidTypeOfTradeRequested',
    'Group': '',
    'Sort': '3',
    'Description': 'Invalid type of trade requested',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '3',
    'SymbolicName': 'InvalidParties',
    'Group': '',
    'Sort': '4',
    'Description': 'Invalid parties',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '4',
    'SymbolicName': 'InvalidTransportTypeRequested',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid transport type requested',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '5',
    'SymbolicName': 'InvalidDestinationRequested',
    'Group': '',
    'Sort': '6',
    'Description': 'Invalid destination requested',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '8',
    'SymbolicName': 'TradeRequestTypeNotSupported',
    'Group': '',
    'Sort': '7',
    'Description': 'TradeRequestType not supported',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '9',
    'SymbolicName': 'NotAuthorized',
    'Group': '',
    'Sort': '8',
    'Description': 'Not authorized',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '749',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '750',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '750',
    'Value': '1',
    'SymbolicName': 'Completed',
    'Group': '',
    'Sort': '2',
    'Description': 'Completed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '750',
    'Value': '2',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '3',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '751',
    'Value': '0',
    'SymbolicName': 'Successful',
    'Group': '',
    'Sort': '1',
    'Description': 'Successful (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '751',
    'Value': '1',
    'SymbolicName': 'InvalidPartyOnformation',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid party onformation',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '751',
    'Value': '2',
    'SymbolicName': 'UnknownInstrument',
    'Group': '',
    'Sort': '3',
    'Description': 'Unknown instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '751',
    'Value': '3',
    'SymbolicName': 'UnauthorizedToReportTrades',
    'Group': '',
    'Sort': '4',
    'Description': 'Unauthorized to report trades',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '751',
    'Value': '4',
    'SymbolicName': 'InvalidTradeType',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid trade type',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '751',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '752',
    'Value': '1',
    'SymbolicName': 'SingleSecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Single Security (default if not specified)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '752',
    'Value': '2',
    'SymbolicName': 'IndividualLegOfAMultilegSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Individual leg of a multileg security',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '752',
    'Value': '3',
    'SymbolicName': 'MultilegSecurity',
    'Group': '',
    'Sort': '3',
    'Description': 'Multileg Security',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '770',
    'Value': '1',
    'SymbolicName': 'ExecutionTime',
    'Group': '',
    'Sort': '1',
    'Description': 'Execution Time',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '770',
    'Value': '2',
    'SymbolicName': 'TimeIn',
    'Group': '',
    'Sort': '2',
    'Description': 'Time In',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '770',
    'Value': '3',
    'SymbolicName': 'TimeOut',
    'Group': '',
    'Sort': '3',
    'Description': 'Time Out',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '770',
    'Value': '4',
    'SymbolicName': 'BrokerReceipt',
    'Group': '',
    'Sort': '4',
    'Description': 'Broker Receipt',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '770',
    'Value': '5',
    'SymbolicName': 'BrokerExecution',
    'Group': '',
    'Sort': '5',
    'Description': 'Broker Execution',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '770',
    'Value': '6',
    'SymbolicName': 'DeskReceipt',
    'Group': '',
    'Sort': '6',
    'Description': 'Desk Receipt',
    'Added': 'FIX.4.4',
    'AddedEP': '9'
  },
  {
    'Tag': '773',
    'Value': '1',
    'SymbolicName': 'Status',
    'Group': '',
    'Sort': '1',
    'Description': 'Status',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '773',
    'Value': '2',
    'SymbolicName': 'Confirmation',
    'Group': '',
    'Sort': '2',
    'Description': 'Confirmation',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '773',
    'Value': '3',
    'SymbolicName': 'ConfirmationRequestRejected',
    'Group': '',
    'Sort': '3',
    'Description': 'Confirmation Request Rejected (reason can be stated in Text (58) field)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '774',
    'Value': '1',
    'SymbolicName': 'MismatchedAccount',
    'Group': '',
    'Sort': '1',
    'Description': 'Mismatched account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '774',
    'Value': '2',
    'SymbolicName': 'MissingSettlementInstructions',
    'Group': '',
    'Sort': '2',
    'Description': 'Missing settlement instructions',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '774',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '775',
    'Value': '0',
    'SymbolicName': 'RegularBooking',
    'Group': '',
    'Sort': '1',
    'Description': 'Regular booking',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '775',
    'Value': '1',
    'SymbolicName': 'CFD',
    'Group': '',
    'Sort': '2',
    'Description': 'CFD (Contract for difference)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '775',
    'Value': '2',
    'SymbolicName': 'TotalReturnSwap',
    'Group': '',
    'Sort': '3',
    'Description': 'Total Return Swap',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '780',
    'Value': '0',
    'SymbolicName': 'UseDefaultInstructions',
    'Group': '',
    'Sort': '1',
    'Description': 'Use default instructions',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '780',
    'Value': '1',
    'SymbolicName': 'DeriveFromParametersProvided',
    'Group': '',
    'Sort': '2',
    'Description': 'Derive from parameters provided',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '780',
    'Value': '2',
    'SymbolicName': 'FullDetailsProvided',
    'Group': '',
    'Sort': '3',
    'Description': 'Full details provided',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '780',
    'Value': '3',
    'SymbolicName': 'SSIDBIDsProvided',
    'Group': '',
    'Sort': '4',
    'Description': 'SSI DB IDs provided',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '780',
    'Value': '4',
    'SymbolicName': 'PhoneForInstructions',
    'Group': '',
    'Sort': '5',
    'Description': 'Phone for instructions',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '787',
    'Value': 'C',
    'SymbolicName': 'Cash',
    'Group': '',
    'Sort': '1',
    'Description': 'Cash',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '787',
    'Value': 'S',
    'SymbolicName': 'Securities',
    'Group': '',
    'Sort': '2',
    'Description': 'Securities',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '788',
    'Value': '1',
    'SymbolicName': 'Overnight',
    'Group': '',
    'Sort': '1',
    'Description': 'Overnight',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '788',
    'Value': '2',
    'SymbolicName': 'Term',
    'Group': '',
    'Sort': '2',
    'Description': 'Term',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '788',
    'Value': '3',
    'SymbolicName': 'Flexible',
    'Group': '',
    'Sort': '3',
    'Description': 'Flexible',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '788',
    'Value': '4',
    'SymbolicName': 'Open',
    'Group': '',
    'Sort': '4',
    'Description': 'Open',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '792',
    'Value': '0',
    'SymbolicName': 'UnableToProcessRequest',
    'Group': '',
    'Sort': '1',
    'Description': 'Unable to process request',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '792',
    'Value': '1',
    'SymbolicName': 'UnknownAccount',
    'Group': '',
    'Sort': '2',
    'Description': 'Unknown account',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '792',
    'Value': '2',
    'SymbolicName': 'NoMatchingSettlementInstructionsFound',
    'Group': '',
    'Sort': '3',
    'Description': 'No matching settlement instructions found',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '792',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '794',
    'Value': '2',
    'SymbolicName': 'PreliminaryRequestToIntermediary',
    'Group': '',
    'Sort': '1',
    'Description': 'Preliminary Request to Intermediary',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '794',
    'Value': '3',
    'SymbolicName': 'SellsideCalculatedUsingPreliminary',
    'Group': '',
    'Sort': '2',
    'Description': 'Sellside Calculated Using Preliminary (includes MiscFees and NetMoney)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '794',
    'Value': '4',
    'SymbolicName': 'SellsideCalculatedWithoutPreliminary',
    'Group': '',
    'Sort': '3',
    'Description': 'Sellside Calculated Without Preliminary (sent unsolicited by sellside, includes MiscFees and NetMoney)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '794',
    'Value': '5',
    'SymbolicName': 'WarehouseRecap',
    'Group': '',
    'Sort': '4',
    'Description': 'Warehouse Recap',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '794',
    'Value': '8',
    'SymbolicName': 'RequestToIntermediary',
    'Group': '',
    'Sort': '5',
    'Description': 'Request to Intermediary',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '794',
    'Value': '9',
    'SymbolicName': 'Accept',
    'Group': '',
    'Sort': '6',
    'Description': 'Accept',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '794',
    'Value': '10',
    'SymbolicName': 'Reject',
    'Group': '',
    'Sort': '7',
    'Description': 'Reject',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '794',
    'Value': '11',
    'SymbolicName': 'AcceptPending',
    'Group': '',
    'Sort': '8',
    'Description': 'Accept Pending',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '794',
    'Value': '12',
    'SymbolicName': 'Complete',
    'Group': '',
    'Sort': '9',
    'Description': 'Complete',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '794',
    'Value': '14',
    'SymbolicName': 'ReversePending',
    'Group': '',
    'Sort': '10',
    'Description': 'Reverse Pending',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '796',
    'Value': '1',
    'SymbolicName': 'OriginalDetailsIncomplete',
    'Group': '',
    'Sort': '1',
    'Description': 'Original details incomplete/incorrect',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '796',
    'Value': '2',
    'SymbolicName': 'ChangeInUnderlyingOrderDetails',
    'Group': '',
    'Sort': '2',
    'Description': 'Change in underlying order details',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '796',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '1',
    'SymbolicName': 'CarriedCustomerSide',
    'Group': '',
    'Sort': '1',
    'Description': 'Account is carried pn customer side of books',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '2',
    'SymbolicName': 'CarriedNonCustomerSide',
    'Group': '',
    'Sort': '2',
    'Description': 'Account is carried on non-customer side of books',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '3',
    'SymbolicName': 'HouseTrader',
    'Group': '',
    'Sort': '3',
    'Description': 'House trader',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '4',
    'SymbolicName': 'FloorTrader',
    'Group': '',
    'Sort': '4',
    'Description': 'Floor trader',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '6',
    'SymbolicName': 'CarriedNonCustomerSideCrossMargined',
    'Group': '',
    'Sort': '5',
    'Description': 'Account is carried on non-customer side of books and is cross margined',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '7',
    'SymbolicName': 'HouseTraderCrossMargined',
    'Group': '',
    'Sort': '6',
    'Description': 'Account is house trader and is cross margined',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '798',
    'Value': '8',
    'SymbolicName': 'JointBackOfficeAccount',
    'Group': '',
    'Sort': '7',
    'Description': 'Joint back office account (JBO)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '1',
    'SymbolicName': 'Firm',
    'Group': '',
    'Sort': '0',
    'Description': 'Firm',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '2',
    'SymbolicName': 'Person',
    'Group': '',
    'Sort': '1',
    'Description': 'Person',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '3',
    'SymbolicName': 'System',
    'Group': '',
    'Sort': '2',
    'Description': 'System',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '4',
    'SymbolicName': 'Application',
    'Group': '',
    'Sort': '3',
    'Description': 'Application',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '5',
    'SymbolicName': 'FullLegalNameOfFirm',
    'Group': '',
    'Sort': '4',
    'Description': 'Full legal name of firm',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '6',
    'SymbolicName': 'PostalAddress',
    'Group': '',
    'Sort': '5',
    'Description': 'Postal address',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '7',
    'SymbolicName': 'PhoneNumber',
    'Group': '',
    'Sort': '6',
    'Description': 'Phone number',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '8',
    'SymbolicName': 'EmailAddress',
    'Group': '',
    'Sort': '7',
    'Description': 'Email address',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '9',
    'SymbolicName': 'ContactName',
    'Group': '',
    'Sort': '8',
    'Description': 'Contact name',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '10',
    'SymbolicName': 'SecuritiesAccountNumber',
    'Group': '',
    'Sort': '9',
    'Description': 'Securities account number (for settlement instructions)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '11',
    'SymbolicName': 'RegistrationNumber',
    'Group': '',
    'Sort': '10',
    'Description': 'Registration number (for settlement instructions and confirmations)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '12',
    'SymbolicName': 'RegisteredAddressForConfirmation',
    'Group': '',
    'Sort': '11',
    'Description': 'Registered address (for confirmation purposes)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '13',
    'SymbolicName': 'RegulatoryStatus',
    'Group': '',
    'Sort': '12',
    'Description': 'Regulatory status (for confirmation purposes)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '14',
    'SymbolicName': 'RegistrationName',
    'Group': '',
    'Sort': '13',
    'Description': 'Registration name (for settlement instructions)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '15',
    'SymbolicName': 'CashAccountNumber',
    'Group': '',
    'Sort': '14',
    'Description': 'Cash account number (for settlement instructions)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '16',
    'SymbolicName': 'BIC',
    'Group': '',
    'Sort': '15',
    'Description': 'BIC',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '17',
    'SymbolicName': 'CSDParticipantMemberCode',
    'Group': '',
    'Sort': '16',
    'Description': 'CSD participant member code',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '18',
    'SymbolicName': 'RegisteredAddress',
    'Group': '',
    'Sort': '17',
    'Description': 'Registered address',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '19',
    'SymbolicName': 'FundAccountName',
    'Group': '',
    'Sort': '18',
    'Description': 'Fund account name',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '20',
    'SymbolicName': 'TelexNumber',
    'Group': '',
    'Sort': '19',
    'Description': 'Telex number',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '21',
    'SymbolicName': 'FaxNumber',
    'Group': '',
    'Sort': '20',
    'Description': 'Fax number',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '22',
    'SymbolicName': 'SecuritiesAccountName',
    'Group': '',
    'Sort': '21',
    'Description': 'Securities account name',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '23',
    'SymbolicName': 'CashAccountName',
    'Group': '',
    'Sort': '22',
    'Description': 'Cash account name',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '24',
    'SymbolicName': 'Department',
    'Group': '',
    'Sort': '23',
    'Description': 'Department',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '25',
    'SymbolicName': 'LocationDesk',
    'Group': '',
    'Sort': '24',
    'Description': 'Location desk',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '26',
    'SymbolicName': 'PositionAccountType',
    'Group': '',
    'Sort': '25',
    'Description': 'Position account type',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '803',
    'Value': '27',
    'SymbolicName': 'SecurityLocateID',
    'Group': '',
    'Sort': '26',
    'Description': 'Security locate ID',
    'Added': 'FIX.4.4',
    'AddedEP': '1'
  },
  {
    'Tag': '803',
    'Value': '28',
    'SymbolicName': 'MarketMaker',
    'Group': '',
    'Sort': '27',
    'Description': 'Market maker',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '803',
    'Value': '29',
    'SymbolicName': 'EligibleCounterparty',
    'Group': '',
    'Sort': '28',
    'Description': 'Eligible counterparty',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '803',
    'Value': '30',
    'SymbolicName': 'ProfessionalClient',
    'Group': '',
    'Sort': '29',
    'Description': 'Professional client',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '803',
    'Value': '31',
    'SymbolicName': 'Location',
    'Group': '',
    'Sort': '30',
    'Description': 'Location',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '803',
    'Value': '32',
    'SymbolicName': 'ExecutionVenue',
    'Group': '',
    'Sort': '31',
    'Description': 'Execution venue',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '803',
    'Value': '33',
    'SymbolicName': 'CurrencyDeliveryIdentifier',
    'Group': '',
    'Sort': '99',
    'Description': 'Currency delivery identifier',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '808',
    'Value': '1',
    'SymbolicName': 'PendingAccept',
    'Group': '',
    'Sort': '1',
    'Description': 'Pending Accept',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '808',
    'Value': '2',
    'SymbolicName': 'PendingRelease',
    'Group': '',
    'Sort': '2',
    'Description': 'Pending Release',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '808',
    'Value': '3',
    'SymbolicName': 'PendingReversal',
    'Group': '',
    'Sort': '3',
    'Description': 'Pending Reversal',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '808',
    'Value': '4',
    'SymbolicName': 'Accept',
    'Group': '',
    'Sort': '4',
    'Description': 'Accept',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '808',
    'Value': '5',
    'SymbolicName': 'BlockLevelReject',
    'Group': '',
    'Sort': '5',
    'Description': 'Block Level Reject',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '808',
    'Value': '6',
    'SymbolicName': 'AccountLevelReject',
    'Group': '',
    'Sort': '6',
    'Description': 'Account Level Reject',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '814',
    'Value': '0',
    'SymbolicName': 'NoActionTaken',
    'Group': '',
    'Sort': '1',
    'Description': 'No Action Taken',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '814',
    'Value': '1',
    'SymbolicName': 'QueueFlushed',
    'Group': '',
    'Sort': '2',
    'Description': 'Queue Flushed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '814',
    'Value': '2',
    'SymbolicName': 'OverlayLast',
    'Group': '',
    'Sort': '3',
    'Description': 'Overlay Last',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '814',
    'Value': '3',
    'SymbolicName': 'EndSession',
    'Group': '',
    'Sort': '4',
    'Description': 'End Session',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '815',
    'Value': '0',
    'SymbolicName': 'NoActionTaken',
    'Group': '',
    'Sort': '1',
    'Description': 'No Action Taken',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '815',
    'Value': '1',
    'SymbolicName': 'QueueFlushed',
    'Group': '',
    'Sort': '2',
    'Description': 'Queue Flushed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '815',
    'Value': '2',
    'SymbolicName': 'OverlayLast',
    'Group': '',
    'Sort': '3',
    'Description': 'Overlay Last',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '815',
    'Value': '3',
    'SymbolicName': 'EndSession',
    'Group': '',
    'Sort': '4',
    'Description': 'End Session',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '819',
    'Value': '0',
    'SymbolicName': 'NoAveragePricing',
    'Group': '',
    'Sort': '1',
    'Description': 'No Average Pricing',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '819',
    'Value': '1',
    'SymbolicName': 'Trade',
    'Group': '',
    'Sort': '2',
    'Description': 'Trade is part of an average price group identified by the TradeLinkID (820)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '819',
    'Value': '2',
    'SymbolicName': 'LastTrade',
    'Group': '',
    'Sort': '3',
    'Description': 'Last trade is the average price group identified by the TradeLinkID (820)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '826',
    'Value': '0',
    'SymbolicName': 'AllocationNotRequired',
    'Group': '',
    'Sort': '1',
    'Description': 'Allocation not required',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '826',
    'Value': '1',
    'SymbolicName': 'AllocationRequired',
    'Group': '',
    'Sort': '2',
    'Description': 'Allocation required (give-up trade) allocation information not provided (incomplete)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '826',
    'Value': '2',
    'SymbolicName': 'UseAllocationProvidedWithTheTrade',
    'Group': '',
    'Sort': '3',
    'Description': 'Use allocation provided with the trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '826',
    'Value': '3',
    'SymbolicName': 'AllocationGiveUpExecutor',
    'Group': '',
    'Sort': '4',
    'Description': 'Allocation give-up executor',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '826',
    'Value': '4',
    'SymbolicName': 'AllocationFromExecutor',
    'Group': '',
    'Sort': '5',
    'Description': 'Allocation from executor',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '826',
    'Value': '5',
    'SymbolicName': 'AllocationToClaimAccount',
    'Group': '',
    'Sort': '6',
    'Description': 'Allocation to claim account',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '827',
    'Value': '0',
    'SymbolicName': 'ExpireOnTradingSessionClose',
    'Group': '',
    'Sort': '1',
    'Description': 'Expire on trading session close (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '827',
    'Value': '1',
    'SymbolicName': 'ExpireOnTradingSessionOpen',
    'Group': '',
    'Sort': '2',
    'Description': 'Expire on trading session open',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '827',
    'Value': '2',
    'SymbolicName': 'SpecifiedExpiration',
    'Group': '',
    'Sort': '3',
    'Description': 'Trading eligibility expiration specified in the date and time fields [EventDate(866) and EventTime(1145)] associated with EventType(865)=7(Last Eligible Trade Date)',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '828',
    'Value': '0',
    'SymbolicName': 'RegularTrade',
    'Group': '',
    'Sort': '0',
    'Description': 'Regular Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '1',
    'SymbolicName': 'BlockTrade',
    'Group': '',
    'Sort': '1',
    'Description': 'Block Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '2',
    'SymbolicName': 'EFP',
    'Group': '',
    'Sort': '2',
    'Description': 'EFP (Exchange for physical)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '3',
    'SymbolicName': 'Transfer',
    'Group': '',
    'Sort': '3',
    'Description': 'Transfer',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '4',
    'SymbolicName': 'LateTrade',
    'Group': '',
    'Sort': '4',
    'Description': 'Late Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '5',
    'SymbolicName': 'TTrade',
    'Group': '',
    'Sort': '5',
    'Description': 'T Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '6',
    'SymbolicName': 'WeightedAveragePriceTrade',
    'Group': '',
    'Sort': '6',
    'Description': 'Weighted Average Price Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '7',
    'SymbolicName': 'BunchedTrade',
    'Group': '',
    'Sort': '7',
    'Description': 'Bunched Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '8',
    'SymbolicName': 'LateBunchedTrade',
    'Group': '',
    'Sort': '8',
    'Description': 'Late Bunched Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '9',
    'SymbolicName': 'PriorReferencePriceTrade',
    'Group': '',
    'Sort': '9',
    'Description': 'Prior Reference Price Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '10',
    'SymbolicName': 'AfterHoursTrade',
    'Group': '',
    'Sort': '10',
    'Description': 'After Hours Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '828',
    'Value': '11',
    'SymbolicName': 'ExchangeForRisk',
    'Group': '',
    'Sort': '11',
    'Description': 'Exchange for Risk (EFR)',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '12',
    'SymbolicName': 'ExchangeForSwap',
    'Group': '',
    'Sort': '12',
    'Description': 'Exchange for Swap (EFS )',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '13',
    'SymbolicName': 'ExchangeOfFuturesFor',
    'Group': '',
    'Sort': '13',
    'Description': 'Exchange of Futures for (in Market) Futures (EFM ) (e,g, full sized for mini)',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '14',
    'SymbolicName': 'ExchangeOfOptionsForOptions',
    'Group': '',
    'Sort': '14',
    'Description': 'Exchange of Options for Options (EOO)',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '15',
    'SymbolicName': 'TradingAtSettlement',
    'Group': '',
    'Sort': '15',
    'Description': 'Trading at Settlement',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '16',
    'SymbolicName': 'AllOrNone',
    'Group': '',
    'Sort': '16',
    'Description': 'All or None',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '17',
    'SymbolicName': 'FuturesLargeOrderExecution',
    'Group': '',
    'Sort': '17',
    'Description': 'Futures Large Order Execution',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '18',
    'SymbolicName': 'ExchangeOfFuturesForFutures',
    'Group': '',
    'Sort': '18',
    'Description': 'Exchange of Futures for Futures (external market) (EFF)',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '19',
    'SymbolicName': 'OptionInterimTrade',
    'Group': '',
    'Sort': '19',
    'Description': 'Option Interim Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '20',
    'SymbolicName': 'OptionCabinetTrade',
    'Group': '',
    'Sort': '20',
    'Description': 'Option Cabinet Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '828',
    'Value': '22',
    'SymbolicName': 'PrivatelyNegotiatedTrades',
    'Group': '',
    'Sort': '21',
    'Description': 'Privately Negotiated Trades',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '828',
    'Value': '23',
    'SymbolicName': 'SubstitutionOfFuturesForForwards',
    'Group': '',
    'Sort': '22',
    'Description': 'Substitution of Futures for Forwards',
    'Added': 'FIX.4.4',
    'AddedEP': '19'
  },
  {
    'Tag': '828',
    'Value': '48',
    'SymbolicName': 'NonStandardSettlement',
    'Group': '',
    'Sort': '48',
    'Description': 'Non-standard settlement',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '49',
    'SymbolicName': 'DerivativeRelatedTransaction',
    'Group': '',
    'Sort': '49',
    'Description': 'Derivative Related Transaction',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '50',
    'SymbolicName': 'PortfolioTrade',
    'Group': '',
    'Sort': '50',
    'Description': 'Portfolio Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '51',
    'SymbolicName': 'VolumeWeightedAverageTrade',
    'Group': '',
    'Sort': '51',
    'Description': 'Volume Weighted Average Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '52',
    'SymbolicName': 'ExchangeGrantedTrade',
    'Group': '',
    'Sort': '52',
    'Description': 'Exchange Granted Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '53',
    'SymbolicName': 'RepurchaseAgreement',
    'Group': '',
    'Sort': '53',
    'Description': 'Repurchase Agreement',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '54',
    'SymbolicName': 'OTC',
    'Group': '',
    'Sort': '54',
    'Description': 'OTC',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '828',
    'Value': '55',
    'SymbolicName': 'ExchangeBasisFacility',
    'Group': '',
    'Sort': '55',
    'Description': 'Exchange Basis Facility (EBF)',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '828',
    'Value': '24',
    'SymbolicName': 'ErrorTrade',
    'Group': 'MiFID Values',
    'Sort': '24',
    'Description': 'Error trade',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '25',
    'SymbolicName': 'SpecialCumDividend',
    'Group': 'MiFID Values',
    'Sort': '25',
    'Description': 'Special cum dividend (CD)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '26',
    'SymbolicName': 'SpecialExDividend',
    'Group': 'MiFID Values',
    'Sort': '26',
    'Description': 'Special ex dividend (XD)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '27',
    'SymbolicName': 'SpecialCumCoupon',
    'Group': 'MiFID Values',
    'Sort': '27',
    'Description': 'Special cum coupon (CC)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '28',
    'SymbolicName': 'SpecialExCoupon',
    'Group': 'MiFID Values',
    'Sort': '28',
    'Description': 'Special ex coupon (XC)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '29',
    'SymbolicName': 'CashSettlement',
    'Group': 'MiFID Values',
    'Sort': '29',
    'Description': 'Cash settlement (CS)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '30',
    'SymbolicName': 'SpecialPrice',
    'Group': 'MiFID Values',
    'Sort': '30',
    'Description': 'Special price (usually net- or all-in price) (SP)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '31',
    'SymbolicName': 'GuaranteedDelivery',
    'Group': 'MiFID Values',
    'Sort': '31',
    'Description': 'Guaranteed delivery (GD)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '32',
    'SymbolicName': 'SpecialCumRights',
    'Group': 'MiFID Values',
    'Sort': '32',
    'Description': 'Special cum rights (CR)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '33',
    'SymbolicName': 'SpecialExRights',
    'Group': 'MiFID Values',
    'Sort': '33',
    'Description': 'Special ex rights (XR)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '34',
    'SymbolicName': 'SpecialCumCapitalRepayments',
    'Group': 'MiFID Values',
    'Sort': '34',
    'Description': 'Special cum capital repayments (CP)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '35',
    'SymbolicName': 'SpecialExCapitalRepayments',
    'Group': 'MiFID Values',
    'Sort': '35',
    'Description': 'Special ex capital repayments (XP)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '36',
    'SymbolicName': 'SpecialCumBonus',
    'Group': 'MiFID Values',
    'Sort': '36',
    'Description': 'Special cum bonus (CB)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '37',
    'SymbolicName': 'SpecialExBonus',
    'Group': 'MiFID Values',
    'Sort': '37',
    'Description': 'Special ex bonus (XB)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '38',
    'SymbolicName': 'LargeTrade',
    'Group': 'MiFID Values',
    'Sort': '38',
    'Description': 'Block trade (same as large trade)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '39',
    'SymbolicName': 'WorkedPrincipalTrade',
    'Group': 'MiFID Values',
    'Sort': '39',
    'Description': 'Worked principal trade (UK-specific)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '40',
    'SymbolicName': 'BlockTrades',
    'Group': 'MiFID Values',
    'Sort': '40',
    'Description': 'Block Trades - after market',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '41',
    'SymbolicName': 'NameChange',
    'Group': 'MiFID Values',
    'Sort': '41',
    'Description': 'Name change',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '42',
    'SymbolicName': 'PortfolioTransfer',
    'Group': 'MiFID Values',
    'Sort': '42',
    'Description': 'Portfolio transfer',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '43',
    'SymbolicName': 'ProrogationBuy',
    'Group': 'MiFID Values',
    'Sort': '43',
    'Description': 'Prorogation buy - Euronext Paris only. Is used to defer settlement under French SRD (deferred settlement system) . Trades must be reported as crosses at zero price',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '44',
    'SymbolicName': 'ProrogationSell',
    'Group': 'MiFID Values',
    'Sort': '44',
    'Description': 'Prorogation sell - see prorogation buy',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '45',
    'SymbolicName': 'OptionExercise',
    'Group': 'MiFID Values',
    'Sort': '45',
    'Description': 'Option exercise',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '46',
    'SymbolicName': 'DeltaNeutralTransaction',
    'Group': 'MiFID Values',
    'Sort': '46',
    'Description': 'Delta neutral transaction',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '828',
    'Value': '47',
    'SymbolicName': 'FinancingTransaction',
    'Group': 'MiFID Values',
    'Sort': '47',
    'Description': 'Financing transaction (includes repo and stock lending)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '0',
    'SymbolicName': 'CMTA',
    'Group': '',
    'Sort': '1',
    'Description': 'CMTA',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '829',
    'Value': '1',
    'SymbolicName': 'InternalTransferOrAdjustment',
    'Group': '',
    'Sort': '2',
    'Description': 'Internal transfer or adjustment',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '829',
    'Value': '2',
    'SymbolicName': 'ExternalTransferOrTransferOfAccount',
    'Group': '',
    'Sort': '3',
    'Description': 'External transfer or transfer of account',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '829',
    'Value': '3',
    'SymbolicName': 'RejectForSubmittingSide',
    'Group': '',
    'Sort': '4',
    'Description': 'Reject for submitting side',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '829',
    'Value': '4',
    'SymbolicName': 'AdvisoryForContraSide',
    'Group': '',
    'Sort': '5',
    'Description': 'Advisory for contra side',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '829',
    'Value': '5',
    'SymbolicName': 'OffsetDueToAnAllocation',
    'Group': '',
    'Sort': '6',
    'Description': 'Offset due to an allocation',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '829',
    'Value': '6',
    'SymbolicName': 'OnsetDueToAnAllocation',
    'Group': '',
    'Sort': '7',
    'Description': 'Onset due to an allocation',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '829',
    'Value': '7',
    'SymbolicName': 'DifferentialSpread',
    'Group': '',
    'Sort': '8',
    'Description': 'Differential spread',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '829',
    'Value': '8',
    'SymbolicName': 'ImpliedSpreadLegExecutedAgainstAnOutright',
    'Group': '',
    'Sort': '9',
    'Description': 'Implied spread leg executed against an outright',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '829',
    'Value': '9',
    'SymbolicName': 'TransactionFromExercise',
    'Group': '',
    'Sort': '10',
    'Description': 'Transaction from exercise',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '829',
    'Value': '10',
    'SymbolicName': 'TransactionFromAssignment',
    'Group': '',
    'Sort': '11',
    'Description': 'Transaction from assignment',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '829',
    'Value': '11',
    'SymbolicName': 'ACATS',
    'Group': '',
    'Sort': '12',
    'Description': 'ACATS',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '829',
    'Value': '33',
    'SymbolicName': 'OffHoursTrade',
    'Group': '',
    'Sort': '32',
    'Description': 'Off Hours Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '829',
    'Value': '34',
    'SymbolicName': 'OnHoursTrade',
    'Group': '',
    'Sort': '33',
    'Description': 'On Hours Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '829',
    'Value': '35',
    'SymbolicName': 'OTCQuote',
    'Group': '',
    'Sort': '34',
    'Description': 'OTC Quote',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '829',
    'Value': '36',
    'SymbolicName': 'ConvertedSWAP',
    'Group': '',
    'Sort': '36',
    'Description': 'Converted SWAP',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '829',
    'Value': '14',
    'SymbolicName': 'AI',
    'Group': 'MiFID Values',
    'Sort': '13',
    'Description': 'AI (Automated input facility disabled in response to an exchange request.)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '15',
    'SymbolicName': 'B',
    'Group': 'MiFID Values',
    'Sort': '14',
    'Description': 'B (Transaction between two member firms where neither member firm is registered as a market maker in the security in question and neither is a designated fund manager. Also used by broker dealers when dealing with another broker which is not a member firm. Non-order book securities only.)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '16',
    'SymbolicName': 'K',
    'Group': 'MiFID Values',
    'Sort': '15',
    'Description': 'K (Transaction using block trade facility.)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '17',
    'SymbolicName': 'LC',
    'Group': 'MiFID Values',
    'Sort': '16',
    'Description': 'LC (Correction submitted more than three days after publication of the original trade report.)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '18',
    'SymbolicName': 'M',
    'Group': 'MiFID Values',
    'Sort': '17',
    'Description': 'M (Transaction, other than a transaction resulting from a stock swap or stock switch, between two market makers registered in that security including IDB or a public display system trades. Non-order book securities only.)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '19',
    'SymbolicName': 'N',
    'Group': 'MiFID Values',
    'Sort': '18',
    'Description': 'N (Non-protected portfolio transaction or a fully disclosed portfolio transaction)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '20',
    'SymbolicName': 'NM',
    'Group': 'MiFID Values',
    'Sort': '19',
    'Description': 'NM ( i) transaction where Exchange has granted permission for non-publication\nii)IDB is reporting as seller\niii) submitting a transaction report to the Exchange, where the transaction report is not also a trade report.)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '21',
    'SymbolicName': 'NR',
    'Group': 'MiFID Values',
    'Sort': '20',
    'Description': 'NR (Non-risk transaction in a SEATS security other than an AIM security)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '22',
    'SymbolicName': 'P',
    'Group': 'MiFID Values',
    'Sort': '21',
    'Description': 'P (Protected portfolio transaction or a worked principal agreement to effect a portfolio transaction which includes order book securities)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '23',
    'SymbolicName': 'PA',
    'Group': 'MiFID Values',
    'Sort': '22',
    'Description': 'PA (Protected transaction notification)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '24',
    'SymbolicName': 'PC',
    'Group': 'MiFID Values',
    'Sort': '23',
    'Description': 'PC (Contra trade for transaction which took place on a previous day and which was automatically executed on the Exchange trading system)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '25',
    'SymbolicName': 'PN',
    'Group': 'MiFID Values',
    'Sort': '24',
    'Description': 'PN (Worked principal notification for a portfolio transaction which includes order book securities)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '26',
    'SymbolicName': 'R',
    'Group': 'MiFID Values',
    'Sort': '25',
    'Description': 'R ( (i) riskless principal transaction between non-members where the buying and selling transactions are executed at different prices or on different terms (requires a trade report with trade type indicator R for each transaction)\n(ii) market maker is reporting all the legs of a riskless principal transaction where the buying and selling transactions are executed at different prices (requires a trade report with trade type indicator R for each transaction)or\n(iii) market maker is reporting the onward leg of a riskless principal transaction where the legs are executed at different prices, and another market maker has submitted a trade report using trade type indicator M for the first leg (this requires a single trade report with trade type indicator R).)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '27',
    'SymbolicName': 'RO',
    'Group': 'MiFID Values',
    'Sort': '26',
    'Description': 'RO (Transaction which resulted from the exercise of a traditional option or a stock-settled covered warrant)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '28',
    'SymbolicName': 'RT',
    'Group': 'MiFID Values',
    'Sort': '27',
    'Description': 'RT (Risk transaction in a SEATS security, (excluding AIM security) reported by a market maker registered in that security)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '29',
    'SymbolicName': 'SW',
    'Group': 'MiFID Values',
    'Sort': '28',
    'Description': 'SW (Transactions resulting from stock swap or a stock switch (one report is required for each line of stock))',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '30',
    'SymbolicName': 'T',
    'Group': 'MiFID Values',
    'Sort': '29',
    'Description': 'T (If reporting a single protected transaction)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '31',
    'SymbolicName': 'WN',
    'Group': 'MiFID Values',
    'Sort': '30',
    'Description': 'WN (Worked principal notification for a single order book security)',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '32',
    'SymbolicName': 'WT',
    'Group': 'MiFID Values',
    'Sort': '31',
    'Description': 'WT (Worked principal transaction (other than a portfolio transaction))',
    'Added': 'FIX.4.4',
    'AddedEP': '26'
  },
  {
    'Tag': '829',
    'Value': '37',
    'SymbolicName': 'CrossedTrade',
    'Group': 'MiFID Values',
    'Sort': '37',
    'Description': 'Crossed Trade (X)',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '829',
    'Value': '38',
    'SymbolicName': 'InterimProtectedTrade',
    'Group': 'MiFID Values',
    'Sort': '38',
    'Description': 'Interim Protected Trade (I)',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '829',
    'Value': '39',
    'SymbolicName': 'LargeInScale',
    'Group': 'MiFID Values',
    'Sort': '39',
    'Description': 'Large in Scale (L)',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '835',
    'Value': '0',
    'SymbolicName': 'Floating',
    'Group': '',
    'Sort': '1',
    'Description': 'Floating (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '835',
    'Value': '1',
    'SymbolicName': 'Fixed',
    'Group': '',
    'Sort': '2',
    'Description': 'Fixed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '836',
    'Value': '0',
    'SymbolicName': 'Price',
    'Group': '',
    'Sort': '1',
    'Description': 'Price (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '836',
    'Value': '1',
    'SymbolicName': 'BasisPoints',
    'Group': '',
    'Sort': '2',
    'Description': 'Basis Points',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '836',
    'Value': '2',
    'SymbolicName': 'Ticks',
    'Group': '',
    'Sort': '3',
    'Description': 'Ticks',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '836',
    'Value': '3',
    'SymbolicName': 'PriceTier',
    'Group': '',
    'Sort': '4',
    'Description': 'Price Tier / Level',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '837',
    'Value': '0',
    'SymbolicName': 'OrBetter',
    'Group': '',
    'Sort': '1',
    'Description': 'Or better (default) - price improvement allowed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '837',
    'Value': '1',
    'SymbolicName': 'Strict',
    'Group': '',
    'Sort': '2',
    'Description': 'Strict - limit is a strict limit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '837',
    'Value': '2',
    'SymbolicName': 'OrWorse',
    'Group': '',
    'Sort': '3',
    'Description': 'Or worse - for a buy the peg limit is a minimum and for a sell the peg limit is a maximum (for use for orders which have a price range)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '838',
    'Value': '1',
    'SymbolicName': 'MoreAggressive',
    'Group': '',
    'Sort': '1',
    'Description': 'More aggressive - on a buy order round the price up to the nearest tick; on a sell order round down to the nearest tick',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '838',
    'Value': '2',
    'SymbolicName': 'MorePassive',
    'Group': '',
    'Sort': '2',
    'Description': 'More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '840',
    'Value': '1',
    'SymbolicName': 'Local',
    'Group': '',
    'Sort': '1',
    'Description': 'Local (Exchange, ECN, ATS)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '840',
    'Value': '2',
    'SymbolicName': 'National',
    'Group': '',
    'Sort': '2',
    'Description': 'National',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '840',
    'Value': '3',
    'SymbolicName': 'Global',
    'Group': '',
    'Sort': '3',
    'Description': 'Global',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '840',
    'Value': '4',
    'SymbolicName': 'NationalExcludingLocal',
    'Group': '',
    'Sort': '4',
    'Description': 'National excluding local',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '841',
    'Value': '0',
    'SymbolicName': 'Floating',
    'Group': '',
    'Sort': '1',
    'Description': 'Floating (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '841',
    'Value': '1',
    'SymbolicName': 'Fixed',
    'Group': '',
    'Sort': '2',
    'Description': 'Fixed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '842',
    'Value': '0',
    'SymbolicName': 'Price',
    'Group': '',
    'Sort': '1',
    'Description': 'Price (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '842',
    'Value': '1',
    'SymbolicName': 'BasisPoints',
    'Group': '',
    'Sort': '2',
    'Description': 'Basis Points',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '842',
    'Value': '2',
    'SymbolicName': 'Ticks',
    'Group': '',
    'Sort': '3',
    'Description': 'Ticks',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '842',
    'Value': '3',
    'SymbolicName': 'PriceTier',
    'Group': '',
    'Sort': '4',
    'Description': 'Price Tier / Level',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '843',
    'Value': '0',
    'SymbolicName': 'OrBetter',
    'Group': '',
    'Sort': '1',
    'Description': 'Or better (default) - price improvement allowed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '843',
    'Value': '1',
    'SymbolicName': 'Strict',
    'Group': '',
    'Sort': '2',
    'Description': 'Strict - limit is a strict limit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '843',
    'Value': '2',
    'SymbolicName': 'OrWorse',
    'Group': '',
    'Sort': '3',
    'Description': 'Or worse - for a buy the discretion price is a minimum and for a sell the discretion price is a maximum (for use for orders which have a price range)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '844',
    'Value': '1',
    'SymbolicName': 'MoreAggressive',
    'Group': '',
    'Sort': '1',
    'Description': 'More aggressive - on a buy order round the price up to the nearest tick; on a sell round down to the nearest tick',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '844',
    'Value': '2',
    'SymbolicName': 'MorePassive',
    'Group': '',
    'Sort': '2',
    'Description': 'More passive - on a buy order round down to the nearest tick; on a sell order round up to the nearest tick',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '846',
    'Value': '1',
    'SymbolicName': 'Local',
    'Group': '',
    'Sort': '1',
    'Description': 'Local (Exchange, ECN, ATS)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '846',
    'Value': '2',
    'SymbolicName': 'National',
    'Group': '',
    'Sort': '2',
    'Description': 'National',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '846',
    'Value': '3',
    'SymbolicName': 'Global',
    'Group': '',
    'Sort': '3',
    'Description': 'Global',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '846',
    'Value': '4',
    'SymbolicName': 'NationalExcludingLocal',
    'Group': '',
    'Sort': '4',
    'Description': 'National excluding local',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '847',
    'Value': '1',
    'SymbolicName': 'VWAP',
    'Group': '',
    'Sort': '1',
    'Description': 'VWAP',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '847',
    'Value': '2',
    'SymbolicName': 'Participate',
    'Group': '',
    'Sort': '3',
    'Description': 'Participate (i.e. aim to be x percent of the market volume)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '847',
    'Value': '3',
    'SymbolicName': 'MininizeMarketImpact',
    'Group': '',
    'Sort': '4',
    'Description': 'Mininize market impact',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '851',
    'Value': '1',
    'SymbolicName': 'AddedLiquidity',
    'Group': '',
    'Sort': '1',
    'Description': 'Added Liquidity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '851',
    'Value': '2',
    'SymbolicName': 'RemovedLiquidity',
    'Group': '',
    'Sort': '2',
    'Description': 'Removed Liquidity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '851',
    'Value': '3',
    'SymbolicName': 'LiquidityRoutedOut',
    'Group': '',
    'Sort': '3',
    'Description': 'Liquidity Routed Out',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '851',
    'Value': '4',
    'SymbolicName': 'Auction',
    'Group': '',
    'Sort': '4',
    'Description': 'Auction',
    'Added': 'FIX.5.0',
    'AddedEP': '57'
  },
  {
    'Tag': '852',
    'Value': 'N',
    'SymbolicName': 'DoNotReportTrade',
    'Group': '',
    'Sort': '1',
    'Description': 'Do Not Report Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '852',
    'Value': 'Y',
    'SymbolicName': 'ReportTrade',
    'Group': '',
    'Sort': '2',
    'Description': 'Report Trade',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '853',
    'Value': '0',
    'SymbolicName': 'DealerSoldShort',
    'Group': '',
    'Sort': '1',
    'Description': 'Dealer Sold Short',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '853',
    'Value': '1',
    'SymbolicName': 'DealerSoldShortExempt',
    'Group': '',
    'Sort': '2',
    'Description': 'Dealer Sold Short Exempt',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '853',
    'Value': '2',
    'SymbolicName': 'SellingCustomerSoldShort',
    'Group': '',
    'Sort': '3',
    'Description': 'Selling Customer Sold Short',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '853',
    'Value': '3',
    'SymbolicName': 'SellingCustomerSoldShortExempt',
    'Group': '',
    'Sort': '4',
    'Description': 'Selling Customer Sold Short Exempt',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '853',
    'Value': '4',
    'SymbolicName': 'QualifiedServiceRepresentative',
    'Group': '',
    'Sort': '5',
    'Description': 'Qualified Service Representative (QSR) or Automatic Give-up (AGU) Contra Side Sold Short',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '853',
    'Value': '5',
    'SymbolicName': 'QSROrAGUContraSideSoldShortExempt',
    'Group': '',
    'Sort': '6',
    'Description': 'QSR or AGU Contra Side Sold Short Exempt',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '854',
    'Value': '0',
    'SymbolicName': 'Units',
    'Group': '',
    'Sort': '1',
    'Description': 'Units (shares, par, currency)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '854',
    'Value': '1',
    'SymbolicName': 'Contracts',
    'Group': '',
    'Sort': '2',
    'Description': 'Contracts (if used - must specify ContractMultiplier (tag 231))',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '854',
    'Value': '2',
    'SymbolicName': 'UnitsOfMeasurePerTimeUnit',
    'Group': '',
    'Sort': '3',
    'Description': 'Units of Measure per Time Unit (if used - must specify UnitofMeasure (tag 996) and TimeUnit (tag 997))',
    'Added': 'FIX.4.4',
    'AddedEP': '5'
  },
  {
    'Tag': '856',
    'Value': '0',
    'SymbolicName': 'Submit',
    'Group': '',
    'Sort': '1',
    'Description': 'Submit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '1',
    'SymbolicName': 'Alleged',
    'Group': '',
    'Sort': '2',
    'Description': 'Alleged',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '2',
    'SymbolicName': 'Accept',
    'Group': '',
    'Sort': '3',
    'Description': 'Accept',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '3',
    'SymbolicName': 'Decline',
    'Group': '',
    'Sort': '4',
    'Description': 'Decline',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '4',
    'SymbolicName': 'Addendum',
    'Group': '',
    'Sort': '5',
    'Description': 'Addendum',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '5',
    'SymbolicName': 'No',
    'Group': '',
    'Sort': '6',
    'Description': 'No/Was',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '6',
    'SymbolicName': 'TradeReportCancel',
    'Group': '',
    'Sort': '7',
    'Description': 'Trade Report Cancel',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '7',
    'SymbolicName': 'LockedIn',
    'Group': '',
    'Sort': '8',
    'Description': '(Locked-In) Trade Break',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '856',
    'Value': '8',
    'SymbolicName': 'Defaulted',
    'Group': '',
    'Sort': '9',
    'Description': 'Defaulted',
    'Added': 'FIX.4.4',
    'AddedEP': '4'
  },
  {
    'Tag': '856',
    'Value': '9',
    'SymbolicName': 'InvalidCMTA',
    'Group': '',
    'Sort': '10',
    'Description': 'Invalid CMTA',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '856',
    'Value': '10',
    'SymbolicName': 'Pended',
    'Group': '',
    'Sort': '11',
    'Description': 'Pended',
    'Added': 'FIX.4.4',
    'AddedEP': '23'
  },
  {
    'Tag': '856',
    'Value': '11',
    'SymbolicName': 'AllegedNew',
    'Group': '',
    'Sort': '12',
    'Description': 'Alleged New',
    'Added': 'FIX.4.4',
    'AddedEP': '23'
  },
  {
    'Tag': '856',
    'Value': '12',
    'SymbolicName': 'AllegedAddendum',
    'Group': '',
    'Sort': '13',
    'Description': 'Alleged Addendum',
    'Added': 'FIX.4.4',
    'AddedEP': '23'
  },
  {
    'Tag': '856',
    'Value': '13',
    'SymbolicName': 'AllegedNo',
    'Group': '',
    'Sort': '14',
    'Description': 'Alleged No/Was',
    'Added': 'FIX.4.4',
    'AddedEP': '23'
  },
  {
    'Tag': '856',
    'Value': '14',
    'SymbolicName': 'AllegedTradeReportCancel',
    'Group': '',
    'Sort': '15',
    'Description': 'Alleged Trade Report Cancel',
    'Added': 'FIX.4.4',
    'AddedEP': '23'
  },
  {
    'Tag': '856',
    'Value': '15',
    'SymbolicName': 'AllegedTradeBreak',
    'Group': '',
    'Sort': '16',
    'Description': 'Alleged (Locked-In) Trade Break',
    'Added': 'FIX.4.4',
    'AddedEP': '23'
  },
  {
    'Tag': '857',
    'Value': '0',
    'SymbolicName': 'NotSpecified',
    'Group': '',
    'Sort': '1',
    'Description': 'Not Specified',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '857',
    'Value': '1',
    'SymbolicName': 'ExplicitListProvided',
    'Group': '',
    'Sort': '2',
    'Description': 'Explicit List Provided',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '865',
    'Value': '1',
    'SymbolicName': 'Put',
    'Group': '',
    'Sort': '0',
    'Description': 'Put',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '865',
    'Value': '2',
    'SymbolicName': 'Call',
    'Group': '',
    'Sort': '1',
    'Description': 'Call',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '865',
    'Value': '3',
    'SymbolicName': 'Tender',
    'Group': '',
    'Sort': '2',
    'Description': 'Tender',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '865',
    'Value': '4',
    'SymbolicName': 'SinkingFundCall',
    'Group': '',
    'Sort': '3',
    'Description': 'Sinking Fund Call',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '865',
    'Value': '5',
    'SymbolicName': 'Activation',
    'Group': '',
    'Sort': '4',
    'Description': 'Activation',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '865',
    'Value': '6',
    'SymbolicName': 'Inactiviation',
    'Group': '',
    'Sort': '5',
    'Description': 'Inactiviation',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '865',
    'Value': '7',
    'SymbolicName': 'LastEligibleTradeDate',
    'Group': '',
    'Sort': '6',
    'Description': 'Last Eligible Trade Date',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '865',
    'Value': '8',
    'SymbolicName': 'SwapStartDate',
    'Group': '',
    'Sort': '7',
    'Description': 'Swap Start Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '9',
    'SymbolicName': 'SwapEndDate',
    'Group': '',
    'Sort': '8',
    'Description': 'Swap End Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '10',
    'SymbolicName': 'SwapRollDate',
    'Group': '',
    'Sort': '9',
    'Description': 'Swap Roll Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '11',
    'SymbolicName': 'SwapNextStartDate',
    'Group': '',
    'Sort': '10',
    'Description': 'Swap Next Start Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '12',
    'SymbolicName': 'SwapNextRollDate',
    'Group': '',
    'Sort': '11',
    'Description': 'Swap Next Roll Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '13',
    'SymbolicName': 'FirstDeliveryDate',
    'Group': '',
    'Sort': '12',
    'Description': 'First Delivery Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '14',
    'SymbolicName': 'LastDeliveryDate',
    'Group': '',
    'Sort': '13',
    'Description': 'Last Delivery Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '15',
    'SymbolicName': 'InitialInventoryDueDate',
    'Group': '',
    'Sort': '14',
    'Description': 'Initial Inventory Due Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '16',
    'SymbolicName': 'FinalInventoryDueDate',
    'Group': '',
    'Sort': '15',
    'Description': 'Final Inventory Due Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '17',
    'SymbolicName': 'FirstIntentDate',
    'Group': '',
    'Sort': '16',
    'Description': 'First Intent Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '18',
    'SymbolicName': 'LastIntentDate',
    'Group': '',
    'Sort': '17',
    'Description': 'Last Intent Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '19',
    'SymbolicName': 'PositionRemovalDate',
    'Group': '',
    'Sort': '18',
    'Description': 'Position Removal Date',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '865',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '1',
    'SymbolicName': 'Flat',
    'Group': '',
    'Sort': '0',
    'Description': 'Flat (securities pay interest on a current basis but are traded without interest)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '2',
    'SymbolicName': 'ZeroCoupon',
    'Group': '',
    'Sort': '1',
    'Description': 'Zero coupon',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '3',
    'SymbolicName': 'InterestBearing',
    'Group': '',
    'Sort': '2',
    'Description': 'Interest bearing (for Euro commercial paper when not issued at discount)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '4',
    'SymbolicName': 'NoPeriodicPayments',
    'Group': '',
    'Sort': '3',
    'Description': 'No periodic payments',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '5',
    'SymbolicName': 'VariableRate',
    'Group': '',
    'Sort': '4',
    'Description': 'Variable rate',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '6',
    'SymbolicName': 'LessFeeForPut',
    'Group': '',
    'Sort': '5',
    'Description': 'Less fee for put',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '7',
    'SymbolicName': 'SteppedCoupon',
    'Group': '',
    'Sort': '6',
    'Description': 'Stepped coupon',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '8',
    'SymbolicName': 'CouponPeriod',
    'Group': '',
    'Sort': '7',
    'Description': 'Coupon period (if not semi-annual). Supply redemption date in the InstrAttribValue (872) field.',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '9',
    'SymbolicName': 'When',
    'Group': '',
    'Sort': '8',
    'Description': 'When [and if] issued',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '10',
    'SymbolicName': 'OriginalIssueDiscount',
    'Group': '',
    'Sort': '9',
    'Description': 'Original issue discount',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '11',
    'SymbolicName': 'Callable',
    'Group': '',
    'Sort': '10',
    'Description': 'Callable, puttable',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '12',
    'SymbolicName': 'EscrowedToMaturity',
    'Group': '',
    'Sort': '11',
    'Description': 'Escrowed to Maturity',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '13',
    'SymbolicName': 'EscrowedToRedemptionDate',
    'Group': '',
    'Sort': '12',
    'Description': 'Escrowed to redemption date - callable. Supply redemption date in the InstrAttribValue (872) field',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '14',
    'SymbolicName': 'PreRefunded',
    'Group': '',
    'Sort': '13',
    'Description': 'Pre-refunded',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '15',
    'SymbolicName': 'InDefault',
    'Group': '',
    'Sort': '14',
    'Description': 'In default',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '16',
    'SymbolicName': 'Unrated',
    'Group': '',
    'Sort': '15',
    'Description': 'Unrated',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '17',
    'SymbolicName': 'Taxable',
    'Group': '',
    'Sort': '16',
    'Description': 'Taxable',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '18',
    'SymbolicName': 'Indexed',
    'Group': '',
    'Sort': '17',
    'Description': 'Indexed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '19',
    'SymbolicName': 'SubjectToAlternativeMinimumTax',
    'Group': '',
    'Sort': '18',
    'Description': 'Subject To Alternative Minimum Tax',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '20',
    'SymbolicName': 'OriginalIssueDiscountPrice',
    'Group': '',
    'Sort': '19',
    'Description': 'Original issue discount price. Supply price in the InstrAttribValue (872) field',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '21',
    'SymbolicName': 'CallableBelowMaturityValue',
    'Group': '',
    'Sort': '20',
    'Description': 'Callable below maturity value',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '22',
    'SymbolicName': 'CallableWithoutNotice',
    'Group': '',
    'Sort': '21',
    'Description': 'Callable without notice by mail to holder unless registered',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '871',
    'Value': '23',
    'SymbolicName': 'PriceTickRulesForSecurity',
    'Group': '',
    'Sort': '22',
    'Description': 'Price tick rules for security.',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '871',
    'Value': '24',
    'SymbolicName': 'TradeTypeEligibilityDetailsForSecurity',
    'Group': '',
    'Sort': '23',
    'Description': 'Trade type eligibility details for security.',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '871',
    'Value': '25',
    'SymbolicName': 'InstrumentDenominator',
    'Group': '',
    'Sort': '26',
    'Description': 'Instrument Denominator',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '871',
    'Value': '26',
    'SymbolicName': 'InstrumentNumerator',
    'Group': '',
    'Sort': '27',
    'Description': 'Instrument Numerator',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '871',
    'Value': '27',
    'SymbolicName': 'InstrumentPricePrecision',
    'Group': '',
    'Sort': '28',
    'Description': 'Instrument Price Precision',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '871',
    'Value': '28',
    'SymbolicName': 'InstrumentStrikePrice',
    'Group': '',
    'Sort': '29',
    'Description': 'Instrument Strike Price',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '871',
    'Value': '29',
    'SymbolicName': 'TradeableIndicator',
    'Group': '',
    'Sort': '30',
    'Description': 'Tradeable Indicator',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '871',
    'Value': '99',
    'SymbolicName': 'Text',
    'Group': '',
    'Sort': '99',
    'Description': 'Text. Supply the text of the attribute or disclaimer in the InstrAttribValue (872) field.',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '875',
    'Value': '1',
    'SymbolicName': 'Program3a3',
    'Group': '',
    'Sort': '1',
    'Description': '3(a)(3)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '875',
    'Value': '2',
    'SymbolicName': 'Program42',
    'Group': '',
    'Sort': '2',
    'Description': '4(2)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '875',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '891',
    'Value': '0',
    'SymbolicName': 'Absolute',
    'Group': '',
    'Sort': '1',
    'Description': 'Absolute',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '891',
    'Value': '1',
    'SymbolicName': 'PerUnit',
    'Group': '',
    'Sort': '2',
    'Description': 'Per Unit',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '891',
    'Value': '2',
    'SymbolicName': 'Percentage',
    'Group': '',
    'Sort': '3',
    'Description': 'Percentage',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '893',
    'Value': 'N',
    'SymbolicName': 'NotLastMessage',
    'Group': '',
    'Sort': '1',
    'Description': 'Not Last Message',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '893',
    'Value': 'Y',
    'SymbolicName': 'LastMessage',
    'Group': '',
    'Sort': '2',
    'Description': 'Last Message',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '0',
    'SymbolicName': 'Initial',
    'Group': '',
    'Sort': '1',
    'Description': 'Initial',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '1',
    'SymbolicName': 'Scheduled',
    'Group': '',
    'Sort': '2',
    'Description': 'Scheduled',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '2',
    'SymbolicName': 'TimeWarning',
    'Group': '',
    'Sort': '3',
    'Description': 'Time Warning',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '3',
    'SymbolicName': 'MarginDeficiency',
    'Group': '',
    'Sort': '4',
    'Description': 'Margin Deficiency',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '4',
    'SymbolicName': 'MarginExcess',
    'Group': '',
    'Sort': '5',
    'Description': 'Margin Excess',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '5',
    'SymbolicName': 'ForwardCollateralDemand',
    'Group': '',
    'Sort': '6',
    'Description': 'Forward Collateral Demand',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '6',
    'SymbolicName': 'EventOfDefault',
    'Group': '',
    'Sort': '7',
    'Description': 'Event of default',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '895',
    'Value': '7',
    'SymbolicName': 'AdverseTaxEvent',
    'Group': '',
    'Sort': '8',
    'Description': 'Adverse tax event',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '0',
    'SymbolicName': 'TradeDate',
    'Group': '',
    'Sort': '1',
    'Description': 'Trade Date',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '1',
    'SymbolicName': 'GCInstrument',
    'Group': '',
    'Sort': '2',
    'Description': 'GC Instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '2',
    'SymbolicName': 'CollateralInstrument',
    'Group': '',
    'Sort': '3',
    'Description': 'Collateral Instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '3',
    'SymbolicName': 'SubstitutionEligible',
    'Group': '',
    'Sort': '4',
    'Description': 'Substitution Eligible',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '4',
    'SymbolicName': 'NotAssigned',
    'Group': '',
    'Sort': '5',
    'Description': 'Not Assigned',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '5',
    'SymbolicName': 'PartiallyAssigned',
    'Group': '',
    'Sort': '6',
    'Description': 'Partially Assigned',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '6',
    'SymbolicName': 'FullyAssigned',
    'Group': '',
    'Sort': '7',
    'Description': 'Fully Assigned',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '896',
    'Value': '7',
    'SymbolicName': 'OutstandingTrades',
    'Group': '',
    'Sort': '8',
    'Description': 'Outstanding Trades (Today < end date)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '903',
    'Value': '0',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '1',
    'Description': 'New',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '903',
    'Value': '1',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '2',
    'Description': 'Replace',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '903',
    'Value': '2',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '903',
    'Value': '3',
    'SymbolicName': 'Release',
    'Group': '',
    'Sort': '4',
    'Description': 'Release',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '903',
    'Value': '4',
    'SymbolicName': 'Reverse',
    'Group': '',
    'Sort': '5',
    'Description': 'Reverse',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '905',
    'Value': '0',
    'SymbolicName': 'Received',
    'Group': '',
    'Sort': '1',
    'Description': 'Received',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '905',
    'Value': '1',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '2',
    'Description': 'Accepted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '905',
    'Value': '2',
    'SymbolicName': 'Declined',
    'Group': '',
    'Sort': '3',
    'Description': 'Declined',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '905',
    'Value': '3',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '4',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '0',
    'SymbolicName': 'UnknownDeal',
    'Group': '',
    'Sort': '1',
    'Description': 'Unknown deal (order / trade)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '1',
    'SymbolicName': 'UnknownOrInvalidInstrument',
    'Group': '',
    'Sort': '2',
    'Description': 'Unknown or invalid instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '2',
    'SymbolicName': 'UnauthorizedTransaction',
    'Group': '',
    'Sort': '3',
    'Description': 'Unauthorized transaction',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '3',
    'SymbolicName': 'InsufficientCollateral',
    'Group': '',
    'Sort': '4',
    'Description': 'Insufficient collateral',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '4',
    'SymbolicName': 'InvalidTypeOfCollateral',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid type of collateral',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '5',
    'SymbolicName': 'ExcessiveSubstitution',
    'Group': '',
    'Sort': '6',
    'Description': 'Excessive substitution',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '906',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '910',
    'Value': '0',
    'SymbolicName': 'Unassigned',
    'Group': '',
    'Sort': '1',
    'Description': 'Unassigned',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '910',
    'Value': '1',
    'SymbolicName': 'PartiallyAssigned',
    'Group': '',
    'Sort': '2',
    'Description': 'Partially Assigned',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '910',
    'Value': '2',
    'SymbolicName': 'AssignmentProposed',
    'Group': '',
    'Sort': '3',
    'Description': 'Assignment Proposed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '910',
    'Value': '3',
    'SymbolicName': 'Assigned',
    'Group': '',
    'Sort': '4',
    'Description': 'Assigned (Accepted)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '910',
    'Value': '4',
    'SymbolicName': 'Challenged',
    'Group': '',
    'Sort': '5',
    'Description': 'Challenged',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '912',
    'Value': 'N',
    'SymbolicName': 'NotLastMessage',
    'Group': '',
    'Sort': '1',
    'Description': 'Not last message',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '912',
    'Value': 'Y',
    'SymbolicName': 'LastMessage',
    'Group': '',
    'Sort': '2',
    'Description': 'Last message',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '919',
    'Value': '0',
    'SymbolicName': 'VersusPayment',
    'Group': '',
    'Sort': '1',
    'Description': '\'Versus Payment\': Deliver (if sell) or Receive (if buy) vs. (against) Payment',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '919',
    'Value': '1',
    'SymbolicName': 'Free',
    'Group': '',
    'Sort': '2',
    'Description': '\'Free\': Deliver (if sell) or Receive (if buy) Free',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '919',
    'Value': '2',
    'SymbolicName': 'TriParty',
    'Group': '',
    'Sort': '3',
    'Description': 'Tri-Party',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '919',
    'Value': '3',
    'SymbolicName': 'HoldInCustody',
    'Group': '',
    'Sort': '4',
    'Description': 'Hold In Custody',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '924',
    'Value': '1',
    'SymbolicName': 'LogOnUser',
    'Group': '',
    'Sort': '1',
    'Description': 'Log On User',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '924',
    'Value': '2',
    'SymbolicName': 'LogOffUser',
    'Group': '',
    'Sort': '2',
    'Description': 'Log Off User',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '924',
    'Value': '3',
    'SymbolicName': 'ChangePasswordForUser',
    'Group': '',
    'Sort': '3',
    'Description': 'Change Password For User',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '924',
    'Value': '4',
    'SymbolicName': 'RequestIndividualUserStatus',
    'Group': '',
    'Sort': '4',
    'Description': 'Request Individual User Status',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '1',
    'SymbolicName': 'LoggedIn',
    'Group': '',
    'Sort': '1',
    'Description': 'Logged In',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '2',
    'SymbolicName': 'NotLoggedIn',
    'Group': '',
    'Sort': '2',
    'Description': 'Not Logged In',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '3',
    'SymbolicName': 'UserNotRecognised',
    'Group': '',
    'Sort': '3',
    'Description': 'User Not Recognised',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '4',
    'SymbolicName': 'PasswordIncorrect',
    'Group': '',
    'Sort': '4',
    'Description': 'Password Incorrect',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '5',
    'SymbolicName': 'PasswordChanged',
    'Group': '',
    'Sort': '5',
    'Description': 'Password Changed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '6',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '6',
    'Description': 'Other',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '926',
    'Value': '7',
    'SymbolicName': 'ForcedUserLogoutByExchange',
    'Group': '',
    'Sort': '7',
    'Description': 'Forced user logout by Exchange',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '926',
    'Value': '8',
    'SymbolicName': 'SessionShutdownWarning',
    'Group': '',
    'Sort': '8',
    'Description': 'Session shutdown warning',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '928',
    'Value': '1',
    'SymbolicName': 'Connected',
    'Group': '',
    'Sort': '1',
    'Description': 'Connected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '928',
    'Value': '2',
    'SymbolicName': 'NotConnectedUnexpected',
    'Group': '',
    'Sort': '2',
    'Description': 'Not Connected - down expected up',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '928',
    'Value': '3',
    'SymbolicName': 'NotConnectedExpected',
    'Group': '',
    'Sort': '3',
    'Description': 'Not Connected - down expected down',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '928',
    'Value': '4',
    'SymbolicName': 'InProcess',
    'Group': '',
    'Sort': '4',
    'Description': 'In Process',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '935',
    'Value': '1',
    'SymbolicName': 'Snapshot',
    'Group': '',
    'Sort': '1',
    'Description': 'Snapshot',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '935',
    'Value': '2',
    'SymbolicName': 'Subscribe',
    'Group': '',
    'Sort': '2',
    'Description': 'Subscribe',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '935',
    'Value': '4',
    'SymbolicName': 'StopSubscribing',
    'Group': '',
    'Sort': '3',
    'Description': 'Stop Subscribing',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '935',
    'Value': '8',
    'SymbolicName': 'LevelOfDetail',
    'Group': '',
    'Sort': '4',
    'Description': 'Level of Detail, then NoCompID\'s becomes required',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '937',
    'Value': '1',
    'SymbolicName': 'Full',
    'Group': '',
    'Sort': '1',
    'Description': 'Full',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '937',
    'Value': '2',
    'SymbolicName': 'IncrementalUpdate',
    'Group': '',
    'Sort': '2',
    'Description': 'Incremental Update',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '939',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '939',
    'Value': '1',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '2',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '939',
    'Value': '3',
    'SymbolicName': 'AcceptedWithErrors',
    'Group': '',
    'Sort': '3',
    'Description': 'Accepted with errors',
    'Added': 'FIX.4.4',
    'AddedEP': '13'
  },
  {
    'Tag': '940',
    'Value': '1',
    'SymbolicName': 'Received',
    'Group': '',
    'Sort': '1',
    'Description': 'Received',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '940',
    'Value': '2',
    'SymbolicName': 'ConfirmRejected',
    'Group': '',
    'Sort': '2',
    'Description': 'Confirm rejected, i.e. not affirmed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '940',
    'Value': '3',
    'SymbolicName': 'Affirmed',
    'Group': '',
    'Sort': '3',
    'Description': 'Affirmed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '944',
    'Value': '0',
    'SymbolicName': 'Retain',
    'Group': '',
    'Sort': '1',
    'Description': 'Retain',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '944',
    'Value': '1',
    'SymbolicName': 'Add',
    'Group': '',
    'Sort': '2',
    'Description': 'Add',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '944',
    'Value': '2',
    'SymbolicName': 'Remove',
    'Group': '',
    'Sort': '3',
    'Description': 'Remove',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '945',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '945',
    'Value': '1',
    'SymbolicName': 'AcceptedWithWarnings',
    'Group': '',
    'Sort': '2',
    'Description': 'Accepted With Warnings',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '945',
    'Value': '2',
    'SymbolicName': 'Completed',
    'Group': '',
    'Sort': '3',
    'Description': 'Completed',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '945',
    'Value': '3',
    'SymbolicName': 'CompletedWithWarnings',
    'Group': '',
    'Sort': '4',
    'Description': 'Completed With Warnings',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '945',
    'Value': '4',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '5',
    'Description': 'Rejected',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '0',
    'SymbolicName': 'Successful',
    'Group': '',
    'Sort': '1',
    'Description': 'Successful (default)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '1',
    'SymbolicName': 'InvalidOrUnknownInstrument',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid or unknown instrument',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '2',
    'SymbolicName': 'InvalidOrUnknownCollateralType',
    'Group': '',
    'Sort': '3',
    'Description': 'Invalid or unknown collateral type',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '3',
    'SymbolicName': 'InvalidParties',
    'Group': '',
    'Sort': '4',
    'Description': 'Invalid Parties',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '4',
    'SymbolicName': 'InvalidTransportTypeRequested',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid Transport Type requested',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '5',
    'SymbolicName': 'InvalidDestinationRequested',
    'Group': '',
    'Sort': '6',
    'Description': 'Invalid Destination requested',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '6',
    'SymbolicName': 'NoCollateralFoundForTheTradeSpecified',
    'Group': '',
    'Sort': '7',
    'Description': 'No collateral found for the trade specified',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '7',
    'SymbolicName': 'NoCollateralFoundForTheOrderSpecified',
    'Group': '',
    'Sort': '8',
    'Description': 'No collateral found for the order specified',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '8',
    'SymbolicName': 'CollateralInquiryTypeNotSupported',
    'Group': '',
    'Sort': '9',
    'Description': 'Collateral inquiry type not supported',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '9',
    'SymbolicName': 'UnauthorizedForCollateralInquiry',
    'Group': '',
    'Sort': '10',
    'Description': 'Unauthorized for collateral inquiry',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '946',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other (further information in Text (58) field)',
    'Added': 'FIX.4.4'
  },
  {
    'Tag': '959',
    'Value': '1',
    'SymbolicName': 'Int',
    'Group': '',
    'Sort': '1',
    'Description': 'Int',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '2',
    'SymbolicName': 'Length',
    'Group': '',
    'Sort': '2',
    'Description': 'Length',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '3',
    'SymbolicName': 'NumInGroup',
    'Group': '',
    'Sort': '3',
    'Description': 'NumInGroup',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '4',
    'SymbolicName': 'SeqNum',
    'Group': '',
    'Sort': '4',
    'Description': 'SeqNum',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '5',
    'SymbolicName': 'TagNum',
    'Group': '',
    'Sort': '5',
    'Description': 'TagNum',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '6',
    'SymbolicName': 'Float',
    'Group': '',
    'Sort': '6',
    'Description': 'float',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '7',
    'SymbolicName': 'Qty',
    'Group': '',
    'Sort': '7',
    'Description': 'Qty',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '8',
    'SymbolicName': 'Price',
    'Group': '',
    'Sort': '8',
    'Description': 'Price',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '9',
    'SymbolicName': 'PriceOffset',
    'Group': '',
    'Sort': '9',
    'Description': 'PriceOffset',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '10',
    'SymbolicName': 'Amt',
    'Group': '',
    'Sort': '10',
    'Description': 'Amt',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '11',
    'SymbolicName': 'Percentage',
    'Group': '',
    'Sort': '11',
    'Description': 'Percentage',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '12',
    'SymbolicName': 'Char',
    'Group': '',
    'Sort': '12',
    'Description': 'Char',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '13',
    'SymbolicName': 'Boolean',
    'Group': '',
    'Sort': '13',
    'Description': 'Boolean',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '14',
    'SymbolicName': 'String',
    'Group': '',
    'Sort': '14',
    'Description': 'String',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '15',
    'SymbolicName': 'MultipleCharValue',
    'Group': '',
    'Sort': '15',
    'Description': 'MultipleCharValue',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '16',
    'SymbolicName': 'Currency',
    'Group': '',
    'Sort': '16',
    'Description': 'Currency',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '17',
    'SymbolicName': 'Exchange',
    'Group': '',
    'Sort': '17',
    'Description': 'Exchange',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '18',
    'SymbolicName': 'MonthYear',
    'Group': '',
    'Sort': '18',
    'Description': 'MonthYear',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '19',
    'SymbolicName': 'UTCTimestamp',
    'Group': '',
    'Sort': '19',
    'Description': 'UTCTimestamp',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '20',
    'SymbolicName': 'UTCTimeOnly',
    'Group': '',
    'Sort': '20',
    'Description': 'UTCTimeOnly',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '21',
    'SymbolicName': 'LocalMktDate',
    'Group': '',
    'Sort': '21',
    'Description': 'LocalMktDate',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '22',
    'SymbolicName': 'UTCDateOnly',
    'Group': '',
    'Sort': '22',
    'Description': 'UTCDateOnly',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '23',
    'SymbolicName': 'Data',
    'Group': '',
    'Sort': '23',
    'Description': 'data',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '959',
    'Value': '24',
    'SymbolicName': 'MultipleStringValue',
    'Group': '',
    'Sort': '24',
    'Description': 'MultipleStringValue',
    'Added': 'FIX.4.4',
    'AddedEP': '34'
  },
  {
    'Tag': '965',
    'Value': '1',
    'SymbolicName': 'Active',
    'Group': '',
    'Sort': '1',
    'Description': 'Active',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '965',
    'Value': '2',
    'SymbolicName': 'Inactive',
    'Group': '',
    'Sort': '2',
    'Description': 'Inactive',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '974',
    'Value': 'FIXED',
    'SymbolicName': 'FIXED',
    'Group': '',
    'Sort': '1',
    'Description': 'FIXED',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '974',
    'Value': 'DIFF',
    'SymbolicName': 'DIFF',
    'Group': '',
    'Sort': '2',
    'Description': 'DIFF',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '975',
    'Value': '2',
    'SymbolicName': 'TPlus1',
    'Group': '',
    'Sort': '1',
    'Description': 'T+1',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '975',
    'Value': '4',
    'SymbolicName': 'TPlus3',
    'Group': '',
    'Sort': '2',
    'Description': 'T+3',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '975',
    'Value': '5',
    'SymbolicName': 'TPlus4',
    'Group': '',
    'Sort': '3',
    'Description': 'T+4',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '980',
    'Value': 'A',
    'SymbolicName': 'Add',
    'Group': '',
    'Sort': '1',
    'Description': 'Add',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '980',
    'Value': 'D',
    'SymbolicName': 'Delete',
    'Group': '',
    'Sort': '2',
    'Description': 'Delete',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '980',
    'Value': 'M',
    'SymbolicName': 'Modify',
    'Group': '',
    'Sort': '3',
    'Description': 'Modify',
    'Added': 'FIX.4.4',
    'AddedEP': '8'
  },
  {
    'Tag': '982',
    'Value': '1',
    'SymbolicName': 'AutoExercise',
    'Group': '',
    'Sort': '1',
    'Description': 'Auto Exercise',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '982',
    'Value': '2',
    'SymbolicName': 'NonAutoExercise',
    'Group': '',
    'Sort': '2',
    'Description': 'Non Auto Exercise',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '982',
    'Value': '3',
    'SymbolicName': 'FinalWillBeExercised',
    'Group': '',
    'Sort': '3',
    'Description': 'Final Will Be Exercised',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '982',
    'Value': '4',
    'SymbolicName': 'ContraryIntention',
    'Group': '',
    'Sort': '4',
    'Description': 'Contrary Intention',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '982',
    'Value': '5',
    'SymbolicName': 'Difference',
    'Group': '',
    'Sort': '5',
    'Description': 'Difference',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '992',
    'Value': '1',
    'SymbolicName': 'SubAllocate',
    'Group': '',
    'Sort': '1',
    'Description': 'Sub Allocate',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '992',
    'Value': '2',
    'SymbolicName': 'ThirdPartyAllocation',
    'Group': '',
    'Sort': '2',
    'Description': 'Third Party Allocation',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'Bcf',
    'SymbolicName': 'BillionCubicFeet',
    'Group': 'Fixed Magnitude UOM',
    'Sort': '1',
    'Description': 'Billion cubic feet',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'MMbbl',
    'SymbolicName': 'MillionBarrels',
    'Group': 'Fixed Magnitude UOM',
    'Sort': '5',
    'Description': 'Million Barrels',
    'Added': 'FIX.4.4',
    'AddedEP': '-1',
    'Deprecated': 'FIX.5.0SP1'
  },
  {
    'Tag': '996',
    'Value': 'MMBtu',
    'SymbolicName': 'OneMillionBTU',
    'Group': 'Fixed Magnitude UOM',
    'Sort': '6',
    'Description': 'One Million BTU',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'MWh',
    'SymbolicName': 'MegawattHours',
    'Group': 'Fixed Magnitude UOM',
    'Sort': '7',
    'Description': 'Megawatt hours',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'Bbl',
    'SymbolicName': 'Barrels',
    'Group': 'Variable Quantity UOM',
    'Sort': '0',
    'Description': 'Barrels',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'Bu',
    'SymbolicName': 'Bushels',
    'Group': 'Variable Quantity UOM',
    'Sort': '2',
    'Description': 'Bushels',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'lbs',
    'SymbolicName': 'Pounds',
    'Group': 'Variable Quantity UOM',
    'Sort': '3',
    'Description': 'pounds',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'Gal',
    'SymbolicName': 'Gallons',
    'Group': 'Variable Quantity UOM',
    'Sort': '4',
    'Description': 'Gallons',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'oz_tr',
    'SymbolicName': 'TroyOunces',
    'Group': 'Variable Quantity UOM',
    'Sort': '8',
    'Description': 'Troy Ounces',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 't',
    'SymbolicName': 'MetricTons',
    'Group': 'Variable Quantity UOM',
    'Sort': '9',
    'Description': 'Metric Tons (aka Tonne)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'tn',
    'SymbolicName': 'Tons',
    'Group': 'Variable Quantity UOM',
    'Sort': '10',
    'Description': 'Tons (US)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '996',
    'Value': 'USD',
    'SymbolicName': 'USDollars',
    'Group': 'Variable Quantity UOM',
    'Sort': '11',
    'Description': 'US Dollars',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'H',
    'SymbolicName': 'Hour',
    'Group': '',
    'Sort': '0',
    'Description': 'Hour',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'Min',
    'SymbolicName': 'Minute',
    'Group': '',
    'Sort': '1',
    'Description': 'Minute',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'S',
    'SymbolicName': 'Second',
    'Group': '',
    'Sort': '2',
    'Description': 'Second',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'D',
    'SymbolicName': 'Day',
    'Group': '',
    'Sort': '3',
    'Description': 'Day',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'Wk',
    'SymbolicName': 'Week',
    'Group': '',
    'Sort': '4',
    'Description': 'Week',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'Mo',
    'SymbolicName': 'Month',
    'Group': '',
    'Sort': '5',
    'Description': 'Month',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '997',
    'Value': 'Yr',
    'SymbolicName': 'Year',
    'Group': '',
    'Sort': '6',
    'Description': 'Year',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1002',
    'Value': '1',
    'SymbolicName': 'Automatic',
    'Group': '',
    'Sort': '1',
    'Description': 'Automatic',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1002',
    'Value': '2',
    'SymbolicName': 'Guarantor',
    'Group': '',
    'Sort': '2',
    'Description': 'Guarantor',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1002',
    'Value': '3',
    'SymbolicName': 'Manual',
    'Group': '',
    'Sort': '3',
    'Description': 'Manual',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1015',
    'Value': '0',
    'SymbolicName': 'False',
    'Group': '',
    'Sort': '1',
    'Description': 'false - trade is not an AsOf trade',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1015',
    'Value': '1',
    'SymbolicName': 'True',
    'Group': '',
    'Sort': '2',
    'Description': 'true - trade is an AsOf trade',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1021',
    'Value': '1',
    'SymbolicName': 'TopOfBook',
    'Group': '',
    'Sort': '1',
    'Description': 'Top of Book',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1021',
    'Value': '2',
    'SymbolicName': 'PriceDepth',
    'Group': '',
    'Sort': '2',
    'Description': 'Price Depth',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1021',
    'Value': '3',
    'SymbolicName': 'OrderDepth',
    'Group': '',
    'Sort': '3',
    'Description': 'Order Depth',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1024',
    'Value': '0',
    'SymbolicName': 'Book',
    'Group': '',
    'Sort': '1',
    'Description': 'Book',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1024',
    'Value': '1',
    'SymbolicName': 'OffBook',
    'Group': '',
    'Sort': '2',
    'Description': 'Off-Book',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1024',
    'Value': '2',
    'SymbolicName': 'Cross',
    'Group': '',
    'Sort': '3',
    'Description': 'Cross',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'ADD',
    'SymbolicName': 'AddOnOrder',
    'Group': 'NASD OATS',
    'Sort': '1',
    'Description': 'Add-on Order',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'AON',
    'SymbolicName': 'AllOrNone',
    'Group': 'NASD OATS',
    'Sort': '2',
    'Description': 'All or None',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'CNH',
    'SymbolicName': 'CashNotHeld',
    'Group': 'NASD OATS',
    'Sort': '3',
    'Description': 'Cash Not Held',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'DIR',
    'SymbolicName': 'DirectedOrder',
    'Group': 'NASD OATS',
    'Sort': '4',
    'Description': 'Directed Order',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'E.W',
    'SymbolicName': 'ExchangeForPhysicalTransaction',
    'Group': 'NASD OATS',
    'Sort': '5',
    'Description': 'Exchange for Physical Transaction',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'FOK',
    'SymbolicName': 'FillOrKill',
    'Group': 'NASD OATS',
    'Sort': '6',
    'Description': 'Fill or Kill',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'IO',
    'SymbolicName': 'ImbalanceOnly',
    'Group': 'NASD OATS',
    'Sort': '7',
    'Description': 'Imbalance Only',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'IOC',
    'SymbolicName': 'ImmediateOrCancel',
    'Group': 'NASD OATS',
    'Sort': '8',
    'Description': 'Immediate or Cancel',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'LOO',
    'SymbolicName': 'LimitOnOpen',
    'Group': 'NASD OATS',
    'Sort': '9',
    'Description': 'Limit On Open',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'LOC',
    'SymbolicName': 'LimitOnClose',
    'Group': 'NASD OATS',
    'Sort': '10',
    'Description': 'Limit on Close',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'MAO',
    'SymbolicName': 'MarketAtOpen',
    'Group': 'NASD OATS',
    'Sort': '11',
    'Description': 'Market at Open',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'MAC',
    'SymbolicName': 'MarketAtClose',
    'Group': 'NASD OATS',
    'Sort': '12',
    'Description': 'Market at Close',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'MOO',
    'SymbolicName': 'MarketOnOpen',
    'Group': 'NASD OATS',
    'Sort': '13',
    'Description': 'Market on Open',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'MOC',
    'SymbolicName': 'MarketOnClose',
    'Group': 'NASD OATS',
    'Sort': '14',
    'Description': 'Market On Close',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'MQT',
    'SymbolicName': 'MinimumQuantity',
    'Group': 'NASD OATS',
    'Sort': '15',
    'Description': 'Minimum Quantity',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'NH',
    'SymbolicName': 'NotHeld',
    'Group': 'NASD OATS',
    'Sort': '16',
    'Description': 'Not Held',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'OVD',
    'SymbolicName': 'OverTheDay',
    'Group': 'NASD OATS',
    'Sort': '17',
    'Description': 'Over the Day',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'PEG',
    'SymbolicName': 'Pegged',
    'Group': 'NASD OATS',
    'Sort': '18',
    'Description': 'Pegged',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'RSV',
    'SymbolicName': 'ReserveSizeOrder',
    'Group': 'NASD OATS',
    'Sort': '19',
    'Description': 'Reserve Size Order',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'S.W',
    'SymbolicName': 'StopStockTransaction',
    'Group': 'NASD OATS',
    'Sort': '20',
    'Description': 'Stop Stock Transaction',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'SCL',
    'SymbolicName': 'Scale',
    'Group': 'NASD OATS',
    'Sort': '21',
    'Description': 'Scale',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'TMO',
    'SymbolicName': 'TimeOrder',
    'Group': 'NASD OATS',
    'Sort': '22',
    'Description': 'Time Order',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'TS',
    'SymbolicName': 'TrailingStop',
    'Group': 'NASD OATS',
    'Sort': '23',
    'Description': 'Trailing Stop',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1031',
    'Value': 'WRK',
    'SymbolicName': 'Work',
    'Group': 'NASD OATS',
    'Sort': '24',
    'Description': 'Work',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1032',
    'Value': '1',
    'SymbolicName': 'NASDOATS',
    'Group': '',
    'Sort': '1',
    'Description': 'NASD OATS',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'A',
    'SymbolicName': 'Agency',
    'Group': 'NASD OATS',
    'Sort': '1',
    'Description': 'Agency',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'AR',
    'SymbolicName': 'Arbitrage',
    'Group': 'NASD OATS',
    'Sort': '2',
    'Description': 'Arbitrage',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'D',
    'SymbolicName': 'Derivatives',
    'Group': 'NASD OATS',
    'Sort': '3',
    'Description': 'Derivatives',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'IN',
    'SymbolicName': 'International',
    'Group': 'NASD OATS',
    'Sort': '4',
    'Description': 'International',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'IS',
    'SymbolicName': 'Institutional',
    'Group': 'NASD OATS',
    'Sort': '5',
    'Description': 'Institutional',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'O',
    'SymbolicName': 'Other',
    'Group': 'NASD OATS',
    'Sort': '6',
    'Description': 'Other',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'PF',
    'SymbolicName': 'PreferredTrading',
    'Group': 'NASD OATS',
    'Sort': '7',
    'Description': 'Preferred Trading',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'PR',
    'SymbolicName': 'Proprietary',
    'Group': 'NASD OATS',
    'Sort': '8',
    'Description': 'Proprietary',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'PT',
    'SymbolicName': 'ProgramTrading',
    'Group': 'NASD OATS',
    'Sort': '9',
    'Description': 'Program Trading',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'S',
    'SymbolicName': 'Sales',
    'Group': 'NASD OATS',
    'Sort': '10',
    'Description': 'Sales',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1033',
    'Value': 'T',
    'SymbolicName': 'Trading',
    'Group': 'NASD OATS',
    'Sort': '11',
    'Description': 'Trading',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1034',
    'Value': '1',
    'SymbolicName': 'NASDOATS',
    'Group': '',
    'Sort': '1',
    'Description': 'NASD OATS',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'ADD',
    'SymbolicName': 'AddOnOrder',
    'Group': '',
    'Sort': '1',
    'Description': 'Add-on Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'AON',
    'SymbolicName': 'AllOrNone',
    'Group': '',
    'Sort': '2',
    'Description': 'All or None',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'CNH',
    'SymbolicName': 'CashNotHeld',
    'Group': '',
    'Sort': '3',
    'Description': 'Cash Not Held',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'DIR',
    'SymbolicName': 'DirectedOrder',
    'Group': '',
    'Sort': '4',
    'Description': 'Directed Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'E.W',
    'SymbolicName': 'ExchangeForPhysicalTransaction',
    'Group': '',
    'Sort': '5',
    'Description': 'Exchange for Physical Transaction',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'FOK',
    'SymbolicName': 'FillOrKill',
    'Group': '',
    'Sort': '6',
    'Description': 'Fill or Kill',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'IO',
    'SymbolicName': 'ImbalanceOnly',
    'Group': '',
    'Sort': '7',
    'Description': 'Imbalance Only',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'IOC',
    'SymbolicName': 'ImmediateOrCancel',
    'Group': '',
    'Sort': '8',
    'Description': 'Immediate or Cancel',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'LOO',
    'SymbolicName': 'LimitOnOpen',
    'Group': '',
    'Sort': '9',
    'Description': 'Limit On Open',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'LOC',
    'SymbolicName': 'LimitOnClose',
    'Group': '',
    'Sort': '10',
    'Description': 'Limit on Close',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'MAO',
    'SymbolicName': 'MarketAtOpen',
    'Group': '',
    'Sort': '11',
    'Description': 'Market at Open',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'MAC',
    'SymbolicName': 'MarketAtClose',
    'Group': '',
    'Sort': '12',
    'Description': 'Market at Close',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'MOO',
    'SymbolicName': 'MarketOnOpen',
    'Group': '',
    'Sort': '13',
    'Description': 'Market on Open',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'MOC',
    'SymbolicName': 'MarketOnClose',
    'Group': '',
    'Sort': '14',
    'Description': 'Market On Close',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'MQT',
    'SymbolicName': 'MinimumQuantity',
    'Group': '',
    'Sort': '15',
    'Description': 'Minimum Quantity',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'NH',
    'SymbolicName': 'NotHeld',
    'Group': '',
    'Sort': '16',
    'Description': 'Not Held',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'OVD',
    'SymbolicName': 'OverTheDay',
    'Group': '',
    'Sort': '17',
    'Description': 'Over the Day',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'PEG',
    'SymbolicName': 'Pegged',
    'Group': '',
    'Sort': '18',
    'Description': 'Pegged',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'RSV',
    'SymbolicName': 'ReserveSizeOrder',
    'Group': '',
    'Sort': '19',
    'Description': 'Reserve Size Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'S.W',
    'SymbolicName': 'StopStockTransaction',
    'Group': '',
    'Sort': '20',
    'Description': 'Stop Stock Transaction',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'SCL',
    'SymbolicName': 'Scale',
    'Group': '',
    'Sort': '21',
    'Description': 'Scale',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'TMO',
    'SymbolicName': 'TimeOrder',
    'Group': '',
    'Sort': '22',
    'Description': 'Time Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'TS',
    'SymbolicName': 'TrailingStop',
    'Group': '',
    'Sort': '23',
    'Description': 'Trailing Stop',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1035',
    'Value': 'WRK',
    'SymbolicName': 'Work',
    'Group': '',
    'Sort': '24',
    'Description': 'Work',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1036',
    'Value': '0',
    'SymbolicName': 'Received',
    'Group': '',
    'Sort': '1',
    'Description': 'Received, not yet processed',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1036',
    'Value': '1',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '2',
    'Description': 'Accepted',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1036',
    'Value': '2',
    'SymbolicName': 'Don',
    'Group': '',
    'Sort': '3',
    'Description': 'Don\'t know / Rejected',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1043',
    'Value': '0',
    'SymbolicName': 'SpecificDeposit',
    'Group': '',
    'Sort': '1',
    'Description': 'Specific Deposit',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1043',
    'Value': '1',
    'SymbolicName': 'General',
    'Group': '',
    'Sort': '2',
    'Description': 'General',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1046',
    'Value': 'D',
    'SymbolicName': 'Divide',
    'Group': '',
    'Sort': '0',
    'Description': 'Divide',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1046',
    'Value': 'M',
    'SymbolicName': 'Multiply',
    'Group': '',
    'Sort': '1',
    'Description': 'Multiply',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1047',
    'Value': 'O',
    'SymbolicName': 'Open',
    'Group': '',
    'Sort': '1',
    'Description': 'Open',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1047',
    'Value': 'C',
    'SymbolicName': 'Close',
    'Group': '',
    'Sort': '2',
    'Description': 'Close',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1047',
    'Value': 'R',
    'SymbolicName': 'Rolled',
    'Group': '',
    'Sort': '3',
    'Description': 'Rolled',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1047',
    'Value': 'F',
    'SymbolicName': 'FIFO',
    'Group': '',
    'Sort': '4',
    'Description': 'FIFO',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1057',
    'Value': 'Y',
    'SymbolicName': 'OrderInitiatorIsAggressor',
    'Group': '',
    'Sort': '1',
    'Description': 'Order initiator is aggressor',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1057',
    'Value': 'N',
    'SymbolicName': 'OrderInitiatorIsPassive',
    'Group': '',
    'Sort': '2',
    'Description': 'Order initiator is passive',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1070',
    'Value': '0',
    'SymbolicName': 'Indicative',
    'Group': '',
    'Sort': '1',
    'Description': 'Indicative',
    'Added': 'FIX.4.4',
    'AddedEP': '32'
  },
  {
    'Tag': '1070',
    'Value': '1',
    'SymbolicName': 'Tradeable',
    'Group': '',
    'Sort': '3',
    'Description': 'Tradeable',
    'Added': 'FIX.4.4',
    'AddedEP': '32'
  },
  {
    'Tag': '1070',
    'Value': '2',
    'SymbolicName': 'RestrictedTradeable',
    'Group': '',
    'Sort': '4',
    'Description': 'Restricted Tradeable',
    'Added': 'FIX.4.4',
    'AddedEP': '32'
  },
  {
    'Tag': '1070',
    'Value': '3',
    'SymbolicName': 'Counter',
    'Group': '',
    'Sort': '5',
    'Description': 'Counter',
    'Added': 'FIX.4.4',
    'AddedEP': '32'
  },
  {
    'Tag': '1070',
    'Value': '4',
    'SymbolicName': 'IndicativeAndTradeable',
    'Group': '',
    'Sort': '6',
    'Description': 'Indicative and Tradeable',
    'Added': 'FIX.4.4',
    'AddedEP': '32'
  },
  {
    'Tag': '1081',
    'Value': '0',
    'SymbolicName': 'SecondaryOrderID',
    'Group': '',
    'Sort': '1',
    'Description': 'SecondaryOrderID(198)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1081',
    'Value': '1',
    'SymbolicName': 'OrderID',
    'Group': '',
    'Sort': '2',
    'Description': 'OrderID(37)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1081',
    'Value': '2',
    'SymbolicName': 'MDEntryID',
    'Group': '',
    'Sort': '3',
    'Description': 'MDEntryID(278)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1081',
    'Value': '3',
    'SymbolicName': 'QuoteEntryID',
    'Group': '',
    'Sort': '4',
    'Description': 'QuoteEntryID(299)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1083',
    'Value': '1',
    'SymbolicName': 'Immediate',
    'Group': '',
    'Sort': '1',
    'Description': 'Immediate (after each fill)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1083',
    'Value': '2',
    'SymbolicName': 'Exhaust',
    'Group': '',
    'Sort': '2',
    'Description': 'Exhaust (when DisplayQty = 0)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1084',
    'Value': '1',
    'SymbolicName': 'Initial',
    'Group': '',
    'Sort': '1',
    'Description': 'Initial (use original DisplayQty)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1084',
    'Value': '2',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '2',
    'Description': 'New (use RefreshQty)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1084',
    'Value': '3',
    'SymbolicName': 'Random',
    'Group': '',
    'Sort': '3',
    'Description': 'Random (randomize value)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1092',
    'Value': '0',
    'SymbolicName': 'None',
    'Group': '',
    'Sort': '1',
    'Description': 'None',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1092',
    'Value': '1',
    'SymbolicName': 'Local',
    'Group': '',
    'Sort': '2',
    'Description': 'Local (Exchange, ECN, ATS)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1092',
    'Value': '2',
    'SymbolicName': 'National',
    'Group': '',
    'Sort': '3',
    'Description': 'National (Across all national markets)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1092',
    'Value': '3',
    'SymbolicName': 'Global',
    'Group': '',
    'Sort': '4',
    'Description': 'Global (Across all markets)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1093',
    'Value': '1',
    'SymbolicName': 'OddLot',
    'Group': '',
    'Sort': '1',
    'Description': 'Odd Lot',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1093',
    'Value': '2',
    'SymbolicName': 'RoundLot',
    'Group': '',
    'Sort': '2',
    'Description': 'Round Lot',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1093',
    'Value': '3',
    'SymbolicName': 'BlockLot',
    'Group': '',
    'Sort': '3',
    'Description': 'Block Lot',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '1',
    'SymbolicName': 'LastPeg',
    'Group': '',
    'Sort': '1',
    'Description': 'Last peg (last sale)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '2',
    'SymbolicName': 'MidPricePeg',
    'Group': '',
    'Sort': '2',
    'Description': 'Mid-price peg (midprice of inside quote)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '3',
    'SymbolicName': 'OpeningPeg',
    'Group': '',
    'Sort': '3',
    'Description': 'Opening peg',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '4',
    'SymbolicName': 'MarketPeg',
    'Group': '',
    'Sort': '4',
    'Description': 'Market peg',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '5',
    'SymbolicName': 'PrimaryPeg',
    'Group': '',
    'Sort': '5',
    'Description': 'Primary peg (primary market - buy at bid or sell at offer)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '7',
    'SymbolicName': 'PegToVWAP',
    'Group': '',
    'Sort': '7',
    'Description': 'Peg to VWAP',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '8',
    'SymbolicName': 'TrailingStopPeg',
    'Group': '',
    'Sort': '8',
    'Description': 'Trailing Stop Peg',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1094',
    'Value': '9',
    'SymbolicName': 'PegToLimitPrice',
    'Group': '',
    'Sort': '9',
    'Description': 'Peg to Limit Price',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1100',
    'Value': '1',
    'SymbolicName': 'PartialExecution',
    'Group': '',
    'Sort': '1',
    'Description': 'Partial Execution',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1100',
    'Value': '2',
    'SymbolicName': 'SpecifiedTradingSession',
    'Group': '',
    'Sort': '2',
    'Description': 'Specified Trading Session',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1100',
    'Value': '3',
    'SymbolicName': 'NextAuction',
    'Group': '',
    'Sort': '3',
    'Description': 'Next Auction',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1100',
    'Value': '4',
    'SymbolicName': 'PriceMovement',
    'Group': '',
    'Sort': '4',
    'Description': 'Price Movement',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1101',
    'Value': '1',
    'SymbolicName': 'Activate',
    'Group': '',
    'Sort': '1',
    'Description': 'Activate',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1101',
    'Value': '2',
    'SymbolicName': 'Modify',
    'Group': '',
    'Sort': '2',
    'Description': 'Modify',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1101',
    'Value': '3',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1107',
    'Value': '1',
    'SymbolicName': 'BestOffer',
    'Group': '',
    'Sort': '1',
    'Description': 'Best Offer',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1107',
    'Value': '2',
    'SymbolicName': 'LastTrade',
    'Group': '',
    'Sort': '2',
    'Description': 'Last Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1107',
    'Value': '3',
    'SymbolicName': 'BestBid',
    'Group': '',
    'Sort': '3',
    'Description': 'Best Bid',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1107',
    'Value': '4',
    'SymbolicName': 'BestBidOrLastTrade',
    'Group': '',
    'Sort': '4',
    'Description': 'Best Bid or Last Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1107',
    'Value': '5',
    'SymbolicName': 'BestOfferOrLastTrade',
    'Group': '',
    'Sort': '5',
    'Description': 'Best Offer or Last Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1107',
    'Value': '6',
    'SymbolicName': 'BestMid',
    'Group': '',
    'Sort': '6',
    'Description': 'Best Mid',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1108',
    'Value': '0',
    'SymbolicName': 'None',
    'Group': '',
    'Sort': '1',
    'Description': 'None',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1108',
    'Value': '1',
    'SymbolicName': 'Local',
    'Group': '',
    'Sort': '2',
    'Description': 'Local (Exchange, ECN, ATS)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1108',
    'Value': '2',
    'SymbolicName': 'National',
    'Group': '',
    'Sort': '3',
    'Description': 'National (Across all national markets)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1108',
    'Value': '3',
    'SymbolicName': 'Global',
    'Group': '',
    'Sort': '4',
    'Description': 'Global (Across all markets)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1109',
    'Value': 'U',
    'SymbolicName': 'Up',
    'Group': '',
    'Sort': '1',
    'Description': 'Trigger if the price of the specified type goes UP to or through the specified Trigger Price.',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1109',
    'Value': 'D',
    'SymbolicName': 'Down',
    'Group': '',
    'Sort': '2',
    'Description': 'Trigger if the price of the specified type goes DOWN to or through the specified Trigger Price.',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1111',
    'Value': '1',
    'SymbolicName': 'Market',
    'Group': '',
    'Sort': '1',
    'Description': 'Market',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '1111',
    'Value': '2',
    'SymbolicName': 'Limit',
    'Group': '',
    'Sort': '2',
    'Description': 'Limit',
    'Added': 'FIX.4.4',
    'AddedEP': '35'
  },
  {
    'Tag': '1115',
    'Value': '1',
    'SymbolicName': 'Order',
    'Group': '',
    'Sort': '1',
    'Description': 'Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '2',
    'SymbolicName': 'Quote',
    'Group': '',
    'Sort': '2',
    'Description': 'Quote',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '3',
    'SymbolicName': 'PrivatelyNegotiatedTrade',
    'Group': '',
    'Sort': '3',
    'Description': 'Privately Negotiated Trade',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '4',
    'SymbolicName': 'MultilegOrder',
    'Group': '',
    'Sort': '4',
    'Description': 'Multileg order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '5',
    'SymbolicName': 'LinkedOrder',
    'Group': '',
    'Sort': '5',
    'Description': 'Linked order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '6',
    'SymbolicName': 'QuoteRequest',
    'Group': '',
    'Sort': '6',
    'Description': 'Quote Request',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '7',
    'SymbolicName': 'ImpliedOrder',
    'Group': '',
    'Sort': '7',
    'Description': 'Implied Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '8',
    'SymbolicName': 'CrossOrder',
    'Group': '',
    'Sort': '8',
    'Description': 'Cross Order',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1115',
    'Value': '9',
    'SymbolicName': 'StreamingPrice',
    'Group': '',
    'Sort': '9',
    'Description': 'Streaming price (quote)',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '1123',
    'Value': '0',
    'SymbolicName': 'TradeConfirmation',
    'Group': '',
    'Sort': '1',
    'Description': 'Trade Confirmation',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1123',
    'Value': '1',
    'SymbolicName': 'TwoPartyReport',
    'Group': '',
    'Sort': '2',
    'Description': 'Two-Party Report',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1123',
    'Value': '2',
    'SymbolicName': 'OnePartyReportForMatching',
    'Group': '',
    'Sort': '3',
    'Description': 'One-Party Report for Matching',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1123',
    'Value': '3',
    'SymbolicName': 'OnePartyReportForPassThrough',
    'Group': '',
    'Sort': '4',
    'Description': 'One-Party Report for Pass Through',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1123',
    'Value': '4',
    'SymbolicName': 'AutomatedFloorOrderRouting',
    'Group': '',
    'Sort': '5',
    'Description': 'Automated Floor Order Routing',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1123',
    'Value': '5',
    'SymbolicName': 'TwoPartyReportForClaim',
    'Group': '',
    'Sort': '6',
    'Description': 'Two Party Report for Claim',
    'Added': 'FIX.5.0',
    'AddedEP': '55'
  },
  {
    'Tag': '1128',
    'Value': '0',
    'SymbolicName': 'FIX27',
    'Group': '',
    'Sort': '0',
    'Description': 'FIX27',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '1',
    'SymbolicName': 'FIX30',
    'Group': '',
    'Sort': '1',
    'Description': 'FIX30',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '2',
    'SymbolicName': 'FIX40',
    'Group': '',
    'Sort': '2',
    'Description': 'FIX40',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '3',
    'SymbolicName': 'FIX41',
    'Group': '',
    'Sort': '3',
    'Description': 'FIX41',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '4',
    'SymbolicName': 'FIX42',
    'Group': '',
    'Sort': '4',
    'Description': 'FIX42',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '5',
    'SymbolicName': 'FIX43',
    'Group': '',
    'Sort': '5',
    'Description': 'FIX43',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '6',
    'SymbolicName': 'FIX44',
    'Group': '',
    'Sort': '6',
    'Description': 'FIX44',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '7',
    'SymbolicName': 'FIX50',
    'Group': '',
    'Sort': '7',
    'Description': 'FIX50',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1128',
    'Value': '8',
    'SymbolicName': 'FIX50SP1',
    'Group': '',
    'Sort': '8',
    'Description': 'FIX50SP1',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '1133',
    'Value': 'B',
    'SymbolicName': 'BIC',
    'Group': '',
    'Sort': '1',
    'Description': 'BIC (Bank Identification Code) (ISO 9362)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1133',
    'Value': 'C',
    'SymbolicName': 'GeneralIdentifier',
    'Group': '',
    'Sort': '2',
    'Description': 'Generally accepted market participant identifier (e.g. NASD mnemonic)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1133',
    'Value': 'D',
    'SymbolicName': 'Proprietary',
    'Group': '',
    'Sort': '3',
    'Description': 'Proprietary / Custom code',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1133',
    'Value': 'E',
    'SymbolicName': 'ISOCountryCode',
    'Group': '',
    'Sort': '4',
    'Description': 'ISO Country Code',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1133',
    'Value': 'G',
    'SymbolicName': 'MIC',
    'Group': '',
    'Sort': '5',
    'Description': 'MIC (ISO 10383 - Market Identifier Code)',
    'Added': 'FIX.4.4',
    'AddedEP': '-1'
  },
  {
    'Tag': '1144',
    'Value': '0',
    'SymbolicName': 'NotImplied',
    'Group': '',
    'Sort': '1',
    'Description': 'Not implied',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '1144',
    'Value': '1',
    'SymbolicName': 'ImpliedIn',
    'Group': '',
    'Sort': '2',
    'Description': 'Implied-in - The existence of a multi-leg instrument is implied by the legs of that instrument',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '1144',
    'Value': '2',
    'SymbolicName': 'ImpliedOut',
    'Group': '',
    'Sort': '3',
    'Description': 'Implied-out - The existence of the underlying legs are implied by the multi-leg instrument',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '1144',
    'Value': '3',
    'SymbolicName': 'BothImpliedInAndImpliedOut',
    'Group': '',
    'Sort': '4',
    'Description': 'Both Implied-in and Implied-out',
    'Added': 'FIX.5.0',
    'AddedEP': '42'
  },
  {
    'Tag': '1159',
    'Value': '1',
    'SymbolicName': 'Preliminary',
    'Group': '',
    'Sort': '1',
    'Description': 'Preliminary',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1159',
    'Value': '2',
    'SymbolicName': 'Final',
    'Group': '',
    'Sort': '2',
    'Description': 'Final',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1162',
    'Value': 'C',
    'SymbolicName': 'Cancel',
    'Group': '',
    'Sort': '1',
    'Description': 'Cancel',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1162',
    'Value': 'N',
    'SymbolicName': 'New',
    'Group': '',
    'Sort': '2',
    'Description': 'New',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1162',
    'Value': 'R',
    'SymbolicName': 'Replace',
    'Group': '',
    'Sort': '3',
    'Description': 'Replace',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1162',
    'Value': 'T',
    'SymbolicName': 'Restate',
    'Group': '',
    'Sort': '4',
    'Description': 'Restate',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1164',
    'Value': '1',
    'SymbolicName': 'InstructionsOfBroker',
    'Group': '',
    'Sort': '1',
    'Description': 'Instructions of Broker',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1164',
    'Value': '2',
    'SymbolicName': 'InstructionsForInstitution',
    'Group': '',
    'Sort': '2',
    'Description': 'Instructions for Institution',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1164',
    'Value': '3',
    'SymbolicName': 'Investor',
    'Group': '',
    'Sort': '3',
    'Description': 'Investor',
    'Added': 'FIX.5.0',
    'AddedEP': '44'
  },
  {
    'Tag': '1167',
    'Value': '0',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '5',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '2',
    'Description': 'Rejected',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '6',
    'SymbolicName': 'RemovedFromMarket',
    'Group': '',
    'Sort': '3',
    'Description': 'Removed from Market',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '7',
    'SymbolicName': 'Expired',
    'Group': '',
    'Sort': '4',
    'Description': 'Expired',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '12',
    'SymbolicName': 'LockedMarketWarning',
    'Group': '',
    'Sort': '5',
    'Description': 'Locked Market Warning',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '13',
    'SymbolicName': 'CrossMarketWarning',
    'Group': '',
    'Sort': '6',
    'Description': 'Cross Market Warning',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '14',
    'SymbolicName': 'CanceledDueToLockMarket',
    'Group': '',
    'Sort': '7',
    'Description': 'Canceled due to Lock Market',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '15',
    'SymbolicName': 'CanceledDueToCrossMarket',
    'Group': '',
    'Sort': '8',
    'Description': 'Canceled due to Cross Market',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1167',
    'Value': '16',
    'SymbolicName': 'Active',
    'Group': '',
    'Sort': '9',
    'Description': 'Active',
    'Added': 'FIX.5.0',
    'AddedEP': '45'
  },
  {
    'Tag': '1171',
    'Value': 'Y',
    'SymbolicName': 'PrivateQuote',
    'Group': '',
    'Sort': '1',
    'Description': 'Private Quote',
    'Added': 'FIX.5.0',
    'AddedEP': '46'
  },
  {
    'Tag': '1171',
    'Value': 'N',
    'SymbolicName': 'PublicQuote',
    'Group': '',
    'Sort': '2',
    'Description': 'Public Quote',
    'Added': 'FIX.5.0',
    'AddedEP': '46'
  },
  {
    'Tag': '1172',
    'Value': '1',
    'SymbolicName': 'AllMarketParticipants',
    'Group': '',
    'Sort': '1',
    'Description': 'All market participants',
    'Added': 'FIX.5.0',
    'AddedEP': '46'
  },
  {
    'Tag': '1172',
    'Value': '2',
    'SymbolicName': 'SpecifiedMarketParticipants',
    'Group': '',
    'Sort': '2',
    'Description': 'Specified market participants',
    'Added': 'FIX.5.0',
    'AddedEP': '46'
  },
  {
    'Tag': '1172',
    'Value': '3',
    'SymbolicName': 'AllMarketMakers',
    'Group': '',
    'Sort': '3',
    'Description': 'All Market Makers',
    'Added': 'FIX.5.0',
    'AddedEP': '46'
  },
  {
    'Tag': '1172',
    'Value': '4',
    'SymbolicName': 'PrimaryMarketMaker',
    'Group': '',
    'Sort': '4',
    'Description': 'Primary Market Maker(s)',
    'Added': 'FIX.5.0',
    'AddedEP': '46'
  },
  {
    'Tag': '1174',
    'Value': '1',
    'SymbolicName': 'OrderImbalance',
    'Group': '',
    'Sort': '1',
    'Description': 'Order imbalance, auction is extended',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '2',
    'SymbolicName': 'TradingResumes',
    'Group': '',
    'Sort': '2',
    'Description': 'Trading resumes (after Halt)',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '3',
    'SymbolicName': 'PriceVolatilityInterruption',
    'Group': '',
    'Sort': '3',
    'Description': 'Price Volatility Interruption',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '4',
    'SymbolicName': 'ChangeOfTradingSession',
    'Group': '',
    'Sort': '4',
    'Description': 'Change of Trading Session',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '5',
    'SymbolicName': 'ChangeOfTradingSubsession',
    'Group': '',
    'Sort': '5',
    'Description': 'Change of Trading Subsession',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '6',
    'SymbolicName': 'ChangeOfSecurityTradingStatus',
    'Group': '',
    'Sort': '6',
    'Description': 'Change of Security Trading Status',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '7',
    'SymbolicName': 'ChangeOfBookType',
    'Group': '',
    'Sort': '7',
    'Description': 'Change of Book Type',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1174',
    'Value': '8',
    'SymbolicName': 'ChangeOfMarketDepth',
    'Group': '',
    'Sort': '8',
    'Description': 'Change of Market Depth',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1176',
    'Value': '1',
    'SymbolicName': 'ExchangeLast',
    'Group': '',
    'Sort': '1',
    'Description': 'Exchange Last',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1176',
    'Value': '2',
    'SymbolicName': 'High',
    'Group': '',
    'Sort': '2',
    'Description': 'High / Low Price',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1176',
    'Value': '3',
    'SymbolicName': 'AveragePrice',
    'Group': '',
    'Sort': '3',
    'Description': 'Average Price (VWAP, TWAP ... )',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1176',
    'Value': '4',
    'SymbolicName': 'Turnover',
    'Group': '',
    'Sort': '4',
    'Description': 'Turnover (Price * Qty)',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1178',
    'Value': '1',
    'SymbolicName': 'Customer',
    'Group': '',
    'Sort': '1',
    'Description': 'Customer',
    'Added': 'FIX.5.0',
    'AddedEP': '47'
  },
  {
    'Tag': '1193',
    'Value': 'C',
    'SymbolicName': 'CashSettlementRequired',
    'Group': '',
    'Sort': '1',
    'Description': 'Cash settlement required',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1193',
    'Value': 'P',
    'SymbolicName': 'PhysicalSettlementRequired',
    'Group': '',
    'Sort': '2',
    'Description': 'Physical settlement required',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1194',
    'Value': '0',
    'SymbolicName': 'European',
    'Group': '',
    'Sort': '1',
    'Description': 'European',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1194',
    'Value': '1',
    'SymbolicName': 'American',
    'Group': '',
    'Sort': '2',
    'Description': 'American',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1194',
    'Value': '2',
    'SymbolicName': 'Bermuda',
    'Group': '',
    'Sort': '3',
    'Description': 'Bermuda',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1196',
    'Value': 'STD',
    'SymbolicName': 'Standard',
    'Group': '',
    'Sort': '1',
    'Description': 'Standard, money per unit of a physical',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1196',
    'Value': 'INX',
    'SymbolicName': 'Index',
    'Group': '',
    'Sort': '2',
    'Description': 'Index',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1196',
    'Value': 'INT',
    'SymbolicName': 'InterestRateIndex',
    'Group': '',
    'Sort': '3',
    'Description': 'Interest rate Index',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1197',
    'Value': 'EQTY',
    'SymbolicName': 'PremiumStyle',
    'Group': '',
    'Sort': '1',
    'Description': 'premium style',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1197',
    'Value': 'FUT',
    'SymbolicName': 'FuturesStyleMarkToMarket',
    'Group': '',
    'Sort': '2',
    'Description': 'futures style mark-to-market',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1197',
    'Value': 'FUTDA',
    'SymbolicName': 'FuturesStyleWithAnAttachedCashAdjustment',
    'Group': '',
    'Sort': '3',
    'Description': 'futures style with an attached cash adjustment',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1198',
    'Value': '0',
    'SymbolicName': 'PreListedOnly',
    'Group': '',
    'Sort': '1',
    'Description': 'pre-listed only',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1198',
    'Value': '1',
    'SymbolicName': 'UserRequested',
    'Group': '',
    'Sort': '2',
    'Description': 'user requested',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1209',
    'Value': '0',
    'SymbolicName': 'Regular',
    'Group': '',
    'Sort': '1',
    'Description': 'Regular',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1209',
    'Value': '1',
    'SymbolicName': 'Variable',
    'Group': '',
    'Sort': '2',
    'Description': 'Variable',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1209',
    'Value': '2',
    'SymbolicName': 'Fixed',
    'Group': '',
    'Sort': '3',
    'Description': 'Fixed',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1209',
    'Value': '3',
    'SymbolicName': 'TradedAsASpreadLeg',
    'Group': '',
    'Sort': '4',
    'Description': 'Traded as a spread leg',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1209',
    'Value': '4',
    'SymbolicName': 'SettledAsASpreadLeg',
    'Group': '',
    'Sort': '5',
    'Description': 'Settled as a spread leg',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1302',
    'Value': '0',
    'SymbolicName': 'Months',
    'Group': '',
    'Sort': '1',
    'Description': 'Months',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1302',
    'Value': '1',
    'SymbolicName': 'Days',
    'Group': '',
    'Sort': '2',
    'Description': 'Days',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1302',
    'Value': '2',
    'SymbolicName': 'Weeks',
    'Group': '',
    'Sort': '3',
    'Description': 'Weeks',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1302',
    'Value': '3',
    'SymbolicName': 'Years',
    'Group': '',
    'Sort': '4',
    'Description': 'Years',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1303',
    'Value': '0',
    'SymbolicName': 'YearMonthOnly',
    'Group': '',
    'Sort': '1',
    'Description': 'YearMonth Only (default)',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1303',
    'Value': '1',
    'SymbolicName': 'YearMonthDay',
    'Group': '',
    'Sort': '2',
    'Description': 'YearMonthDay',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1303',
    'Value': '2',
    'SymbolicName': 'YearMonthWeek',
    'Group': '',
    'Sort': '3',
    'Description': 'YearMonthWeek',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1306',
    'Value': '0',
    'SymbolicName': 'Price',
    'Group': '',
    'Sort': '1',
    'Description': 'Price',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1306',
    'Value': '1',
    'SymbolicName': 'Ticks',
    'Group': '',
    'Sort': '2',
    'Description': 'Ticks',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1306',
    'Value': '2',
    'SymbolicName': 'Percentage',
    'Group': '',
    'Sort': '3',
    'Description': 'Percentage',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '0',
    'SymbolicName': 'Symbol',
    'Group': '',
    'Sort': '1',
    'Description': 'Symbol',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '1',
    'SymbolicName': 'SecurityTypeAndOrCFICode',
    'Group': '',
    'Sort': '2',
    'Description': 'SecurityType and or CFICode',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '2',
    'SymbolicName': 'Product',
    'Group': '',
    'Sort': '3',
    'Description': 'Product',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '3',
    'SymbolicName': 'TradingSessionID',
    'Group': '',
    'Sort': '4',
    'Description': 'TradingSessionID',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '4',
    'SymbolicName': 'AllSecurities',
    'Group': '',
    'Sort': '5',
    'Description': 'All Securities',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '5',
    'SymbolicName': 'UndelyingSymbol',
    'Group': '',
    'Sort': '6',
    'Description': 'UndelyingSymbol',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '6',
    'SymbolicName': 'UnderlyingSecurityTypeAndOrCFICode',
    'Group': '',
    'Sort': '7',
    'Description': 'Underlying SecurityType and or CFICode',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '7',
    'SymbolicName': 'UnderlyingProduct',
    'Group': '',
    'Sort': '8',
    'Description': 'Underlying Product',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1307',
    'Value': '8',
    'SymbolicName': 'MarketIDOrMarketID',
    'Group': '',
    'Sort': '9',
    'Description': 'MarketID or MarketID + MarketSegmentID',
    'Added': 'FIX.5.0',
    'AddedEP': '52'
  },
  {
    'Tag': '1395',
    'Value': 'A',
    'SymbolicName': 'Add',
    'Group': '',
    'Sort': '1',
    'Description': 'Add',
    'Added': 'FIX.5.0',
    'AddedEP': '53'
  },
  {
    'Tag': '1395',
    'Value': 'D',
    'SymbolicName': 'Delete',
    'Group': '',
    'Sort': '2',
    'Description': 'Delete',
    'Added': 'FIX.5.0',
    'AddedEP': '53'
  },
  {
    'Tag': '1395',
    'Value': 'M',
    'SymbolicName': 'Modify',
    'Group': '',
    'Sort': '3',
    'Description': 'Modify',
    'Added': 'FIX.5.0',
    'AddedEP': '53'
  },
  {
    'Tag': '1409',
    'Value': '0',
    'SymbolicName': 'SessionActive',
    'Group': '',
    'Sort': '1',
    'Description': 'Session active',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '1',
    'SymbolicName': 'SessionPasswordChanged',
    'Group': '',
    'Sort': '2',
    'Description': 'Session password changed',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '2',
    'SymbolicName': 'SessionPasswordDueToExpire',
    'Group': '',
    'Sort': '3',
    'Description': 'Session password due to expire',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '3',
    'SymbolicName': 'NewSessionPasswordDoesNotComplyWithPolicy',
    'Group': '',
    'Sort': '4',
    'Description': 'New session password does not comply with policy',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '4',
    'SymbolicName': 'SessionLogoutComplete',
    'Group': '',
    'Sort': '5',
    'Description': 'Session logout complete',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '5',
    'SymbolicName': 'InvalidUsernameOrPassword',
    'Group': '',
    'Sort': '6',
    'Description': 'Invalid username or password',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '6',
    'SymbolicName': 'AccountLocked',
    'Group': '',
    'Sort': '7',
    'Description': 'Account locked',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '7',
    'SymbolicName': 'LogonsAreNotAllowedAtThisTime',
    'Group': '',
    'Sort': '8',
    'Description': 'Logons are not allowed at this time',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1409',
    'Value': '8',
    'SymbolicName': 'PasswordExpired',
    'Group': '',
    'Sort': '9',
    'Description': 'Password expired',
    'Added': 'FIX.5.0',
    'AddedEP': '56'
  },
  {
    'Tag': '1368',
    'Value': '0',
    'SymbolicName': 'TradingResumes',
    'Group': '',
    'Sort': '1',
    'Description': 'Trading resumes (after Halt)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1368',
    'Value': '1',
    'SymbolicName': 'ChangeOfTradingSession',
    'Group': '',
    'Sort': '2',
    'Description': 'Change of Trading Session',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1368',
    'Value': '2',
    'SymbolicName': 'ChangeOfTradingSubsession',
    'Group': '',
    'Sort': '3',
    'Description': 'Change of Trading Subsession',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1368',
    'Value': '3',
    'SymbolicName': 'ChangeOfTradingStatus',
    'Group': '',
    'Sort': '4',
    'Description': 'Change of Trading Status',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1373',
    'Value': '1',
    'SymbolicName': 'SuspendOrders',
    'Group': '',
    'Sort': '1',
    'Description': 'Suspend orders',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1373',
    'Value': '2',
    'SymbolicName': 'ReleaseOrdersFromSuspension',
    'Group': '',
    'Sort': '2',
    'Description': 'Release orders from suspension',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1373',
    'Value': '3',
    'SymbolicName': 'CancelOrders',
    'Group': '',
    'Sort': '3',
    'Description': 'Cancel orders',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '1',
    'SymbolicName': 'AllOrdersForASecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'All orders for a security',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '2',
    'SymbolicName': 'AllOrdersForAnUnderlyingSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'All orders for an underlying security',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '3',
    'SymbolicName': 'AllOrdersForAProduct',
    'Group': '',
    'Sort': '3',
    'Description': 'All orders for a Product',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '4',
    'SymbolicName': 'AllOrdersForACFICode',
    'Group': '',
    'Sort': '4',
    'Description': 'All orders for a CFICode',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '5',
    'SymbolicName': 'AllOrdersForASecurityType',
    'Group': '',
    'Sort': '5',
    'Description': 'All orders for a SecurityType',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '6',
    'SymbolicName': 'AllOrdersForATradingSession',
    'Group': '',
    'Sort': '6',
    'Description': 'All orders for a trading session',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '7',
    'SymbolicName': 'AllOrders',
    'Group': '',
    'Sort': '7',
    'Description': 'All orders',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '8',
    'SymbolicName': 'AllOrdersForAMarket',
    'Group': '',
    'Sort': '8',
    'Description': 'All orders for a Market',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '9',
    'SymbolicName': 'AllOrdersForAMarketSegment',
    'Group': '',
    'Sort': '9',
    'Description': 'All orders for a Market Segment',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1374',
    'Value': '10',
    'SymbolicName': 'AllOrdersForASecurityGroup',
    'Group': '',
    'Sort': '10',
    'Description': 'All orders for a Security Group',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1375',
    'Value': '0',
    'SymbolicName': 'Rejected',
    'Group': '',
    'Sort': '0',
    'Description': 'Rejected - See MassActionRejectReason(1376)',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1375',
    'Value': '1',
    'SymbolicName': 'Accepted',
    'Group': '',
    'Sort': '1',
    'Description': 'Accepted',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '0',
    'SymbolicName': 'MassActionNotSupported',
    'Group': '',
    'Sort': '0',
    'Description': 'Mass Action Not Supported',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '1',
    'SymbolicName': 'InvalidOrUnknownSecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Invalid or unknown security',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '2',
    'SymbolicName': 'InvalidOrUnknownUnderlyingSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'Invalid or unknown underlying security',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '3',
    'SymbolicName': 'InvalidOrUnknownProduct',
    'Group': '',
    'Sort': '3',
    'Description': 'Invalid or unknown Product',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '4',
    'SymbolicName': 'InvalidOrUnknownCFICode',
    'Group': '',
    'Sort': '4',
    'Description': 'Invalid or unknown CFICode',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '5',
    'SymbolicName': 'InvalidOrUnknownSecurityType',
    'Group': '',
    'Sort': '5',
    'Description': 'Invalid or unknown SecurityType',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '6',
    'SymbolicName': 'InvalidOrUnknownTradingSession',
    'Group': '',
    'Sort': '6',
    'Description': 'Invalid or unknown trading session',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '7',
    'SymbolicName': 'InvalidOrUnknownMarket',
    'Group': '',
    'Sort': '7',
    'Description': 'Invalid or unknown Market',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '8',
    'SymbolicName': 'InvalidOrUnknownMarketSegment',
    'Group': '',
    'Sort': '8',
    'Description': 'Invalid or unknown Market Segment',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '9',
    'SymbolicName': 'InvalidOrUnknownSecurityGroup',
    'Group': '',
    'Sort': '9',
    'Description': 'Invalid or unknown Security Group',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1376',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.5.0',
    'AddedEP': '58'
  },
  {
    'Tag': '1377',
    'Value': '0',
    'SymbolicName': 'PredefinedMultilegSecurity',
    'Group': '',
    'Sort': '1',
    'Description': 'Predefined Multileg Security',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1377',
    'Value': '1',
    'SymbolicName': 'UserDefinedMultilegSecurity',
    'Group': '',
    'Sort': '2',
    'Description': 'User-defined Multleg Security',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1377',
    'Value': '2',
    'SymbolicName': 'UserDefined',
    'Group': '',
    'Sort': '3',
    'Description': 'User-defined, Non-Securitized, Multileg',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1378',
    'Value': '0',
    'SymbolicName': 'NetPrice',
    'Group': '',
    'Sort': '1',
    'Description': 'Net Price',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1378',
    'Value': '1',
    'SymbolicName': 'ReversedNetPrice',
    'Group': '',
    'Sort': '2',
    'Description': 'Reversed Net Price',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1378',
    'Value': '2',
    'SymbolicName': 'YieldDifference',
    'Group': '',
    'Sort': '3',
    'Description': 'Yield Difference',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1378',
    'Value': '3',
    'SymbolicName': 'Individual',
    'Group': '',
    'Sort': '4',
    'Description': 'Individual',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1378',
    'Value': '4',
    'SymbolicName': 'ContractWeightedAveragePrice',
    'Group': '',
    'Sort': '5',
    'Description': 'Contract Weighted Average Price',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1378',
    'Value': '5',
    'SymbolicName': 'MultipliedPrice',
    'Group': '',
    'Sort': '6',
    'Description': 'Multiplied Price',
    'Added': 'FIX.5.0',
    'AddedEP': '59'
  },
  {
    'Tag': '1385',
    'Value': '1',
    'SymbolicName': 'OneCancelsTheOther',
    'Group': '',
    'Sort': '1',
    'Description': 'One Cancels the Other (OCO)',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1385',
    'Value': '2',
    'SymbolicName': 'OneTriggersTheOther',
    'Group': '',
    'Sort': '2',
    'Description': 'One Triggers the Other (OTO)',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1385',
    'Value': '3',
    'SymbolicName': 'OneUpdatesTheOtherAbsolute',
    'Group': '',
    'Sort': '3',
    'Description': 'One Updates the Other (OUO) - Absolute Quantity Reduction',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1385',
    'Value': '4',
    'SymbolicName': 'OneUpdatesTheOtherProportional',
    'Group': '',
    'Sort': '4',
    'Description': 'One Updates the Other (OUO) - Proportional Quantity Reduction',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '0',
    'SymbolicName': 'BrokerCredit',
    'Group': '',
    'Sort': '1',
    'Description': 'Broker / Exchange option',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '2',
    'SymbolicName': 'ExchangeClosed',
    'Group': '',
    'Sort': '2',
    'Description': 'Exchange closed',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '4',
    'SymbolicName': 'TooLateToEnter',
    'Group': '',
    'Sort': '3',
    'Description': 'Too late to enter',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '5',
    'SymbolicName': 'UnknownOrder',
    'Group': '',
    'Sort': '4',
    'Description': 'Unknown order',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '6',
    'SymbolicName': 'DuplicateOrder',
    'Group': '',
    'Sort': '5',
    'Description': 'Duplicate Order (e.g. dupe ClOrdID)',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '11',
    'SymbolicName': 'UnsupportedOrderCharacteristic',
    'Group': '',
    'Sort': '6',
    'Description': 'Unsupported order characteristic',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1386',
    'Value': '99',
    'SymbolicName': 'Other',
    'Group': '',
    'Sort': '7',
    'Description': 'Other',
    'Added': 'FIX.5.0',
    'AddedEP': '60'
  },
  {
    'Tag': '1390',
    'Value': '0',
    'SymbolicName': 'DoNotPublishTrade',
    'Group': '',
    'Sort': '1',
    'Description': 'Do Not Publish Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '1390',
    'Value': '1',
    'SymbolicName': 'PublishTrade',
    'Group': '',
    'Sort': '2',
    'Description': 'Publish Trade',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '1390',
    'Value': '2',
    'SymbolicName': 'DeferredPublication',
    'Group': '',
    'Sort': '3',
    'Description': 'Deferred Publication',
    'Added': 'FIX.5.0',
    'AddedEP': '61'
  },
  {
    'Tag': '1347',
    'Value': '0',
    'SymbolicName': 'Retransmission',
    'Group': '',
    'Sort': '1',
    'Description': 'Retransmission of application messages for the specified Applications',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1347',
    'Value': '1',
    'SymbolicName': 'Subscription',
    'Group': '',
    'Sort': '2',
    'Description': 'Subscription to the specified Applications',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1347',
    'Value': '2',
    'SymbolicName': 'RequestLastSeqNum',
    'Group': '',
    'Sort': '3',
    'Description': 'Request for the last ApplLastSeqNum published for the specified Applications',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1347',
    'Value': '3',
    'SymbolicName': 'RequestApplications',
    'Group': '',
    'Sort': '4',
    'Description': 'Request valid set of Applications',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1347',
    'Value': '4',
    'SymbolicName': 'Unsubscribe',
    'Group': '',
    'Sort': '5',
    'Description': 'Unsubscribe to the specified Applications',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1348',
    'Value': '0',
    'SymbolicName': 'RequestSuccessfullyProcessed',
    'Group': '',
    'Sort': '1',
    'Description': 'Request successfully processed',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1348',
    'Value': '1',
    'SymbolicName': 'ApplicationDoesNotExist',
    'Group': '',
    'Sort': '2',
    'Description': 'Application does not exist',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1348',
    'Value': '2',
    'SymbolicName': 'MessagesNotAvailable',
    'Group': '',
    'Sort': '3',
    'Description': 'Messages not available',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1354',
    'Value': '0',
    'SymbolicName': 'ApplicationDoesNotExist',
    'Group': '',
    'Sort': '1',
    'Description': 'Application does not exist',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1354',
    'Value': '1',
    'SymbolicName': 'MessagesRequestedAreNotAvailable',
    'Group': '',
    'Sort': '2',
    'Description': 'Messages requested are not available',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1354',
    'Value': '2',
    'SymbolicName': 'UserNotAuthorizedForApplication',
    'Group': '',
    'Sort': '3',
    'Description': 'User not authorized for application',
    'Added': 'FIX.5.0',
    'AddedEP': '63'
  },
  {
    'Tag': '1426',
    'Value': '0',
    'SymbolicName': 'ApplSeqNumReset',
    'Group': '',
    'Sort': '0',
    'Description': 'Reset ApplSeqNum to new value specified in ApplNewSeqNum(1399)',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '1426',
    'Value': '1',
    'SymbolicName': 'LastMessageSent',
    'Group': '',
    'Sort': '1',
    'Description': 'Reports that the last message has been sent for the ApplIDs Refer to RefApplLastSeqNum(1357) for the application sequence number of the last message.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '1426',
    'Value': '2',
    'SymbolicName': 'ApplicationAlive',
    'Group': '',
    'Sort': '2',
    'Description': 'Heartbeat message indicating that Application identified by RefApplID(1355) is still alive. Refer to RefApplLastSeqNum(1357) for the application sequence number of the previous message.',
    'Added': 'FIX.5.0',
    'AddedEP': '-1'
  },
  {
    'Tag': '1429',
    'Value': '0',
    'SymbolicName': 'Seconds',
    'Sort': '0',
    'Description': 'Seconds (default if not specified)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '1',
    'SymbolicName': 'TenthsOfASecond',
    'Sort': '1',
    'Description': 'Tenths of a second',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '2',
    'SymbolicName': 'HundredthsOfASecond',
    'Sort': '2',
    'Description': 'Hundredths of a second',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '3',
    'SymbolicName': 'Milliseconds',
    'Sort': '3',
    'Description': 'milliseconds',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '4',
    'SymbolicName': 'Microseconds',
    'Sort': '4',
    'Description': 'microseconds',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '5',
    'SymbolicName': 'Nanoseconds',
    'Sort': '5',
    'Description': 'nanoseconds',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '10',
    'SymbolicName': 'Minutes',
    'Sort': '10',
    'Description': 'minutes',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '11',
    'SymbolicName': 'Hours',
    'Sort': '11',
    'Description': 'hours',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '12',
    'SymbolicName': 'Days',
    'Sort': '12',
    'Description': 'days',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '13',
    'SymbolicName': 'Weeks',
    'Sort': '13',
    'Description': 'weeks',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '14',
    'SymbolicName': 'Months',
    'Sort': '14',
    'Description': 'months',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1429',
    'Value': '15',
    'SymbolicName': 'Years',
    'Sort': '15',
    'Description': 'years',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1430',
    'Value': 'E',
    'SymbolicName': 'Electronic',
    'Sort': '0',
    'Description': 'Electronic',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1430',
    'Value': 'P',
    'SymbolicName': 'Pit',
    'Sort': '1',
    'Description': 'Pit',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1430',
    'Value': 'X',
    'SymbolicName': 'ExPit',
    'Sort': '2',
    'Description': 'Ex-Pit',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1431',
    'Value': '0',
    'SymbolicName': 'GTCFromPreviousDay',
    'Sort': '0',
    'Description': 'GTC from previous day',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1431',
    'Value': '1',
    'SymbolicName': 'PartialFillRemaining',
    'Sort': '1',
    'Description': 'Partial Fill Remaining',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1431',
    'Value': '2',
    'SymbolicName': 'OrderChanged',
    'Sort': '2',
    'Description': 'Order Changed',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1432',
    'Value': '1',
    'SymbolicName': 'MemberTradingForTheirOwnAccount',
    'Sort': '1',
    'Description': 'Member trading for their own account',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1432',
    'Value': '2',
    'SymbolicName': 'ClearingFirmTradingForItsProprietaryAccount',
    'Sort': '2',
    'Description': 'Clearing Firm trading for its proprietary account',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1432',
    'Value': '3',
    'SymbolicName': 'MemberTradingForAnotherMember',
    'Sort': '3',
    'Description': 'Member trading for another member',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1432',
    'Value': '4',
    'SymbolicName': 'AllOther',
    'Sort': '4',
    'Description': 'All other',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '770',
    'Value': '7',
    'SymbolicName': 'SubmissionToClearing',
    'Sort': '7',
    'Description': 'Submission to Clearing',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '1081',
    'Value': '4',
    'SymbolicName': 'OriginalOrderID',
    'Sort': '4',
    'Description': 'Original order ID',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '77'
  },
  {
    'Tag': '529',
    'Value': 'F',
    'SymbolicName': 'Cross',
    'Sort': '15',
    'Description': 'Cross',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '78'
  },
  {
    'Tag': '1347',
    'Value': '5',
    'SymbolicName': 'CancelRetransmission',
    'Sort': '6',
    'Description': 'Cancel retransmission',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '78',
    'Issue': 'SPEC-674'
  },
  {
    'Tag': '1347',
    'Value': '6',
    'SymbolicName': 'CancelRetransmissionUnsubscribe',
    'Sort': '7',
    'Description': 'Cancel retransmission and unsubscribe to the specified applications',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '78'
  },
  {
    'Tag': '298',
    'Value': '6',
    'SymbolicName': 'CancelByQuoteType',
    'Sort': '6',
    'Description': 'Cancel by QuoteType(537)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '78'
  },
  {
    'Tag': '1084',
    'Value': '4',
    'SymbolicName': 'Undisclosed',
    'Sort': '4',
    'Description': 'Undisclosed (invisible order)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '78'
  },
  {
    'Tag': '724',
    'Value': '6',
    'SymbolicName': 'DeltaPositions',
    'Sort': '7',
    'Description': 'Delta Positions',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '79'
  },
  {
    'Tag': '452',
    'Value': '82',
    'SymbolicName': 'CentralRegistrationDepository',
    'Sort': '82',
    'Description': 'Central Registration Depository (CRD)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '79'
  },
  {
    'Tag': '1434',
    'Value': '0',
    'SymbolicName': 'UtilityProvidedStandardModel',
    'Sort': '0',
    'Description': 'Utility provided standard model',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '79'
  },
  {
    'Tag': '1434',
    'Value': '1',
    'SymbolicName': 'ProprietaryModel',
    'Sort': '1',
    'Description': 'Proprietary (user supplied) model',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '79'
  },
  {
    'Tag': '703',
    'Value': 'DLT',
    'SymbolicName': 'NetDeltaQty',
    'Sort': '25',
    'Description': 'Net Delta Qty',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '79'
  },
  {
    'Tag': '1093',
    'Value': '4',
    'SymbolicName': 'RoundLotBasedUpon',
    'Group': '',
    'Sort': '4',
    'Description': 'Round lot based upon UnitOfMeasure(996)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1435',
    'Value': '0',
    'SymbolicName': 'Shares',
    'Group': '',
    'Sort': '0',
    'Description': 'Shares',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1435',
    'Value': '1',
    'SymbolicName': 'Hours',
    'Group': '',
    'Sort': '1',
    'Description': 'Hours',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1435',
    'Value': '2',
    'SymbolicName': 'Days',
    'Group': '',
    'Sort': '2',
    'Description': 'Days',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1439',
    'Value': '0',
    'SymbolicName': 'NERCEasternOffPeak',
    'Group': '',
    'Sort': '0',
    'Description': 'NERC Eastern Off-Peak',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1439',
    'Value': '1',
    'SymbolicName': 'NERCWesternOffPeak',
    'Group': '',
    'Sort': '1',
    'Description': 'NERC Western Off-Peak',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1439',
    'Value': '2',
    'SymbolicName': 'NERCCalendarAllDaysInMonth',
    'Group': '',
    'Sort': '2',
    'Description': 'NERC Calendar-All Days in month',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1439',
    'Value': '3',
    'SymbolicName': 'NERCEasternPeak',
    'Group': '',
    'Sort': '3',
    'Description': 'NERC Eastern Peak',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1439',
    'Value': '4',
    'SymbolicName': 'NERCWesternPeak',
    'Group': '',
    'Sort': '4',
    'Description': 'NERC Western Peak',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '80'
  },
  {
    'Tag': '1446',
    'Value': '0',
    'SymbolicName': 'Bloomberg',
    'Sort': '0',
    'Description': 'Bloomberg',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '1446',
    'Value': '1',
    'SymbolicName': 'Reuters',
    'Sort': '1',
    'Description': 'Reuters',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '1446',
    'Value': '2',
    'SymbolicName': 'Telerate',
    'Sort': '2',
    'Description': 'Telerate',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '1446',
    'Value': '99',
    'SymbolicName': 'Other',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '1447',
    'Value': '0',
    'SymbolicName': 'Primary',
    'Sort': '0',
    'Description': 'Primary',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '1447',
    'Value': '1',
    'SymbolicName': 'Secondary',
    'Sort': '1',
    'Description': 'Secondary',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '167',
    'Value': 'FXNDF',
    'SymbolicName': 'NonDeliverableForward',
    'Group': 'Currency',
    'Sort': '1',
    'Description': 'Non-deliverable forward',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '167',
    'Value': 'FXSPOT',
    'SymbolicName': 'FXSpot',
    'Group': 'Currency',
    'Sort': '2',
    'Description': 'FX Spot',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '167',
    'Value': 'FXFWD',
    'SymbolicName': 'FXForward',
    'Group': 'Currency',
    'Sort': '3',
    'Description': 'FX Forward',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '167',
    'Value': 'FXSWAP',
    'SymbolicName': 'FXSwap',
    'Group': 'Currency',
    'Sort': '4',
    'Description': 'FX Swap',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '82'
  },
  {
    'Tag': '1449',
    'Value': 'FR',
    'SymbolicName': 'FullRestructuring',
    'Sort': '0',
    'Description': 'Full Restructuring',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1449',
    'Value': 'MR',
    'SymbolicName': 'ModifiedRestructuring',
    'Sort': '1',
    'Description': 'Modified Restructuring',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1449',
    'Value': 'MM',
    'SymbolicName': 'ModifiedModRestructuring',
    'Sort': '2',
    'Description': 'Modified Mod Restructuring',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1449',
    'Value': 'XR',
    'SymbolicName': 'NoRestructuringSpecified',
    'Sort': '3',
    'Description': 'No Restructuring specified',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1450',
    'Value': 'SD',
    'SymbolicName': 'SeniorSecured',
    'Sort': '0',
    'Description': 'Senior Secured',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1450',
    'Value': 'SR',
    'SymbolicName': 'Senior',
    'Sort': '1',
    'Description': 'Senior',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1450',
    'Value': 'SB',
    'SymbolicName': 'Subordinated',
    'Sort': '2',
    'Description': 'Subordinated',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1196',
    'Value': 'PCTPAR',
    'SymbolicName': 'PercentOfPar',
    'Sort': '4',
    'Description': 'Percent of Par',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1197',
    'Value': 'CDS',
    'SymbolicName': 'CDSStyleCollateralization',
    'Sort': '4',
    'Description': 'CDS style collateralization of market to market and coupon',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '1197',
    'Value': 'CDSD',
    'SymbolicName': 'CDSInDeliveryUseRecoveryRateToCalculate',
    'Sort': '5',
    'Description': 'CDS in delivery - use recovery rate to calculate obligation',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'ICPN',
    'SymbolicName': 'InitialTradeCouponAmount',
    'Sort': '9',
    'Description': 'Initial Trade Coupon Amount',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'ACPN',
    'SymbolicName': 'AccruedCouponAmount',
    'Sort': '10',
    'Description': 'Accrued Coupon Amount',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'CPN',
    'SymbolicName': 'CouponAmount',
    'Sort': '11',
    'Description': 'Coupon Amount',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'IACPN',
    'SymbolicName': 'IncrementalAccruedCoupon',
    'Sort': '12',
    'Description': 'Incremental Accrued Coupon',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'CMTM',
    'SymbolicName': 'CollateralizedMarkToMarket',
    'Sort': '13',
    'Description': 'Collateralized Mark to Market',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'ICMTM',
    'SymbolicName': 'IncrementalCollateralizedMarkToMarket',
    'Sort': '14',
    'Description': 'Incremental Collateralized Mark to market',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'DLV',
    'SymbolicName': 'CompensationAmount',
    'Sort': '15',
    'Description': 'Compensation Amount',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'BANK',
    'SymbolicName': 'TotalBankedAmount',
    'Sort': '16',
    'Description': 'Total Banked Amount',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '707',
    'Value': 'COLAT',
    'SymbolicName': 'TotalCollateralizedAmount',
    'Sort': '17',
    'Description': 'Total Collateralized Amount',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '703',
    'Value': 'CEA',
    'SymbolicName': 'CreditEventAdjustment',
    'Sort': '25',
    'Description': 'Credit Event Adjustment',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '703',
    'Value': 'SEA',
    'SymbolicName': 'SuccessionEventAdjustment',
    'Sort': '26',
    'Description': 'Succession Event Adjustment',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '269',
    'Value': 'Y',
    'SymbolicName': 'RecoveryRate',
    'Sort': '34',
    'Description': 'Recovery Rate',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '269',
    'Value': 'Z',
    'SymbolicName': 'RecoveryRateForLong',
    'Sort': '35',
    'Description': 'Recovery Rate for Long',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '269',
    'Value': 'a',
    'SymbolicName': 'RecoveryRateForShort',
    'Sort': '36',
    'Description': 'Recovery Rate for Short',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '276',
    'Value': '6',
    'SymbolicName': 'FullCurve',
    'Sort': '59',
    'Description': 'Full Curve',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '276',
    'Value': '7',
    'SymbolicName': 'FlatCurve',
    'Sort': '60',
    'Description': 'Flat Curve',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '83'
  },
  {
    'Tag': '269',
    'Value': 'W',
    'SymbolicName': 'FixingPrice',
    'Sort': '32',
    'Description': 'Fixing Price',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '84'
  },
  {
    'Tag': '269',
    'Value': 'X',
    'SymbolicName': 'CashRate',
    'Sort': '33',
    'Description': 'Cash Rate',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '84'
  },
  {
    'Tag': '326',
    'Value': '26',
    'SymbolicName': 'PostClose',
    'Sort': '100',
    'Description': 'Post-close',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '84'
  },
  {
    'Tag': '298',
    'Value': '7',
    'SymbolicName': 'CancelForSecurityIssuer',
    'Sort': '7',
    'Description': 'Cancel for Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '298',
    'Value': '8',
    'SymbolicName': 'CancelForIssuerOfUnderlyingSecurity',
    'Sort': '8',
    'Description': 'Cancel for Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '300',
    'Value': '12',
    'SymbolicName': 'InvalidOrUnknownSecurityIssuer',
    'Sort': '12',
    'Description': 'Invalid or unknown Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '300',
    'Value': '13',
    'SymbolicName': 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    'Sort': '13',
    'Description': 'Invalid or unknown Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '530',
    'Value': 'B',
    'SymbolicName': 'CancelOrdersForSecurityIssuer',
    'Sort': '11',
    'Description': 'Cancel for Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85',
    'Issue': 'SPEC-673'
  },
  {
    'Tag': '530',
    'Value': 'C',
    'SymbolicName': 'CancelForIssuerOfUnderlyingSecurity',
    'Sort': '12',
    'Description': 'Cancel for Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '531',
    'Value': 'B',
    'SymbolicName': 'CancelOrdersForASecuritiesIssuer',
    'Sort': '11',
    'Description': 'Cancel Orders for a Securities Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '531',
    'Value': 'C',
    'SymbolicName': 'CancelOrdersForIssuerOfUnderlyingSecurity',
    'Sort': '12',
    'Description': 'Cancel Orders for Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '532',
    'Value': '10',
    'SymbolicName': 'InvalidOrUnknownSecurityIssuer',
    'Sort': '11',
    'Description': 'Invalid or unknown Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '532',
    'Value': '11',
    'SymbolicName': 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    'Sort': '12',
    'Description': 'Invalid or unknown Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '585',
    'Value': '9',
    'SymbolicName': 'StatusForSecurityIssuer',
    'Sort': '9',
    'Description': 'Status for Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '585',
    'Value': '10',
    'SymbolicName': 'StatusForIssuerOfUnderlyingSecurity',
    'Sort': '10',
    'Description': 'Status for Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '1374',
    'Value': '11',
    'SymbolicName': 'CancelForSecurityIssuer',
    'Sort': '11',
    'Description': 'Cancel for Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '1374',
    'Value': '12',
    'SymbolicName': 'CancelForIssuerOfUnderlyingSecurity',
    'Sort': '12',
    'Description': 'Cancel for Issuer of Underlying Security',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '1376',
    'Value': '10',
    'SymbolicName': 'InvalidOrUnknownSecurityIssuer',
    'Sort': '10',
    'Description': 'Invalid or unknown Security Issuer',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '1376',
    'Value': '11',
    'SymbolicName': 'InvalidOrUnknownIssuerOfUnderlyingSecurity',
    'Sort': '11',
    'Description': 'Invalid or unknown Issuer of Underlying Security ',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '85'
  },
  {
    'Tag': '327',
    'Value': '0',
    'SymbolicName': 'NewsDissemination',
    'Sort': '0',
    'Description': 'News Dissemination',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '86'
  },
  {
    'Tag': '327',
    'Value': '1',
    'SymbolicName': 'OrderInflux',
    'Sort': '1',
    'Description': 'Order Influx',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '86'
  },
  {
    'Tag': '327',
    'Value': '2',
    'SymbolicName': 'OrderImbalance',
    'Sort': '2',
    'Description': 'Order Imbalance',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '86'
  },
  {
    'Tag': '327',
    'Value': '3',
    'SymbolicName': 'AdditionalInformation',
    'Sort': '3',
    'Description': 'Additional Information',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '86'
  },
  {
    'Tag': '327',
    'Value': '4',
    'SymbolicName': 'NewsPending',
    'Sort': '4',
    'Description': 'News Pending',
    'Updated': 'FIX.5.0SP1',
    'UpdatedEP': '95',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '86'
  },
  {
    'Tag': '327',
    'Value': '5',
    'SymbolicName': 'EquipmentChangeover',
    'Sort': '5',
    'Description': 'Equipment Changeover',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '86'
  },
  {
    'Tag': '1470',
    'Value': '1',
    'SymbolicName': 'IndustryClassification',
    'Sort': '1',
    'Description': 'Industry Classification',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '1470',
    'Value': '2',
    'SymbolicName': 'TradingList',
    'Sort': '2',
    'Description': 'Trading List',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '1470',
    'Value': '3',
    'SymbolicName': 'Market',
    'Sort': '3',
    'Description': 'Market / Market Segment List',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '1470',
    'Value': '4',
    'SymbolicName': 'NewspaperList',
    'Sort': '4',
    'Description': 'Newspaper List',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '1471',
    'Value': '1',
    'SymbolicName': 'ICB',
    'Sort': '1',
    'Description': 'ICB (Industry Classification Benchmark) published by Dow Jones and FTSE - www.icbenchmark.com',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '1471',
    'Value': '2',
    'SymbolicName': 'NAICS',
    'Sort': '2',
    'Description': 'NAICS (North American Industry Classification System). Replaced SIC (Standard Industry Classification) www.census.gov/naics or  www.naics.com.',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '1471',
    'Value': '3',
    'SymbolicName': 'GICS',
    'Sort': '3',
    'Description': 'GICS (Global Industry Classification Standard) published by Standards & Poor',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '87'
  },
  {
    'Tag': '996',
    'Value': 'Alw',
    'SymbolicName': 'Allowances',
    'Group': 'Variable Quantity UOM',
    'Sort': '13',
    'Description': 'Allowances',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '89'
  },
  {
    'Tag': '1473',
    'Value': '0',
    'SymbolicName': 'CompanyNews',
    'Sort': '0',
    'Description': 'Company News',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1473',
    'Value': '1',
    'SymbolicName': 'MarketplaceNews',
    'Sort': '1',
    'Description': 'Marketplace News',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1473',
    'Value': '2',
    'SymbolicName': 'FinancialMarketNews',
    'Sort': '2',
    'Description': 'Financial Market News',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1473',
    'Value': '3',
    'SymbolicName': 'TechnicalNews',
    'Sort': '3',
    'Description': 'Technical News',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1473',
    'Value': '99',
    'SymbolicName': 'OtherNews',
    'Sort': '99',
    'Description': 'Other News',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1477',
    'Value': '0',
    'SymbolicName': 'Replacement',
    'Sort': '0',
    'Description': 'Replacement',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1477',
    'Value': '1',
    'SymbolicName': 'OtherLanguage',
    'Sort': '1',
    'Description': 'Other Language',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1477',
    'Value': '2',
    'SymbolicName': 'Complimentary',
    'Sort': '2',
    'Description': 'Complimentary',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '90'
  },
  {
    'Tag': '1426',
    'Value': '3',
    'SymbolicName': 'ResendComplete',
    'Sort': '3',
    'Description': 'Application message re-send completed.',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '91'
  },
  {
    'Tag': '1478',
    'Value': '1',
    'SymbolicName': 'FixedStrike',
    'Sort': '1',
    'Description': 'Fixed Strike',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1478',
    'Value': '2',
    'SymbolicName': 'StrikeSetAtExpiration',
    'Sort': '2',
    'Description': 'Strike set at expiration to underlying or other value (lookback floating)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1478',
    'Value': '3',
    'SymbolicName': 'StrikeSetToAverageAcrossLife',
    'Sort': '3',
    'Description': 'Strike set to average of underlying settlement price across the life of the option',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1478',
    'Value': '4',
    'SymbolicName': 'StrikeSetToOptimalValue',
    'Sort': '4',
    'Description': 'Strike set to optimal value',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1479',
    'Value': '1',
    'SymbolicName': 'LessThan',
    'Sort': '1',
    'Description': 'Less than underlying price is in-the-money (ITM)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1479',
    'Value': '2',
    'SymbolicName': 'LessThanOrEqual',
    'Sort': '2',
    'Description': 'Less than or equal to the underlying price is in-the-money(ITM)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1479',
    'Value': '3',
    'SymbolicName': 'Equal',
    'Sort': '3',
    'Description': 'Equal to the underlying price is in-the-money(ITM)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1479',
    'Value': '4',
    'SymbolicName': 'GreaterThanOrEqual',
    'Sort': '4',
    'Description': 'Greater than or equal to underlying price is in-the-money(ITM)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1479',
    'Value': '5',
    'SymbolicName': 'GreaterThan',
    'Sort': '5',
    'Description': 'Greater than underlying is in-the-money(ITM)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1481',
    'Value': '1',
    'SymbolicName': 'Regular',
    'Sort': '1',
    'Description': 'Regular',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1481',
    'Value': '2',
    'SymbolicName': 'SpecialReference',
    'Sort': '2',
    'Description': 'Special reference',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1481',
    'Value': '3',
    'SymbolicName': 'OptimalValue',
    'Sort': '3',
    'Description': 'Optimal value (Lookback)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1481',
    'Value': '4',
    'SymbolicName': 'AverageValue',
    'Sort': '4',
    'Description': 'Average value (Asian option)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92',
    'Issue': 'SPEC-672'
  },
  {
    'Tag': '1482',
    'Value': '1',
    'SymbolicName': 'Vanilla',
    'Sort': '1',
    'Description': 'Vanilla',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1482',
    'Value': '2',
    'SymbolicName': 'Capped',
    'Sort': '2',
    'Description': 'Capped',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1482',
    'Value': '3',
    'SymbolicName': 'Binary',
    'Sort': '3',
    'Description': 'Binary',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '1',
    'SymbolicName': 'Capped',
    'Sort': '1',
    'Description': 'Capped',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '2',
    'SymbolicName': 'Trigger',
    'Sort': '2',
    'Description': 'Trigger',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '3',
    'SymbolicName': 'KnockInUp',
    'Sort': '3',
    'Description': 'Knock-in up',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '4',
    'SymbolicName': 'KockInDown',
    'Sort': '4',
    'Description': 'Kock-in down',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '5',
    'SymbolicName': 'KnockOutUp',
    'Sort': '5',
    'Description': 'Knock-out up',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '6',
    'SymbolicName': 'KnockOutDown',
    'Sort': '6',
    'Description': 'Knock-out down',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '7',
    'SymbolicName': 'Underlying',
    'Sort': '7',
    'Description': 'Underlying',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '8',
    'SymbolicName': 'ResetBarrier',
    'Sort': '8',
    'Description': 'Reset Barrier',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1484',
    'Value': '9',
    'SymbolicName': 'RollingBarrier',
    'Sort': '9',
    'Description': 'Rolling Barrier',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1487',
    'Value': '1',
    'SymbolicName': 'LessThanComplexEventPrice',
    'Sort': '1',
    'Description': 'Less than ComplexEventPrice(1486)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1487',
    'Value': '2',
    'SymbolicName': 'LessThanOrEqualToComplexEventPrice',
    'Sort': '2',
    'Description': 'Less than or equal to ComplexEventPrice(1486)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1487',
    'Value': '3',
    'SymbolicName': 'EqualToComplexEventPrice',
    'Sort': '3',
    'Description': 'Equal to ComplexEventPrice(1486)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1487',
    'Value': '4',
    'SymbolicName': 'GreaterThanOrEqualToComplexEventPrice',
    'Sort': '4',
    'Description': 'Greater than or equal to ComplexEventPrice(1486)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1487',
    'Value': '5',
    'SymbolicName': 'GreaterThanComplexEventPrice',
    'Sort': '5',
    'Description': 'Greater than ComplexEventPrice(1486)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1489',
    'Value': '1',
    'SymbolicName': 'Expiration',
    'Sort': '1',
    'Description': 'Expiration',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1489',
    'Value': '2',
    'SymbolicName': 'Immediate',
    'Sort': '2',
    'Description': 'Immediate (At Any Time)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1489',
    'Value': '3',
    'SymbolicName': 'SpecifiedDate',
    'Sort': '3',
    'Description': 'Specified Date/Time',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1490',
    'Value': '1',
    'SymbolicName': 'And',
    'Sort': '1',
    'Description': 'And',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1490',
    'Value': '2',
    'SymbolicName': 'Or',
    'Sort': '2',
    'Description': 'Or',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '92'
  },
  {
    'Tag': '1498',
    'Value': '1',
    'SymbolicName': 'StreamAssignmentForNewCustomer',
    'Sort': '1',
    'Description': 'Stream assignment for new customer(s)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1498',
    'Value': '2',
    'SymbolicName': 'StreamAssignmentForExistingCustomer',
    'Sort': '2',
    'Description': 'Stream assignment for existing customer(s)',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1502',
    'Value': '0',
    'SymbolicName': 'UnknownClient',
    'Sort': '0',
    'Description': 'Unknown client',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1502',
    'Value': '1',
    'SymbolicName': 'ExceedsMaximumSize',
    'Sort': '1',
    'Description': 'Exceeds maximum size',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1502',
    'Value': '2',
    'SymbolicName': 'UnknownOrInvalidCurrencyPair',
    'Sort': '2',
    'Description': 'Unknown or Invalid currency pair',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1502',
    'Value': '3',
    'SymbolicName': 'NoAvailableStream',
    'Sort': '3',
    'Description': 'No available stream',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1502',
    'Value': '99',
    'SymbolicName': 'Other',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1503',
    'Value': '0',
    'SymbolicName': 'AssignmentAccepted',
    'Sort': '0',
    'Description': 'Assignment Accepted',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1503',
    'Value': '1',
    'SymbolicName': 'AssignmentRejected',
    'Sort': '1',
    'Description': 'Assignment Rejected',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1617',
    'Value': '1',
    'SymbolicName': 'Assignment',
    'Sort': '1',
    'Description': 'Assignment',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1617',
    'Value': '2',
    'SymbolicName': 'Rejected',
    'Sort': '2',
    'Description': 'Rejected',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1617',
    'Value': '3',
    'SymbolicName': 'Terminate',
    'Sort': '3',
    'Description': 'Terminate/Unassign',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '93'
  },
  {
    'Tag': '1048',
    'Value': 'A',
    'SymbolicName': 'Agent',
    'Sort': '0',
    'Description': 'Agent',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '1048',
    'Value': 'P',
    'SymbolicName': 'Principal',
    'Sort': '1',
    'Description': 'Principal',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '1048',
    'Value': 'R',
    'SymbolicName': 'RisklessPrincipal',
    'Sort': '2',
    'Description': 'Riskless Principal',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '1049',
    'Value': 'P',
    'SymbolicName': 'ProRata',
    'Sort': '1',
    'Description': 'Pro rata',
    'Added': 'FIX.4.4',
    'AddedEP': '4',
    'Issue': 'SPEC-384'
  },
  {
    'Tag': '1049',
    'Value': 'R',
    'SymbolicName': 'Random',
    'Sort': '2',
    'Description': 'Random',
    'Added': 'FIX.4.4',
    'AddedEP': '4',
    'Issue': 'SPEC-384'
  },
  {
    'Tag': '88',
    'Value': '99',
    'SymbolicName': 'Other',
    'Sort': '99',
    'Description': 'Other',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '959',
    'Value': '25',
    'SymbolicName': 'Country',
    'Sort': '25',
    'Description': 'Country',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '959',
    'Value': '26',
    'SymbolicName': 'Language',
    'Sort': '26',
    'Description': 'Language',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '959',
    'Value': '27',
    'SymbolicName': 'TZTimeOnly',
    'Sort': '27',
    'Description': 'TZTimeOnly',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '959',
    'Value': '28',
    'SymbolicName': 'TZTimestamp',
    'Sort': '28',
    'Description': 'TZTimestamp',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '959',
    'Value': '29',
    'SymbolicName': 'Tenor',
    'Sort': '29',
    'Description': 'Tenor',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '95'
  },
  {
    'Tag': '452',
    'Value': '83',
    'SymbolicName': 'ClearingAccount',
    'Sort': '83',
    'Description': 'Clearing Account',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '96'
  },
  {
    'Tag': '452',
    'Value': '84',
    'SymbolicName': 'AcceptableSettlingCounterparty',
    'Sort': '84',
    'Description': 'Acceptable Settling Counterparty',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '96'
  },
  {
    'Tag': '452',
    'Value': '85',
    'SymbolicName': 'UnacceptableSettlingCounterparty',
    'Sort': '85',
    'Description': 'Unacceptable Settling Counterparty',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '96'
  },
  {
    'Tag': '1128',
    'Value': '9',
    'SymbolicName': 'FIX50SP2',
    'Sort': '9',
    'Description': 'FIX50SP2',
    'Added': 'FIX.5.0SP1',
    'AddedEP': '97'
  },
  {
    'Tag': '35',
    'Value': '0',
    'SymbolicName': 'Heartbeat',
    'Group': '',
    'Sort': '0',
    'Description': 'Heartbeat',
    'Elaboration': 'The Heartbeat monitors the status of the communication link and identifies when the last of a string of messages was not received.'
  },
  {
    'Tag': '35',
    'Value': '1',
    'SymbolicName': 'TestRequest',
    'Group': '',
    'Sort': '1',
    'Description': 'TestRequest',
    'Elaboration': 'The test request message forces a heartbeat from the opposing application. The test request message checks sequence numbers or verifies communication line status. The opposite application responds to the Test Request with a Heartbeat containing the TestReqID.'
  },
  {
    'Tag': '35',
    'Value': '2',
    'SymbolicName': 'ResendRequest',
    'Group': '',
    'Sort': '2',
    'Description': 'ResendRequest',
    'Elaboration': 'The resend request is sent by the receiving application to initiate the retransmission of messages. This function is utilized if a sequence number gap is detected, if the receiving application lost a message, or as a function of the initialization process.'
  },
  {
    'Tag': '35',
    'Value': '3',
    'SymbolicName': 'Reject',
    'Group': '',
    'Sort': '3',
    'Description': 'Reject',
    'Elaboration': 'The reject message should be issued when a message is received but cannot be properly processed due to a session-level rule violation. An example of when a reject may be appropriate would be the receipt of a message with invalid basic data which successfully passes de-encryption, CheckSum and BodyLength checks.'
  },
  {
    'Tag': '35',
    'Value': '4',
    'SymbolicName': 'SequenceReset',
    'Group': '',
    'Sort': '4',
    'Description': 'SequenceReset',
    'Elaboration': 'The sequence reset message is used by the sending application to reset the incoming sequence number on the opposing side.'
  },
  {
    'Tag': '35',
    'Value': '5',
    'SymbolicName': 'Logout',
    'Group': '',
    'Sort': '5',
    'Description': 'Logout',
    'Elaboration': 'The logout message initiates or confirms the termination of a FIX session. Disconnection without the exchange of logout messages should be interpreted as an abnormal condition.'
  },
  {
    'Tag': '35',
    'Value': '6',
    'SymbolicName': 'IOI',
    'Group': '',
    'Sort': '6',
    'Description': 'IOI',
    'Elaboration': 'Indication of interest messages are used to market merchandise which the broker is buying or selling in either a proprietary or agency capacity. The indications can be time bound with a specific expiration value. Indications are distributed with the understanding that other firms may react to the message first and that the merchandise may no longer be available due to prior trade.\nIndication messages can be transmitted in various transaction types; NEW, CANCEL, and REPLACE. All message types other than NEW modify the state of the message identified in IOIRefID.'
  },
  {
    'Tag': '35',
    'Value': '7',
    'SymbolicName': 'Advertisement',
    'Group': '',
    'Sort': '7',
    'Description': 'Advertisement',
    'Elaboration': 'Advertisement messages are used to announce completed transactions. The advertisement message can be transmitted in various transaction types; NEW, CANCEL and REPLACE. All message types other than NEW modify the state of a previously transmitted advertisement identified in AdvRefID.'
  },
  {
    'Tag': '35',
    'Value': '8',
    'SymbolicName': 'ExecutionReport',
    'Group': '',
    'Sort': '8',
    'Description': 'ExecutionReport',
    'Elaboration': 'The execution report message is used to:\n1. confirm the receipt of an order\n2. confirm changes to an existing order (i.e. accept cancel and replace requests)\n3. relay order status information\n4. relay fill information on working orders\n5. relay fill information on tradeable or restricted tradeable quotes\n6. reject orders\n7. report post-trade fees calculations associated with a trade'
  },
  {
    'Tag': '35',
    'Value': '9',
    'SymbolicName': 'OrderCancelReject',
    'Group': '',
    'Sort': '9',
    'Description': 'OrderCancelReject',
    'Elaboration': 'The order cancel reject message is issued by the broker upon receipt of a cancel request or cancel/replace request message which cannot be honored.'
  },
  {
    'Tag': '35',
    'Value': 'A',
    'SymbolicName': 'Logon',
    'Group': '',
    'Sort': '10',
    'Description': 'Logon',
    'Elaboration': 'The logon message authenticates a user establishing a connection to a remote system. The logon message must be the first message sent by the application requesting to initiate a FIX session.'
  },
  {
    'Tag': '35',
    'Value': 'AA',
    'SymbolicName': 'DerivativeSecurityList',
    'Group': '',
    'Sort': '11',
    'Description': 'DerivativeSecurityList',
    'Elaboration': 'The Derivative Security List message is used to return a list of securities that matches the criteria specified in a Derivative Security List Request.'
  },
  {
    'Tag': '35',
    'Value': 'AB',
    'SymbolicName': 'NewOrderMultileg',
    'Group': '',
    'Sort': '12',
    'Description': 'NewOrderMultileg',
    'Elaboration': 'The New Order - Multileg is provided to submit orders for securities that are made up of multiple securities, known as legs.'
  },
  {
    'Tag': '35',
    'Value': 'AC',
    'SymbolicName': 'MultilegOrderCancelReplace',
    'Group': '',
    'Sort': '13',
    'Description': 'MultilegOrderCancelReplace',
    'Elaboration': 'Used to modify a multileg order previously submitted using the New Order - Multileg message. See Order Cancel Replace Request for details concerning message usage.'
  },
  {
    'Tag': '35',
    'Value': 'AD',
    'SymbolicName': 'TradeCaptureReportRequest',
    'Group': '',
    'Sort': '14',
    'Description': 'TradeCaptureReportRequest',
    'Elaboration': 'The Trade Capture Report Request can be used to:\n• Request one or more trade capture reports based upon selection criteria provided on the trade capture report request\n• Subscribe for trade capture reports based upon selection criteria provided on the trade capture report request.'
  },
  {
    'Tag': '35',
    'Value': 'AE',
    'SymbolicName': 'TradeCaptureReport',
    'Group': '',
    'Sort': '15',
    'Description': 'TradeCaptureReport',
    'Elaboration': 'The Trade Capture Report message can be:\n• Used to report trades between counterparties.\n• Used to report trades to a trade matching system\n• Can be sent unsolicited between counterparties.\n• Sent as a reply to a Trade Capture Report Request.\n• Can be used to report unmatched and matched trades.'
  },
  {
    'Tag': '35',
    'Value': 'AF',
    'SymbolicName': 'OrderMassStatusRequest',
    'Group': '',
    'Sort': '16',
    'Description': 'OrderMassStatusRequest',
    'Elaboration': 'The order mass status request message requests the status for orders matching criteria specified within the request.'
  },
  {
    'Tag': '35',
    'Value': 'AG',
    'SymbolicName': 'QuoteRequestReject',
    'Group': '',
    'Sort': '17',
    'Description': 'QuoteRequestReject',
    'Elaboration': 'The Quote Request Reject message is used to reject Quote Request messages for all quoting models.'
  },
  {
    'Tag': '35',
    'Value': 'AH',
    'SymbolicName': 'RFQRequest',
    'Group': '',
    'Sort': '18',
    'Description': 'RFQRequest',
    'Elaboration': 'In tradeable and restricted tradeable quoting markets – Quote Requests are issued by counterparties interested in ascertaining the market for an instrument. Quote Requests are then distributed by the market to liquidity providers who make markets in the instrument. The RFQ Request is used by liquidity providers to indicate to the market for which instruments they are interested in receiving Quote Requests. It can be used to register interest in receiving quote requests for a single instrument or for multiple instruments'
  },
  {
    'Tag': '35',
    'Value': 'AI',
    'SymbolicName': 'QuoteStatusReport',
    'Group': '',
    'Sort': '19',
    'Description': 'QuoteStatusReport',
    'Elaboration': 'The quote status report message is used:\n• as the response to a Quote Status Request message\n• as a response to a Quote Cancel message\n• as a response to a Quote Response message in a negotiation dialog (see Volume 7 – PRODUCT: FIXED INCOME and USER GROUP: EXCHANGES AND MARKETS)'
  },
  {
    'Tag': '35',
    'Value': 'AJ',
    'SymbolicName': 'QuoteResponse',
    'Group': '',
    'Sort': '20',
    'Description': 'QuoteResponse',
    'Elaboration': 'The Quote Response message is used to respond to a IOI message or Quote message. It is also used to counter a Quote or end a negotiation dialog.'
  },
  {
    'Tag': '35',
    'Value': 'AK',
    'SymbolicName': 'Confirmation',
    'Group': '',
    'Sort': '21',
    'Description': 'Confirmation',
    'Elaboration': 'The Confirmation messages are used to provide individual trade level confirmations from the sell side to the buy side. In versions of FIX prior to version 4.4, this role was performed by the allocation message. Unlike the allocation message, the confirmation message operates at an allocation account (trade) level rather than block level, allowing for the affirmation or rejection of individual confirmations.'
  },
  {
    'Tag': '35',
    'Value': 'AL',
    'SymbolicName': 'PositionMaintenanceRequest',
    'Group': '',
    'Sort': '22',
    'Description': 'PositionMaintenanceRequest',
    'Elaboration': 'The Position Maintenance Request message allows the position owner to submit requests to the holder of a position which will result in a specific action being taken which will affect the position. Generally, the holder of the position is a central counter party or clearing organization but can also be a party providing investment services.'
  },
  {
    'Tag': '35',
    'Value': 'AM',
    'SymbolicName': 'PositionMaintenanceReport',
    'Group': '',
    'Sort': '23',
    'Description': 'PositionMaintenanceReport',
    'Elaboration': 'The Position Maintenance Report message is sent by the holder of a positon in response to a Position Maintenance Request and is used to confirm that a request has been successfully processed or rejected.'
  },
  {
    'Tag': '35',
    'Value': 'AN',
    'SymbolicName': 'RequestForPositions',
    'Group': '',
    'Sort': '24',
    'Description': 'RequestForPositions',
    'Elaboration': 'The Request For Positions message is used by the owner of a position to request a Position Report from the holder of the position, usually the central counter party or clearing organization. The request can be made at several levels of granularity.'
  },
  {
    'Tag': '35',
    'Value': 'AO',
    'SymbolicName': 'RequestForPositionsAck',
    'Group': '',
    'Sort': '25',
    'Description': 'RequestForPositionsAck',
    'Elaboration': 'The Request for Positions Ack message is returned by the holder of the position in response to a Request for Positions message. The purpose of the message is to acknowledge that a request has been received and is being processed.'
  },
  {
    'Tag': '35',
    'Value': 'AP',
    'SymbolicName': 'PositionReport',
    'Group': '',
    'Sort': '26',
    'Description': 'PositionReport',
    'Elaboration': 'The Position Report message is returned by the holder of a position in response to a Request for Position message. The purpose of the message is to report all aspects of a position and may be provided on a standing basis to report end of day positions to an owner.'
  },
  {
    'Tag': '35',
    'Value': 'AQ',
    'SymbolicName': 'TradeCaptureReportRequestAck',
    'Group': '',
    'Sort': '27',
    'Description': 'TradeCaptureReportRequestAck',
    'Elaboration': 'The Trade Capture Request Ack message is used to:\n• Provide an acknowledgement to a Trade Capture Report Request in the case where the Trade Capture Report Request is used to specify a subscription or delivery of reports via an out-of-band ResponseTransmissionMethod.\n• Provide an acknowledgement to a Trade Capture Report Request in the case when the return of the Trade Capture Reports matching that request will be delayed or delivered asynchronously. This is useful in distributed trading system environments.\n• Indicate that no trades were found that matched the selection criteria specified on the Trade Capture Report Request\n• The Trade Capture Request was invalid for some business reason, such as request is not authorized, invalid or unknown instrument, party, trading session, etc.'
  },
  {
    'Tag': '35',
    'Value': 'AR',
    'SymbolicName': 'TradeCaptureReportAck',
    'Group': '',
    'Sort': '28',
    'Description': 'TradeCaptureReportAck',
    'Elaboration': 'The Trade Capture Report Ack message can be:\n• Used to acknowledge trade capture reports received from a counterparty\n• Used to reject a trade capture report received from a counterparty'
  },
  {
    'Tag': '35',
    'Value': 'AS',
    'SymbolicName': 'AllocationReport',
    'Group': '',
    'Sort': '29',
    'Description': 'AllocationReport',
    'Elaboration': 'Sent from sell-side to buy-side, sell-side to 3rd-party or 3rd-party to buy-side, the Allocation Report (Claim) provides account breakdown of an order or set of orders plus any additional follow-up front-office information developed post-trade during the trade allocation, matching and calculation phase. In versions of FIX prior to version 4.4, this functionality was provided through the Allocation message. Depending on the needs of the market and the timing of \'confirmed\' status, the role of Allocation Report can be taken over in whole or in part by the Confirmation message.'
  },
  {
    'Tag': '35',
    'Value': 'AT',
    'SymbolicName': 'AllocationReportAck',
    'Group': '',
    'Sort': '30',
    'Description': 'AllocationReportAck',
    'Elaboration': 'The Allocation Report Ack message is used to acknowledge the receipt of and provide status for an Allocation Report message.'
  },
  {
    'Tag': '35',
    'Value': 'AU',
    'SymbolicName': 'ConfirmationAck',
    'Group': '',
    'Sort': '31',
    'Description': 'ConfirmationAck',
    'Elaboration': 'The Confirmation Ack (aka Affirmation) message is used to respond to a Confirmation message.'
  },
  {
    'Tag': '35',
    'Value': 'AV',
    'SymbolicName': 'SettlementInstructionRequest',
    'Group': '',
    'Sort': '32',
    'Description': 'SettlementInstructionRequest',
    'Elaboration': 'The Settlement Instruction Request message is used to request standing settlement instructions from another party.'
  },
  {
    'Tag': '35',
    'Value': 'AW',
    'SymbolicName': 'AssignmentReport',
    'Group': '',
    'Sort': '33',
    'Description': 'AssignmentReport',
    'Elaboration': 'Assignment Reports are sent from a clearing house to counterparties, such as a clearing firm as a result of the assignment process.'
  },
  {
    'Tag': '35',
    'Value': 'AX',
    'SymbolicName': 'CollateralRequest',
    'Group': '',
    'Sort': '34',
    'Description': 'CollateralRequest',
    'Elaboration': 'An initiator that requires collateral from a respondent sends a Collateral Request. The initiator can be either counterparty to a trade in a two party model or an intermediary such as an ATS or clearinghouse in a three party model. A Collateral Assignment is expected as a response to a request for collateral.'
  },
  {
    'Tag': '35',
    'Value': 'AY',
    'SymbolicName': 'CollateralAssignment',
    'Group': '',
    'Sort': '35',
    'Description': 'CollateralAssignment',
    'Elaboration': 'Used to assign collateral to cover a trading position. This message can be sent unsolicited or in reply to a Collateral Request message.'
  },
  {
    'Tag': '35',
    'Value': 'AZ',
    'SymbolicName': 'CollateralResponse',
    'Group': '',
    'Sort': '36',
    'Description': 'CollateralResponse',
    'Elaboration': 'Used to respond to a Collateral Assignment message.'
  },
  {
    'Tag': '35',
    'Value': 'B',
    'SymbolicName': 'News',
    'Group': '',
    'Sort': '37',
    'Description': 'News',
    'Elaboration': 'The news message is a general free format message between the broker and institution. The message contains flags to identify the news item\'s urgency and to allow sorting by subject company (symbol). The News message can be originated at either the broker or institution side, or exchanges and other marketplace venues.'
  },
  {
    'Tag': '35',
    'Value': 'BA',
    'SymbolicName': 'CollateralReport',
    'Group': '',
    'Sort': '38',
    'Description': 'CollateralReport',
    'Elaboration': 'Used to report collateral status when responding to a Collateral Inquiry message.'
  },
  {
    'Tag': '35',
    'Value': 'BB',
    'SymbolicName': 'CollateralInquiry',
    'Group': '',
    'Sort': '39',
    'Description': 'CollateralInquiry',
    'Elaboration': 'Used to inquire for collateral status.'
  },
  {
    'Tag': '35',
    'Value': 'BC',
    'SymbolicName': 'NetworkCounterpartySystemStatusRequest',
    'Group': '',
    'Sort': '40',
    'Description': 'NetworkCounterpartySystemStatusRequest',
    'Elaboration': 'This message is send either immediately after logging on to inform a network (counterparty system) of the type of updates required or to at any other time in the FIX conversation to change the nature of the types of status updates required. It can also be used with a NetworkRequestType of Snapshot to request a one-off report of the status of a network (or counterparty) system. Finally this message can also be used to cancel a request to receive updates into the status of the counterparties on a network by sending a NetworkRequestStatusMessage with a NetworkRequestType of StopSubscribing.'
  },
  {
    'Tag': '35',
    'Value': 'BD',
    'SymbolicName': 'NetworkCounterpartySystemStatusResponse',
    'Group': '',
    'Sort': '41',
    'Description': 'NetworkCounterpartySystemStatusResponse',
    'Elaboration': 'This message is sent in response to a Network (Counterparty System) Status Request Message.'
  },
  {
    'Tag': '35',
    'Value': 'BE',
    'SymbolicName': 'UserRequest',
    'Group': '',
    'Sort': '42',
    'Description': 'UserRequest',
    'Elaboration': 'This message is used to initiate a user action, logon, logout or password change. It can also be used to request a report on a user\'s status.'
  },
  {
    'Tag': '35',
    'Value': 'BF',
    'SymbolicName': 'UserResponse',
    'Group': '',
    'Sort': '43',
    'Description': 'UserResponse',
    'Elaboration': 'This message is used to respond to a user request message, it reports the status of the user after the completion of any action requested in the user request message.'
  },
  {
    'Tag': '35',
    'Value': 'BG',
    'SymbolicName': 'CollateralInquiryAck',
    'Group': '',
    'Sort': '44',
    'Description': 'CollateralInquiryAck',
    'Elaboration': 'Used to respond to a Collateral Inquiry in the following situations:\n• When the CollateralInquiry will result in an out of band response (such as a file transfer).\n• When the inquiry is otherwise valid but no collateral is found to match the criteria specified on the Collateral Inquiry message.\n• When the Collateral Inquiry is invalid based upon the business rules of the counterparty.'
  },
  {
    'Tag': '35',
    'Value': 'BH',
    'SymbolicName': 'ConfirmationRequest',
    'Group': '',
    'Sort': '45',
    'Description': 'ConfirmationRequest',
    'Elaboration': 'The Confirmation Request message is used to request a Confirmation message.'
  },
  {
    'Tag': '35',
    'Value': 'BI',
    'SymbolicName': 'TradingSessionListRequest',
    'Group': '',
    'Sort': '46',
    'Description': 'TradingSessionListRequest',
    'Elaboration': 'The Trading Session List Request is used to request a list of trading sessions available in a market place and the state of those trading sessions. A successful request will result in a response from the counterparty of a Trading Session List (MsgType=BJ) message that contains a list of zero or more trading sessions.'
  },
  {
    'Tag': '35',
    'Value': 'BJ',
    'SymbolicName': 'TradingSessionList',
    'Group': '',
    'Sort': '47',
    'Description': 'TradingSessionList',
    'Elaboration': 'The Trading Session List message is sent as a response to a Trading Session List Request. The Trading Session List should contain the characteristics of the trading session and the current state of the trading session.'
  },
  {
    'Tag': '35',
    'Value': 'BK',
    'SymbolicName': 'SecurityListUpdateReport',
    'Group': '',
    'Sort': '48',
    'Description': 'SecurityListUpdateReport',
    'Elaboration': 'The Security List Update Report is used for reporting updates to a Contract Security Masterfile. Updates could be due to Corporate Actions or other business events. Update may include additions, modifications and deletions.'
  },
  {
    'Tag': '35',
    'Value': 'BL',
    'SymbolicName': 'AdjustedPositionReport',
    'Group': '',
    'Sort': '49',
    'Description': 'AdjustedPositionReport',
    'Elaboration': 'Used to report changes in position, primarily in equity options, due to modifications to the underlying due to corporate actions'
  },
  {
    'Tag': '35',
    'Value': 'BM',
    'SymbolicName': 'AllocationInstructionAlert',
    'Group': '',
    'Sort': '50',
    'Description': 'AllocationInstructionAlert',
    'Elaboration': 'This message is used in a 3-party allocation model where notification of group creation and group updates to counterparties is needed. The mssage will also carry trade information that comprised the group to the counterparties.'
  },
  {
    'Tag': '35',
    'Value': 'BN',
    'SymbolicName': 'ExecutionAcknowledgement',
    'Group': '',
    'Sort': '51',
    'Description': 'ExecutionAcknowledgement',
    'Elaboration': 'The Execution Report Acknowledgement message is an optional message that provides dual functionality to notify a trading partner that an electronically received execution has either been accepted or rejected (DK\'d).'
  },
  {
    'Tag': '35',
    'Value': 'BO',
    'SymbolicName': 'ContraryIntentionReport',
    'Group': '',
    'Sort': '52',
    'Description': 'ContraryIntentionReport',
    'Elaboration': 'The Contrary Intention Report is used for reporting of contrary expiration quantities for Saturday expiring options. This information is required by options exchanges for regulatory purposes.'
  },
  {
    'Tag': '35',
    'Value': 'BP',
    'SymbolicName': 'SecurityDefinitionUpdateReport',
    'Group': '',
    'Sort': '53',
    'Description': 'SecurityDefinitionUpdateReport',
    'Elaboration': 'This message is used for reporting updates to a Product Security Masterfile. Updates could be the result of corporate actions or other business events. Updates may include additions, modifications or deletions.'
  },
  {
    'Tag': '35',
    'Value': 'BQ',
    'SymbolicName': 'SettlementObligationReport',
    'Group': '',
    'Sort': '54',
    'Description': 'SettlementObligationReport',
    'Elaboration': 'The Settlement Obligation Report message provides a central counterparty, institution, or individual counterparty with a capacity for reporting the final details of a currency settlement obligation.'
  },
  {
    'Tag': '35',
    'Value': 'BR',
    'SymbolicName': 'DerivativeSecurityListUpdateReport',
    'Group': '',
    'Sort': '55',
    'Description': 'DerivativeSecurityListUpdateReport',
    'Elaboration': 'The Derivative Security List Update Report message is used to send updates to an option family or the strikes that comprise an option family.'
  },
  {
    'Tag': '35',
    'Value': 'BS',
    'SymbolicName': 'TradingSessionListUpdateReport',
    'Group': '',
    'Sort': '56',
    'Description': 'TradingSessionListUpdateReport',
    'Elaboration': 'The Trading Session List Update Report is used by marketplaces to provide intra-day updates of trading sessions when there are changes to one or more trading sessions.'
  },
  {
    'Tag': '35',
    'Value': 'BT',
    'SymbolicName': 'MarketDefinitionRequest',
    'Group': '',
    'Sort': '57',
    'Description': 'MarketDefinitionRequest',
    'Elaboration': 'The Market Definition Request message is used to request for market structure information from the Respondent that receives this request.'
  },
  {
    'Tag': '35',
    'Value': 'BU',
    'SymbolicName': 'MarketDefinition',
    'Group': '',
    'Sort': '58',
    'Description': 'MarketDefinition',
    'Elaboration': 'The Market Definition message is used to respond to Market Definition Request. In a subscription, it will be used to provide the initial snapshot of the information requested. Subsequent updates are provided by the Market Definition Update Report.'
  },
  {
    'Tag': '35',
    'Value': 'BV',
    'SymbolicName': 'MarketDefinitionUpdateReport',
    'Group': '',
    'Sort': '59',
    'Description': 'MarketDefinitionUpdateReport',
    'Elaboration': 'In a subscription for market structure information, this message is used once the initial snapshot of the information has been sent using the Market Definition message.'
  },
  {
    'Tag': '35',
    'Value': 'BW',
    'SymbolicName': 'ApplicationMessageRequest',
    'Group': '',
    'Sort': '60',
    'Description': 'ApplicationMessageRequest',
    'Elaboration': 'This message is used to request a retransmission of a set of one or more messages generated by the application specified in RefApplID (1355).'
  },
  {
    'Tag': '35',
    'Value': 'BX',
    'SymbolicName': 'ApplicationMessageRequestAck',
    'Group': '',
    'Sort': '61',
    'Description': 'ApplicationMessageRequestAck',
    'Elaboration': 'This message is used to acknowledge an Application Message Request providing a status on the request (i.e. whether successful or not). This message does not provide the actual content of the messages to be resent.'
  },
  {
    'Tag': '35',
    'Value': 'BY',
    'SymbolicName': 'ApplicationMessageReport',
    'Group': '',
    'Sort': '62',
    'Description': 'ApplicationMessageReport',
    'Elaboration': 'This message is used for three difference purposes: to reset the ApplSeqNum (1181) of a specified ApplID (1180). to indicate that the last message has been sent for a particular ApplID, or as a keep-alive mechanism for ApplIDs with infrequent message traffic.'
  },
  {
    'Tag': '35',
    'Value': 'BZ',
    'SymbolicName': 'OrderMassActionReport',
    'Group': '',
    'Sort': '63',
    'Description': 'OrderMassActionReport',
    'Elaboration': 'The Order Mass Action Report is used to acknowledge an Order Mass Action Request. Note that each affected order that is suspended or released or canceled is acknowledged with a separate Execution Report for each order.'
  },
  {
    'Tag': '35',
    'Value': 'C',
    'SymbolicName': 'Email',
    'Group': '',
    'Sort': '64',
    'Description': 'Email',
    'Elaboration': 'The email message is similar to the format and purpose of the News message, however, it is intended for private use between two parties.'
  },
  {
    'Tag': '35',
    'Value': 'CA',
    'SymbolicName': 'OrderMassActionRequest',
    'Group': '',
    'Sort': '65',
    'Description': 'OrderMassActionRequest',
    'Elaboration': 'The Order Mass Action Request message can be used to request the suspension or release of a group of orders that match the criteria specified within the request. This is equivalent to individual Order Cancel Replace Requests for each order with or without adding \'S\' to the ExecInst values. It can also be used for mass order cancellation.'
  },
  {
    'Tag': '35',
    'Value': 'CB',
    'SymbolicName': 'UserNotification',
    'Group': '',
    'Sort': '66',
    'Description': 'UserNotification',
    'Elaboration': 'The User Notification message is used to notify one or more users of an event or information from the sender of the message. This message is usually sent unsolicited from a marketplace (e.g. Exchange, ECN) to a market participant.'
  },
  {
    'Tag': '35',
    'Value': 'CC',
    'SymbolicName': 'StreamAssignmentRequest',
    'Group': '',
    'Sort': '67',
    'Description': 'StreamAssignmentRequest',
    'Elaboration': 'In certain markets where market data aggregators fan out to end clients the pricing streams provided by the price makers, the price maker may assign the clients to certain pricing streams that the price maker publishes via the aggregator. An example of this use is in the FX markets where clients may be assigned to different pricing streams based on volume bands and currency pairs.'
  },
  {
    'Tag': '35',
    'Value': 'CD',
    'SymbolicName': 'StreamAssignmentReport',
    'Group': '',
    'Sort': '68',
    'Description': 'StreamAssignmentReport',
    'Elaboration': 'he StreamAssignmentReport message is in response to the StreamAssignmentRequest message. It provides information back to the aggregator as to which clients to assign to receive which price stream based on requested CCY pair. This message can be sent unsolicited to the Aggregator from the Price Maker.'
  },
  {
    'Tag': '35',
    'Value': 'CE',
    'SymbolicName': 'StreamAssignmentReportACK',
    'Group': '',
    'Sort': '69',
    'Description': 'StreamAssignmentReportACK',
    'Elaboration': 'This message is used to respond to the Stream Assignment Report, to either accept or reject an unsolicited assingment.'
  },
  {
    'Tag': '35',
    'Value': 'D',
    'SymbolicName': 'NewOrderSingle',
    'Group': '',
    'Sort': '70',
    'Description': 'NewOrderSingle',
    'Elaboration': 'The new order message type is used by institutions wishing to electronically submit securities and forex orders to a broker for execution.\nThe New Order message type may also be used by institutions or retail intermediaries wishing to electronically submit Collective Investment Vehicle (CIV) orders to a broker or fund manager for execution.'
  },
  {
    'Tag': '35',
    'Value': 'E',
    'SymbolicName': 'NewOrderList',
    'Group': '',
    'Sort': '71',
    'Description': 'NewOrderList',
    'Elaboration': 'The NewOrderList Message can be used in one of two ways depending on which market conventions are being followed.'
  },
  {
    'Tag': '35',
    'Value': 'F',
    'SymbolicName': 'OrderCancelRequest',
    'Group': '',
    'Sort': '72',
    'Description': 'OrderCancelRequest',
    'Elaboration': 'The order cancel request message requests the cancellation of all of the remaining quantity of an existing order. Note that the Order Cancel/Replace Request should be used to partially cancel (reduce) an order).'
  },
  {
    'Tag': '35',
    'Value': 'G',
    'SymbolicName': 'OrderCancelReplaceRequest',
    'Group': '',
    'Sort': '73',
    'Description': 'OrderCancelReplaceRequest',
    'Elaboration': 'The order cancel/replace request is used to change the parameters of an existing order.\nDo not use this message to cancel the remaining quantity of an outstanding order, use the Order Cancel Request message for this purpose.'
  },
  {
    'Tag': '35',
    'Value': 'H',
    'SymbolicName': 'OrderStatusRequest',
    'Group': '',
    'Sort': '74',
    'Description': 'OrderStatusRequest',
    'Elaboration': 'The order status request message is used by the institution to generate an order status message back from the broker.'
  },
  {
    'Tag': '35',
    'Value': 'J',
    'SymbolicName': 'AllocationInstruction',
    'Group': '',
    'Sort': '75',
    'Description': 'AllocationInstruction',
    'Elaboration': 'The Allocation Instruction message provides the ability to specify how an order or set of orders should be subdivided amongst one or more accounts. In versions of FIX prior to version 4.4, this same message was known as the Allocation message. Note in versions of FIX prior to version 4.4, the allocation message was also used to communicate fee and expense details from the Sellside to the Buyside. This role has now been removed from the Allocation Instruction and is now performed by the new (to version 4.4) Allocation Report and Confirmation messages.,The Allocation Report message should be used for the Sell-side Initiated Allocation role as defined in previous versions of the protocol.'
  },
  {
    'Tag': '35',
    'Value': 'K',
    'SymbolicName': 'ListCancelRequest',
    'Group': '',
    'Sort': '76',
    'Description': 'ListCancelRequest',
    'Elaboration': 'The List Cancel Request message type is used by institutions wishing to cancel previously submitted lists either before or during execution.'
  },
  {
    'Tag': '35',
    'Value': 'L',
    'SymbolicName': 'ListExecute',
    'Group': '',
    'Sort': '77',
    'Description': 'ListExecute',
    'Elaboration': 'The List Execute message type is used by institutions to instruct the broker to begin execution of a previously submitted list. This message may or may not be used, as it may be mirroring a phone conversation.'
  },
  {
    'Tag': '35',
    'Value': 'M',
    'SymbolicName': 'ListStatusRequest',
    'Group': '',
    'Sort': '78',
    'Description': 'ListStatusRequest',
    'Elaboration': 'The list status request message type is used by institutions to instruct the broker to generate status messages for a list.'
  },
  {
    'Tag': '35',
    'Value': 'N',
    'SymbolicName': 'ListStatus',
    'Group': '',
    'Sort': '79',
    'Description': 'ListStatus',
    'Elaboration': 'The list status message is issued as the response to a List Status Request message sent in an unsolicited fashion by the sell-side. It indicates the current state of the orders within the list as they exist at the broker\'s site. This message may also be used to respond to the List Cancel Request.'
  },
  {
    'Tag': '35',
    'Value': 'P',
    'SymbolicName': 'AllocationInstructionAck',
    'Group': '',
    'Sort': '80',
    'Description': 'AllocationInstructionAck',
    'Elaboration': 'In versions of FIX prior to version 4.4, this message was known as the Allocation ACK message.\nThe Allocation Instruction Ack message is used to acknowledge the receipt of and provide status for an Allocation Instruction message.'
  },
  {
    'Tag': '35',
    'Value': 'Q',
    'SymbolicName': 'DontKnowTrade',
    'Group': '',
    'Sort': '81',
    'Description': 'DontKnowTrade',
    'Elaboration': 'The Don’t Know Trade (DK) message notifies a trading partner that an electronically received execution has been rejected. This message can be thought of as an execution reject message.'
  },
  {
    'Tag': '35',
    'Value': 'R',
    'SymbolicName': 'QuoteRequest',
    'Group': '',
    'Sort': '82',
    'Description': 'QuoteRequest',
    'Elaboration': 'In some markets it is the practice to request quotes from brokers prior to placement of an order. The quote request message is used for this purpose. This message is commonly referred to as an Request For Quote (RFQ)'
  },
  {
    'Tag': '35',
    'Value': 'S',
    'SymbolicName': 'Quote',
    'Group': '',
    'Sort': '83',
    'Description': 'Quote',
    'Elaboration': 'The Quote message is used as the response to a Quote Request or a Quote Response message in both indicative, tradeable, and restricted tradeable quoting markets.'
  },
  {
    'Tag': '35',
    'Value': 'T',
    'SymbolicName': 'SettlementInstructions',
    'Group': '',
    'Sort': '84',
    'Description': 'SettlementInstructions',
    'Elaboration': 'The Settlement Instructions message provides the broker’s, the institution’s, or the intermediary’s instructions for trade settlement. This message has been designed so that it can be sent from the broker to the institution, from the institution to the broker, or from either to an independent \'standing instructions\' database or matching system or, for CIV, from an intermediary to a fund manager.'
  },
  {
    'Tag': '35',
    'Value': 'V',
    'SymbolicName': 'MarketDataRequest',
    'Group': '',
    'Sort': '85',
    'Description': 'MarketDataRequest',
    'Elaboration': 'Some systems allow the transmission of real-time quote, order, trade, trade volume, open interest, and/or other price information on a subscription basis. A Market Data Request is a general request for market data on specific securities or forex quotes.'
  },
  {
    'Tag': '35',
    'Value': 'W',
    'SymbolicName': 'MarketDataSnapshotFullRefresh',
    'Group': '',
    'Sort': '86',
    'Description': 'MarketDataSnapshotFullRefresh',
    'Elaboration': 'The Market Data messages are used as the response to a Market Data Request message. In all cases, one Market Data message refers only to one Market Data Request. It can be used to transmit a 2-sided book of orders or list of quotes, a list of trades, index values, opening, closing, settlement, high, low, or VWAP prices, the trade volume or open interest for a security, or any combination of these.'
  },
  {
    'Tag': '35',
    'Value': 'X',
    'SymbolicName': 'MarketDataIncrementalRefresh',
    'Group': '',
    'Sort': '87',
    'Description': 'MarketDataIncrementalRefresh',
    'Elaboration': 'The Market Data message for incremental updates may contain any combination of new, changed, or deleted Market Data Entries, for any combination of instruments, with any combination of trades, imbalances, quotes, index values, open, close, settlement, high, low, and VWAP prices, trade volume and open interest so long as the maximum FIX message size is not exceeded. All of these types of Market Data Entries can be changed and deleted.'
  },
  {
    'Tag': '35',
    'Value': 'Y',
    'SymbolicName': 'MarketDataRequestReject',
    'Group': '',
    'Sort': '88',
    'Description': 'MarketDataRequestReject',
    'Elaboration': 'The Market Data Request Reject is used when the broker cannot honor the Market Data Request, due to business or technical reasons. Brokers may choose to limit various parameters, such as the size of requests, whether just the top of book or the entire book may be displayed, and whether Full or Incremental updates must be used.'
  },
  {
    'Tag': '35',
    'Value': 'Z',
    'SymbolicName': 'QuoteCancel',
    'Group': '',
    'Sort': '89',
    'Description': 'QuoteCancel',
    'Elaboration': 'The Quote Cancel message is used by an originator of quotes to cancel quotes.\nThe Quote Cancel message supports cancellation of:\n• All quotes\n• Quotes for a specific symbol or security ID\n• All quotes for a security type\n• All quotes for an underlying'
  },
  {
    'Tag': '35',
    'Value': 'a',
    'SymbolicName': 'QuoteStatusRequest',
    'Group': '',
    'Sort': '90',
    'Description': 'QuoteStatusRequest',
    'Elaboration': 'The quote status request message is used for the following purposes in markets that employ tradeable or restricted tradeable quotes:\n• For the issuer of a quote in a market to query the status of that quote (using the QuoteID to specify the target quote).\n• To subscribe and unsubscribe for Quote Status Report messages for one or more securities.'
  },
  {
    'Tag': '35',
    'Value': 'b',
    'SymbolicName': 'MassQuoteAcknowledgement',
    'Group': '',
    'Sort': '91',
    'Description': 'MassQuoteAcknowledgement',
    'Elaboration': 'Mass Quote Acknowledgement is used as the application level response to a Mass Quote message.'
  },
  {
    'Tag': '35',
    'Value': 'c',
    'SymbolicName': 'SecurityDefinitionRequest',
    'Group': '',
    'Sort': '92',
    'Description': 'SecurityDefinitionRequest',
    'Elaboration': 'The Security Definition Request message is used for the following:\n1. Request a specific Security to be traded with the second party. The request security can be defined as a multileg security made up of one or more instrument legs.\n2. Request a set of individual securities for a single market segment.\n3. Request all securities, independent of market segment.'
  },
  {
    'Tag': '35',
    'Value': 'd',
    'SymbolicName': 'SecurityDefinition',
    'Group': '',
    'Sort': '93',
    'Description': 'SecurityDefinition',
    'Elaboration': 'The Security Definition message is used for the following:\n1. Accept the security defined in a Security Definition message.\n2. Accept the security defined in a Security Definition message with changes to the definition and/or identity of the security.\n3. Reject the security requested in a Security Definition message.\n4. Respond to a request for securities within a specified market segment.\n5. Convey comprehensive security definition for all market segments that the security participates in.\n6. Convey the security\'s trading rules that differ from default rules for the market segment.'
  },
  {
    'Tag': '35',
    'Value': 'e',
    'SymbolicName': 'SecurityStatusRequest',
    'Group': '',
    'Sort': '94',
    'Description': 'SecurityStatusRequest',
    'Elaboration': 'The Security Status Request message provides for the ability to request the status of a security. One or more Security Status messages are returned as a result of a Security Status Request message.'
  },
  {
    'Tag': '35',
    'Value': 'f',
    'SymbolicName': 'SecurityStatus',
    'Group': '',
    'Sort': '95',
    'Description': 'SecurityStatus',
    'Elaboration': 'The Security Status message provides for the ability to report changes in status to a security. The Security Status message contains fields to indicate trading status, corporate actions, financial status of the company. The Security Status message is used by one trading entity (for instance an exchange) to report changes in the state of a security.'
  },
  {
    'Tag': '35',
    'Value': 'g',
    'SymbolicName': 'TradingSessionStatusRequest',
    'Group': '',
    'Sort': '96',
    'Description': 'TradingSessionStatusRequest',
    'Elaboration': 'The Trading Session Status Request is used to request information on the status of a market. With the move to multiple sessions occurring for a given trading party (morning and evening sessions for instance) there is a need to be able to provide information on what product is trading on what market.'
  },
  {
    'Tag': '35',
    'Value': 'h',
    'SymbolicName': 'TradingSessionStatus',
    'Group': '',
    'Sort': '97',
    'Description': 'TradingSessionStatus',
    'Elaboration': 'The Trading Session Status provides information on the status of a market. For markets multiple trading sessions on multiple-markets occurring (morning and evening sessions for instance), this message is able to provide information on what products are trading on what market during what trading session.'
  },
  {
    'Tag': '35',
    'Value': 'i',
    'SymbolicName': 'MassQuote',
    'Group': '',
    'Sort': '98',
    'Description': 'MassQuote',
    'Elaboration': 'The Mass Quote message can contain quotes for multiple securities to support applications that allow for the mass quoting of an option series. Two levels of repeating groups have been provided to minimize the amount of data required to submit a set of quotes for a class of options (e.g. all option series for IBM).'
  },
  {
    'Tag': '35',
    'Value': 'j',
    'SymbolicName': 'BusinessMessageReject',
    'Group': '',
    'Sort': '99',
    'Description': 'BusinessMessageReject',
    'Elaboration': 'The Business Message Reject message can reject an application-level message which fulfills session-level rules and cannot be rejected via any other means. Note if the message fails a session-level rule (e.g. body length is incorrect), a session-level Reject message should be issued.'
  },
  {
    'Tag': '35',
    'Value': 'k',
    'SymbolicName': 'BidRequest',
    'Group': '',
    'Sort': '100',
    'Description': 'BidRequest',
    'Elaboration': 'The BidRequest Message can be used in one of two ways depending on which market conventions are being followed.\n      In the \'Non disclosed\' convention (e.g. US/European model) the BidRequest message can be used to request a bid based on the sector, country, index and liquidity information contained within the message itself. In the \'Non disclosed\' convention the entry repeating group is used to define liquidity of the program. See \' Program/Basket/List Trading\'  for an example.\n      In the \'Disclosed\' convention (e.g. Japanese model) the BidRequest message can be used to request bids based on the ListOrderDetail messages sent in advance of BidRequest message. In the \'Disclosed\' convention the list repeating group is used to define which ListOrderDetail messages a bid is being sort for and the directions of the required bids.'
  },
  {
    'Tag': '35',
    'Value': 'l',
    'SymbolicName': 'BidResponse',
    'Group': '',
    'Sort': '101',
    'Description': 'BidResponse',
    'Elaboration': 'The Bid Response message can be used in one of two ways depending on which market conventions are being followed.\n      In the \'Non disclosed\' convention the Bid Response message can be used to supply a bid based on the sector, country, index and liquidity information contained within the corresponding bid request message. See \'Program/Basket/List Trading\'  for an example.\n      In the \'Disclosed\' convention the Bid Response message can be used to supply bids based on the List Order Detail messages sent in advance of the corresponding Bid Request message.'
  },
  {
    'Tag': '35',
    'Value': 'm',
    'SymbolicName': 'ListStrikePrice',
    'Group': '',
    'Sort': '102',
    'Description': 'ListStrikePrice',
    'Elaboration': 'The strike price message is used to exchange strike price information for principal trades. It can also be used to exchange reference prices for agency trades.'
  },
  {
    'Tag': '35',
    'Value': 'n',
    'SymbolicName': 'XMLnonFIX',
    'Group': '',
    'Sort': '103',
    'Description': 'XMLnonFIX',
    'Elaboration': ''
  },
  {
    'Tag': '35',
    'Value': 'o',
    'SymbolicName': 'RegistrationInstructions',
    'Group': '',
    'Sort': '104',
    'Description': 'RegistrationInstructions',
    'Elaboration': 'The Registration Instructions message type may be used by institutions or retail intermediaries wishing to electronically submit registration information to a broker or fund manager (for CIV) for an order or for an allocation.'
  },
  {
    'Tag': '35',
    'Value': 'p',
    'SymbolicName': 'RegistrationInstructionsResponse',
    'Group': '',
    'Sort': '105',
    'Description': 'RegistrationInstructionsResponse',
    'Elaboration': 'The Registration Instructions Response message type may be used by broker or fund manager (for CIV) in response to a Registration Instructions message submitted by an institution or retail intermediary for an order or for an allocation.'
  },
  {
    'Tag': '35',
    'Value': 'q',
    'SymbolicName': 'OrderMassCancelRequest',
    'Group': '',
    'Sort': '106',
    'Description': 'OrderMassCancelRequest',
    'Elaboration': 'The order mass cancel request message requests the cancellation of all of the remaining quantity of a group of orders matching criteria specified within the request. NOTE: This message can only be used to cancel order messages (reduce the full quantity).'
  },
  {
    'Tag': '35',
    'Value': 'r',
    'SymbolicName': 'OrderMassCancelReport',
    'Group': '',
    'Sort': '107',
    'Description': 'OrderMassCancelReport',
    'Elaboration': 'The Order Mass Cancel Report is used to acknowledge an Order Mass Cancel Request. Note that each affected order that is canceled is acknowledged with a separate Execution Report or Order Cancel Reject message.'
  },
  {
    'Tag': '35',
    'Value': 's',
    'SymbolicName': 'NewOrderCross',
    'Group': '',
    'Sort': '108',
    'Description': 'NewOrderCross',
    'Elaboration': 'Used to submit a cross order into a market. The cross order contains two order sides (a buy and a sell). The cross order is identified by its CrossID.'
  },
  {
    'Tag': '35',
    'Value': 't',
    'SymbolicName': 'CrossOrderCancelReplaceRequest',
    'Group': '',
    'Sort': '109',
    'Description': 'CrossOrderCancelReplaceRequest',
    'Elaboration': 'Used to modify a cross order previously submitted using the New Order - Cross message. See Order Cancel Replace Request for details concerning message usage.'
  },
  {
    'Tag': '35',
    'Value': 'u',
    'SymbolicName': 'CrossOrderCancelRequest',
    'Group': '',
    'Sort': '110',
    'Description': 'CrossOrderCancelRequest',
    'Elaboration': 'Used to fully cancel the remaining open quantity of a cross order.'
  },
  {
    'Tag': '35',
    'Value': 'v',
    'SymbolicName': 'SecurityTypeRequest',
    'Group': '',
    'Sort': '111',
    'Description': 'SecurityTypeRequest',
    'Elaboration': 'The Security Type Request message is used to return a list of security types available from a counterparty or market.'
  },
  {
    'Tag': '35',
    'Value': 'w',
    'SymbolicName': 'SecurityTypes',
    'Group': '',
    'Sort': '112',
    'Description': 'SecurityTypes',
    'Elaboration': 'The Security Type Request message is used to return a list of security types available from a counterparty or market.'
  },
  {
    'Tag': '35',
    'Value': 'x',
    'SymbolicName': 'SecurityListRequest',
    'Group': '',
    'Sort': '113',
    'Description': 'SecurityListRequest',
    'Elaboration': 'The Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request'
  },
  {
    'Tag': '35',
    'Value': 'y',
    'SymbolicName': 'SecurityList',
    'Group': '',
    'Sort': '114',
    'Description': 'SecurityList',
    'Elaboration': 'The Security List message is used to return a list of securities that matches the criteria specified in a Security List Request.'
  },
  {
    'Tag': '35',
    'Value': 'z',
    'SymbolicName': 'DerivativeSecurityListRequest',
    'Group': '',
    'Sort': '115',
    'Description': 'DerivativeSecurityListRequest',
    'Elaboration': 'The Derivative Security List Request message is used to return a list of securities from the counterparty that match criteria provided on the request'
  }
];